/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `DateTime` scalar type represents a DateTime. The DateTime is serialized as an RFC 3339 quoted string */
  DateTime: { input: any; output: any; }
  /** The `Long` scalar type represents non-fractional signed whole numeric values in string format to prevent lossy conversions */
  Long: { input: any; output: any; }
  ObjectId: { input: any; output: any; }
};

export type Alignment = {
  __typename?: 'Alignment';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type AlignmentInsertInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type AlignmentQueryInput = {
  AND?: InputMaybe<Array<AlignmentQueryInput>>;
  OR?: InputMaybe<Array<AlignmentQueryInput>>;
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  _id_gt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_gte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  _id_lt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_lte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_ne?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum AlignmentSortByInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type AlignmentUpdateInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Archetype = {
  __typename?: 'Archetype';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ArchetypeInsertInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ArchetypeQueryInput = {
  AND?: InputMaybe<Array<ArchetypeQueryInput>>;
  OR?: InputMaybe<Array<ArchetypeQueryInput>>;
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  _id_gt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_gte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  _id_lt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_lte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_ne?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum ArchetypeSortByInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type ArchetypeUpdateInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Body_Shape = {
  __typename?: 'Body_shape';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  mask_url?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Body_ShapeInsertInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  mask_url?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Body_ShapeQueryInput = {
  AND?: InputMaybe<Array<Body_ShapeQueryInput>>;
  OR?: InputMaybe<Array<Body_ShapeQueryInput>>;
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  _id_gt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_gte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  _id_lt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_lte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_ne?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  mask_url?: InputMaybe<Scalars['String']['input']>;
  mask_url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mask_url_gt?: InputMaybe<Scalars['String']['input']>;
  mask_url_gte?: InputMaybe<Scalars['String']['input']>;
  mask_url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mask_url_lt?: InputMaybe<Scalars['String']['input']>;
  mask_url_lte?: InputMaybe<Scalars['String']['input']>;
  mask_url_ne?: InputMaybe<Scalars['String']['input']>;
  mask_url_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum Body_ShapeSortByInput {
  MaskUrlAsc = 'MASK_URL_ASC',
  MaskUrlDesc = 'MASK_URL_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type Body_ShapeUpdateInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  mask_url?: InputMaybe<Scalars['String']['input']>;
  mask_url_unset?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Campaign = {
  __typename?: 'Campaign';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  background_asset?: Maybe<Media_Asset>;
  calendars?: Maybe<Array<Maybe<Campaign_Calendar>>>;
  campaign_acts?: Maybe<Array<Maybe<Campaign_Act>>>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  event_history?: Maybe<Array<Maybe<Campaign_Event>>>;
  main_location?: Maybe<Location>;
  maps?: Maybe<Array<Maybe<Map>>>;
  modified_at?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  other_media_assets?: Maybe<Array<Maybe<Media_Asset>>>;
  owner: User;
  realm: Realm;
  story_plot?: Maybe<CampaignStory_Plot>;
  thumbnail_asset?: Maybe<Media_Asset>;
};

export type CampaignBackground_AssetRelationInput = {
  create?: InputMaybe<Media_AssetInsertInput>;
  link?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type CampaignCalendarsRelationInput = {
  create?: InputMaybe<Array<InputMaybe<Campaign_CalendarInsertInput>>>;
  link?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
};

export type CampaignCampaign_ActsRelationInput = {
  create?: InputMaybe<Array<InputMaybe<Campaign_ActInsertInput>>>;
  link?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
};

export type CampaignEvent_HistoryRelationInput = {
  create?: InputMaybe<Array<InputMaybe<Campaign_EventInsertInput>>>;
  link?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
};

export type CampaignInsertInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  background_asset?: InputMaybe<CampaignBackground_AssetRelationInput>;
  calendars?: InputMaybe<CampaignCalendarsRelationInput>;
  campaign_acts?: InputMaybe<CampaignCampaign_ActsRelationInput>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  event_history?: InputMaybe<CampaignEvent_HistoryRelationInput>;
  main_location?: InputMaybe<CampaignMain_LocationRelationInput>;
  maps?: InputMaybe<CampaignMapsRelationInput>;
  modified_at?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  other_media_assets?: InputMaybe<CampaignOther_Media_AssetsRelationInput>;
  owner: CampaignOwnerRelationInput;
  realm: CampaignRealmRelationInput;
  story_plot?: InputMaybe<CampaignStory_PlotInsertInput>;
  thumbnail_asset?: InputMaybe<CampaignThumbnail_AssetRelationInput>;
};

export type CampaignMain_LocationRelationInput = {
  create?: InputMaybe<LocationInsertInput>;
  link?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type CampaignMapsRelationInput = {
  create?: InputMaybe<Array<InputMaybe<MapInsertInput>>>;
  link?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
};

export type CampaignOther_Media_AssetsRelationInput = {
  create?: InputMaybe<Array<InputMaybe<Media_AssetInsertInput>>>;
  link?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
};

export type CampaignOwnerRelationInput = {
  create?: InputMaybe<UserInsertInput>;
  link?: InputMaybe<Scalars['String']['input']>;
};

export type CampaignQueryInput = {
  AND?: InputMaybe<Array<CampaignQueryInput>>;
  OR?: InputMaybe<Array<CampaignQueryInput>>;
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  _id_gt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_gte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  _id_lt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_lte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_ne?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  background_asset?: InputMaybe<Media_AssetQueryInput>;
  background_asset_exists?: InputMaybe<Scalars['Boolean']['input']>;
  calendars?: InputMaybe<Array<InputMaybe<Campaign_CalendarQueryInput>>>;
  calendars_exists?: InputMaybe<Scalars['Boolean']['input']>;
  calendars_in?: InputMaybe<Array<InputMaybe<Campaign_CalendarQueryInput>>>;
  calendars_nin?: InputMaybe<Array<InputMaybe<Campaign_CalendarQueryInput>>>;
  campaign_acts?: InputMaybe<Array<InputMaybe<Campaign_ActQueryInput>>>;
  campaign_acts_exists?: InputMaybe<Scalars['Boolean']['input']>;
  campaign_acts_in?: InputMaybe<Array<InputMaybe<Campaign_ActQueryInput>>>;
  campaign_acts_nin?: InputMaybe<Array<InputMaybe<Campaign_ActQueryInput>>>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_exists?: InputMaybe<Scalars['Boolean']['input']>;
  created_at_gt?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_gte?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  created_at_lt?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_lte?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_ne?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  event_history?: InputMaybe<Array<InputMaybe<Campaign_EventQueryInput>>>;
  event_history_exists?: InputMaybe<Scalars['Boolean']['input']>;
  event_history_in?: InputMaybe<Array<InputMaybe<Campaign_EventQueryInput>>>;
  event_history_nin?: InputMaybe<Array<InputMaybe<Campaign_EventQueryInput>>>;
  main_location?: InputMaybe<LocationQueryInput>;
  main_location_exists?: InputMaybe<Scalars['Boolean']['input']>;
  maps?: InputMaybe<Array<InputMaybe<MapQueryInput>>>;
  maps_exists?: InputMaybe<Scalars['Boolean']['input']>;
  maps_in?: InputMaybe<Array<InputMaybe<MapQueryInput>>>;
  maps_nin?: InputMaybe<Array<InputMaybe<MapQueryInput>>>;
  modified_at?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_exists?: InputMaybe<Scalars['Boolean']['input']>;
  modified_at_gt?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_gte?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  modified_at_lt?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_lte?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_ne?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  other_media_assets?: InputMaybe<Array<InputMaybe<Media_AssetQueryInput>>>;
  other_media_assets_exists?: InputMaybe<Scalars['Boolean']['input']>;
  other_media_assets_in?: InputMaybe<Array<InputMaybe<Media_AssetQueryInput>>>;
  other_media_assets_nin?: InputMaybe<Array<InputMaybe<Media_AssetQueryInput>>>;
  owner?: InputMaybe<UserQueryInput>;
  owner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  realm?: InputMaybe<RealmQueryInput>;
  realm_exists?: InputMaybe<Scalars['Boolean']['input']>;
  story_plot?: InputMaybe<CampaignStory_PlotQueryInput>;
  story_plot_exists?: InputMaybe<Scalars['Boolean']['input']>;
  thumbnail_asset?: InputMaybe<Media_AssetQueryInput>;
  thumbnail_asset_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CampaignRealmRelationInput = {
  create?: InputMaybe<RealmInsertInput>;
  link?: InputMaybe<Scalars['ObjectId']['input']>;
};

export enum CampaignSortByInput {
  BackgroundAssetAsc = 'BACKGROUND_ASSET_ASC',
  BackgroundAssetDesc = 'BACKGROUND_ASSET_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  MainLocationAsc = 'MAIN_LOCATION_ASC',
  MainLocationDesc = 'MAIN_LOCATION_DESC',
  ModifiedAtAsc = 'MODIFIED_AT_ASC',
  ModifiedAtDesc = 'MODIFIED_AT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  OwnerAsc = 'OWNER_ASC',
  OwnerDesc = 'OWNER_DESC',
  RealmAsc = 'REALM_ASC',
  RealmDesc = 'REALM_DESC',
  ThumbnailAssetAsc = 'THUMBNAIL_ASSET_ASC',
  ThumbnailAssetDesc = 'THUMBNAIL_ASSET_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type CampaignStory_Plot = {
  __typename?: 'CampaignStory_plot';
  narrative?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type CampaignStory_PlotInsertInput = {
  narrative?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type CampaignStory_PlotQueryInput = {
  AND?: InputMaybe<Array<CampaignStory_PlotQueryInput>>;
  OR?: InputMaybe<Array<CampaignStory_PlotQueryInput>>;
  narrative?: InputMaybe<Scalars['String']['input']>;
  narrative_exists?: InputMaybe<Scalars['Boolean']['input']>;
  narrative_gt?: InputMaybe<Scalars['String']['input']>;
  narrative_gte?: InputMaybe<Scalars['String']['input']>;
  narrative_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  narrative_lt?: InputMaybe<Scalars['String']['input']>;
  narrative_lte?: InputMaybe<Scalars['String']['input']>;
  narrative_ne?: InputMaybe<Scalars['String']['input']>;
  narrative_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type_gt?: InputMaybe<Scalars['String']['input']>;
  type_gte?: InputMaybe<Scalars['String']['input']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_lt?: InputMaybe<Scalars['String']['input']>;
  type_lte?: InputMaybe<Scalars['String']['input']>;
  type_ne?: InputMaybe<Scalars['String']['input']>;
  type_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CampaignStory_PlotUpdateInput = {
  narrative?: InputMaybe<Scalars['String']['input']>;
  narrative_unset?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CampaignThumbnail_AssetRelationInput = {
  create?: InputMaybe<Media_AssetInsertInput>;
  link?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type CampaignUpdateInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  background_asset?: InputMaybe<CampaignBackground_AssetRelationInput>;
  background_asset_unset?: InputMaybe<Scalars['Boolean']['input']>;
  calendars?: InputMaybe<CampaignCalendarsRelationInput>;
  calendars_unset?: InputMaybe<Scalars['Boolean']['input']>;
  campaign_acts?: InputMaybe<CampaignCampaign_ActsRelationInput>;
  campaign_acts_unset?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_unset?: InputMaybe<Scalars['Boolean']['input']>;
  event_history?: InputMaybe<CampaignEvent_HistoryRelationInput>;
  event_history_unset?: InputMaybe<Scalars['Boolean']['input']>;
  main_location?: InputMaybe<CampaignMain_LocationRelationInput>;
  main_location_unset?: InputMaybe<Scalars['Boolean']['input']>;
  maps?: InputMaybe<CampaignMapsRelationInput>;
  maps_unset?: InputMaybe<Scalars['Boolean']['input']>;
  modified_at?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_unset?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_unset?: InputMaybe<Scalars['Boolean']['input']>;
  other_media_assets?: InputMaybe<CampaignOther_Media_AssetsRelationInput>;
  other_media_assets_unset?: InputMaybe<Scalars['Boolean']['input']>;
  owner?: InputMaybe<CampaignOwnerRelationInput>;
  owner_unset?: InputMaybe<Scalars['Boolean']['input']>;
  realm?: InputMaybe<CampaignRealmRelationInput>;
  realm_unset?: InputMaybe<Scalars['Boolean']['input']>;
  story_plot?: InputMaybe<CampaignStory_PlotUpdateInput>;
  story_plot_unset?: InputMaybe<Scalars['Boolean']['input']>;
  thumbnail_asset?: InputMaybe<CampaignThumbnail_AssetRelationInput>;
  thumbnail_asset_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Campaign_Act = {
  __typename?: 'Campaign_act';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  background_asset?: Maybe<Media_Asset>;
  calendars?: Maybe<Array<Maybe<Campaign_Calendar>>>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  modified_at?: Maybe<Scalars['DateTime']['output']>;
  narrative?: Maybe<Scalars['String']['output']>;
  other_media_assets?: Maybe<Array<Maybe<Media_Asset>>>;
  outcomes?: Maybe<Array<Maybe<Campaign_ActOutcome>>>;
  owner: User;
  thumbnail_asset?: Maybe<Media_Asset>;
  title?: Maybe<Scalars['String']['output']>;
};

export type Campaign_ActBackground_AssetRelationInput = {
  create?: InputMaybe<Media_AssetInsertInput>;
  link?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type Campaign_ActCalendarsRelationInput = {
  create?: InputMaybe<Array<InputMaybe<Campaign_CalendarInsertInput>>>;
  link?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
};

export type Campaign_ActInsertInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  background_asset?: InputMaybe<Campaign_ActBackground_AssetRelationInput>;
  calendars?: InputMaybe<Campaign_ActCalendarsRelationInput>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at?: InputMaybe<Scalars['DateTime']['input']>;
  narrative?: InputMaybe<Scalars['String']['input']>;
  other_media_assets?: InputMaybe<Campaign_ActOther_Media_AssetsRelationInput>;
  outcomes?: InputMaybe<Array<InputMaybe<Campaign_ActOutcomeInsertInput>>>;
  owner: Campaign_ActOwnerRelationInput;
  thumbnail_asset?: InputMaybe<Campaign_ActThumbnail_AssetRelationInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Campaign_ActOther_Media_AssetsRelationInput = {
  create?: InputMaybe<Array<InputMaybe<Media_AssetInsertInput>>>;
  link?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
};

export type Campaign_ActOutcome = {
  __typename?: 'Campaign_actOutcome';
  description?: Maybe<Scalars['String']['output']>;
  impact?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  quests?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Campaign_ActOutcomeInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  impact?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  quests?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type Campaign_ActOutcomeQueryInput = {
  AND?: InputMaybe<Array<Campaign_ActOutcomeQueryInput>>;
  OR?: InputMaybe<Array<Campaign_ActOutcomeQueryInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_gt?: InputMaybe<Scalars['String']['input']>;
  description_gte?: InputMaybe<Scalars['String']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_lt?: InputMaybe<Scalars['String']['input']>;
  description_lte?: InputMaybe<Scalars['String']['input']>;
  description_ne?: InputMaybe<Scalars['String']['input']>;
  description_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  impact?: InputMaybe<Scalars['String']['input']>;
  impact_exists?: InputMaybe<Scalars['Boolean']['input']>;
  impact_gt?: InputMaybe<Scalars['String']['input']>;
  impact_gte?: InputMaybe<Scalars['String']['input']>;
  impact_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  impact_lt?: InputMaybe<Scalars['String']['input']>;
  impact_lte?: InputMaybe<Scalars['String']['input']>;
  impact_ne?: InputMaybe<Scalars['String']['input']>;
  impact_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  quests?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  quests_exists?: InputMaybe<Scalars['Boolean']['input']>;
  quests_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  quests_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type_gt?: InputMaybe<Scalars['String']['input']>;
  type_gte?: InputMaybe<Scalars['String']['input']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_lt?: InputMaybe<Scalars['String']['input']>;
  type_lte?: InputMaybe<Scalars['String']['input']>;
  type_ne?: InputMaybe<Scalars['String']['input']>;
  type_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Campaign_ActOutcomeUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  description_unset?: InputMaybe<Scalars['Boolean']['input']>;
  impact?: InputMaybe<Scalars['String']['input']>;
  impact_unset?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_unset?: InputMaybe<Scalars['Boolean']['input']>;
  quests?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  quests_unset?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Campaign_ActOwnerRelationInput = {
  create?: InputMaybe<UserInsertInput>;
  link?: InputMaybe<Scalars['String']['input']>;
};

export type Campaign_ActQueryInput = {
  AND?: InputMaybe<Array<Campaign_ActQueryInput>>;
  OR?: InputMaybe<Array<Campaign_ActQueryInput>>;
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  _id_gt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_gte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  _id_lt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_lte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_ne?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  background_asset?: InputMaybe<Media_AssetQueryInput>;
  background_asset_exists?: InputMaybe<Scalars['Boolean']['input']>;
  calendars?: InputMaybe<Array<InputMaybe<Campaign_CalendarQueryInput>>>;
  calendars_exists?: InputMaybe<Scalars['Boolean']['input']>;
  calendars_in?: InputMaybe<Array<InputMaybe<Campaign_CalendarQueryInput>>>;
  calendars_nin?: InputMaybe<Array<InputMaybe<Campaign_CalendarQueryInput>>>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_exists?: InputMaybe<Scalars['Boolean']['input']>;
  created_at_gt?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_gte?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  created_at_lt?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_lte?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_ne?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  modified_at?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_exists?: InputMaybe<Scalars['Boolean']['input']>;
  modified_at_gt?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_gte?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  modified_at_lt?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_lte?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_ne?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  narrative?: InputMaybe<Scalars['String']['input']>;
  narrative_exists?: InputMaybe<Scalars['Boolean']['input']>;
  narrative_gt?: InputMaybe<Scalars['String']['input']>;
  narrative_gte?: InputMaybe<Scalars['String']['input']>;
  narrative_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  narrative_lt?: InputMaybe<Scalars['String']['input']>;
  narrative_lte?: InputMaybe<Scalars['String']['input']>;
  narrative_ne?: InputMaybe<Scalars['String']['input']>;
  narrative_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  other_media_assets?: InputMaybe<Array<InputMaybe<Media_AssetQueryInput>>>;
  other_media_assets_exists?: InputMaybe<Scalars['Boolean']['input']>;
  other_media_assets_in?: InputMaybe<Array<InputMaybe<Media_AssetQueryInput>>>;
  other_media_assets_nin?: InputMaybe<Array<InputMaybe<Media_AssetQueryInput>>>;
  outcomes?: InputMaybe<Array<InputMaybe<Campaign_ActOutcomeQueryInput>>>;
  outcomes_exists?: InputMaybe<Scalars['Boolean']['input']>;
  outcomes_in?: InputMaybe<Array<InputMaybe<Campaign_ActOutcomeQueryInput>>>;
  outcomes_nin?: InputMaybe<Array<InputMaybe<Campaign_ActOutcomeQueryInput>>>;
  owner?: InputMaybe<UserQueryInput>;
  owner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  thumbnail_asset?: InputMaybe<Media_AssetQueryInput>;
  thumbnail_asset_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_gt?: InputMaybe<Scalars['String']['input']>;
  title_gte?: InputMaybe<Scalars['String']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_lt?: InputMaybe<Scalars['String']['input']>;
  title_lte?: InputMaybe<Scalars['String']['input']>;
  title_ne?: InputMaybe<Scalars['String']['input']>;
  title_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum Campaign_ActSortByInput {
  BackgroundAssetAsc = 'BACKGROUND_ASSET_ASC',
  BackgroundAssetDesc = 'BACKGROUND_ASSET_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  ModifiedAtAsc = 'MODIFIED_AT_ASC',
  ModifiedAtDesc = 'MODIFIED_AT_DESC',
  NarrativeAsc = 'NARRATIVE_ASC',
  NarrativeDesc = 'NARRATIVE_DESC',
  OwnerAsc = 'OWNER_ASC',
  OwnerDesc = 'OWNER_DESC',
  ThumbnailAssetAsc = 'THUMBNAIL_ASSET_ASC',
  ThumbnailAssetDesc = 'THUMBNAIL_ASSET_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type Campaign_ActThumbnail_AssetRelationInput = {
  create?: InputMaybe<Media_AssetInsertInput>;
  link?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type Campaign_ActUpdateInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  background_asset?: InputMaybe<Campaign_ActBackground_AssetRelationInput>;
  background_asset_unset?: InputMaybe<Scalars['Boolean']['input']>;
  calendars?: InputMaybe<Campaign_ActCalendarsRelationInput>;
  calendars_unset?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_unset?: InputMaybe<Scalars['Boolean']['input']>;
  modified_at?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_unset?: InputMaybe<Scalars['Boolean']['input']>;
  narrative?: InputMaybe<Scalars['String']['input']>;
  narrative_unset?: InputMaybe<Scalars['Boolean']['input']>;
  other_media_assets?: InputMaybe<Campaign_ActOther_Media_AssetsRelationInput>;
  other_media_assets_unset?: InputMaybe<Scalars['Boolean']['input']>;
  outcomes?: InputMaybe<Array<InputMaybe<Campaign_ActOutcomeUpdateInput>>>;
  outcomes_unset?: InputMaybe<Scalars['Boolean']['input']>;
  owner?: InputMaybe<Campaign_ActOwnerRelationInput>;
  owner_unset?: InputMaybe<Scalars['Boolean']['input']>;
  thumbnail_asset?: InputMaybe<Campaign_ActThumbnail_AssetRelationInput>;
  thumbnail_asset_unset?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Campaign_Calendar = {
  __typename?: 'Campaign_calendar';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  day?: Maybe<Scalars['Int']['output']>;
  modified_at?: Maybe<Scalars['DateTime']['output']>;
  months?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
  owner: User;
  startEvent?: Maybe<Campaign_Event>;
  years?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type Campaign_CalendarInsertInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  day?: InputMaybe<Scalars['Int']['input']>;
  modified_at?: InputMaybe<Scalars['DateTime']['input']>;
  months?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner: Campaign_CalendarOwnerRelationInput;
  startEvent?: InputMaybe<Campaign_CalendarStartEventRelationInput>;
  years?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Campaign_CalendarOwnerRelationInput = {
  create?: InputMaybe<UserInsertInput>;
  link?: InputMaybe<Scalars['String']['input']>;
};

export type Campaign_CalendarQueryInput = {
  AND?: InputMaybe<Array<Campaign_CalendarQueryInput>>;
  OR?: InputMaybe<Array<Campaign_CalendarQueryInput>>;
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  _id_gt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_gte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  _id_lt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_lte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_ne?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_exists?: InputMaybe<Scalars['Boolean']['input']>;
  created_at_gt?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_gte?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  created_at_lt?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_lte?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_ne?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  day?: InputMaybe<Scalars['Int']['input']>;
  day_exists?: InputMaybe<Scalars['Boolean']['input']>;
  day_gt?: InputMaybe<Scalars['Int']['input']>;
  day_gte?: InputMaybe<Scalars['Int']['input']>;
  day_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  day_lt?: InputMaybe<Scalars['Int']['input']>;
  day_lte?: InputMaybe<Scalars['Int']['input']>;
  day_ne?: InputMaybe<Scalars['Int']['input']>;
  day_nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  modified_at?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_exists?: InputMaybe<Scalars['Boolean']['input']>;
  modified_at_gt?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_gte?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  modified_at_lt?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_lte?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_ne?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  months?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  months_exists?: InputMaybe<Scalars['Boolean']['input']>;
  months_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  months_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  owner?: InputMaybe<UserQueryInput>;
  owner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  startEvent?: InputMaybe<Campaign_EventQueryInput>;
  startEvent_exists?: InputMaybe<Scalars['Boolean']['input']>;
  years?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  years_exists?: InputMaybe<Scalars['Boolean']['input']>;
  years_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  years_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum Campaign_CalendarSortByInput {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DayAsc = 'DAY_ASC',
  DayDesc = 'DAY_DESC',
  ModifiedAtAsc = 'MODIFIED_AT_ASC',
  ModifiedAtDesc = 'MODIFIED_AT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  OwnerAsc = 'OWNER_ASC',
  OwnerDesc = 'OWNER_DESC',
  StarteventAsc = 'STARTEVENT_ASC',
  StarteventDesc = 'STARTEVENT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type Campaign_CalendarStartEventRelationInput = {
  create?: InputMaybe<Campaign_EventInsertInput>;
  link?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type Campaign_CalendarUpdateInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_unset?: InputMaybe<Scalars['Boolean']['input']>;
  day?: InputMaybe<Scalars['Int']['input']>;
  day_inc?: InputMaybe<Scalars['Int']['input']>;
  day_unset?: InputMaybe<Scalars['Boolean']['input']>;
  modified_at?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_unset?: InputMaybe<Scalars['Boolean']['input']>;
  months?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  months_unset?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_unset?: InputMaybe<Scalars['Boolean']['input']>;
  owner?: InputMaybe<Campaign_CalendarOwnerRelationInput>;
  owner_unset?: InputMaybe<Scalars['Boolean']['input']>;
  startEvent?: InputMaybe<Campaign_CalendarStartEventRelationInput>;
  startEvent_unset?: InputMaybe<Scalars['Boolean']['input']>;
  years?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  years_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Campaign_Event = {
  __typename?: 'Campaign_event';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  calendar_used?: Maybe<Campaign_Calendar>;
  characters?: Maybe<Array<Maybe<Character>>>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Location>;
  modified_at?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  owner: User;
};

export type Campaign_EventCalendar_UsedRelationInput = {
  create?: InputMaybe<Campaign_CalendarInsertInput>;
  link?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type Campaign_EventCharactersRelationInput = {
  create?: InputMaybe<Array<InputMaybe<CharacterInsertInput>>>;
  link?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
};

export type Campaign_EventInsertInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  calendar_used?: InputMaybe<Campaign_EventCalendar_UsedRelationInput>;
  characters?: InputMaybe<Campaign_EventCharactersRelationInput>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Campaign_EventLocationRelationInput>;
  modified_at?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner: Campaign_EventOwnerRelationInput;
};

export type Campaign_EventLocationRelationInput = {
  create?: InputMaybe<LocationInsertInput>;
  link?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type Campaign_EventOwnerRelationInput = {
  create?: InputMaybe<UserInsertInput>;
  link?: InputMaybe<Scalars['String']['input']>;
};

export type Campaign_EventQueryInput = {
  AND?: InputMaybe<Array<Campaign_EventQueryInput>>;
  OR?: InputMaybe<Array<Campaign_EventQueryInput>>;
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  _id_gt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_gte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  _id_lt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_lte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_ne?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  calendar_used?: InputMaybe<Campaign_CalendarQueryInput>;
  calendar_used_exists?: InputMaybe<Scalars['Boolean']['input']>;
  characters?: InputMaybe<Array<InputMaybe<CharacterQueryInput>>>;
  characters_exists?: InputMaybe<Scalars['Boolean']['input']>;
  characters_in?: InputMaybe<Array<InputMaybe<CharacterQueryInput>>>;
  characters_nin?: InputMaybe<Array<InputMaybe<CharacterQueryInput>>>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_exists?: InputMaybe<Scalars['Boolean']['input']>;
  created_at_gt?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_gte?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  created_at_lt?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_lte?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_ne?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_gt?: InputMaybe<Scalars['String']['input']>;
  description_gte?: InputMaybe<Scalars['String']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_lt?: InputMaybe<Scalars['String']['input']>;
  description_lte?: InputMaybe<Scalars['String']['input']>;
  description_ne?: InputMaybe<Scalars['String']['input']>;
  description_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  location?: InputMaybe<LocationQueryInput>;
  location_exists?: InputMaybe<Scalars['Boolean']['input']>;
  modified_at?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_exists?: InputMaybe<Scalars['Boolean']['input']>;
  modified_at_gt?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_gte?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  modified_at_lt?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_lte?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_ne?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  owner?: InputMaybe<UserQueryInput>;
  owner_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum Campaign_EventSortByInput {
  CalendarUsedAsc = 'CALENDAR_USED_ASC',
  CalendarUsedDesc = 'CALENDAR_USED_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  LocationAsc = 'LOCATION_ASC',
  LocationDesc = 'LOCATION_DESC',
  ModifiedAtAsc = 'MODIFIED_AT_ASC',
  ModifiedAtDesc = 'MODIFIED_AT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  OwnerAsc = 'OWNER_ASC',
  OwnerDesc = 'OWNER_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type Campaign_EventUpdateInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  calendar_used?: InputMaybe<Campaign_EventCalendar_UsedRelationInput>;
  calendar_used_unset?: InputMaybe<Scalars['Boolean']['input']>;
  characters?: InputMaybe<Campaign_EventCharactersRelationInput>;
  characters_unset?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_unset?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_unset?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Campaign_EventLocationRelationInput>;
  location_unset?: InputMaybe<Scalars['Boolean']['input']>;
  modified_at?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_unset?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_unset?: InputMaybe<Scalars['Boolean']['input']>;
  owner?: InputMaybe<Campaign_EventOwnerRelationInput>;
  owner_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Campaign_Quest = {
  __typename?: 'Campaign_quest';
  _id?: Maybe<Character>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  encounters?: Maybe<Array<Maybe<Campaign_QuestEncounter>>>;
  goals?: Maybe<Array<Maybe<Campaign_QuestGoal>>>;
  media_assets?: Maybe<Array<Maybe<Media_Asset>>>;
  modified_at?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  owner: User;
};

export type Campaign_QuestEncounter = {
  __typename?: 'Campaign_questEncounter';
  involved_characters?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Campaign_QuestEncounterInsertInput = {
  involved_characters?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type Campaign_QuestEncounterQueryInput = {
  AND?: InputMaybe<Array<Campaign_QuestEncounterQueryInput>>;
  OR?: InputMaybe<Array<Campaign_QuestEncounterQueryInput>>;
  involved_characters?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  involved_characters_exists?: InputMaybe<Scalars['Boolean']['input']>;
  involved_characters_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  involved_characters_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type_gt?: InputMaybe<Scalars['String']['input']>;
  type_gte?: InputMaybe<Scalars['String']['input']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_lt?: InputMaybe<Scalars['String']['input']>;
  type_lte?: InputMaybe<Scalars['String']['input']>;
  type_ne?: InputMaybe<Scalars['String']['input']>;
  type_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Campaign_QuestEncounterUpdateInput = {
  involved_characters?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  involved_characters_unset?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Campaign_QuestGoal = {
  __typename?: 'Campaign_questGoal';
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Campaign_QuestGoalInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Campaign_QuestGoalQueryInput = {
  AND?: InputMaybe<Array<Campaign_QuestGoalQueryInput>>;
  OR?: InputMaybe<Array<Campaign_QuestGoalQueryInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_gt?: InputMaybe<Scalars['String']['input']>;
  description_gte?: InputMaybe<Scalars['String']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_lt?: InputMaybe<Scalars['String']['input']>;
  description_lte?: InputMaybe<Scalars['String']['input']>;
  description_ne?: InputMaybe<Scalars['String']['input']>;
  description_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Campaign_QuestGoalUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  description_unset?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Campaign_QuestInsertInput = {
  _id?: InputMaybe<Campaign_Quest_IdRelationInput>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  encounters?: InputMaybe<Array<InputMaybe<Campaign_QuestEncounterInsertInput>>>;
  goals?: InputMaybe<Array<InputMaybe<Campaign_QuestGoalInsertInput>>>;
  media_assets?: InputMaybe<Campaign_QuestMedia_AssetsRelationInput>;
  modified_at?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner: Campaign_QuestOwnerRelationInput;
};

export type Campaign_QuestMedia_AssetsRelationInput = {
  create?: InputMaybe<Array<InputMaybe<Media_AssetInsertInput>>>;
  link?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
};

export type Campaign_QuestOwnerRelationInput = {
  create?: InputMaybe<UserInsertInput>;
  link?: InputMaybe<Scalars['String']['input']>;
};

export type Campaign_QuestQueryInput = {
  AND?: InputMaybe<Array<Campaign_QuestQueryInput>>;
  OR?: InputMaybe<Array<Campaign_QuestQueryInput>>;
  _id?: InputMaybe<CharacterQueryInput>;
  _id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_exists?: InputMaybe<Scalars['Boolean']['input']>;
  created_at_gt?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_gte?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  created_at_lt?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_lte?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_ne?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_gt?: InputMaybe<Scalars['String']['input']>;
  description_gte?: InputMaybe<Scalars['String']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_lt?: InputMaybe<Scalars['String']['input']>;
  description_lte?: InputMaybe<Scalars['String']['input']>;
  description_ne?: InputMaybe<Scalars['String']['input']>;
  description_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  encounters?: InputMaybe<Array<InputMaybe<Campaign_QuestEncounterQueryInput>>>;
  encounters_exists?: InputMaybe<Scalars['Boolean']['input']>;
  encounters_in?: InputMaybe<Array<InputMaybe<Campaign_QuestEncounterQueryInput>>>;
  encounters_nin?: InputMaybe<Array<InputMaybe<Campaign_QuestEncounterQueryInput>>>;
  goals?: InputMaybe<Array<InputMaybe<Campaign_QuestGoalQueryInput>>>;
  goals_exists?: InputMaybe<Scalars['Boolean']['input']>;
  goals_in?: InputMaybe<Array<InputMaybe<Campaign_QuestGoalQueryInput>>>;
  goals_nin?: InputMaybe<Array<InputMaybe<Campaign_QuestGoalQueryInput>>>;
  media_assets?: InputMaybe<Array<InputMaybe<Media_AssetQueryInput>>>;
  media_assets_exists?: InputMaybe<Scalars['Boolean']['input']>;
  media_assets_in?: InputMaybe<Array<InputMaybe<Media_AssetQueryInput>>>;
  media_assets_nin?: InputMaybe<Array<InputMaybe<Media_AssetQueryInput>>>;
  modified_at?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_exists?: InputMaybe<Scalars['Boolean']['input']>;
  modified_at_gt?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_gte?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  modified_at_lt?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_lte?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_ne?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  owner?: InputMaybe<UserQueryInput>;
  owner_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum Campaign_QuestSortByInput {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  ModifiedAtAsc = 'MODIFIED_AT_ASC',
  ModifiedAtDesc = 'MODIFIED_AT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  OwnerAsc = 'OWNER_ASC',
  OwnerDesc = 'OWNER_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type Campaign_QuestUpdateInput = {
  _id?: InputMaybe<Campaign_Quest_IdRelationInput>;
  _id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_unset?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_unset?: InputMaybe<Scalars['Boolean']['input']>;
  encounters?: InputMaybe<Array<InputMaybe<Campaign_QuestEncounterUpdateInput>>>;
  encounters_unset?: InputMaybe<Scalars['Boolean']['input']>;
  goals?: InputMaybe<Array<InputMaybe<Campaign_QuestGoalUpdateInput>>>;
  goals_unset?: InputMaybe<Scalars['Boolean']['input']>;
  media_assets?: InputMaybe<Campaign_QuestMedia_AssetsRelationInput>;
  media_assets_unset?: InputMaybe<Scalars['Boolean']['input']>;
  modified_at?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_unset?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_unset?: InputMaybe<Scalars['Boolean']['input']>;
  owner?: InputMaybe<Campaign_QuestOwnerRelationInput>;
  owner_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Campaign_Quest_IdRelationInput = {
  create?: InputMaybe<CharacterInsertInput>;
  link?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type Canvase = {
  __typename?: 'Canvase';
  _id?: Maybe<Scalars['String']['output']>;
  activeUsers?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>;
  containers?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>;
  realm?: Maybe<Scalars['ObjectId']['output']>;
  widgets?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>;
};

export type CanvaseInsertInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  activeUsers?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  containers?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  realm?: InputMaybe<Scalars['ObjectId']['input']>;
  widgets?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
};

export type CanvaseQueryInput = {
  AND?: InputMaybe<Array<CanvaseQueryInput>>;
  OR?: InputMaybe<Array<CanvaseQueryInput>>;
  _id?: InputMaybe<Scalars['String']['input']>;
  _id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  _id_gt?: InputMaybe<Scalars['String']['input']>;
  _id_gte?: InputMaybe<Scalars['String']['input']>;
  _id_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  _id_lt?: InputMaybe<Scalars['String']['input']>;
  _id_lte?: InputMaybe<Scalars['String']['input']>;
  _id_ne?: InputMaybe<Scalars['String']['input']>;
  _id_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activeUsers?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  activeUsers_exists?: InputMaybe<Scalars['Boolean']['input']>;
  activeUsers_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  activeUsers_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  containers?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  containers_exists?: InputMaybe<Scalars['Boolean']['input']>;
  containers_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  containers_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  realm?: InputMaybe<Scalars['ObjectId']['input']>;
  realm_exists?: InputMaybe<Scalars['Boolean']['input']>;
  realm_gt?: InputMaybe<Scalars['ObjectId']['input']>;
  realm_gte?: InputMaybe<Scalars['ObjectId']['input']>;
  realm_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  realm_lt?: InputMaybe<Scalars['ObjectId']['input']>;
  realm_lte?: InputMaybe<Scalars['ObjectId']['input']>;
  realm_ne?: InputMaybe<Scalars['ObjectId']['input']>;
  realm_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  widgets?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  widgets_exists?: InputMaybe<Scalars['Boolean']['input']>;
  widgets_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  widgets_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
};

export enum CanvaseSortByInput {
  RealmAsc = 'REALM_ASC',
  RealmDesc = 'REALM_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type CanvaseUpdateInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  _id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  activeUsers?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  activeUsers_unset?: InputMaybe<Scalars['Boolean']['input']>;
  containers?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  containers_unset?: InputMaybe<Scalars['Boolean']['input']>;
  realm?: InputMaybe<Scalars['ObjectId']['input']>;
  realm_unset?: InputMaybe<Scalars['Boolean']['input']>;
  widgets?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  widgets_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Character = {
  __typename?: 'Character';
  _id: Scalars['ObjectId']['output'];
  abilities?: Maybe<CharacterAbility>;
  alignment?: Maybe<Scalars['String']['output']>;
  assets?: Maybe<Array<Maybe<Media_Asset>>>;
  attributes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  avatar_path?: Maybe<Scalars['String']['output']>;
  avatar_thumbnail_path?: Maybe<Scalars['String']['output']>;
  avatar_thumbnail_url?: Maybe<Scalars['String']['output']>;
  avatar_url?: Maybe<Scalars['String']['output']>;
  backstory?: Maybe<Scalars['String']['output']>;
  character_image_path?: Maybe<Scalars['String']['output']>;
  character_image_thumbnail_path?: Maybe<Scalars['String']['output']>;
  character_image_thumbnail_url?: Maybe<Scalars['String']['output']>;
  character_image_url?: Maybe<Scalars['String']['output']>;
  character_sets?: Maybe<Array<Maybe<Character_Set>>>;
  character_type?: Maybe<Scalars['String']['output']>;
  class?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['String']['output']>;
  home?: Maybe<Array<Maybe<Location>>>;
  is_pack_character?: Maybe<Scalars['Boolean']['output']>;
  life_altering_event?: Maybe<Scalars['String']['output']>;
  long_term_goals?: Maybe<Array<Maybe<CharacterLong_Term_Goal>>>;
  motivations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name: Scalars['String']['output'];
  notes?: Maybe<Array<Maybe<Note>>>;
  owner?: Maybe<User>;
  physical_profile?: Maybe<CharacterPhysical_Profile>;
  profession?: Maybe<Scalars['String']['output']>;
  pronoun?: Maybe<Scalars['String']['output']>;
  race?: Maybe<Scalars['String']['output']>;
  realms?: Maybe<Array<Maybe<Realm>>>;
  relationship_status?: Maybe<Scalars['String']['output']>;
  short_term_goals?: Maybe<Array<Maybe<CharacterShort_Term_Goal>>>;
  token_sets?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>;
  tone?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  visited_locations?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>;
  weight?: Maybe<Scalars['String']['output']>;
};

export type CharacterAbility = {
  __typename?: 'CharacterAbility';
  charisma?: Maybe<Scalars['Int']['output']>;
  consitution?: Maybe<Scalars['Int']['output']>;
  dexterity?: Maybe<Scalars['Int']['output']>;
  intelligence?: Maybe<Scalars['Int']['output']>;
  strength?: Maybe<Scalars['String']['output']>;
  wisdom?: Maybe<Scalars['Int']['output']>;
};

export type CharacterAbilityInsertInput = {
  charisma?: InputMaybe<Scalars['Int']['input']>;
  consitution?: InputMaybe<Scalars['Int']['input']>;
  dexterity?: InputMaybe<Scalars['Int']['input']>;
  intelligence?: InputMaybe<Scalars['Int']['input']>;
  strength?: InputMaybe<Scalars['String']['input']>;
  wisdom?: InputMaybe<Scalars['Int']['input']>;
};

export type CharacterAbilityQueryInput = {
  AND?: InputMaybe<Array<CharacterAbilityQueryInput>>;
  OR?: InputMaybe<Array<CharacterAbilityQueryInput>>;
  charisma?: InputMaybe<Scalars['Int']['input']>;
  charisma_exists?: InputMaybe<Scalars['Boolean']['input']>;
  charisma_gt?: InputMaybe<Scalars['Int']['input']>;
  charisma_gte?: InputMaybe<Scalars['Int']['input']>;
  charisma_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  charisma_lt?: InputMaybe<Scalars['Int']['input']>;
  charisma_lte?: InputMaybe<Scalars['Int']['input']>;
  charisma_ne?: InputMaybe<Scalars['Int']['input']>;
  charisma_nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  consitution?: InputMaybe<Scalars['Int']['input']>;
  consitution_exists?: InputMaybe<Scalars['Boolean']['input']>;
  consitution_gt?: InputMaybe<Scalars['Int']['input']>;
  consitution_gte?: InputMaybe<Scalars['Int']['input']>;
  consitution_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  consitution_lt?: InputMaybe<Scalars['Int']['input']>;
  consitution_lte?: InputMaybe<Scalars['Int']['input']>;
  consitution_ne?: InputMaybe<Scalars['Int']['input']>;
  consitution_nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  dexterity?: InputMaybe<Scalars['Int']['input']>;
  dexterity_exists?: InputMaybe<Scalars['Boolean']['input']>;
  dexterity_gt?: InputMaybe<Scalars['Int']['input']>;
  dexterity_gte?: InputMaybe<Scalars['Int']['input']>;
  dexterity_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  dexterity_lt?: InputMaybe<Scalars['Int']['input']>;
  dexterity_lte?: InputMaybe<Scalars['Int']['input']>;
  dexterity_ne?: InputMaybe<Scalars['Int']['input']>;
  dexterity_nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  intelligence?: InputMaybe<Scalars['Int']['input']>;
  intelligence_exists?: InputMaybe<Scalars['Boolean']['input']>;
  intelligence_gt?: InputMaybe<Scalars['Int']['input']>;
  intelligence_gte?: InputMaybe<Scalars['Int']['input']>;
  intelligence_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  intelligence_lt?: InputMaybe<Scalars['Int']['input']>;
  intelligence_lte?: InputMaybe<Scalars['Int']['input']>;
  intelligence_ne?: InputMaybe<Scalars['Int']['input']>;
  intelligence_nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  strength?: InputMaybe<Scalars['String']['input']>;
  strength_exists?: InputMaybe<Scalars['Boolean']['input']>;
  strength_gt?: InputMaybe<Scalars['String']['input']>;
  strength_gte?: InputMaybe<Scalars['String']['input']>;
  strength_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  strength_lt?: InputMaybe<Scalars['String']['input']>;
  strength_lte?: InputMaybe<Scalars['String']['input']>;
  strength_ne?: InputMaybe<Scalars['String']['input']>;
  strength_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  wisdom?: InputMaybe<Scalars['Int']['input']>;
  wisdom_exists?: InputMaybe<Scalars['Boolean']['input']>;
  wisdom_gt?: InputMaybe<Scalars['Int']['input']>;
  wisdom_gte?: InputMaybe<Scalars['Int']['input']>;
  wisdom_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  wisdom_lt?: InputMaybe<Scalars['Int']['input']>;
  wisdom_lte?: InputMaybe<Scalars['Int']['input']>;
  wisdom_ne?: InputMaybe<Scalars['Int']['input']>;
  wisdom_nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type CharacterAbilityUpdateInput = {
  charisma?: InputMaybe<Scalars['Int']['input']>;
  charisma_inc?: InputMaybe<Scalars['Int']['input']>;
  charisma_unset?: InputMaybe<Scalars['Boolean']['input']>;
  consitution?: InputMaybe<Scalars['Int']['input']>;
  consitution_inc?: InputMaybe<Scalars['Int']['input']>;
  consitution_unset?: InputMaybe<Scalars['Boolean']['input']>;
  dexterity?: InputMaybe<Scalars['Int']['input']>;
  dexterity_inc?: InputMaybe<Scalars['Int']['input']>;
  dexterity_unset?: InputMaybe<Scalars['Boolean']['input']>;
  intelligence?: InputMaybe<Scalars['Int']['input']>;
  intelligence_inc?: InputMaybe<Scalars['Int']['input']>;
  intelligence_unset?: InputMaybe<Scalars['Boolean']['input']>;
  strength?: InputMaybe<Scalars['String']['input']>;
  strength_unset?: InputMaybe<Scalars['Boolean']['input']>;
  wisdom?: InputMaybe<Scalars['Int']['input']>;
  wisdom_inc?: InputMaybe<Scalars['Int']['input']>;
  wisdom_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CharacterAssetsRelationInput = {
  create?: InputMaybe<Array<InputMaybe<Media_AssetInsertInput>>>;
  link?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
};

export type CharacterCharacter_SetsRelationInput = {
  create?: InputMaybe<Array<InputMaybe<Character_SetInsertInput>>>;
  link?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
};

export type CharacterHomeRelationInput = {
  create?: InputMaybe<Array<InputMaybe<LocationInsertInput>>>;
  link?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
};

export type CharacterInsertInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  abilities?: InputMaybe<CharacterAbilityInsertInput>;
  alignment?: InputMaybe<Scalars['String']['input']>;
  assets?: InputMaybe<CharacterAssetsRelationInput>;
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  avatar_path?: InputMaybe<Scalars['String']['input']>;
  avatar_thumbnail_path?: InputMaybe<Scalars['String']['input']>;
  avatar_thumbnail_url?: InputMaybe<Scalars['String']['input']>;
  avatar_url?: InputMaybe<Scalars['String']['input']>;
  backstory?: InputMaybe<Scalars['String']['input']>;
  character_image_path?: InputMaybe<Scalars['String']['input']>;
  character_image_thumbnail_path?: InputMaybe<Scalars['String']['input']>;
  character_image_thumbnail_url?: InputMaybe<Scalars['String']['input']>;
  character_image_url?: InputMaybe<Scalars['String']['input']>;
  character_sets?: InputMaybe<CharacterCharacter_SetsRelationInput>;
  character_type?: InputMaybe<Scalars['String']['input']>;
  class?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['String']['input']>;
  home?: InputMaybe<CharacterHomeRelationInput>;
  is_pack_character?: InputMaybe<Scalars['Boolean']['input']>;
  life_altering_event?: InputMaybe<Scalars['String']['input']>;
  long_term_goals?: InputMaybe<Array<InputMaybe<CharacterLong_Term_GoalInsertInput>>>;
  motivations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<CharacterNotesRelationInput>;
  owner?: InputMaybe<CharacterOwnerRelationInput>;
  physical_profile?: InputMaybe<CharacterPhysical_ProfileInsertInput>;
  profession?: InputMaybe<Scalars['String']['input']>;
  pronoun?: InputMaybe<Scalars['String']['input']>;
  race?: InputMaybe<Scalars['String']['input']>;
  realms?: InputMaybe<CharacterRealmsRelationInput>;
  relationship_status?: InputMaybe<Scalars['String']['input']>;
  short_term_goals?: InputMaybe<Array<InputMaybe<CharacterShort_Term_GoalInsertInput>>>;
  token_sets?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  tone?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  visited_locations?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  weight?: InputMaybe<Scalars['String']['input']>;
};

export type CharacterLong_Term_Goal = {
  __typename?: 'CharacterLong_term_goal';
  content?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CharacterLong_Term_GoalInsertInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CharacterLong_Term_GoalQueryInput = {
  AND?: InputMaybe<Array<CharacterLong_Term_GoalQueryInput>>;
  OR?: InputMaybe<Array<CharacterLong_Term_GoalQueryInput>>;
  content?: InputMaybe<Scalars['String']['input']>;
  content_exists?: InputMaybe<Scalars['Boolean']['input']>;
  content_gt?: InputMaybe<Scalars['String']['input']>;
  content_gte?: InputMaybe<Scalars['String']['input']>;
  content_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  content_lt?: InputMaybe<Scalars['String']['input']>;
  content_lte?: InputMaybe<Scalars['String']['input']>;
  content_ne?: InputMaybe<Scalars['String']['input']>;
  content_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_gt?: InputMaybe<Scalars['String']['input']>;
  title_gte?: InputMaybe<Scalars['String']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_lt?: InputMaybe<Scalars['String']['input']>;
  title_lte?: InputMaybe<Scalars['String']['input']>;
  title_ne?: InputMaybe<Scalars['String']['input']>;
  title_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CharacterLong_Term_GoalUpdateInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  content_unset?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CharacterNotesRelationInput = {
  create?: InputMaybe<Array<InputMaybe<NoteInsertInput>>>;
  link?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
};

export type CharacterOwnerRelationInput = {
  create?: InputMaybe<UserInsertInput>;
  link?: InputMaybe<Scalars['String']['input']>;
};

export type CharacterPhysical_Profile = {
  __typename?: 'CharacterPhysical_profile';
  body_type?: Maybe<Scalars['String']['output']>;
  eye_color?: Maybe<Scalars['String']['output']>;
  hair_color?: Maybe<Scalars['String']['output']>;
  hair_style?: Maybe<Scalars['String']['output']>;
  skin_color?: Maybe<Scalars['String']['output']>;
};

export type CharacterPhysical_ProfileInsertInput = {
  body_type?: InputMaybe<Scalars['String']['input']>;
  eye_color?: InputMaybe<Scalars['String']['input']>;
  hair_color?: InputMaybe<Scalars['String']['input']>;
  hair_style?: InputMaybe<Scalars['String']['input']>;
  skin_color?: InputMaybe<Scalars['String']['input']>;
};

export type CharacterPhysical_ProfileQueryInput = {
  AND?: InputMaybe<Array<CharacterPhysical_ProfileQueryInput>>;
  OR?: InputMaybe<Array<CharacterPhysical_ProfileQueryInput>>;
  body_type?: InputMaybe<Scalars['String']['input']>;
  body_type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  body_type_gt?: InputMaybe<Scalars['String']['input']>;
  body_type_gte?: InputMaybe<Scalars['String']['input']>;
  body_type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  body_type_lt?: InputMaybe<Scalars['String']['input']>;
  body_type_lte?: InputMaybe<Scalars['String']['input']>;
  body_type_ne?: InputMaybe<Scalars['String']['input']>;
  body_type_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eye_color?: InputMaybe<Scalars['String']['input']>;
  eye_color_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eye_color_gt?: InputMaybe<Scalars['String']['input']>;
  eye_color_gte?: InputMaybe<Scalars['String']['input']>;
  eye_color_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eye_color_lt?: InputMaybe<Scalars['String']['input']>;
  eye_color_lte?: InputMaybe<Scalars['String']['input']>;
  eye_color_ne?: InputMaybe<Scalars['String']['input']>;
  eye_color_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hair_color?: InputMaybe<Scalars['String']['input']>;
  hair_color_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hair_color_gt?: InputMaybe<Scalars['String']['input']>;
  hair_color_gte?: InputMaybe<Scalars['String']['input']>;
  hair_color_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hair_color_lt?: InputMaybe<Scalars['String']['input']>;
  hair_color_lte?: InputMaybe<Scalars['String']['input']>;
  hair_color_ne?: InputMaybe<Scalars['String']['input']>;
  hair_color_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hair_style?: InputMaybe<Scalars['String']['input']>;
  hair_style_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hair_style_gt?: InputMaybe<Scalars['String']['input']>;
  hair_style_gte?: InputMaybe<Scalars['String']['input']>;
  hair_style_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hair_style_lt?: InputMaybe<Scalars['String']['input']>;
  hair_style_lte?: InputMaybe<Scalars['String']['input']>;
  hair_style_ne?: InputMaybe<Scalars['String']['input']>;
  hair_style_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  skin_color?: InputMaybe<Scalars['String']['input']>;
  skin_color_exists?: InputMaybe<Scalars['Boolean']['input']>;
  skin_color_gt?: InputMaybe<Scalars['String']['input']>;
  skin_color_gte?: InputMaybe<Scalars['String']['input']>;
  skin_color_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  skin_color_lt?: InputMaybe<Scalars['String']['input']>;
  skin_color_lte?: InputMaybe<Scalars['String']['input']>;
  skin_color_ne?: InputMaybe<Scalars['String']['input']>;
  skin_color_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CharacterPhysical_ProfileUpdateInput = {
  body_type?: InputMaybe<Scalars['String']['input']>;
  body_type_unset?: InputMaybe<Scalars['Boolean']['input']>;
  eye_color?: InputMaybe<Scalars['String']['input']>;
  eye_color_unset?: InputMaybe<Scalars['Boolean']['input']>;
  hair_color?: InputMaybe<Scalars['String']['input']>;
  hair_color_unset?: InputMaybe<Scalars['Boolean']['input']>;
  hair_style?: InputMaybe<Scalars['String']['input']>;
  hair_style_unset?: InputMaybe<Scalars['Boolean']['input']>;
  skin_color?: InputMaybe<Scalars['String']['input']>;
  skin_color_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CharacterQueryInput = {
  AND?: InputMaybe<Array<CharacterQueryInput>>;
  OR?: InputMaybe<Array<CharacterQueryInput>>;
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  _id_gt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_gte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  _id_lt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_lte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_ne?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  abilities?: InputMaybe<CharacterAbilityQueryInput>;
  abilities_exists?: InputMaybe<Scalars['Boolean']['input']>;
  alignment?: InputMaybe<Scalars['String']['input']>;
  alignment_exists?: InputMaybe<Scalars['Boolean']['input']>;
  alignment_gt?: InputMaybe<Scalars['String']['input']>;
  alignment_gte?: InputMaybe<Scalars['String']['input']>;
  alignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  alignment_lt?: InputMaybe<Scalars['String']['input']>;
  alignment_lte?: InputMaybe<Scalars['String']['input']>;
  alignment_ne?: InputMaybe<Scalars['String']['input']>;
  alignment_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  assets?: InputMaybe<Array<InputMaybe<Media_AssetQueryInput>>>;
  assets_exists?: InputMaybe<Scalars['Boolean']['input']>;
  assets_in?: InputMaybe<Array<InputMaybe<Media_AssetQueryInput>>>;
  assets_nin?: InputMaybe<Array<InputMaybe<Media_AssetQueryInput>>>;
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attributes_exists?: InputMaybe<Scalars['Boolean']['input']>;
  attributes_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attributes_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  avatar_path?: InputMaybe<Scalars['String']['input']>;
  avatar_path_exists?: InputMaybe<Scalars['Boolean']['input']>;
  avatar_path_gt?: InputMaybe<Scalars['String']['input']>;
  avatar_path_gte?: InputMaybe<Scalars['String']['input']>;
  avatar_path_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  avatar_path_lt?: InputMaybe<Scalars['String']['input']>;
  avatar_path_lte?: InputMaybe<Scalars['String']['input']>;
  avatar_path_ne?: InputMaybe<Scalars['String']['input']>;
  avatar_path_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  avatar_thumbnail_path?: InputMaybe<Scalars['String']['input']>;
  avatar_thumbnail_path_exists?: InputMaybe<Scalars['Boolean']['input']>;
  avatar_thumbnail_path_gt?: InputMaybe<Scalars['String']['input']>;
  avatar_thumbnail_path_gte?: InputMaybe<Scalars['String']['input']>;
  avatar_thumbnail_path_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  avatar_thumbnail_path_lt?: InputMaybe<Scalars['String']['input']>;
  avatar_thumbnail_path_lte?: InputMaybe<Scalars['String']['input']>;
  avatar_thumbnail_path_ne?: InputMaybe<Scalars['String']['input']>;
  avatar_thumbnail_path_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  avatar_thumbnail_url?: InputMaybe<Scalars['String']['input']>;
  avatar_thumbnail_url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  avatar_thumbnail_url_gt?: InputMaybe<Scalars['String']['input']>;
  avatar_thumbnail_url_gte?: InputMaybe<Scalars['String']['input']>;
  avatar_thumbnail_url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  avatar_thumbnail_url_lt?: InputMaybe<Scalars['String']['input']>;
  avatar_thumbnail_url_lte?: InputMaybe<Scalars['String']['input']>;
  avatar_thumbnail_url_ne?: InputMaybe<Scalars['String']['input']>;
  avatar_thumbnail_url_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  avatar_url?: InputMaybe<Scalars['String']['input']>;
  avatar_url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  avatar_url_gt?: InputMaybe<Scalars['String']['input']>;
  avatar_url_gte?: InputMaybe<Scalars['String']['input']>;
  avatar_url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  avatar_url_lt?: InputMaybe<Scalars['String']['input']>;
  avatar_url_lte?: InputMaybe<Scalars['String']['input']>;
  avatar_url_ne?: InputMaybe<Scalars['String']['input']>;
  avatar_url_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backstory?: InputMaybe<Scalars['String']['input']>;
  backstory_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backstory_gt?: InputMaybe<Scalars['String']['input']>;
  backstory_gte?: InputMaybe<Scalars['String']['input']>;
  backstory_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backstory_lt?: InputMaybe<Scalars['String']['input']>;
  backstory_lte?: InputMaybe<Scalars['String']['input']>;
  backstory_ne?: InputMaybe<Scalars['String']['input']>;
  backstory_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  character_image_path?: InputMaybe<Scalars['String']['input']>;
  character_image_path_exists?: InputMaybe<Scalars['Boolean']['input']>;
  character_image_path_gt?: InputMaybe<Scalars['String']['input']>;
  character_image_path_gte?: InputMaybe<Scalars['String']['input']>;
  character_image_path_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  character_image_path_lt?: InputMaybe<Scalars['String']['input']>;
  character_image_path_lte?: InputMaybe<Scalars['String']['input']>;
  character_image_path_ne?: InputMaybe<Scalars['String']['input']>;
  character_image_path_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  character_image_thumbnail_path?: InputMaybe<Scalars['String']['input']>;
  character_image_thumbnail_path_exists?: InputMaybe<Scalars['Boolean']['input']>;
  character_image_thumbnail_path_gt?: InputMaybe<Scalars['String']['input']>;
  character_image_thumbnail_path_gte?: InputMaybe<Scalars['String']['input']>;
  character_image_thumbnail_path_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  character_image_thumbnail_path_lt?: InputMaybe<Scalars['String']['input']>;
  character_image_thumbnail_path_lte?: InputMaybe<Scalars['String']['input']>;
  character_image_thumbnail_path_ne?: InputMaybe<Scalars['String']['input']>;
  character_image_thumbnail_path_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  character_image_thumbnail_url?: InputMaybe<Scalars['String']['input']>;
  character_image_thumbnail_url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  character_image_thumbnail_url_gt?: InputMaybe<Scalars['String']['input']>;
  character_image_thumbnail_url_gte?: InputMaybe<Scalars['String']['input']>;
  character_image_thumbnail_url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  character_image_thumbnail_url_lt?: InputMaybe<Scalars['String']['input']>;
  character_image_thumbnail_url_lte?: InputMaybe<Scalars['String']['input']>;
  character_image_thumbnail_url_ne?: InputMaybe<Scalars['String']['input']>;
  character_image_thumbnail_url_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  character_image_url?: InputMaybe<Scalars['String']['input']>;
  character_image_url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  character_image_url_gt?: InputMaybe<Scalars['String']['input']>;
  character_image_url_gte?: InputMaybe<Scalars['String']['input']>;
  character_image_url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  character_image_url_lt?: InputMaybe<Scalars['String']['input']>;
  character_image_url_lte?: InputMaybe<Scalars['String']['input']>;
  character_image_url_ne?: InputMaybe<Scalars['String']['input']>;
  character_image_url_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  character_sets?: InputMaybe<Array<InputMaybe<Character_SetQueryInput>>>;
  character_sets_exists?: InputMaybe<Scalars['Boolean']['input']>;
  character_sets_in?: InputMaybe<Array<InputMaybe<Character_SetQueryInput>>>;
  character_sets_nin?: InputMaybe<Array<InputMaybe<Character_SetQueryInput>>>;
  character_type?: InputMaybe<Scalars['String']['input']>;
  character_type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  character_type_gt?: InputMaybe<Scalars['String']['input']>;
  character_type_gte?: InputMaybe<Scalars['String']['input']>;
  character_type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  character_type_lt?: InputMaybe<Scalars['String']['input']>;
  character_type_lte?: InputMaybe<Scalars['String']['input']>;
  character_type_ne?: InputMaybe<Scalars['String']['input']>;
  character_type_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  class?: InputMaybe<Scalars['String']['input']>;
  class_exists?: InputMaybe<Scalars['Boolean']['input']>;
  class_gt?: InputMaybe<Scalars['String']['input']>;
  class_gte?: InputMaybe<Scalars['String']['input']>;
  class_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  class_lt?: InputMaybe<Scalars['String']['input']>;
  class_lte?: InputMaybe<Scalars['String']['input']>;
  class_ne?: InputMaybe<Scalars['String']['input']>;
  class_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  gender?: InputMaybe<Scalars['String']['input']>;
  gender_exists?: InputMaybe<Scalars['Boolean']['input']>;
  gender_gt?: InputMaybe<Scalars['String']['input']>;
  gender_gte?: InputMaybe<Scalars['String']['input']>;
  gender_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  gender_lt?: InputMaybe<Scalars['String']['input']>;
  gender_lte?: InputMaybe<Scalars['String']['input']>;
  gender_ne?: InputMaybe<Scalars['String']['input']>;
  gender_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  height?: InputMaybe<Scalars['String']['input']>;
  height_exists?: InputMaybe<Scalars['Boolean']['input']>;
  height_gt?: InputMaybe<Scalars['String']['input']>;
  height_gte?: InputMaybe<Scalars['String']['input']>;
  height_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  height_lt?: InputMaybe<Scalars['String']['input']>;
  height_lte?: InputMaybe<Scalars['String']['input']>;
  height_ne?: InputMaybe<Scalars['String']['input']>;
  height_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  home?: InputMaybe<Array<InputMaybe<LocationQueryInput>>>;
  home_exists?: InputMaybe<Scalars['Boolean']['input']>;
  home_in?: InputMaybe<Array<InputMaybe<LocationQueryInput>>>;
  home_nin?: InputMaybe<Array<InputMaybe<LocationQueryInput>>>;
  is_pack_character?: InputMaybe<Scalars['Boolean']['input']>;
  is_pack_character_exists?: InputMaybe<Scalars['Boolean']['input']>;
  is_pack_character_ne?: InputMaybe<Scalars['Boolean']['input']>;
  life_altering_event?: InputMaybe<Scalars['String']['input']>;
  life_altering_event_exists?: InputMaybe<Scalars['Boolean']['input']>;
  life_altering_event_gt?: InputMaybe<Scalars['String']['input']>;
  life_altering_event_gte?: InputMaybe<Scalars['String']['input']>;
  life_altering_event_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  life_altering_event_lt?: InputMaybe<Scalars['String']['input']>;
  life_altering_event_lte?: InputMaybe<Scalars['String']['input']>;
  life_altering_event_ne?: InputMaybe<Scalars['String']['input']>;
  life_altering_event_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  long_term_goals?: InputMaybe<Array<InputMaybe<CharacterLong_Term_GoalQueryInput>>>;
  long_term_goals_exists?: InputMaybe<Scalars['Boolean']['input']>;
  long_term_goals_in?: InputMaybe<Array<InputMaybe<CharacterLong_Term_GoalQueryInput>>>;
  long_term_goals_nin?: InputMaybe<Array<InputMaybe<CharacterLong_Term_GoalQueryInput>>>;
  motivations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  motivations_exists?: InputMaybe<Scalars['Boolean']['input']>;
  motivations_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  motivations_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notes?: InputMaybe<Array<InputMaybe<NoteQueryInput>>>;
  notes_exists?: InputMaybe<Scalars['Boolean']['input']>;
  notes_in?: InputMaybe<Array<InputMaybe<NoteQueryInput>>>;
  notes_nin?: InputMaybe<Array<InputMaybe<NoteQueryInput>>>;
  owner?: InputMaybe<UserQueryInput>;
  owner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  physical_profile?: InputMaybe<CharacterPhysical_ProfileQueryInput>;
  physical_profile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  profession?: InputMaybe<Scalars['String']['input']>;
  profession_exists?: InputMaybe<Scalars['Boolean']['input']>;
  profession_gt?: InputMaybe<Scalars['String']['input']>;
  profession_gte?: InputMaybe<Scalars['String']['input']>;
  profession_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  profession_lt?: InputMaybe<Scalars['String']['input']>;
  profession_lte?: InputMaybe<Scalars['String']['input']>;
  profession_ne?: InputMaybe<Scalars['String']['input']>;
  profession_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pronoun?: InputMaybe<Scalars['String']['input']>;
  pronoun_exists?: InputMaybe<Scalars['Boolean']['input']>;
  pronoun_gt?: InputMaybe<Scalars['String']['input']>;
  pronoun_gte?: InputMaybe<Scalars['String']['input']>;
  pronoun_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pronoun_lt?: InputMaybe<Scalars['String']['input']>;
  pronoun_lte?: InputMaybe<Scalars['String']['input']>;
  pronoun_ne?: InputMaybe<Scalars['String']['input']>;
  pronoun_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  race?: InputMaybe<Scalars['String']['input']>;
  race_exists?: InputMaybe<Scalars['Boolean']['input']>;
  race_gt?: InputMaybe<Scalars['String']['input']>;
  race_gte?: InputMaybe<Scalars['String']['input']>;
  race_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  race_lt?: InputMaybe<Scalars['String']['input']>;
  race_lte?: InputMaybe<Scalars['String']['input']>;
  race_ne?: InputMaybe<Scalars['String']['input']>;
  race_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  realms?: InputMaybe<Array<InputMaybe<RealmQueryInput>>>;
  realms_exists?: InputMaybe<Scalars['Boolean']['input']>;
  realms_in?: InputMaybe<Array<InputMaybe<RealmQueryInput>>>;
  realms_nin?: InputMaybe<Array<InputMaybe<RealmQueryInput>>>;
  relationship_status?: InputMaybe<Scalars['String']['input']>;
  relationship_status_exists?: InputMaybe<Scalars['Boolean']['input']>;
  relationship_status_gt?: InputMaybe<Scalars['String']['input']>;
  relationship_status_gte?: InputMaybe<Scalars['String']['input']>;
  relationship_status_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relationship_status_lt?: InputMaybe<Scalars['String']['input']>;
  relationship_status_lte?: InputMaybe<Scalars['String']['input']>;
  relationship_status_ne?: InputMaybe<Scalars['String']['input']>;
  relationship_status_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  short_term_goals?: InputMaybe<Array<InputMaybe<CharacterShort_Term_GoalQueryInput>>>;
  short_term_goals_exists?: InputMaybe<Scalars['Boolean']['input']>;
  short_term_goals_in?: InputMaybe<Array<InputMaybe<CharacterShort_Term_GoalQueryInput>>>;
  short_term_goals_nin?: InputMaybe<Array<InputMaybe<CharacterShort_Term_GoalQueryInput>>>;
  token_sets?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  token_sets_exists?: InputMaybe<Scalars['Boolean']['input']>;
  token_sets_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  token_sets_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  tone?: InputMaybe<Scalars['String']['input']>;
  tone_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tone_gt?: InputMaybe<Scalars['String']['input']>;
  tone_gte?: InputMaybe<Scalars['String']['input']>;
  tone_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tone_lt?: InputMaybe<Scalars['String']['input']>;
  tone_lte?: InputMaybe<Scalars['String']['input']>;
  tone_ne?: InputMaybe<Scalars['String']['input']>;
  tone_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type_gt?: InputMaybe<Scalars['String']['input']>;
  type_gte?: InputMaybe<Scalars['String']['input']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_lt?: InputMaybe<Scalars['String']['input']>;
  type_lte?: InputMaybe<Scalars['String']['input']>;
  type_ne?: InputMaybe<Scalars['String']['input']>;
  type_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  visited_locations?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  visited_locations_exists?: InputMaybe<Scalars['Boolean']['input']>;
  visited_locations_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  visited_locations_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  weight?: InputMaybe<Scalars['String']['input']>;
  weight_exists?: InputMaybe<Scalars['Boolean']['input']>;
  weight_gt?: InputMaybe<Scalars['String']['input']>;
  weight_gte?: InputMaybe<Scalars['String']['input']>;
  weight_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  weight_lt?: InputMaybe<Scalars['String']['input']>;
  weight_lte?: InputMaybe<Scalars['String']['input']>;
  weight_ne?: InputMaybe<Scalars['String']['input']>;
  weight_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CharacterRealmsRelationInput = {
  create?: InputMaybe<Array<InputMaybe<RealmInsertInput>>>;
  link?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
};

export type CharacterShort_Term_Goal = {
  __typename?: 'CharacterShort_term_goal';
  content?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CharacterShort_Term_GoalInsertInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CharacterShort_Term_GoalQueryInput = {
  AND?: InputMaybe<Array<CharacterShort_Term_GoalQueryInput>>;
  OR?: InputMaybe<Array<CharacterShort_Term_GoalQueryInput>>;
  content?: InputMaybe<Scalars['String']['input']>;
  content_exists?: InputMaybe<Scalars['Boolean']['input']>;
  content_gt?: InputMaybe<Scalars['String']['input']>;
  content_gte?: InputMaybe<Scalars['String']['input']>;
  content_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  content_lt?: InputMaybe<Scalars['String']['input']>;
  content_lte?: InputMaybe<Scalars['String']['input']>;
  content_ne?: InputMaybe<Scalars['String']['input']>;
  content_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_gt?: InputMaybe<Scalars['String']['input']>;
  title_gte?: InputMaybe<Scalars['String']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_lt?: InputMaybe<Scalars['String']['input']>;
  title_lte?: InputMaybe<Scalars['String']['input']>;
  title_ne?: InputMaybe<Scalars['String']['input']>;
  title_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CharacterShort_Term_GoalUpdateInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  content_unset?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum CharacterSortByInput {
  AlignmentAsc = 'ALIGNMENT_ASC',
  AlignmentDesc = 'ALIGNMENT_DESC',
  AvatarPathAsc = 'AVATAR_PATH_ASC',
  AvatarPathDesc = 'AVATAR_PATH_DESC',
  AvatarThumbnailPathAsc = 'AVATAR_THUMBNAIL_PATH_ASC',
  AvatarThumbnailPathDesc = 'AVATAR_THUMBNAIL_PATH_DESC',
  AvatarThumbnailUrlAsc = 'AVATAR_THUMBNAIL_URL_ASC',
  AvatarThumbnailUrlDesc = 'AVATAR_THUMBNAIL_URL_DESC',
  AvatarUrlAsc = 'AVATAR_URL_ASC',
  AvatarUrlDesc = 'AVATAR_URL_DESC',
  BackstoryAsc = 'BACKSTORY_ASC',
  BackstoryDesc = 'BACKSTORY_DESC',
  CharacterImagePathAsc = 'CHARACTER_IMAGE_PATH_ASC',
  CharacterImagePathDesc = 'CHARACTER_IMAGE_PATH_DESC',
  CharacterImageThumbnailPathAsc = 'CHARACTER_IMAGE_THUMBNAIL_PATH_ASC',
  CharacterImageThumbnailPathDesc = 'CHARACTER_IMAGE_THUMBNAIL_PATH_DESC',
  CharacterImageThumbnailUrlAsc = 'CHARACTER_IMAGE_THUMBNAIL_URL_ASC',
  CharacterImageThumbnailUrlDesc = 'CHARACTER_IMAGE_THUMBNAIL_URL_DESC',
  CharacterImageUrlAsc = 'CHARACTER_IMAGE_URL_ASC',
  CharacterImageUrlDesc = 'CHARACTER_IMAGE_URL_DESC',
  CharacterTypeAsc = 'CHARACTER_TYPE_ASC',
  CharacterTypeDesc = 'CHARACTER_TYPE_DESC',
  ClassAsc = 'CLASS_ASC',
  ClassDesc = 'CLASS_DESC',
  GenderAsc = 'GENDER_ASC',
  GenderDesc = 'GENDER_DESC',
  HeightAsc = 'HEIGHT_ASC',
  HeightDesc = 'HEIGHT_DESC',
  LifeAlteringEventAsc = 'LIFE_ALTERING_EVENT_ASC',
  LifeAlteringEventDesc = 'LIFE_ALTERING_EVENT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  OwnerAsc = 'OWNER_ASC',
  OwnerDesc = 'OWNER_DESC',
  ProfessionAsc = 'PROFESSION_ASC',
  ProfessionDesc = 'PROFESSION_DESC',
  PronounAsc = 'PRONOUN_ASC',
  PronounDesc = 'PRONOUN_DESC',
  RaceAsc = 'RACE_ASC',
  RaceDesc = 'RACE_DESC',
  RelationshipStatusAsc = 'RELATIONSHIP_STATUS_ASC',
  RelationshipStatusDesc = 'RELATIONSHIP_STATUS_DESC',
  ToneAsc = 'TONE_ASC',
  ToneDesc = 'TONE_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  WeightAsc = 'WEIGHT_ASC',
  WeightDesc = 'WEIGHT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type CharacterUpdateInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  abilities?: InputMaybe<CharacterAbilityUpdateInput>;
  abilities_unset?: InputMaybe<Scalars['Boolean']['input']>;
  alignment?: InputMaybe<Scalars['String']['input']>;
  alignment_unset?: InputMaybe<Scalars['Boolean']['input']>;
  assets?: InputMaybe<CharacterAssetsRelationInput>;
  assets_unset?: InputMaybe<Scalars['Boolean']['input']>;
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attributes_unset?: InputMaybe<Scalars['Boolean']['input']>;
  avatar_path?: InputMaybe<Scalars['String']['input']>;
  avatar_path_unset?: InputMaybe<Scalars['Boolean']['input']>;
  avatar_thumbnail_path?: InputMaybe<Scalars['String']['input']>;
  avatar_thumbnail_path_unset?: InputMaybe<Scalars['Boolean']['input']>;
  avatar_thumbnail_url?: InputMaybe<Scalars['String']['input']>;
  avatar_thumbnail_url_unset?: InputMaybe<Scalars['Boolean']['input']>;
  avatar_url?: InputMaybe<Scalars['String']['input']>;
  avatar_url_unset?: InputMaybe<Scalars['Boolean']['input']>;
  backstory?: InputMaybe<Scalars['String']['input']>;
  backstory_unset?: InputMaybe<Scalars['Boolean']['input']>;
  character_image_path?: InputMaybe<Scalars['String']['input']>;
  character_image_path_unset?: InputMaybe<Scalars['Boolean']['input']>;
  character_image_thumbnail_path?: InputMaybe<Scalars['String']['input']>;
  character_image_thumbnail_path_unset?: InputMaybe<Scalars['Boolean']['input']>;
  character_image_thumbnail_url?: InputMaybe<Scalars['String']['input']>;
  character_image_thumbnail_url_unset?: InputMaybe<Scalars['Boolean']['input']>;
  character_image_url?: InputMaybe<Scalars['String']['input']>;
  character_image_url_unset?: InputMaybe<Scalars['Boolean']['input']>;
  character_sets?: InputMaybe<CharacterCharacter_SetsRelationInput>;
  character_sets_unset?: InputMaybe<Scalars['Boolean']['input']>;
  character_type?: InputMaybe<Scalars['String']['input']>;
  character_type_unset?: InputMaybe<Scalars['Boolean']['input']>;
  class?: InputMaybe<Scalars['String']['input']>;
  class_unset?: InputMaybe<Scalars['Boolean']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  gender_unset?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Scalars['String']['input']>;
  height_unset?: InputMaybe<Scalars['Boolean']['input']>;
  home?: InputMaybe<CharacterHomeRelationInput>;
  home_unset?: InputMaybe<Scalars['Boolean']['input']>;
  is_pack_character?: InputMaybe<Scalars['Boolean']['input']>;
  is_pack_character_unset?: InputMaybe<Scalars['Boolean']['input']>;
  life_altering_event?: InputMaybe<Scalars['String']['input']>;
  life_altering_event_unset?: InputMaybe<Scalars['Boolean']['input']>;
  long_term_goals?: InputMaybe<Array<InputMaybe<CharacterLong_Term_GoalUpdateInput>>>;
  long_term_goals_unset?: InputMaybe<Scalars['Boolean']['input']>;
  motivations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  motivations_unset?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_unset?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<CharacterNotesRelationInput>;
  notes_unset?: InputMaybe<Scalars['Boolean']['input']>;
  owner?: InputMaybe<CharacterOwnerRelationInput>;
  owner_unset?: InputMaybe<Scalars['Boolean']['input']>;
  physical_profile?: InputMaybe<CharacterPhysical_ProfileUpdateInput>;
  physical_profile_unset?: InputMaybe<Scalars['Boolean']['input']>;
  profession?: InputMaybe<Scalars['String']['input']>;
  profession_unset?: InputMaybe<Scalars['Boolean']['input']>;
  pronoun?: InputMaybe<Scalars['String']['input']>;
  pronoun_unset?: InputMaybe<Scalars['Boolean']['input']>;
  race?: InputMaybe<Scalars['String']['input']>;
  race_unset?: InputMaybe<Scalars['Boolean']['input']>;
  realms?: InputMaybe<CharacterRealmsRelationInput>;
  realms_unset?: InputMaybe<Scalars['Boolean']['input']>;
  relationship_status?: InputMaybe<Scalars['String']['input']>;
  relationship_status_unset?: InputMaybe<Scalars['Boolean']['input']>;
  short_term_goals?: InputMaybe<Array<InputMaybe<CharacterShort_Term_GoalUpdateInput>>>;
  short_term_goals_unset?: InputMaybe<Scalars['Boolean']['input']>;
  token_sets?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  token_sets_unset?: InputMaybe<Scalars['Boolean']['input']>;
  tone?: InputMaybe<Scalars['String']['input']>;
  tone_unset?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_unset?: InputMaybe<Scalars['Boolean']['input']>;
  visited_locations?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  visited_locations_unset?: InputMaybe<Scalars['Boolean']['input']>;
  weight?: InputMaybe<Scalars['String']['input']>;
  weight_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Character_Content_Pack = {
  __typename?: 'Character_content_pack';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  background_media_asset?: Maybe<Media_Asset>;
  background_thumbnail_media_asset?: Maybe<Scalars['String']['output']>;
  characters?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  credit_price?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  min_subscription_tier_id?: Maybe<Subscription_Tier>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  ssgp_product_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  visible?: Maybe<Scalars['Boolean']['output']>;
};

export type Character_Content_PackBackground_Media_AssetRelationInput = {
  create?: InputMaybe<Media_AssetInsertInput>;
  link?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type Character_Content_PackInsertInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  background_media_asset?: InputMaybe<Character_Content_PackBackground_Media_AssetRelationInput>;
  background_thumbnail_media_asset?: InputMaybe<Scalars['String']['input']>;
  characters?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  credit_price?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  min_subscription_tier_id?: InputMaybe<Character_Content_PackMin_Subscription_Tier_IdRelationInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['String']['input']>;
  ssgp_product_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Character_Content_PackMin_Subscription_Tier_IdRelationInput = {
  create?: InputMaybe<Subscription_TierInsertInput>;
  link?: InputMaybe<Scalars['Int']['input']>;
};

export type Character_Content_PackQueryInput = {
  AND?: InputMaybe<Array<Character_Content_PackQueryInput>>;
  OR?: InputMaybe<Array<Character_Content_PackQueryInput>>;
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  _id_gt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_gte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  _id_lt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_lte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_ne?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  background_media_asset?: InputMaybe<Media_AssetQueryInput>;
  background_media_asset_exists?: InputMaybe<Scalars['Boolean']['input']>;
  background_thumbnail_media_asset?: InputMaybe<Scalars['String']['input']>;
  background_thumbnail_media_asset_exists?: InputMaybe<Scalars['Boolean']['input']>;
  background_thumbnail_media_asset_gt?: InputMaybe<Scalars['String']['input']>;
  background_thumbnail_media_asset_gte?: InputMaybe<Scalars['String']['input']>;
  background_thumbnail_media_asset_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  background_thumbnail_media_asset_lt?: InputMaybe<Scalars['String']['input']>;
  background_thumbnail_media_asset_lte?: InputMaybe<Scalars['String']['input']>;
  background_thumbnail_media_asset_ne?: InputMaybe<Scalars['String']['input']>;
  background_thumbnail_media_asset_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  characters?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  characters_exists?: InputMaybe<Scalars['Boolean']['input']>;
  characters_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  characters_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_exists?: InputMaybe<Scalars['Boolean']['input']>;
  created_at_gt?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_gte?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  created_at_lt?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_lte?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_ne?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  credit_price?: InputMaybe<Scalars['Int']['input']>;
  credit_price_exists?: InputMaybe<Scalars['Boolean']['input']>;
  credit_price_gt?: InputMaybe<Scalars['Int']['input']>;
  credit_price_gte?: InputMaybe<Scalars['Int']['input']>;
  credit_price_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  credit_price_lt?: InputMaybe<Scalars['Int']['input']>;
  credit_price_lte?: InputMaybe<Scalars['Int']['input']>;
  credit_price_ne?: InputMaybe<Scalars['Int']['input']>;
  credit_price_nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_gt?: InputMaybe<Scalars['String']['input']>;
  description_gte?: InputMaybe<Scalars['String']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_lt?: InputMaybe<Scalars['String']['input']>;
  description_lte?: InputMaybe<Scalars['String']['input']>;
  description_ne?: InputMaybe<Scalars['String']['input']>;
  description_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  min_subscription_tier_id?: InputMaybe<Subscription_TierQueryInput>;
  min_subscription_tier_id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  price?: InputMaybe<Scalars['String']['input']>;
  price_exists?: InputMaybe<Scalars['Boolean']['input']>;
  price_gt?: InputMaybe<Scalars['String']['input']>;
  price_gte?: InputMaybe<Scalars['String']['input']>;
  price_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  price_lt?: InputMaybe<Scalars['String']['input']>;
  price_lte?: InputMaybe<Scalars['String']['input']>;
  price_ne?: InputMaybe<Scalars['String']['input']>;
  price_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ssgp_product_id?: InputMaybe<Scalars['Int']['input']>;
  ssgp_product_id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ssgp_product_id_gt?: InputMaybe<Scalars['Int']['input']>;
  ssgp_product_id_gte?: InputMaybe<Scalars['Int']['input']>;
  ssgp_product_id_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  ssgp_product_id_lt?: InputMaybe<Scalars['Int']['input']>;
  ssgp_product_id_lte?: InputMaybe<Scalars['Int']['input']>;
  ssgp_product_id_ne?: InputMaybe<Scalars['Int']['input']>;
  ssgp_product_id_nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at_exists?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updated_at_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at_ne?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
  visible_exists?: InputMaybe<Scalars['Boolean']['input']>;
  visible_ne?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum Character_Content_PackSortByInput {
  BackgroundMediaAssetAsc = 'BACKGROUND_MEDIA_ASSET_ASC',
  BackgroundMediaAssetDesc = 'BACKGROUND_MEDIA_ASSET_DESC',
  BackgroundThumbnailMediaAssetAsc = 'BACKGROUND_THUMBNAIL_MEDIA_ASSET_ASC',
  BackgroundThumbnailMediaAssetDesc = 'BACKGROUND_THUMBNAIL_MEDIA_ASSET_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreditPriceAsc = 'CREDIT_PRICE_ASC',
  CreditPriceDesc = 'CREDIT_PRICE_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  MinSubscriptionTierIdAsc = 'MIN_SUBSCRIPTION_TIER_ID_ASC',
  MinSubscriptionTierIdDesc = 'MIN_SUBSCRIPTION_TIER_ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  PriceAsc = 'PRICE_ASC',
  PriceDesc = 'PRICE_DESC',
  SsgpProductIdAsc = 'SSGP_PRODUCT_ID_ASC',
  SsgpProductIdDesc = 'SSGP_PRODUCT_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type Character_Content_PackUpdateInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  background_media_asset?: InputMaybe<Character_Content_PackBackground_Media_AssetRelationInput>;
  background_media_asset_unset?: InputMaybe<Scalars['Boolean']['input']>;
  background_thumbnail_media_asset?: InputMaybe<Scalars['String']['input']>;
  background_thumbnail_media_asset_unset?: InputMaybe<Scalars['Boolean']['input']>;
  characters?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  characters_unset?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_unset?: InputMaybe<Scalars['Boolean']['input']>;
  credit_price?: InputMaybe<Scalars['Int']['input']>;
  credit_price_inc?: InputMaybe<Scalars['Int']['input']>;
  credit_price_unset?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_unset?: InputMaybe<Scalars['Boolean']['input']>;
  min_subscription_tier_id?: InputMaybe<Character_Content_PackMin_Subscription_Tier_IdRelationInput>;
  min_subscription_tier_id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_unset?: InputMaybe<Scalars['Boolean']['input']>;
  price?: InputMaybe<Scalars['String']['input']>;
  price_unset?: InputMaybe<Scalars['Boolean']['input']>;
  ssgp_product_id?: InputMaybe<Scalars['Int']['input']>;
  ssgp_product_id_inc?: InputMaybe<Scalars['Int']['input']>;
  ssgp_product_id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at_unset?: InputMaybe<Scalars['Boolean']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
  visible_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Character_Height = {
  __typename?: 'Character_height';
  _id: Scalars['ObjectId']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Character_HeightInsertInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Character_HeightQueryInput = {
  AND?: InputMaybe<Array<Character_HeightQueryInput>>;
  OR?: InputMaybe<Array<Character_HeightQueryInput>>;
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  _id_gt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_gte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  _id_lt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_lte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_ne?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum Character_HeightSortByInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type Character_HeightUpdateInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Character_Note = {
  __typename?: 'Character_note';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  character?: Maybe<Character>;
  content?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<Scalars['String']['output']>;
  realm?: Maybe<Realm>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type Character_NoteCharacterRelationInput = {
  create?: InputMaybe<CharacterInsertInput>;
  link?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type Character_NoteInsertInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  character?: InputMaybe<Character_NoteCharacterRelationInput>;
  content?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  realm?: InputMaybe<Character_NoteRealmRelationInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Character_NoteQueryInput = {
  AND?: InputMaybe<Array<Character_NoteQueryInput>>;
  OR?: InputMaybe<Array<Character_NoteQueryInput>>;
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  _id_gt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_gte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  _id_lt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_lte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_ne?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  character?: InputMaybe<CharacterQueryInput>;
  character_exists?: InputMaybe<Scalars['Boolean']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  content_exists?: InputMaybe<Scalars['Boolean']['input']>;
  content_gt?: InputMaybe<Scalars['String']['input']>;
  content_gte?: InputMaybe<Scalars['String']['input']>;
  content_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  content_lt?: InputMaybe<Scalars['String']['input']>;
  content_lte?: InputMaybe<Scalars['String']['input']>;
  content_ne?: InputMaybe<Scalars['String']['input']>;
  content_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  owner?: InputMaybe<Scalars['String']['input']>;
  owner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  owner_gt?: InputMaybe<Scalars['String']['input']>;
  owner_gte?: InputMaybe<Scalars['String']['input']>;
  owner_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  owner_lt?: InputMaybe<Scalars['String']['input']>;
  owner_lte?: InputMaybe<Scalars['String']['input']>;
  owner_ne?: InputMaybe<Scalars['String']['input']>;
  owner_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  realm?: InputMaybe<RealmQueryInput>;
  realm_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tags_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_gt?: InputMaybe<Scalars['String']['input']>;
  title_gte?: InputMaybe<Scalars['String']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_lt?: InputMaybe<Scalars['String']['input']>;
  title_lte?: InputMaybe<Scalars['String']['input']>;
  title_ne?: InputMaybe<Scalars['String']['input']>;
  title_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Character_NoteRealmRelationInput = {
  create?: InputMaybe<RealmInsertInput>;
  link?: InputMaybe<Scalars['ObjectId']['input']>;
};

export enum Character_NoteSortByInput {
  CharacterAsc = 'CHARACTER_ASC',
  CharacterDesc = 'CHARACTER_DESC',
  ContentAsc = 'CONTENT_ASC',
  ContentDesc = 'CONTENT_DESC',
  OwnerAsc = 'OWNER_ASC',
  OwnerDesc = 'OWNER_DESC',
  RealmAsc = 'REALM_ASC',
  RealmDesc = 'REALM_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type Character_NoteUpdateInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  character?: InputMaybe<Character_NoteCharacterRelationInput>;
  character_unset?: InputMaybe<Scalars['Boolean']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  content_unset?: InputMaybe<Scalars['Boolean']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  owner_unset?: InputMaybe<Scalars['Boolean']['input']>;
  realm?: InputMaybe<Character_NoteRealmRelationInput>;
  realm_unset?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_unset?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Character_Set = {
  __typename?: 'Character_set';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  background_path?: Maybe<Scalars['String']['output']>;
  background_thumbnail_path?: Maybe<Scalars['String']['output']>;
  background_thumbnail_url?: Maybe<Scalars['String']['output']>;
  background_url?: Maybe<Scalars['String']['output']>;
  characters?: Maybe<Array<Maybe<Character>>>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  is_default?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  original_image_path?: Maybe<Scalars['String']['output']>;
  original_image_thumbnail_path?: Maybe<Scalars['String']['output']>;
  original_image_thumbnail_url?: Maybe<Scalars['String']['output']>;
  original_image_url?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<User>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type Character_SetCharactersRelationInput = {
  create?: InputMaybe<Array<InputMaybe<CharacterInsertInput>>>;
  link?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
};

export type Character_SetInsertInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  background_path?: InputMaybe<Scalars['String']['input']>;
  background_thumbnail_path?: InputMaybe<Scalars['String']['input']>;
  background_thumbnail_url?: InputMaybe<Scalars['String']['input']>;
  background_url?: InputMaybe<Scalars['String']['input']>;
  characters?: InputMaybe<Character_SetCharactersRelationInput>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  original_image_path?: InputMaybe<Scalars['String']['input']>;
  original_image_thumbnail_path?: InputMaybe<Scalars['String']['input']>;
  original_image_thumbnail_url?: InputMaybe<Scalars['String']['input']>;
  original_image_url?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Character_SetOwnerRelationInput>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Character_SetOwnerRelationInput = {
  create?: InputMaybe<UserInsertInput>;
  link?: InputMaybe<Scalars['String']['input']>;
};

export type Character_SetQueryInput = {
  AND?: InputMaybe<Array<Character_SetQueryInput>>;
  OR?: InputMaybe<Array<Character_SetQueryInput>>;
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  _id_gt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_gte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  _id_lt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_lte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_ne?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  background_path?: InputMaybe<Scalars['String']['input']>;
  background_path_exists?: InputMaybe<Scalars['Boolean']['input']>;
  background_path_gt?: InputMaybe<Scalars['String']['input']>;
  background_path_gte?: InputMaybe<Scalars['String']['input']>;
  background_path_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  background_path_lt?: InputMaybe<Scalars['String']['input']>;
  background_path_lte?: InputMaybe<Scalars['String']['input']>;
  background_path_ne?: InputMaybe<Scalars['String']['input']>;
  background_path_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  background_thumbnail_path?: InputMaybe<Scalars['String']['input']>;
  background_thumbnail_path_exists?: InputMaybe<Scalars['Boolean']['input']>;
  background_thumbnail_path_gt?: InputMaybe<Scalars['String']['input']>;
  background_thumbnail_path_gte?: InputMaybe<Scalars['String']['input']>;
  background_thumbnail_path_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  background_thumbnail_path_lt?: InputMaybe<Scalars['String']['input']>;
  background_thumbnail_path_lte?: InputMaybe<Scalars['String']['input']>;
  background_thumbnail_path_ne?: InputMaybe<Scalars['String']['input']>;
  background_thumbnail_path_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  background_thumbnail_url?: InputMaybe<Scalars['String']['input']>;
  background_thumbnail_url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  background_thumbnail_url_gt?: InputMaybe<Scalars['String']['input']>;
  background_thumbnail_url_gte?: InputMaybe<Scalars['String']['input']>;
  background_thumbnail_url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  background_thumbnail_url_lt?: InputMaybe<Scalars['String']['input']>;
  background_thumbnail_url_lte?: InputMaybe<Scalars['String']['input']>;
  background_thumbnail_url_ne?: InputMaybe<Scalars['String']['input']>;
  background_thumbnail_url_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  background_url?: InputMaybe<Scalars['String']['input']>;
  background_url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  background_url_gt?: InputMaybe<Scalars['String']['input']>;
  background_url_gte?: InputMaybe<Scalars['String']['input']>;
  background_url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  background_url_lt?: InputMaybe<Scalars['String']['input']>;
  background_url_lte?: InputMaybe<Scalars['String']['input']>;
  background_url_ne?: InputMaybe<Scalars['String']['input']>;
  background_url_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  characters?: InputMaybe<Array<InputMaybe<CharacterQueryInput>>>;
  characters_exists?: InputMaybe<Scalars['Boolean']['input']>;
  characters_in?: InputMaybe<Array<InputMaybe<CharacterQueryInput>>>;
  characters_nin?: InputMaybe<Array<InputMaybe<CharacterQueryInput>>>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_exists?: InputMaybe<Scalars['Boolean']['input']>;
  created_at_gt?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_gte?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  created_at_lt?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_lte?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_ne?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_gt?: InputMaybe<Scalars['String']['input']>;
  description_gte?: InputMaybe<Scalars['String']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_lt?: InputMaybe<Scalars['String']['input']>;
  description_lte?: InputMaybe<Scalars['String']['input']>;
  description_ne?: InputMaybe<Scalars['String']['input']>;
  description_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
  is_default_exists?: InputMaybe<Scalars['Boolean']['input']>;
  is_default_ne?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  original_image_path?: InputMaybe<Scalars['String']['input']>;
  original_image_path_exists?: InputMaybe<Scalars['Boolean']['input']>;
  original_image_path_gt?: InputMaybe<Scalars['String']['input']>;
  original_image_path_gte?: InputMaybe<Scalars['String']['input']>;
  original_image_path_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  original_image_path_lt?: InputMaybe<Scalars['String']['input']>;
  original_image_path_lte?: InputMaybe<Scalars['String']['input']>;
  original_image_path_ne?: InputMaybe<Scalars['String']['input']>;
  original_image_path_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  original_image_thumbnail_path?: InputMaybe<Scalars['String']['input']>;
  original_image_thumbnail_path_exists?: InputMaybe<Scalars['Boolean']['input']>;
  original_image_thumbnail_path_gt?: InputMaybe<Scalars['String']['input']>;
  original_image_thumbnail_path_gte?: InputMaybe<Scalars['String']['input']>;
  original_image_thumbnail_path_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  original_image_thumbnail_path_lt?: InputMaybe<Scalars['String']['input']>;
  original_image_thumbnail_path_lte?: InputMaybe<Scalars['String']['input']>;
  original_image_thumbnail_path_ne?: InputMaybe<Scalars['String']['input']>;
  original_image_thumbnail_path_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  original_image_thumbnail_url?: InputMaybe<Scalars['String']['input']>;
  original_image_thumbnail_url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  original_image_thumbnail_url_gt?: InputMaybe<Scalars['String']['input']>;
  original_image_thumbnail_url_gte?: InputMaybe<Scalars['String']['input']>;
  original_image_thumbnail_url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  original_image_thumbnail_url_lt?: InputMaybe<Scalars['String']['input']>;
  original_image_thumbnail_url_lte?: InputMaybe<Scalars['String']['input']>;
  original_image_thumbnail_url_ne?: InputMaybe<Scalars['String']['input']>;
  original_image_thumbnail_url_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  original_image_url?: InputMaybe<Scalars['String']['input']>;
  original_image_url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  original_image_url_gt?: InputMaybe<Scalars['String']['input']>;
  original_image_url_gte?: InputMaybe<Scalars['String']['input']>;
  original_image_url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  original_image_url_lt?: InputMaybe<Scalars['String']['input']>;
  original_image_url_lte?: InputMaybe<Scalars['String']['input']>;
  original_image_url_ne?: InputMaybe<Scalars['String']['input']>;
  original_image_url_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  owner?: InputMaybe<UserQueryInput>;
  owner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at_exists?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updated_at_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at_ne?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum Character_SetSortByInput {
  BackgroundPathAsc = 'BACKGROUND_PATH_ASC',
  BackgroundPathDesc = 'BACKGROUND_PATH_DESC',
  BackgroundThumbnailPathAsc = 'BACKGROUND_THUMBNAIL_PATH_ASC',
  BackgroundThumbnailPathDesc = 'BACKGROUND_THUMBNAIL_PATH_DESC',
  BackgroundThumbnailUrlAsc = 'BACKGROUND_THUMBNAIL_URL_ASC',
  BackgroundThumbnailUrlDesc = 'BACKGROUND_THUMBNAIL_URL_DESC',
  BackgroundUrlAsc = 'BACKGROUND_URL_ASC',
  BackgroundUrlDesc = 'BACKGROUND_URL_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  OriginalImagePathAsc = 'ORIGINAL_IMAGE_PATH_ASC',
  OriginalImagePathDesc = 'ORIGINAL_IMAGE_PATH_DESC',
  OriginalImageThumbnailPathAsc = 'ORIGINAL_IMAGE_THUMBNAIL_PATH_ASC',
  OriginalImageThumbnailPathDesc = 'ORIGINAL_IMAGE_THUMBNAIL_PATH_DESC',
  OriginalImageThumbnailUrlAsc = 'ORIGINAL_IMAGE_THUMBNAIL_URL_ASC',
  OriginalImageThumbnailUrlDesc = 'ORIGINAL_IMAGE_THUMBNAIL_URL_DESC',
  OriginalImageUrlAsc = 'ORIGINAL_IMAGE_URL_ASC',
  OriginalImageUrlDesc = 'ORIGINAL_IMAGE_URL_DESC',
  OwnerAsc = 'OWNER_ASC',
  OwnerDesc = 'OWNER_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type Character_SetUpdateInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  background_path?: InputMaybe<Scalars['String']['input']>;
  background_path_unset?: InputMaybe<Scalars['Boolean']['input']>;
  background_thumbnail_path?: InputMaybe<Scalars['String']['input']>;
  background_thumbnail_path_unset?: InputMaybe<Scalars['Boolean']['input']>;
  background_thumbnail_url?: InputMaybe<Scalars['String']['input']>;
  background_thumbnail_url_unset?: InputMaybe<Scalars['Boolean']['input']>;
  background_url?: InputMaybe<Scalars['String']['input']>;
  background_url_unset?: InputMaybe<Scalars['Boolean']['input']>;
  characters?: InputMaybe<Character_SetCharactersRelationInput>;
  characters_unset?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_unset?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_unset?: InputMaybe<Scalars['Boolean']['input']>;
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
  is_default_unset?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_unset?: InputMaybe<Scalars['Boolean']['input']>;
  original_image_path?: InputMaybe<Scalars['String']['input']>;
  original_image_path_unset?: InputMaybe<Scalars['Boolean']['input']>;
  original_image_thumbnail_path?: InputMaybe<Scalars['String']['input']>;
  original_image_thumbnail_path_unset?: InputMaybe<Scalars['Boolean']['input']>;
  original_image_thumbnail_url?: InputMaybe<Scalars['String']['input']>;
  original_image_thumbnail_url_unset?: InputMaybe<Scalars['Boolean']['input']>;
  original_image_url?: InputMaybe<Scalars['String']['input']>;
  original_image_url_unset?: InputMaybe<Scalars['Boolean']['input']>;
  owner?: InputMaybe<Character_SetOwnerRelationInput>;
  owner_unset?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Character_Type = {
  __typename?: 'Character_type';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  modified_at?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Character_TypeInsertInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  modified_at?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Character_TypeQueryInput = {
  AND?: InputMaybe<Array<Character_TypeQueryInput>>;
  OR?: InputMaybe<Array<Character_TypeQueryInput>>;
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  _id_gt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_gte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  _id_lt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_lte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_ne?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_exists?: InputMaybe<Scalars['Boolean']['input']>;
  created_at_gt?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_gte?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  created_at_lt?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_lte?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_ne?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_gt?: InputMaybe<Scalars['String']['input']>;
  description_gte?: InputMaybe<Scalars['String']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_lt?: InputMaybe<Scalars['String']['input']>;
  description_lte?: InputMaybe<Scalars['String']['input']>;
  description_ne?: InputMaybe<Scalars['String']['input']>;
  description_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modified_at?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_exists?: InputMaybe<Scalars['Boolean']['input']>;
  modified_at_gt?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_gte?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  modified_at_lt?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_lte?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_ne?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum Character_TypeSortByInput {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  ModifiedAtAsc = 'MODIFIED_AT_ASC',
  ModifiedAtDesc = 'MODIFIED_AT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type Character_TypeUpdateInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_unset?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_unset?: InputMaybe<Scalars['Boolean']['input']>;
  modified_at?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_unset?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Class = {
  __typename?: 'Class';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ClassInsertInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ClassQueryInput = {
  AND?: InputMaybe<Array<ClassQueryInput>>;
  OR?: InputMaybe<Array<ClassQueryInput>>;
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  _id_gt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_gte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  _id_lt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_lte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_ne?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum ClassSortByInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type ClassUpdateInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Container = {
  __typename?: 'Container';
  _id: Scalars['String']['output'];
  assets?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>;
  canvas: Scalars['ObjectId']['output'];
  containerType: Scalars['String']['output'];
  notes?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>;
  position?: Maybe<ContainerPosition>;
  style?: Maybe<ContainerStyle>;
  subtitle?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  widgets?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>;
};

export type ContainerInsertInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  assets?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  canvas: Scalars['ObjectId']['input'];
  containerType: Scalars['String']['input'];
  notes?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  position?: InputMaybe<ContainerPositionInsertInput>;
  style?: InputMaybe<ContainerStyleInsertInput>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  widgets?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
};

export type ContainerPosition = {
  __typename?: 'ContainerPosition';
  x?: Maybe<Scalars['Long']['output']>;
  y?: Maybe<Scalars['Long']['output']>;
  z?: Maybe<Scalars['Long']['output']>;
};

export type ContainerPositionInsertInput = {
  x?: InputMaybe<Scalars['Long']['input']>;
  y?: InputMaybe<Scalars['Long']['input']>;
  z?: InputMaybe<Scalars['Long']['input']>;
};

export type ContainerPositionQueryInput = {
  AND?: InputMaybe<Array<ContainerPositionQueryInput>>;
  OR?: InputMaybe<Array<ContainerPositionQueryInput>>;
  x?: InputMaybe<Scalars['Long']['input']>;
  x_exists?: InputMaybe<Scalars['Boolean']['input']>;
  x_gt?: InputMaybe<Scalars['Long']['input']>;
  x_gte?: InputMaybe<Scalars['Long']['input']>;
  x_in?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  x_lt?: InputMaybe<Scalars['Long']['input']>;
  x_lte?: InputMaybe<Scalars['Long']['input']>;
  x_ne?: InputMaybe<Scalars['Long']['input']>;
  x_nin?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  y?: InputMaybe<Scalars['Long']['input']>;
  y_exists?: InputMaybe<Scalars['Boolean']['input']>;
  y_gt?: InputMaybe<Scalars['Long']['input']>;
  y_gte?: InputMaybe<Scalars['Long']['input']>;
  y_in?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  y_lt?: InputMaybe<Scalars['Long']['input']>;
  y_lte?: InputMaybe<Scalars['Long']['input']>;
  y_ne?: InputMaybe<Scalars['Long']['input']>;
  y_nin?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  z?: InputMaybe<Scalars['Long']['input']>;
  z_exists?: InputMaybe<Scalars['Boolean']['input']>;
  z_gt?: InputMaybe<Scalars['Long']['input']>;
  z_gte?: InputMaybe<Scalars['Long']['input']>;
  z_in?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  z_lt?: InputMaybe<Scalars['Long']['input']>;
  z_lte?: InputMaybe<Scalars['Long']['input']>;
  z_ne?: InputMaybe<Scalars['Long']['input']>;
  z_nin?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};

export type ContainerPositionUpdateInput = {
  x?: InputMaybe<Scalars['Long']['input']>;
  x_unset?: InputMaybe<Scalars['Boolean']['input']>;
  y?: InputMaybe<Scalars['Long']['input']>;
  y_unset?: InputMaybe<Scalars['Boolean']['input']>;
  z?: InputMaybe<Scalars['Long']['input']>;
  z_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContainerQueryInput = {
  AND?: InputMaybe<Array<ContainerQueryInput>>;
  OR?: InputMaybe<Array<ContainerQueryInput>>;
  _id?: InputMaybe<Scalars['String']['input']>;
  _id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  _id_gt?: InputMaybe<Scalars['String']['input']>;
  _id_gte?: InputMaybe<Scalars['String']['input']>;
  _id_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  _id_lt?: InputMaybe<Scalars['String']['input']>;
  _id_lte?: InputMaybe<Scalars['String']['input']>;
  _id_ne?: InputMaybe<Scalars['String']['input']>;
  _id_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  assets?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  assets_exists?: InputMaybe<Scalars['Boolean']['input']>;
  assets_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  assets_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  canvas?: InputMaybe<Scalars['ObjectId']['input']>;
  canvas_exists?: InputMaybe<Scalars['Boolean']['input']>;
  canvas_gt?: InputMaybe<Scalars['ObjectId']['input']>;
  canvas_gte?: InputMaybe<Scalars['ObjectId']['input']>;
  canvas_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  canvas_lt?: InputMaybe<Scalars['ObjectId']['input']>;
  canvas_lte?: InputMaybe<Scalars['ObjectId']['input']>;
  canvas_ne?: InputMaybe<Scalars['ObjectId']['input']>;
  canvas_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  containerType?: InputMaybe<Scalars['String']['input']>;
  containerType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  containerType_gt?: InputMaybe<Scalars['String']['input']>;
  containerType_gte?: InputMaybe<Scalars['String']['input']>;
  containerType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  containerType_lt?: InputMaybe<Scalars['String']['input']>;
  containerType_lte?: InputMaybe<Scalars['String']['input']>;
  containerType_ne?: InputMaybe<Scalars['String']['input']>;
  containerType_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notes?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  notes_exists?: InputMaybe<Scalars['Boolean']['input']>;
  notes_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  notes_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  position?: InputMaybe<ContainerPositionQueryInput>;
  position_exists?: InputMaybe<Scalars['Boolean']['input']>;
  style?: InputMaybe<ContainerStyleQueryInput>;
  style_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  subtitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subtitle_gt?: InputMaybe<Scalars['String']['input']>;
  subtitle_gte?: InputMaybe<Scalars['String']['input']>;
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subtitle_lt?: InputMaybe<Scalars['String']['input']>;
  subtitle_lte?: InputMaybe<Scalars['String']['input']>;
  subtitle_ne?: InputMaybe<Scalars['String']['input']>;
  subtitle_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  thumbnailUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  thumbnailUrl_gt?: InputMaybe<Scalars['String']['input']>;
  thumbnailUrl_gte?: InputMaybe<Scalars['String']['input']>;
  thumbnailUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  thumbnailUrl_lt?: InputMaybe<Scalars['String']['input']>;
  thumbnailUrl_lte?: InputMaybe<Scalars['String']['input']>;
  thumbnailUrl_ne?: InputMaybe<Scalars['String']['input']>;
  thumbnailUrl_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_gt?: InputMaybe<Scalars['String']['input']>;
  title_gte?: InputMaybe<Scalars['String']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_lt?: InputMaybe<Scalars['String']['input']>;
  title_lte?: InputMaybe<Scalars['String']['input']>;
  title_ne?: InputMaybe<Scalars['String']['input']>;
  title_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  widgets?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  widgets_exists?: InputMaybe<Scalars['Boolean']['input']>;
  widgets_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  widgets_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
};

export enum ContainerSortByInput {
  CanvasAsc = 'CANVAS_ASC',
  CanvasDesc = 'CANVAS_DESC',
  ContainertypeAsc = 'CONTAINERTYPE_ASC',
  ContainertypeDesc = 'CONTAINERTYPE_DESC',
  SubtitleAsc = 'SUBTITLE_ASC',
  SubtitleDesc = 'SUBTITLE_DESC',
  ThumbnailurlAsc = 'THUMBNAILURL_ASC',
  ThumbnailurlDesc = 'THUMBNAILURL_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type ContainerStyle = {
  __typename?: 'ContainerStyle';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  borderColor?: Maybe<Scalars['String']['output']>;
  borderRadius?: Maybe<Scalars['Long']['output']>;
  borderWidth?: Maybe<Scalars['Long']['output']>;
  height?: Maybe<Scalars['Long']['output']>;
  opacity?: Maybe<Scalars['Long']['output']>;
  width?: Maybe<Scalars['Long']['output']>;
};

export type ContainerStyleInsertInput = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  borderColor?: InputMaybe<Scalars['String']['input']>;
  borderRadius?: InputMaybe<Scalars['Long']['input']>;
  borderWidth?: InputMaybe<Scalars['Long']['input']>;
  height?: InputMaybe<Scalars['Long']['input']>;
  opacity?: InputMaybe<Scalars['Long']['input']>;
  width?: InputMaybe<Scalars['Long']['input']>;
};

export type ContainerStyleQueryInput = {
  AND?: InputMaybe<Array<ContainerStyleQueryInput>>;
  OR?: InputMaybe<Array<ContainerStyleQueryInput>>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_gt?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_gte?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_lt?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_lte?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_ne?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  borderColor?: InputMaybe<Scalars['String']['input']>;
  borderColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  borderColor_gt?: InputMaybe<Scalars['String']['input']>;
  borderColor_gte?: InputMaybe<Scalars['String']['input']>;
  borderColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  borderColor_lt?: InputMaybe<Scalars['String']['input']>;
  borderColor_lte?: InputMaybe<Scalars['String']['input']>;
  borderColor_ne?: InputMaybe<Scalars['String']['input']>;
  borderColor_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  borderRadius?: InputMaybe<Scalars['Long']['input']>;
  borderRadius_exists?: InputMaybe<Scalars['Boolean']['input']>;
  borderRadius_gt?: InputMaybe<Scalars['Long']['input']>;
  borderRadius_gte?: InputMaybe<Scalars['Long']['input']>;
  borderRadius_in?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  borderRadius_lt?: InputMaybe<Scalars['Long']['input']>;
  borderRadius_lte?: InputMaybe<Scalars['Long']['input']>;
  borderRadius_ne?: InputMaybe<Scalars['Long']['input']>;
  borderRadius_nin?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  borderWidth?: InputMaybe<Scalars['Long']['input']>;
  borderWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  borderWidth_gt?: InputMaybe<Scalars['Long']['input']>;
  borderWidth_gte?: InputMaybe<Scalars['Long']['input']>;
  borderWidth_in?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  borderWidth_lt?: InputMaybe<Scalars['Long']['input']>;
  borderWidth_lte?: InputMaybe<Scalars['Long']['input']>;
  borderWidth_ne?: InputMaybe<Scalars['Long']['input']>;
  borderWidth_nin?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  height?: InputMaybe<Scalars['Long']['input']>;
  height_exists?: InputMaybe<Scalars['Boolean']['input']>;
  height_gt?: InputMaybe<Scalars['Long']['input']>;
  height_gte?: InputMaybe<Scalars['Long']['input']>;
  height_in?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  height_lt?: InputMaybe<Scalars['Long']['input']>;
  height_lte?: InputMaybe<Scalars['Long']['input']>;
  height_ne?: InputMaybe<Scalars['Long']['input']>;
  height_nin?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  opacity?: InputMaybe<Scalars['Long']['input']>;
  opacity_exists?: InputMaybe<Scalars['Boolean']['input']>;
  opacity_gt?: InputMaybe<Scalars['Long']['input']>;
  opacity_gte?: InputMaybe<Scalars['Long']['input']>;
  opacity_in?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  opacity_lt?: InputMaybe<Scalars['Long']['input']>;
  opacity_lte?: InputMaybe<Scalars['Long']['input']>;
  opacity_ne?: InputMaybe<Scalars['Long']['input']>;
  opacity_nin?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  width?: InputMaybe<Scalars['Long']['input']>;
  width_exists?: InputMaybe<Scalars['Boolean']['input']>;
  width_gt?: InputMaybe<Scalars['Long']['input']>;
  width_gte?: InputMaybe<Scalars['Long']['input']>;
  width_in?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  width_lt?: InputMaybe<Scalars['Long']['input']>;
  width_lte?: InputMaybe<Scalars['Long']['input']>;
  width_ne?: InputMaybe<Scalars['Long']['input']>;
  width_nin?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};

export type ContainerStyleUpdateInput = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_unset?: InputMaybe<Scalars['Boolean']['input']>;
  borderColor?: InputMaybe<Scalars['String']['input']>;
  borderColor_unset?: InputMaybe<Scalars['Boolean']['input']>;
  borderRadius?: InputMaybe<Scalars['Long']['input']>;
  borderRadius_unset?: InputMaybe<Scalars['Boolean']['input']>;
  borderWidth?: InputMaybe<Scalars['Long']['input']>;
  borderWidth_unset?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Scalars['Long']['input']>;
  height_unset?: InputMaybe<Scalars['Boolean']['input']>;
  opacity?: InputMaybe<Scalars['Long']['input']>;
  opacity_unset?: InputMaybe<Scalars['Boolean']['input']>;
  width?: InputMaybe<Scalars['Long']['input']>;
  width_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContainerUpdateInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  _id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  assets?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  assets_unset?: InputMaybe<Scalars['Boolean']['input']>;
  canvas?: InputMaybe<Scalars['ObjectId']['input']>;
  canvas_unset?: InputMaybe<Scalars['Boolean']['input']>;
  containerType?: InputMaybe<Scalars['String']['input']>;
  containerType_unset?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  notes_unset?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<ContainerPositionUpdateInput>;
  position_unset?: InputMaybe<Scalars['Boolean']['input']>;
  style?: InputMaybe<ContainerStyleUpdateInput>;
  style_unset?: InputMaybe<Scalars['Boolean']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  subtitle_unset?: InputMaybe<Scalars['Boolean']['input']>;
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  thumbnailUrl_unset?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_unset?: InputMaybe<Scalars['Boolean']['input']>;
  widgets?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  widgets_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeleteManyPayload = {
  __typename?: 'DeleteManyPayload';
  deletedCount: Scalars['Int']['output'];
};

export type Eye = {
  __typename?: 'Eye';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type EyeInsertInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type EyeQueryInput = {
  AND?: InputMaybe<Array<EyeQueryInput>>;
  OR?: InputMaybe<Array<EyeQueryInput>>;
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  _id_gt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_gte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  _id_lt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_lte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_ne?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum EyeSortByInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type EyeUpdateInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Gender = {
  __typename?: 'Gender';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type GenderInsertInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type GenderQueryInput = {
  AND?: InputMaybe<Array<GenderQueryInput>>;
  OR?: InputMaybe<Array<GenderQueryInput>>;
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  _id_gt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_gte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  _id_lt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_lte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_ne?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum GenderSortByInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type GenderUpdateInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Hair = {
  __typename?: 'Hair';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type HairInsertInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type HairQueryInput = {
  AND?: InputMaybe<Array<HairQueryInput>>;
  OR?: InputMaybe<Array<HairQueryInput>>;
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  _id_gt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_gte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  _id_lt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_lte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_ne?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum HairSortByInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type HairUpdateInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Image_Generation_Sku = {
  __typename?: 'Image_generation_sku';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  credit_cost?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  image_count?: Maybe<Scalars['Int']['output']>;
  image_height?: Maybe<Scalars['Int']['output']>;
  image_width?: Maybe<Scalars['Int']['output']>;
  min_subscription_tier_id?: Maybe<Subscription_Tier>;
  model?: Maybe<Scalars['String']['output']>;
  modified_at?: Maybe<Scalars['DateTime']['output']>;
  n_iter?: Maybe<Scalars['Int']['output']>;
  n_samples?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  scale?: Maybe<Scalars['Float']['output']>;
  speed_tier?: Maybe<Scalars['String']['output']>;
  steps?: Maybe<Scalars['Int']['output']>;
};

export type Image_Generation_SkuInsertInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  credit_cost?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  image_count?: InputMaybe<Scalars['Int']['input']>;
  image_height?: InputMaybe<Scalars['Int']['input']>;
  image_width?: InputMaybe<Scalars['Int']['input']>;
  min_subscription_tier_id?: InputMaybe<Image_Generation_SkuMin_Subscription_Tier_IdRelationInput>;
  model?: InputMaybe<Scalars['String']['input']>;
  modified_at?: InputMaybe<Scalars['DateTime']['input']>;
  n_iter?: InputMaybe<Scalars['Int']['input']>;
  n_samples?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  scale?: InputMaybe<Scalars['Float']['input']>;
  speed_tier?: InputMaybe<Scalars['String']['input']>;
  steps?: InputMaybe<Scalars['Int']['input']>;
};

export type Image_Generation_SkuMin_Subscription_Tier_IdRelationInput = {
  create?: InputMaybe<Subscription_TierInsertInput>;
  link?: InputMaybe<Scalars['Int']['input']>;
};

export type Image_Generation_SkuQueryInput = {
  AND?: InputMaybe<Array<Image_Generation_SkuQueryInput>>;
  OR?: InputMaybe<Array<Image_Generation_SkuQueryInput>>;
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  _id_gt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_gte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  _id_lt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_lte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_ne?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_exists?: InputMaybe<Scalars['Boolean']['input']>;
  created_at_gt?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_gte?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  created_at_lt?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_lte?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_ne?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  credit_cost?: InputMaybe<Scalars['Int']['input']>;
  credit_cost_exists?: InputMaybe<Scalars['Boolean']['input']>;
  credit_cost_gt?: InputMaybe<Scalars['Int']['input']>;
  credit_cost_gte?: InputMaybe<Scalars['Int']['input']>;
  credit_cost_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  credit_cost_lt?: InputMaybe<Scalars['Int']['input']>;
  credit_cost_lte?: InputMaybe<Scalars['Int']['input']>;
  credit_cost_ne?: InputMaybe<Scalars['Int']['input']>;
  credit_cost_nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_gt?: InputMaybe<Scalars['String']['input']>;
  description_gte?: InputMaybe<Scalars['String']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_lt?: InputMaybe<Scalars['String']['input']>;
  description_lte?: InputMaybe<Scalars['String']['input']>;
  description_ne?: InputMaybe<Scalars['String']['input']>;
  description_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image_count?: InputMaybe<Scalars['Int']['input']>;
  image_count_exists?: InputMaybe<Scalars['Boolean']['input']>;
  image_count_gt?: InputMaybe<Scalars['Int']['input']>;
  image_count_gte?: InputMaybe<Scalars['Int']['input']>;
  image_count_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  image_count_lt?: InputMaybe<Scalars['Int']['input']>;
  image_count_lte?: InputMaybe<Scalars['Int']['input']>;
  image_count_ne?: InputMaybe<Scalars['Int']['input']>;
  image_count_nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  image_height?: InputMaybe<Scalars['Int']['input']>;
  image_height_exists?: InputMaybe<Scalars['Boolean']['input']>;
  image_height_gt?: InputMaybe<Scalars['Int']['input']>;
  image_height_gte?: InputMaybe<Scalars['Int']['input']>;
  image_height_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  image_height_lt?: InputMaybe<Scalars['Int']['input']>;
  image_height_lte?: InputMaybe<Scalars['Int']['input']>;
  image_height_ne?: InputMaybe<Scalars['Int']['input']>;
  image_height_nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  image_width?: InputMaybe<Scalars['Int']['input']>;
  image_width_exists?: InputMaybe<Scalars['Boolean']['input']>;
  image_width_gt?: InputMaybe<Scalars['Int']['input']>;
  image_width_gte?: InputMaybe<Scalars['Int']['input']>;
  image_width_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  image_width_lt?: InputMaybe<Scalars['Int']['input']>;
  image_width_lte?: InputMaybe<Scalars['Int']['input']>;
  image_width_ne?: InputMaybe<Scalars['Int']['input']>;
  image_width_nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  min_subscription_tier_id?: InputMaybe<Subscription_TierQueryInput>;
  min_subscription_tier_id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  model_exists?: InputMaybe<Scalars['Boolean']['input']>;
  model_gt?: InputMaybe<Scalars['String']['input']>;
  model_gte?: InputMaybe<Scalars['String']['input']>;
  model_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  model_lt?: InputMaybe<Scalars['String']['input']>;
  model_lte?: InputMaybe<Scalars['String']['input']>;
  model_ne?: InputMaybe<Scalars['String']['input']>;
  model_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modified_at?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_exists?: InputMaybe<Scalars['Boolean']['input']>;
  modified_at_gt?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_gte?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  modified_at_lt?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_lte?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_ne?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  n_iter?: InputMaybe<Scalars['Int']['input']>;
  n_iter_exists?: InputMaybe<Scalars['Boolean']['input']>;
  n_iter_gt?: InputMaybe<Scalars['Int']['input']>;
  n_iter_gte?: InputMaybe<Scalars['Int']['input']>;
  n_iter_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  n_iter_lt?: InputMaybe<Scalars['Int']['input']>;
  n_iter_lte?: InputMaybe<Scalars['Int']['input']>;
  n_iter_ne?: InputMaybe<Scalars['Int']['input']>;
  n_iter_nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  n_samples?: InputMaybe<Scalars['Int']['input']>;
  n_samples_exists?: InputMaybe<Scalars['Boolean']['input']>;
  n_samples_gt?: InputMaybe<Scalars['Int']['input']>;
  n_samples_gte?: InputMaybe<Scalars['Int']['input']>;
  n_samples_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  n_samples_lt?: InputMaybe<Scalars['Int']['input']>;
  n_samples_lte?: InputMaybe<Scalars['Int']['input']>;
  n_samples_ne?: InputMaybe<Scalars['Int']['input']>;
  n_samples_nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scale?: InputMaybe<Scalars['Float']['input']>;
  scale_exists?: InputMaybe<Scalars['Boolean']['input']>;
  scale_gt?: InputMaybe<Scalars['Float']['input']>;
  scale_gte?: InputMaybe<Scalars['Float']['input']>;
  scale_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  scale_lt?: InputMaybe<Scalars['Float']['input']>;
  scale_lte?: InputMaybe<Scalars['Float']['input']>;
  scale_ne?: InputMaybe<Scalars['Float']['input']>;
  scale_nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  speed_tier?: InputMaybe<Scalars['String']['input']>;
  speed_tier_exists?: InputMaybe<Scalars['Boolean']['input']>;
  speed_tier_gt?: InputMaybe<Scalars['String']['input']>;
  speed_tier_gte?: InputMaybe<Scalars['String']['input']>;
  speed_tier_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  speed_tier_lt?: InputMaybe<Scalars['String']['input']>;
  speed_tier_lte?: InputMaybe<Scalars['String']['input']>;
  speed_tier_ne?: InputMaybe<Scalars['String']['input']>;
  speed_tier_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  steps?: InputMaybe<Scalars['Int']['input']>;
  steps_exists?: InputMaybe<Scalars['Boolean']['input']>;
  steps_gt?: InputMaybe<Scalars['Int']['input']>;
  steps_gte?: InputMaybe<Scalars['Int']['input']>;
  steps_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  steps_lt?: InputMaybe<Scalars['Int']['input']>;
  steps_lte?: InputMaybe<Scalars['Int']['input']>;
  steps_ne?: InputMaybe<Scalars['Int']['input']>;
  steps_nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export enum Image_Generation_SkuSortByInput {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreditCostAsc = 'CREDIT_COST_ASC',
  CreditCostDesc = 'CREDIT_COST_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  ImageCountAsc = 'IMAGE_COUNT_ASC',
  ImageCountDesc = 'IMAGE_COUNT_DESC',
  ImageHeightAsc = 'IMAGE_HEIGHT_ASC',
  ImageHeightDesc = 'IMAGE_HEIGHT_DESC',
  ImageWidthAsc = 'IMAGE_WIDTH_ASC',
  ImageWidthDesc = 'IMAGE_WIDTH_DESC',
  MinSubscriptionTierIdAsc = 'MIN_SUBSCRIPTION_TIER_ID_ASC',
  MinSubscriptionTierIdDesc = 'MIN_SUBSCRIPTION_TIER_ID_DESC',
  ModelAsc = 'MODEL_ASC',
  ModelDesc = 'MODEL_DESC',
  ModifiedAtAsc = 'MODIFIED_AT_ASC',
  ModifiedAtDesc = 'MODIFIED_AT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  NIterAsc = 'N_ITER_ASC',
  NIterDesc = 'N_ITER_DESC',
  NSamplesAsc = 'N_SAMPLES_ASC',
  NSamplesDesc = 'N_SAMPLES_DESC',
  ScaleAsc = 'SCALE_ASC',
  ScaleDesc = 'SCALE_DESC',
  SpeedTierAsc = 'SPEED_TIER_ASC',
  SpeedTierDesc = 'SPEED_TIER_DESC',
  StepsAsc = 'STEPS_ASC',
  StepsDesc = 'STEPS_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type Image_Generation_SkuUpdateInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_unset?: InputMaybe<Scalars['Boolean']['input']>;
  credit_cost?: InputMaybe<Scalars['Int']['input']>;
  credit_cost_inc?: InputMaybe<Scalars['Int']['input']>;
  credit_cost_unset?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_unset?: InputMaybe<Scalars['Boolean']['input']>;
  image_count?: InputMaybe<Scalars['Int']['input']>;
  image_count_inc?: InputMaybe<Scalars['Int']['input']>;
  image_count_unset?: InputMaybe<Scalars['Boolean']['input']>;
  image_height?: InputMaybe<Scalars['Int']['input']>;
  image_height_inc?: InputMaybe<Scalars['Int']['input']>;
  image_height_unset?: InputMaybe<Scalars['Boolean']['input']>;
  image_width?: InputMaybe<Scalars['Int']['input']>;
  image_width_inc?: InputMaybe<Scalars['Int']['input']>;
  image_width_unset?: InputMaybe<Scalars['Boolean']['input']>;
  min_subscription_tier_id?: InputMaybe<Image_Generation_SkuMin_Subscription_Tier_IdRelationInput>;
  min_subscription_tier_id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  model_unset?: InputMaybe<Scalars['Boolean']['input']>;
  modified_at?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_unset?: InputMaybe<Scalars['Boolean']['input']>;
  n_iter?: InputMaybe<Scalars['Int']['input']>;
  n_iter_inc?: InputMaybe<Scalars['Int']['input']>;
  n_iter_unset?: InputMaybe<Scalars['Boolean']['input']>;
  n_samples?: InputMaybe<Scalars['Int']['input']>;
  n_samples_inc?: InputMaybe<Scalars['Int']['input']>;
  n_samples_unset?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_unset?: InputMaybe<Scalars['Boolean']['input']>;
  scale?: InputMaybe<Scalars['Float']['input']>;
  scale_inc?: InputMaybe<Scalars['Float']['input']>;
  scale_unset?: InputMaybe<Scalars['Boolean']['input']>;
  speed_tier?: InputMaybe<Scalars['String']['input']>;
  speed_tier_unset?: InputMaybe<Scalars['Boolean']['input']>;
  steps?: InputMaybe<Scalars['Int']['input']>;
  steps_inc?: InputMaybe<Scalars['Int']['input']>;
  steps_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Image_Generation_Style = {
  __typename?: 'Image_generation_style';
  _id: Scalars['ObjectId']['output'];
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  previews?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type Image_Generation_StyleInsertInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  previews?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Image_Generation_StyleQueryInput = {
  AND?: InputMaybe<Array<Image_Generation_StyleQueryInput>>;
  OR?: InputMaybe<Array<Image_Generation_StyleQueryInput>>;
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  _id_gt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_gte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  _id_lt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_lte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_ne?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_gt?: InputMaybe<Scalars['String']['input']>;
  description_gte?: InputMaybe<Scalars['String']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_lt?: InputMaybe<Scalars['String']['input']>;
  description_lte?: InputMaybe<Scalars['String']['input']>;
  description_ne?: InputMaybe<Scalars['String']['input']>;
  description_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  previews?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  previews_exists?: InputMaybe<Scalars['Boolean']['input']>;
  previews_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  previews_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum Image_Generation_StyleSortByInput {
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type Image_Generation_StyleUpdateInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_unset?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_unset?: InputMaybe<Scalars['Boolean']['input']>;
  previews?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  previews_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Image_Mask = {
  __typename?: 'Image_mask';
  _id: Scalars['ObjectId']['output'];
  created_at?: Maybe<Scalars['DateTime']['output']>;
  mask_url?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Image_MaskInsertInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  mask_url?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Image_MaskQueryInput = {
  AND?: InputMaybe<Array<Image_MaskQueryInput>>;
  OR?: InputMaybe<Array<Image_MaskQueryInput>>;
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  _id_gt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_gte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  _id_lt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_lte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_ne?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_exists?: InputMaybe<Scalars['Boolean']['input']>;
  created_at_gt?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_gte?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  created_at_lt?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_lte?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_ne?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  mask_url?: InputMaybe<Scalars['String']['input']>;
  mask_url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mask_url_gt?: InputMaybe<Scalars['String']['input']>;
  mask_url_gte?: InputMaybe<Scalars['String']['input']>;
  mask_url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mask_url_lt?: InputMaybe<Scalars['String']['input']>;
  mask_url_lte?: InputMaybe<Scalars['String']['input']>;
  mask_url_ne?: InputMaybe<Scalars['String']['input']>;
  mask_url_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum Image_MaskSortByInput {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  MaskUrlAsc = 'MASK_URL_ASC',
  MaskUrlDesc = 'MASK_URL_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type Image_MaskUpdateInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_unset?: InputMaybe<Scalars['Boolean']['input']>;
  mask_url?: InputMaybe<Scalars['String']['input']>;
  mask_url_unset?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Image_Prompt_Template = {
  __typename?: 'Image_prompt_template';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  prompt_template?: Maybe<Scalars['String']['output']>;
};

export type Image_Prompt_TemplateInsertInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  prompt_template?: InputMaybe<Scalars['String']['input']>;
};

export type Image_Prompt_TemplateQueryInput = {
  AND?: InputMaybe<Array<Image_Prompt_TemplateQueryInput>>;
  OR?: InputMaybe<Array<Image_Prompt_TemplateQueryInput>>;
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  _id_gt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_gte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  _id_lt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_lte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_ne?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  prompt_template?: InputMaybe<Scalars['String']['input']>;
  prompt_template_exists?: InputMaybe<Scalars['Boolean']['input']>;
  prompt_template_gt?: InputMaybe<Scalars['String']['input']>;
  prompt_template_gte?: InputMaybe<Scalars['String']['input']>;
  prompt_template_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  prompt_template_lt?: InputMaybe<Scalars['String']['input']>;
  prompt_template_lte?: InputMaybe<Scalars['String']['input']>;
  prompt_template_ne?: InputMaybe<Scalars['String']['input']>;
  prompt_template_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum Image_Prompt_TemplateSortByInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  PromptTemplateAsc = 'PROMPT_TEMPLATE_ASC',
  PromptTemplateDesc = 'PROMPT_TEMPLATE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type Image_Prompt_TemplateUpdateInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_unset?: InputMaybe<Scalars['Boolean']['input']>;
  prompt_template?: InputMaybe<Scalars['String']['input']>;
  prompt_template_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsertManyPayload = {
  __typename?: 'InsertManyPayload';
  insertedIds: Array<Maybe<Scalars['ObjectId']['output']>>;
};

export type Library_Content_Pack = {
  __typename?: 'Library_content_pack';
  _id: Scalars['ObjectId']['output'];
  asset_category_type?: Maybe<Scalars['String']['output']>;
  catagories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  creator?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  media_assets?: Maybe<Array<Maybe<Media_Asset>>>;
  name: Scalars['String']['output'];
  price?: Maybe<Array<Maybe<Library_Content_PackPrice>>>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title_image_url?: Maybe<Scalars['String']['output']>;
};

export type Library_Content_PackCreatorRelationInput = {
  create?: InputMaybe<UserInsertInput>;
  link?: InputMaybe<Scalars['String']['input']>;
};

export type Library_Content_PackInsertInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  asset_category_type?: InputMaybe<Scalars['String']['input']>;
  catagories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  created_date?: InputMaybe<Scalars['DateTime']['input']>;
  creator?: InputMaybe<Library_Content_PackCreatorRelationInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  media_assets?: InputMaybe<Library_Content_PackMedia_AssetsRelationInput>;
  name: Scalars['String']['input'];
  price?: InputMaybe<Array<InputMaybe<Library_Content_PackPriceInsertInput>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_image_url?: InputMaybe<Scalars['String']['input']>;
};

export type Library_Content_PackMedia_AssetsRelationInput = {
  create?: InputMaybe<Array<InputMaybe<Media_AssetInsertInput>>>;
  link?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
};

export type Library_Content_PackPrice = {
  __typename?: 'Library_content_packPrice';
  credit_price?: Maybe<Scalars['String']['output']>;
  money?: Maybe<Scalars['Float']['output']>;
  price_name?: Maybe<Scalars['String']['output']>;
  subscription_tier?: Maybe<Scalars['ObjectId']['output']>;
};

export type Library_Content_PackPriceInsertInput = {
  credit_price?: InputMaybe<Scalars['String']['input']>;
  money?: InputMaybe<Scalars['Float']['input']>;
  price_name?: InputMaybe<Scalars['String']['input']>;
  subscription_tier?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type Library_Content_PackPriceQueryInput = {
  AND?: InputMaybe<Array<Library_Content_PackPriceQueryInput>>;
  OR?: InputMaybe<Array<Library_Content_PackPriceQueryInput>>;
  credit_price?: InputMaybe<Scalars['String']['input']>;
  credit_price_exists?: InputMaybe<Scalars['Boolean']['input']>;
  credit_price_gt?: InputMaybe<Scalars['String']['input']>;
  credit_price_gte?: InputMaybe<Scalars['String']['input']>;
  credit_price_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  credit_price_lt?: InputMaybe<Scalars['String']['input']>;
  credit_price_lte?: InputMaybe<Scalars['String']['input']>;
  credit_price_ne?: InputMaybe<Scalars['String']['input']>;
  credit_price_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  money?: InputMaybe<Scalars['Float']['input']>;
  money_exists?: InputMaybe<Scalars['Boolean']['input']>;
  money_gt?: InputMaybe<Scalars['Float']['input']>;
  money_gte?: InputMaybe<Scalars['Float']['input']>;
  money_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  money_lt?: InputMaybe<Scalars['Float']['input']>;
  money_lte?: InputMaybe<Scalars['Float']['input']>;
  money_ne?: InputMaybe<Scalars['Float']['input']>;
  money_nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  price_name?: InputMaybe<Scalars['String']['input']>;
  price_name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  price_name_gt?: InputMaybe<Scalars['String']['input']>;
  price_name_gte?: InputMaybe<Scalars['String']['input']>;
  price_name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  price_name_lt?: InputMaybe<Scalars['String']['input']>;
  price_name_lte?: InputMaybe<Scalars['String']['input']>;
  price_name_ne?: InputMaybe<Scalars['String']['input']>;
  price_name_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subscription_tier?: InputMaybe<Scalars['ObjectId']['input']>;
  subscription_tier_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subscription_tier_gt?: InputMaybe<Scalars['ObjectId']['input']>;
  subscription_tier_gte?: InputMaybe<Scalars['ObjectId']['input']>;
  subscription_tier_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  subscription_tier_lt?: InputMaybe<Scalars['ObjectId']['input']>;
  subscription_tier_lte?: InputMaybe<Scalars['ObjectId']['input']>;
  subscription_tier_ne?: InputMaybe<Scalars['ObjectId']['input']>;
  subscription_tier_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
};

export type Library_Content_PackPriceUpdateInput = {
  credit_price?: InputMaybe<Scalars['String']['input']>;
  credit_price_unset?: InputMaybe<Scalars['Boolean']['input']>;
  money?: InputMaybe<Scalars['Float']['input']>;
  money_inc?: InputMaybe<Scalars['Float']['input']>;
  money_unset?: InputMaybe<Scalars['Boolean']['input']>;
  price_name?: InputMaybe<Scalars['String']['input']>;
  price_name_unset?: InputMaybe<Scalars['Boolean']['input']>;
  subscription_tier?: InputMaybe<Scalars['ObjectId']['input']>;
  subscription_tier_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Library_Content_PackQueryInput = {
  AND?: InputMaybe<Array<Library_Content_PackQueryInput>>;
  OR?: InputMaybe<Array<Library_Content_PackQueryInput>>;
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  _id_gt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_gte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  _id_lt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_lte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_ne?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  asset_category_type?: InputMaybe<Scalars['String']['input']>;
  asset_category_type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  asset_category_type_gt?: InputMaybe<Scalars['String']['input']>;
  asset_category_type_gte?: InputMaybe<Scalars['String']['input']>;
  asset_category_type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  asset_category_type_lt?: InputMaybe<Scalars['String']['input']>;
  asset_category_type_lte?: InputMaybe<Scalars['String']['input']>;
  asset_category_type_ne?: InputMaybe<Scalars['String']['input']>;
  asset_category_type_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  catagories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  catagories_exists?: InputMaybe<Scalars['Boolean']['input']>;
  catagories_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  catagories_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  created_date?: InputMaybe<Scalars['DateTime']['input']>;
  created_date_exists?: InputMaybe<Scalars['Boolean']['input']>;
  created_date_gt?: InputMaybe<Scalars['DateTime']['input']>;
  created_date_gte?: InputMaybe<Scalars['DateTime']['input']>;
  created_date_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  created_date_lt?: InputMaybe<Scalars['DateTime']['input']>;
  created_date_lte?: InputMaybe<Scalars['DateTime']['input']>;
  created_date_ne?: InputMaybe<Scalars['DateTime']['input']>;
  created_date_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  creator?: InputMaybe<UserQueryInput>;
  creator_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_gt?: InputMaybe<Scalars['String']['input']>;
  description_gte?: InputMaybe<Scalars['String']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_lt?: InputMaybe<Scalars['String']['input']>;
  description_lte?: InputMaybe<Scalars['String']['input']>;
  description_ne?: InputMaybe<Scalars['String']['input']>;
  description_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  media_assets?: InputMaybe<Array<InputMaybe<Media_AssetQueryInput>>>;
  media_assets_exists?: InputMaybe<Scalars['Boolean']['input']>;
  media_assets_in?: InputMaybe<Array<InputMaybe<Media_AssetQueryInput>>>;
  media_assets_nin?: InputMaybe<Array<InputMaybe<Media_AssetQueryInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  price?: InputMaybe<Array<InputMaybe<Library_Content_PackPriceQueryInput>>>;
  price_exists?: InputMaybe<Scalars['Boolean']['input']>;
  price_in?: InputMaybe<Array<InputMaybe<Library_Content_PackPriceQueryInput>>>;
  price_nin?: InputMaybe<Array<InputMaybe<Library_Content_PackPriceQueryInput>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tags_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_image_url?: InputMaybe<Scalars['String']['input']>;
  title_image_url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_image_url_gt?: InputMaybe<Scalars['String']['input']>;
  title_image_url_gte?: InputMaybe<Scalars['String']['input']>;
  title_image_url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_image_url_lt?: InputMaybe<Scalars['String']['input']>;
  title_image_url_lte?: InputMaybe<Scalars['String']['input']>;
  title_image_url_ne?: InputMaybe<Scalars['String']['input']>;
  title_image_url_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum Library_Content_PackSortByInput {
  AssetCategoryTypeAsc = 'ASSET_CATEGORY_TYPE_ASC',
  AssetCategoryTypeDesc = 'ASSET_CATEGORY_TYPE_DESC',
  CreatedDateAsc = 'CREATED_DATE_ASC',
  CreatedDateDesc = 'CREATED_DATE_DESC',
  CreatorAsc = 'CREATOR_ASC',
  CreatorDesc = 'CREATOR_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  TitleImageUrlAsc = 'TITLE_IMAGE_URL_ASC',
  TitleImageUrlDesc = 'TITLE_IMAGE_URL_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type Library_Content_PackUpdateInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  asset_category_type?: InputMaybe<Scalars['String']['input']>;
  asset_category_type_unset?: InputMaybe<Scalars['Boolean']['input']>;
  catagories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  catagories_unset?: InputMaybe<Scalars['Boolean']['input']>;
  created_date?: InputMaybe<Scalars['DateTime']['input']>;
  created_date_unset?: InputMaybe<Scalars['Boolean']['input']>;
  creator?: InputMaybe<Library_Content_PackCreatorRelationInput>;
  creator_unset?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_unset?: InputMaybe<Scalars['Boolean']['input']>;
  media_assets?: InputMaybe<Library_Content_PackMedia_AssetsRelationInput>;
  media_assets_unset?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_unset?: InputMaybe<Scalars['Boolean']['input']>;
  price?: InputMaybe<Array<InputMaybe<Library_Content_PackPriceUpdateInput>>>;
  price_unset?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_unset?: InputMaybe<Scalars['Boolean']['input']>;
  title_image_url?: InputMaybe<Scalars['String']['input']>;
  title_image_url_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Location = {
  __typename?: 'Location';
  _id: Scalars['ObjectId']['output'];
  assets?: Maybe<Array<Maybe<Media_Asset>>>;
  attributes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  description?: Maybe<Scalars['String']['output']>;
  maps?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>;
  owner: User;
  rooms?: Maybe<Array<Maybe<Room>>>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  visibility?: Maybe<Scalars['String']['output']>;
};

export type LocationAssetsRelationInput = {
  create?: InputMaybe<Array<InputMaybe<Media_AssetInsertInput>>>;
  link?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
};

export type LocationInsertInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  assets?: InputMaybe<LocationAssetsRelationInput>;
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  maps?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  owner: LocationOwnerRelationInput;
  rooms?: InputMaybe<Array<InputMaybe<RoomInsertInput>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<Scalars['String']['input']>;
};

export type LocationOwnerRelationInput = {
  create?: InputMaybe<UserInsertInput>;
  link?: InputMaybe<Scalars['String']['input']>;
};

export type LocationQueryInput = {
  AND?: InputMaybe<Array<LocationQueryInput>>;
  OR?: InputMaybe<Array<LocationQueryInput>>;
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  _id_gt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_gte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  _id_lt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_lte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_ne?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  assets?: InputMaybe<Array<InputMaybe<Media_AssetQueryInput>>>;
  assets_exists?: InputMaybe<Scalars['Boolean']['input']>;
  assets_in?: InputMaybe<Array<InputMaybe<Media_AssetQueryInput>>>;
  assets_nin?: InputMaybe<Array<InputMaybe<Media_AssetQueryInput>>>;
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attributes_exists?: InputMaybe<Scalars['Boolean']['input']>;
  attributes_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attributes_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_gt?: InputMaybe<Scalars['String']['input']>;
  description_gte?: InputMaybe<Scalars['String']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_lt?: InputMaybe<Scalars['String']['input']>;
  description_lte?: InputMaybe<Scalars['String']['input']>;
  description_ne?: InputMaybe<Scalars['String']['input']>;
  description_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  maps?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  maps_exists?: InputMaybe<Scalars['Boolean']['input']>;
  maps_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  maps_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  owner?: InputMaybe<UserQueryInput>;
  owner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  rooms?: InputMaybe<Array<InputMaybe<RoomQueryInput>>>;
  rooms_exists?: InputMaybe<Scalars['Boolean']['input']>;
  rooms_in?: InputMaybe<Array<InputMaybe<RoomQueryInput>>>;
  rooms_nin?: InputMaybe<Array<InputMaybe<RoomQueryInput>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tags_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_gt?: InputMaybe<Scalars['String']['input']>;
  title_gte?: InputMaybe<Scalars['String']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_lt?: InputMaybe<Scalars['String']['input']>;
  title_lte?: InputMaybe<Scalars['String']['input']>;
  title_ne?: InputMaybe<Scalars['String']['input']>;
  title_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type_gt?: InputMaybe<Scalars['String']['input']>;
  type_gte?: InputMaybe<Scalars['String']['input']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_lt?: InputMaybe<Scalars['String']['input']>;
  type_lte?: InputMaybe<Scalars['String']['input']>;
  type_ne?: InputMaybe<Scalars['String']['input']>;
  type_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  visibility?: InputMaybe<Scalars['String']['input']>;
  visibility_exists?: InputMaybe<Scalars['Boolean']['input']>;
  visibility_gt?: InputMaybe<Scalars['String']['input']>;
  visibility_gte?: InputMaybe<Scalars['String']['input']>;
  visibility_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  visibility_lt?: InputMaybe<Scalars['String']['input']>;
  visibility_lte?: InputMaybe<Scalars['String']['input']>;
  visibility_ne?: InputMaybe<Scalars['String']['input']>;
  visibility_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum LocationSortByInput {
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  OwnerAsc = 'OWNER_ASC',
  OwnerDesc = 'OWNER_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  VisibilityAsc = 'VISIBILITY_ASC',
  VisibilityDesc = 'VISIBILITY_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type LocationUpdateInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  assets?: InputMaybe<LocationAssetsRelationInput>;
  assets_unset?: InputMaybe<Scalars['Boolean']['input']>;
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attributes_unset?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_unset?: InputMaybe<Scalars['Boolean']['input']>;
  maps?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  maps_unset?: InputMaybe<Scalars['Boolean']['input']>;
  owner?: InputMaybe<LocationOwnerRelationInput>;
  owner_unset?: InputMaybe<Scalars['Boolean']['input']>;
  rooms?: InputMaybe<Array<InputMaybe<RoomUpdateInput>>>;
  rooms_unset?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_unset?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_unset?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_unset?: InputMaybe<Scalars['Boolean']['input']>;
  visibility?: InputMaybe<Scalars['String']['input']>;
  visibility_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Map = {
  __typename?: 'Map';
  _id: Scalars['ObjectId']['output'];
  assets?: Maybe<Array<Maybe<Media_Asset>>>;
  calendar_used?: Maybe<Campaign_Calendar>;
  description?: Maybe<Scalars['String']['output']>;
  locations?: Maybe<Array<Maybe<Location>>>;
  name: Scalars['String']['output'];
  owner: User;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type MapAssetsRelationInput = {
  create?: InputMaybe<Array<InputMaybe<Media_AssetInsertInput>>>;
  link?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
};

export type MapCalendar_UsedRelationInput = {
  create?: InputMaybe<Campaign_CalendarInsertInput>;
  link?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type MapInsertInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  assets?: InputMaybe<MapAssetsRelationInput>;
  calendar_used?: InputMaybe<MapCalendar_UsedRelationInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  locations?: InputMaybe<MapLocationsRelationInput>;
  name: Scalars['String']['input'];
  owner: MapOwnerRelationInput;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MapLocationsRelationInput = {
  create?: InputMaybe<Array<InputMaybe<LocationInsertInput>>>;
  link?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
};

export type MapOwnerRelationInput = {
  create?: InputMaybe<UserInsertInput>;
  link?: InputMaybe<Scalars['String']['input']>;
};

export type MapQueryInput = {
  AND?: InputMaybe<Array<MapQueryInput>>;
  OR?: InputMaybe<Array<MapQueryInput>>;
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  _id_gt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_gte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  _id_lt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_lte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_ne?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  assets?: InputMaybe<Array<InputMaybe<Media_AssetQueryInput>>>;
  assets_exists?: InputMaybe<Scalars['Boolean']['input']>;
  assets_in?: InputMaybe<Array<InputMaybe<Media_AssetQueryInput>>>;
  assets_nin?: InputMaybe<Array<InputMaybe<Media_AssetQueryInput>>>;
  calendar_used?: InputMaybe<Campaign_CalendarQueryInput>;
  calendar_used_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_gt?: InputMaybe<Scalars['String']['input']>;
  description_gte?: InputMaybe<Scalars['String']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_lt?: InputMaybe<Scalars['String']['input']>;
  description_lte?: InputMaybe<Scalars['String']['input']>;
  description_ne?: InputMaybe<Scalars['String']['input']>;
  description_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locations?: InputMaybe<Array<InputMaybe<LocationQueryInput>>>;
  locations_exists?: InputMaybe<Scalars['Boolean']['input']>;
  locations_in?: InputMaybe<Array<InputMaybe<LocationQueryInput>>>;
  locations_nin?: InputMaybe<Array<InputMaybe<LocationQueryInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  owner?: InputMaybe<UserQueryInput>;
  owner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tags_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum MapSortByInput {
  CalendarUsedAsc = 'CALENDAR_USED_ASC',
  CalendarUsedDesc = 'CALENDAR_USED_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  OwnerAsc = 'OWNER_ASC',
  OwnerDesc = 'OWNER_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type MapUpdateInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  assets?: InputMaybe<MapAssetsRelationInput>;
  assets_unset?: InputMaybe<Scalars['Boolean']['input']>;
  calendar_used?: InputMaybe<MapCalendar_UsedRelationInput>;
  calendar_used_unset?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_unset?: InputMaybe<Scalars['Boolean']['input']>;
  locations?: InputMaybe<MapLocationsRelationInput>;
  locations_unset?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_unset?: InputMaybe<Scalars['Boolean']['input']>;
  owner?: InputMaybe<MapOwnerRelationInput>;
  owner_unset?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Media_Asset = {
  __typename?: 'Media_asset';
  _id: Scalars['ObjectId']['output'];
  asset_category_type?: Maybe<Scalars['String']['output']>;
  asset_content_type: Scalars['String']['output'];
  asset_path?: Maybe<Scalars['String']['output']>;
  asset_url: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  owner: User;
  realm?: Maybe<Realm>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  thumbnail_path?: Maybe<Scalars['String']['output']>;
  thumbnail_url: Scalars['String']['output'];
};

export type Media_AssetInsertInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  asset_category_type?: InputMaybe<Scalars['String']['input']>;
  asset_content_type: Scalars['String']['input'];
  asset_path?: InputMaybe<Scalars['String']['input']>;
  asset_url: Scalars['String']['input'];
  created_at: Scalars['DateTime']['input'];
  name: Scalars['String']['input'];
  owner: Media_AssetOwnerRelationInput;
  realm?: InputMaybe<Media_AssetRealmRelationInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  thumbnail_path?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url: Scalars['String']['input'];
};

export type Media_AssetOwnerRelationInput = {
  create?: InputMaybe<UserInsertInput>;
  link?: InputMaybe<Scalars['String']['input']>;
};

export type Media_AssetQueryInput = {
  AND?: InputMaybe<Array<Media_AssetQueryInput>>;
  OR?: InputMaybe<Array<Media_AssetQueryInput>>;
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  _id_gt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_gte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  _id_lt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_lte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_ne?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  asset_category_type?: InputMaybe<Scalars['String']['input']>;
  asset_category_type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  asset_category_type_gt?: InputMaybe<Scalars['String']['input']>;
  asset_category_type_gte?: InputMaybe<Scalars['String']['input']>;
  asset_category_type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  asset_category_type_lt?: InputMaybe<Scalars['String']['input']>;
  asset_category_type_lte?: InputMaybe<Scalars['String']['input']>;
  asset_category_type_ne?: InputMaybe<Scalars['String']['input']>;
  asset_category_type_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  asset_content_type?: InputMaybe<Scalars['String']['input']>;
  asset_content_type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  asset_content_type_gt?: InputMaybe<Scalars['String']['input']>;
  asset_content_type_gte?: InputMaybe<Scalars['String']['input']>;
  asset_content_type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  asset_content_type_lt?: InputMaybe<Scalars['String']['input']>;
  asset_content_type_lte?: InputMaybe<Scalars['String']['input']>;
  asset_content_type_ne?: InputMaybe<Scalars['String']['input']>;
  asset_content_type_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  asset_path?: InputMaybe<Scalars['String']['input']>;
  asset_path_exists?: InputMaybe<Scalars['Boolean']['input']>;
  asset_path_gt?: InputMaybe<Scalars['String']['input']>;
  asset_path_gte?: InputMaybe<Scalars['String']['input']>;
  asset_path_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  asset_path_lt?: InputMaybe<Scalars['String']['input']>;
  asset_path_lte?: InputMaybe<Scalars['String']['input']>;
  asset_path_ne?: InputMaybe<Scalars['String']['input']>;
  asset_path_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  asset_url?: InputMaybe<Scalars['String']['input']>;
  asset_url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  asset_url_gt?: InputMaybe<Scalars['String']['input']>;
  asset_url_gte?: InputMaybe<Scalars['String']['input']>;
  asset_url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  asset_url_lt?: InputMaybe<Scalars['String']['input']>;
  asset_url_lte?: InputMaybe<Scalars['String']['input']>;
  asset_url_ne?: InputMaybe<Scalars['String']['input']>;
  asset_url_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_exists?: InputMaybe<Scalars['Boolean']['input']>;
  created_at_gt?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_gte?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  created_at_lt?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_lte?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_ne?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  owner?: InputMaybe<UserQueryInput>;
  owner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  realm?: InputMaybe<RealmQueryInput>;
  realm_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tags_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  thumbnail_path?: InputMaybe<Scalars['String']['input']>;
  thumbnail_path_exists?: InputMaybe<Scalars['Boolean']['input']>;
  thumbnail_path_gt?: InputMaybe<Scalars['String']['input']>;
  thumbnail_path_gte?: InputMaybe<Scalars['String']['input']>;
  thumbnail_path_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  thumbnail_path_lt?: InputMaybe<Scalars['String']['input']>;
  thumbnail_path_lte?: InputMaybe<Scalars['String']['input']>;
  thumbnail_path_ne?: InputMaybe<Scalars['String']['input']>;
  thumbnail_path_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  thumbnail_url?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  thumbnail_url_gt?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url_gte?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  thumbnail_url_lt?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url_lte?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url_ne?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Media_AssetRealmRelationInput = {
  create?: InputMaybe<RealmInsertInput>;
  link?: InputMaybe<Scalars['ObjectId']['input']>;
};

export enum Media_AssetSortByInput {
  AssetCategoryTypeAsc = 'ASSET_CATEGORY_TYPE_ASC',
  AssetCategoryTypeDesc = 'ASSET_CATEGORY_TYPE_DESC',
  AssetContentTypeAsc = 'ASSET_CONTENT_TYPE_ASC',
  AssetContentTypeDesc = 'ASSET_CONTENT_TYPE_DESC',
  AssetPathAsc = 'ASSET_PATH_ASC',
  AssetPathDesc = 'ASSET_PATH_DESC',
  AssetUrlAsc = 'ASSET_URL_ASC',
  AssetUrlDesc = 'ASSET_URL_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  OwnerAsc = 'OWNER_ASC',
  OwnerDesc = 'OWNER_DESC',
  RealmAsc = 'REALM_ASC',
  RealmDesc = 'REALM_DESC',
  ThumbnailPathAsc = 'THUMBNAIL_PATH_ASC',
  ThumbnailPathDesc = 'THUMBNAIL_PATH_DESC',
  ThumbnailUrlAsc = 'THUMBNAIL_URL_ASC',
  ThumbnailUrlDesc = 'THUMBNAIL_URL_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type Media_AssetUpdateInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  asset_category_type?: InputMaybe<Scalars['String']['input']>;
  asset_category_type_unset?: InputMaybe<Scalars['Boolean']['input']>;
  asset_content_type?: InputMaybe<Scalars['String']['input']>;
  asset_content_type_unset?: InputMaybe<Scalars['Boolean']['input']>;
  asset_path?: InputMaybe<Scalars['String']['input']>;
  asset_path_unset?: InputMaybe<Scalars['Boolean']['input']>;
  asset_url?: InputMaybe<Scalars['String']['input']>;
  asset_url_unset?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_unset?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_unset?: InputMaybe<Scalars['Boolean']['input']>;
  owner?: InputMaybe<Media_AssetOwnerRelationInput>;
  owner_unset?: InputMaybe<Scalars['Boolean']['input']>;
  realm?: InputMaybe<Media_AssetRealmRelationInput>;
  realm_unset?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_unset?: InputMaybe<Scalars['Boolean']['input']>;
  thumbnail_path?: InputMaybe<Scalars['String']['input']>;
  thumbnail_path_unset?: InputMaybe<Scalars['Boolean']['input']>;
  thumbnail_url?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  deleteManyAlignments?: Maybe<DeleteManyPayload>;
  deleteManyArchetypes?: Maybe<DeleteManyPayload>;
  deleteManyBody_shapes?: Maybe<DeleteManyPayload>;
  deleteManyCampaign_acts?: Maybe<DeleteManyPayload>;
  deleteManyCampaign_calendars?: Maybe<DeleteManyPayload>;
  deleteManyCampaign_events?: Maybe<DeleteManyPayload>;
  deleteManyCampaign_quests?: Maybe<DeleteManyPayload>;
  deleteManyCampaigns?: Maybe<DeleteManyPayload>;
  deleteManyCanvases?: Maybe<DeleteManyPayload>;
  deleteManyCharacter_content_packs?: Maybe<DeleteManyPayload>;
  deleteManyCharacter_heights?: Maybe<DeleteManyPayload>;
  deleteManyCharacter_notes?: Maybe<DeleteManyPayload>;
  deleteManyCharacter_sets?: Maybe<DeleteManyPayload>;
  deleteManyCharacter_types?: Maybe<DeleteManyPayload>;
  deleteManyCharacters?: Maybe<DeleteManyPayload>;
  deleteManyClasses?: Maybe<DeleteManyPayload>;
  deleteManyContainers?: Maybe<DeleteManyPayload>;
  deleteManyEyes?: Maybe<DeleteManyPayload>;
  deleteManyGenders?: Maybe<DeleteManyPayload>;
  deleteManyHairs?: Maybe<DeleteManyPayload>;
  deleteManyImage_generation_skus?: Maybe<DeleteManyPayload>;
  deleteManyImage_generation_styles?: Maybe<DeleteManyPayload>;
  deleteManyImage_masks?: Maybe<DeleteManyPayload>;
  deleteManyImage_prompt_templates?: Maybe<DeleteManyPayload>;
  deleteManyLibrary_content_packs?: Maybe<DeleteManyPayload>;
  deleteManyLocations?: Maybe<DeleteManyPayload>;
  deleteManyMaps?: Maybe<DeleteManyPayload>;
  deleteManyMedia_assets?: Maybe<DeleteManyPayload>;
  deleteManyNotes?: Maybe<DeleteManyPayload>;
  deleteManyPersonalities?: Maybe<DeleteManyPayload>;
  deleteManyProfessions?: Maybe<DeleteManyPayload>;
  deleteManyPrompt_templates?: Maybe<DeleteManyPayload>;
  deleteManyPronouns?: Maybe<DeleteManyPayload>;
  deleteManyRaces?: Maybe<DeleteManyPayload>;
  deleteManyRealm_templates?: Maybe<DeleteManyPayload>;
  deleteManyRealms?: Maybe<DeleteManyPayload>;
  deleteManyRelationship_statuses?: Maybe<DeleteManyPayload>;
  deleteManySkins?: Maybe<DeleteManyPayload>;
  deleteManyStripe_customers?: Maybe<DeleteManyPayload>;
  deleteManySubscription_tiers?: Maybe<DeleteManyPayload>;
  deleteManyText_generation_skus?: Maybe<DeleteManyPayload>;
  deleteManyThemes?: Maybe<DeleteManyPayload>;
  deleteManyToken_sets?: Maybe<DeleteManyPayload>;
  deleteManyTokens?: Maybe<DeleteManyPayload>;
  deleteManyUser_character_content_pack_purchases?: Maybe<DeleteManyPayload>;
  deleteManyUser_character_generations?: Maybe<DeleteManyPayload>;
  deleteManyUser_image_generations?: Maybe<DeleteManyPayload>;
  deleteManyUser_invoices?: Maybe<DeleteManyPayload>;
  deleteManyUser_library_content_pack_favorites?: Maybe<DeleteManyPayload>;
  deleteManyUser_library_image_uploads?: Maybe<DeleteManyPayload>;
  deleteManyUser_library_purchases?: Maybe<DeleteManyPayload>;
  deleteManyUser_realm_counts?: Maybe<DeleteManyPayload>;
  deleteManyUser_realms_counts?: Maybe<DeleteManyPayload>;
  deleteManyUser_text_generations?: Maybe<DeleteManyPayload>;
  deleteManyUsers?: Maybe<DeleteManyPayload>;
  deleteManyWeapons?: Maybe<DeleteManyPayload>;
  deleteManyWidgets?: Maybe<DeleteManyPayload>;
  deleteOneAlignment?: Maybe<Alignment>;
  deleteOneArchetype?: Maybe<Archetype>;
  deleteOneBody_shape?: Maybe<Body_Shape>;
  deleteOneCampaign?: Maybe<Campaign>;
  deleteOneCampaign_act?: Maybe<Campaign_Act>;
  deleteOneCampaign_calendar?: Maybe<Campaign_Calendar>;
  deleteOneCampaign_event?: Maybe<Campaign_Event>;
  deleteOneCampaign_quest?: Maybe<Campaign_Quest>;
  deleteOneCanvase?: Maybe<Canvase>;
  deleteOneCharacter?: Maybe<Character>;
  deleteOneCharacter_content_pack?: Maybe<Character_Content_Pack>;
  deleteOneCharacter_height?: Maybe<Character_Height>;
  deleteOneCharacter_note?: Maybe<Character_Note>;
  deleteOneCharacter_set?: Maybe<Character_Set>;
  deleteOneCharacter_type?: Maybe<Character_Type>;
  deleteOneClass?: Maybe<Class>;
  deleteOneContainer?: Maybe<Container>;
  deleteOneEye?: Maybe<Eye>;
  deleteOneGender?: Maybe<Gender>;
  deleteOneHair?: Maybe<Hair>;
  deleteOneImage_generation_sku?: Maybe<Image_Generation_Sku>;
  deleteOneImage_generation_style?: Maybe<Image_Generation_Style>;
  deleteOneImage_mask?: Maybe<Image_Mask>;
  deleteOneImage_prompt_template?: Maybe<Image_Prompt_Template>;
  deleteOneLibrary_content_pack?: Maybe<Library_Content_Pack>;
  deleteOneLocation?: Maybe<Location>;
  deleteOneMap?: Maybe<Map>;
  deleteOneMedia_asset?: Maybe<Media_Asset>;
  deleteOneNote?: Maybe<Note>;
  deleteOnePersonality?: Maybe<Personality>;
  deleteOneProfession?: Maybe<Profession>;
  deleteOnePrompt_template?: Maybe<Prompt_Template>;
  deleteOnePronoun?: Maybe<Pronoun>;
  deleteOneRace?: Maybe<Race>;
  deleteOneRealm?: Maybe<Realm>;
  deleteOneRealm_template?: Maybe<Realm_Template>;
  deleteOneRelationship_status?: Maybe<Relationship_Status>;
  deleteOneSkin?: Maybe<Skin>;
  deleteOneStripe_customer?: Maybe<Stripe_Customer>;
  deleteOneSubscription_tier?: Maybe<Subscription_Tier>;
  deleteOneText_generation_sku?: Maybe<Text_Generation_Sku>;
  deleteOneTheme?: Maybe<Theme>;
  deleteOneToken?: Maybe<Token>;
  deleteOneToken_set?: Maybe<Token_Set>;
  deleteOneUser?: Maybe<User>;
  deleteOneUser_character_content_pack_purchase?: Maybe<User_Character_Content_Pack_Purchase>;
  deleteOneUser_character_generation?: Maybe<User_Character_Generation>;
  deleteOneUser_image_generation?: Maybe<User_Image_Generation>;
  deleteOneUser_invoice?: Maybe<User_Invoice>;
  deleteOneUser_library_content_pack_favorite?: Maybe<User_Library_Content_Pack_Favorite>;
  deleteOneUser_library_image_upload?: Maybe<User_Library_Image_Upload>;
  deleteOneUser_library_purchase?: Maybe<User_Library_Purchase>;
  deleteOneUser_realm_count?: Maybe<User_Realm_Count>;
  deleteOneUser_realms_count?: Maybe<User_Realms_Count>;
  deleteOneUser_text_generation?: Maybe<User_Text_Generation>;
  deleteOneWeapon?: Maybe<Weapon>;
  deleteOneWidget?: Maybe<Widget>;
  insertManyAlignments?: Maybe<InsertManyPayload>;
  insertManyArchetypes?: Maybe<InsertManyPayload>;
  insertManyBody_shapes?: Maybe<InsertManyPayload>;
  insertManyCampaign_acts?: Maybe<InsertManyPayload>;
  insertManyCampaign_calendars?: Maybe<InsertManyPayload>;
  insertManyCampaign_events?: Maybe<InsertManyPayload>;
  insertManyCampaign_quests?: Maybe<InsertManyPayload>;
  insertManyCampaigns?: Maybe<InsertManyPayload>;
  insertManyCanvases?: Maybe<InsertManyPayload>;
  insertManyCharacter_content_packs?: Maybe<InsertManyPayload>;
  insertManyCharacter_heights?: Maybe<InsertManyPayload>;
  insertManyCharacter_notes?: Maybe<InsertManyPayload>;
  insertManyCharacter_sets?: Maybe<InsertManyPayload>;
  insertManyCharacter_types?: Maybe<InsertManyPayload>;
  insertManyCharacters?: Maybe<InsertManyPayload>;
  insertManyClasses?: Maybe<InsertManyPayload>;
  insertManyContainers?: Maybe<InsertManyPayload>;
  insertManyEyes?: Maybe<InsertManyPayload>;
  insertManyGenders?: Maybe<InsertManyPayload>;
  insertManyHairs?: Maybe<InsertManyPayload>;
  insertManyImage_generation_skus?: Maybe<InsertManyPayload>;
  insertManyImage_generation_styles?: Maybe<InsertManyPayload>;
  insertManyImage_masks?: Maybe<InsertManyPayload>;
  insertManyImage_prompt_templates?: Maybe<InsertManyPayload>;
  insertManyLibrary_content_packs?: Maybe<InsertManyPayload>;
  insertManyLocations?: Maybe<InsertManyPayload>;
  insertManyMaps?: Maybe<InsertManyPayload>;
  insertManyMedia_assets?: Maybe<InsertManyPayload>;
  insertManyNotes?: Maybe<InsertManyPayload>;
  insertManyPersonalities?: Maybe<InsertManyPayload>;
  insertManyProfessions?: Maybe<InsertManyPayload>;
  insertManyPrompt_templates?: Maybe<InsertManyPayload>;
  insertManyPronouns?: Maybe<InsertManyPayload>;
  insertManyRaces?: Maybe<InsertManyPayload>;
  insertManyRealm_templates?: Maybe<InsertManyPayload>;
  insertManyRealms?: Maybe<InsertManyPayload>;
  insertManyRelationship_statuses?: Maybe<InsertManyPayload>;
  insertManySkins?: Maybe<InsertManyPayload>;
  insertManyStripe_customers?: Maybe<InsertManyPayload>;
  insertManySubscription_tiers?: Maybe<InsertManyPayload>;
  insertManyText_generation_skus?: Maybe<InsertManyPayload>;
  insertManyThemes?: Maybe<InsertManyPayload>;
  insertManyToken_sets?: Maybe<InsertManyPayload>;
  insertManyTokens?: Maybe<InsertManyPayload>;
  insertManyUser_character_content_pack_purchases?: Maybe<InsertManyPayload>;
  insertManyUser_character_generations?: Maybe<InsertManyPayload>;
  insertManyUser_image_generations?: Maybe<InsertManyPayload>;
  insertManyUser_invoices?: Maybe<InsertManyPayload>;
  insertManyUser_library_content_pack_favorites?: Maybe<InsertManyPayload>;
  insertManyUser_library_image_uploads?: Maybe<InsertManyPayload>;
  insertManyUser_library_purchases?: Maybe<InsertManyPayload>;
  insertManyUser_realm_counts?: Maybe<InsertManyPayload>;
  insertManyUser_realms_counts?: Maybe<InsertManyPayload>;
  insertManyUser_text_generations?: Maybe<InsertManyPayload>;
  insertManyUsers?: Maybe<InsertManyPayload>;
  insertManyWeapons?: Maybe<InsertManyPayload>;
  insertManyWidgets?: Maybe<InsertManyPayload>;
  insertOneAlignment?: Maybe<Alignment>;
  insertOneArchetype?: Maybe<Archetype>;
  insertOneBody_shape?: Maybe<Body_Shape>;
  insertOneCampaign?: Maybe<Campaign>;
  insertOneCampaign_act?: Maybe<Campaign_Act>;
  insertOneCampaign_calendar?: Maybe<Campaign_Calendar>;
  insertOneCampaign_event?: Maybe<Campaign_Event>;
  insertOneCampaign_quest?: Maybe<Campaign_Quest>;
  insertOneCanvase?: Maybe<Canvase>;
  insertOneCharacter?: Maybe<Character>;
  insertOneCharacter_content_pack?: Maybe<Character_Content_Pack>;
  insertOneCharacter_height?: Maybe<Character_Height>;
  insertOneCharacter_note?: Maybe<Character_Note>;
  insertOneCharacter_set?: Maybe<Character_Set>;
  insertOneCharacter_type?: Maybe<Character_Type>;
  insertOneClass?: Maybe<Class>;
  insertOneContainer?: Maybe<Container>;
  insertOneEye?: Maybe<Eye>;
  insertOneGender?: Maybe<Gender>;
  insertOneHair?: Maybe<Hair>;
  insertOneImage_generation_sku?: Maybe<Image_Generation_Sku>;
  insertOneImage_generation_style?: Maybe<Image_Generation_Style>;
  insertOneImage_mask?: Maybe<Image_Mask>;
  insertOneImage_prompt_template?: Maybe<Image_Prompt_Template>;
  insertOneLibrary_content_pack?: Maybe<Library_Content_Pack>;
  insertOneLocation?: Maybe<Location>;
  insertOneMap?: Maybe<Map>;
  insertOneMedia_asset?: Maybe<Media_Asset>;
  insertOneNote?: Maybe<Note>;
  insertOnePersonality?: Maybe<Personality>;
  insertOneProfession?: Maybe<Profession>;
  insertOnePrompt_template?: Maybe<Prompt_Template>;
  insertOnePronoun?: Maybe<Pronoun>;
  insertOneRace?: Maybe<Race>;
  insertOneRealm?: Maybe<Realm>;
  insertOneRealm_template?: Maybe<Realm_Template>;
  insertOneRelationship_status?: Maybe<Relationship_Status>;
  insertOneSkin?: Maybe<Skin>;
  insertOneStripe_customer?: Maybe<Stripe_Customer>;
  insertOneSubscription_tier?: Maybe<Subscription_Tier>;
  insertOneText_generation_sku?: Maybe<Text_Generation_Sku>;
  insertOneTheme?: Maybe<Theme>;
  insertOneToken?: Maybe<Token>;
  insertOneToken_set?: Maybe<Token_Set>;
  insertOneUser?: Maybe<User>;
  insertOneUser_character_content_pack_purchase?: Maybe<User_Character_Content_Pack_Purchase>;
  insertOneUser_character_generation?: Maybe<User_Character_Generation>;
  insertOneUser_image_generation?: Maybe<User_Image_Generation>;
  insertOneUser_invoice?: Maybe<User_Invoice>;
  insertOneUser_library_content_pack_favorite?: Maybe<User_Library_Content_Pack_Favorite>;
  insertOneUser_library_image_upload?: Maybe<User_Library_Image_Upload>;
  insertOneUser_library_purchase?: Maybe<User_Library_Purchase>;
  insertOneUser_realm_count?: Maybe<User_Realm_Count>;
  insertOneUser_realms_count?: Maybe<User_Realms_Count>;
  insertOneUser_text_generation?: Maybe<User_Text_Generation>;
  insertOneWeapon?: Maybe<Weapon>;
  insertOneWidget?: Maybe<Widget>;
  replaceOneAlignment?: Maybe<Alignment>;
  replaceOneArchetype?: Maybe<Archetype>;
  replaceOneBody_shape?: Maybe<Body_Shape>;
  replaceOneCampaign?: Maybe<Campaign>;
  replaceOneCampaign_act?: Maybe<Campaign_Act>;
  replaceOneCampaign_calendar?: Maybe<Campaign_Calendar>;
  replaceOneCampaign_event?: Maybe<Campaign_Event>;
  replaceOneCampaign_quest?: Maybe<Campaign_Quest>;
  replaceOneCanvase?: Maybe<Canvase>;
  replaceOneCharacter?: Maybe<Character>;
  replaceOneCharacter_content_pack?: Maybe<Character_Content_Pack>;
  replaceOneCharacter_height?: Maybe<Character_Height>;
  replaceOneCharacter_note?: Maybe<Character_Note>;
  replaceOneCharacter_set?: Maybe<Character_Set>;
  replaceOneCharacter_type?: Maybe<Character_Type>;
  replaceOneClass?: Maybe<Class>;
  replaceOneContainer?: Maybe<Container>;
  replaceOneEye?: Maybe<Eye>;
  replaceOneGender?: Maybe<Gender>;
  replaceOneHair?: Maybe<Hair>;
  replaceOneImage_generation_sku?: Maybe<Image_Generation_Sku>;
  replaceOneImage_generation_style?: Maybe<Image_Generation_Style>;
  replaceOneImage_mask?: Maybe<Image_Mask>;
  replaceOneImage_prompt_template?: Maybe<Image_Prompt_Template>;
  replaceOneLibrary_content_pack?: Maybe<Library_Content_Pack>;
  replaceOneLocation?: Maybe<Location>;
  replaceOneMap?: Maybe<Map>;
  replaceOneMedia_asset?: Maybe<Media_Asset>;
  replaceOneNote?: Maybe<Note>;
  replaceOnePersonality?: Maybe<Personality>;
  replaceOneProfession?: Maybe<Profession>;
  replaceOnePrompt_template?: Maybe<Prompt_Template>;
  replaceOnePronoun?: Maybe<Pronoun>;
  replaceOneRace?: Maybe<Race>;
  replaceOneRealm?: Maybe<Realm>;
  replaceOneRealm_template?: Maybe<Realm_Template>;
  replaceOneRelationship_status?: Maybe<Relationship_Status>;
  replaceOneSkin?: Maybe<Skin>;
  replaceOneStripe_customer?: Maybe<Stripe_Customer>;
  replaceOneSubscription_tier?: Maybe<Subscription_Tier>;
  replaceOneText_generation_sku?: Maybe<Text_Generation_Sku>;
  replaceOneTheme?: Maybe<Theme>;
  replaceOneToken?: Maybe<Token>;
  replaceOneToken_set?: Maybe<Token_Set>;
  replaceOneUser?: Maybe<User>;
  replaceOneUser_character_content_pack_purchase?: Maybe<User_Character_Content_Pack_Purchase>;
  replaceOneUser_character_generation?: Maybe<User_Character_Generation>;
  replaceOneUser_image_generation?: Maybe<User_Image_Generation>;
  replaceOneUser_invoice?: Maybe<User_Invoice>;
  replaceOneUser_library_content_pack_favorite?: Maybe<User_Library_Content_Pack_Favorite>;
  replaceOneUser_library_image_upload?: Maybe<User_Library_Image_Upload>;
  replaceOneUser_library_purchase?: Maybe<User_Library_Purchase>;
  replaceOneUser_realm_count?: Maybe<User_Realm_Count>;
  replaceOneUser_realms_count?: Maybe<User_Realms_Count>;
  replaceOneUser_text_generation?: Maybe<User_Text_Generation>;
  replaceOneWeapon?: Maybe<Weapon>;
  replaceOneWidget?: Maybe<Widget>;
  updateManyAlignments?: Maybe<UpdateManyPayload>;
  updateManyArchetypes?: Maybe<UpdateManyPayload>;
  updateManyBody_shapes?: Maybe<UpdateManyPayload>;
  updateManyCampaign_acts?: Maybe<UpdateManyPayload>;
  updateManyCampaign_calendars?: Maybe<UpdateManyPayload>;
  updateManyCampaign_events?: Maybe<UpdateManyPayload>;
  updateManyCampaign_quests?: Maybe<UpdateManyPayload>;
  updateManyCampaigns?: Maybe<UpdateManyPayload>;
  updateManyCanvases?: Maybe<UpdateManyPayload>;
  updateManyCharacter_content_packs?: Maybe<UpdateManyPayload>;
  updateManyCharacter_heights?: Maybe<UpdateManyPayload>;
  updateManyCharacter_notes?: Maybe<UpdateManyPayload>;
  updateManyCharacter_sets?: Maybe<UpdateManyPayload>;
  updateManyCharacter_types?: Maybe<UpdateManyPayload>;
  updateManyCharacters?: Maybe<UpdateManyPayload>;
  updateManyClasses?: Maybe<UpdateManyPayload>;
  updateManyContainers?: Maybe<UpdateManyPayload>;
  updateManyEyes?: Maybe<UpdateManyPayload>;
  updateManyGenders?: Maybe<UpdateManyPayload>;
  updateManyHairs?: Maybe<UpdateManyPayload>;
  updateManyImage_generation_skus?: Maybe<UpdateManyPayload>;
  updateManyImage_generation_styles?: Maybe<UpdateManyPayload>;
  updateManyImage_masks?: Maybe<UpdateManyPayload>;
  updateManyImage_prompt_templates?: Maybe<UpdateManyPayload>;
  updateManyLibrary_content_packs?: Maybe<UpdateManyPayload>;
  updateManyLocations?: Maybe<UpdateManyPayload>;
  updateManyMaps?: Maybe<UpdateManyPayload>;
  updateManyMedia_assets?: Maybe<UpdateManyPayload>;
  updateManyNotes?: Maybe<UpdateManyPayload>;
  updateManyPersonalities?: Maybe<UpdateManyPayload>;
  updateManyProfessions?: Maybe<UpdateManyPayload>;
  updateManyPrompt_templates?: Maybe<UpdateManyPayload>;
  updateManyPronouns?: Maybe<UpdateManyPayload>;
  updateManyRaces?: Maybe<UpdateManyPayload>;
  updateManyRealm_templates?: Maybe<UpdateManyPayload>;
  updateManyRealms?: Maybe<UpdateManyPayload>;
  updateManyRelationship_statuses?: Maybe<UpdateManyPayload>;
  updateManySkins?: Maybe<UpdateManyPayload>;
  updateManyStripe_customers?: Maybe<UpdateManyPayload>;
  updateManySubscription_tiers?: Maybe<UpdateManyPayload>;
  updateManyText_generation_skus?: Maybe<UpdateManyPayload>;
  updateManyThemes?: Maybe<UpdateManyPayload>;
  updateManyToken_sets?: Maybe<UpdateManyPayload>;
  updateManyTokens?: Maybe<UpdateManyPayload>;
  updateManyUser_character_content_pack_purchases?: Maybe<UpdateManyPayload>;
  updateManyUser_character_generations?: Maybe<UpdateManyPayload>;
  updateManyUser_image_generations?: Maybe<UpdateManyPayload>;
  updateManyUser_invoices?: Maybe<UpdateManyPayload>;
  updateManyUser_library_content_pack_favorites?: Maybe<UpdateManyPayload>;
  updateManyUser_library_image_uploads?: Maybe<UpdateManyPayload>;
  updateManyUser_library_purchases?: Maybe<UpdateManyPayload>;
  updateManyUser_realm_counts?: Maybe<UpdateManyPayload>;
  updateManyUser_realms_counts?: Maybe<UpdateManyPayload>;
  updateManyUser_text_generations?: Maybe<UpdateManyPayload>;
  updateManyUsers?: Maybe<UpdateManyPayload>;
  updateManyWeapons?: Maybe<UpdateManyPayload>;
  updateManyWidgets?: Maybe<UpdateManyPayload>;
  updateOneAlignment?: Maybe<Alignment>;
  updateOneArchetype?: Maybe<Archetype>;
  updateOneBody_shape?: Maybe<Body_Shape>;
  updateOneCampaign?: Maybe<Campaign>;
  updateOneCampaign_act?: Maybe<Campaign_Act>;
  updateOneCampaign_calendar?: Maybe<Campaign_Calendar>;
  updateOneCampaign_event?: Maybe<Campaign_Event>;
  updateOneCampaign_quest?: Maybe<Campaign_Quest>;
  updateOneCanvase?: Maybe<Canvase>;
  updateOneCharacter?: Maybe<Character>;
  updateOneCharacter_content_pack?: Maybe<Character_Content_Pack>;
  updateOneCharacter_height?: Maybe<Character_Height>;
  updateOneCharacter_note?: Maybe<Character_Note>;
  updateOneCharacter_set?: Maybe<Character_Set>;
  updateOneCharacter_type?: Maybe<Character_Type>;
  updateOneClass?: Maybe<Class>;
  updateOneContainer?: Maybe<Container>;
  updateOneEye?: Maybe<Eye>;
  updateOneGender?: Maybe<Gender>;
  updateOneHair?: Maybe<Hair>;
  updateOneImage_generation_sku?: Maybe<Image_Generation_Sku>;
  updateOneImage_generation_style?: Maybe<Image_Generation_Style>;
  updateOneImage_mask?: Maybe<Image_Mask>;
  updateOneImage_prompt_template?: Maybe<Image_Prompt_Template>;
  updateOneLibrary_content_pack?: Maybe<Library_Content_Pack>;
  updateOneLocation?: Maybe<Location>;
  updateOneMap?: Maybe<Map>;
  updateOneMedia_asset?: Maybe<Media_Asset>;
  updateOneNote?: Maybe<Note>;
  updateOnePersonality?: Maybe<Personality>;
  updateOneProfession?: Maybe<Profession>;
  updateOnePrompt_template?: Maybe<Prompt_Template>;
  updateOnePronoun?: Maybe<Pronoun>;
  updateOneRace?: Maybe<Race>;
  updateOneRealm?: Maybe<Realm>;
  updateOneRealm_template?: Maybe<Realm_Template>;
  updateOneRelationship_status?: Maybe<Relationship_Status>;
  updateOneSkin?: Maybe<Skin>;
  updateOneStripe_customer?: Maybe<Stripe_Customer>;
  updateOneSubscription_tier?: Maybe<Subscription_Tier>;
  updateOneText_generation_sku?: Maybe<Text_Generation_Sku>;
  updateOneTheme?: Maybe<Theme>;
  updateOneToken?: Maybe<Token>;
  updateOneToken_set?: Maybe<Token_Set>;
  updateOneUser?: Maybe<User>;
  updateOneUser_character_content_pack_purchase?: Maybe<User_Character_Content_Pack_Purchase>;
  updateOneUser_character_generation?: Maybe<User_Character_Generation>;
  updateOneUser_image_generation?: Maybe<User_Image_Generation>;
  updateOneUser_invoice?: Maybe<User_Invoice>;
  updateOneUser_library_content_pack_favorite?: Maybe<User_Library_Content_Pack_Favorite>;
  updateOneUser_library_image_upload?: Maybe<User_Library_Image_Upload>;
  updateOneUser_library_purchase?: Maybe<User_Library_Purchase>;
  updateOneUser_realm_count?: Maybe<User_Realm_Count>;
  updateOneUser_realms_count?: Maybe<User_Realms_Count>;
  updateOneUser_text_generation?: Maybe<User_Text_Generation>;
  updateOneWeapon?: Maybe<Weapon>;
  updateOneWidget?: Maybe<Widget>;
  upsertOneAlignment?: Maybe<Alignment>;
  upsertOneArchetype?: Maybe<Archetype>;
  upsertOneBody_shape?: Maybe<Body_Shape>;
  upsertOneCampaign?: Maybe<Campaign>;
  upsertOneCampaign_act?: Maybe<Campaign_Act>;
  upsertOneCampaign_calendar?: Maybe<Campaign_Calendar>;
  upsertOneCampaign_event?: Maybe<Campaign_Event>;
  upsertOneCampaign_quest?: Maybe<Campaign_Quest>;
  upsertOneCanvase?: Maybe<Canvase>;
  upsertOneCharacter?: Maybe<Character>;
  upsertOneCharacter_content_pack?: Maybe<Character_Content_Pack>;
  upsertOneCharacter_height?: Maybe<Character_Height>;
  upsertOneCharacter_note?: Maybe<Character_Note>;
  upsertOneCharacter_set?: Maybe<Character_Set>;
  upsertOneCharacter_type?: Maybe<Character_Type>;
  upsertOneClass?: Maybe<Class>;
  upsertOneContainer?: Maybe<Container>;
  upsertOneEye?: Maybe<Eye>;
  upsertOneGender?: Maybe<Gender>;
  upsertOneHair?: Maybe<Hair>;
  upsertOneImage_generation_sku?: Maybe<Image_Generation_Sku>;
  upsertOneImage_generation_style?: Maybe<Image_Generation_Style>;
  upsertOneImage_mask?: Maybe<Image_Mask>;
  upsertOneImage_prompt_template?: Maybe<Image_Prompt_Template>;
  upsertOneLibrary_content_pack?: Maybe<Library_Content_Pack>;
  upsertOneLocation?: Maybe<Location>;
  upsertOneMap?: Maybe<Map>;
  upsertOneMedia_asset?: Maybe<Media_Asset>;
  upsertOneNote?: Maybe<Note>;
  upsertOnePersonality?: Maybe<Personality>;
  upsertOneProfession?: Maybe<Profession>;
  upsertOnePrompt_template?: Maybe<Prompt_Template>;
  upsertOnePronoun?: Maybe<Pronoun>;
  upsertOneRace?: Maybe<Race>;
  upsertOneRealm?: Maybe<Realm>;
  upsertOneRealm_template?: Maybe<Realm_Template>;
  upsertOneRelationship_status?: Maybe<Relationship_Status>;
  upsertOneSkin?: Maybe<Skin>;
  upsertOneStripe_customer?: Maybe<Stripe_Customer>;
  upsertOneSubscription_tier?: Maybe<Subscription_Tier>;
  upsertOneText_generation_sku?: Maybe<Text_Generation_Sku>;
  upsertOneTheme?: Maybe<Theme>;
  upsertOneToken?: Maybe<Token>;
  upsertOneToken_set?: Maybe<Token_Set>;
  upsertOneUser?: Maybe<User>;
  upsertOneUser_character_content_pack_purchase?: Maybe<User_Character_Content_Pack_Purchase>;
  upsertOneUser_character_generation?: Maybe<User_Character_Generation>;
  upsertOneUser_image_generation?: Maybe<User_Image_Generation>;
  upsertOneUser_invoice?: Maybe<User_Invoice>;
  upsertOneUser_library_content_pack_favorite?: Maybe<User_Library_Content_Pack_Favorite>;
  upsertOneUser_library_image_upload?: Maybe<User_Library_Image_Upload>;
  upsertOneUser_library_purchase?: Maybe<User_Library_Purchase>;
  upsertOneUser_realm_count?: Maybe<User_Realm_Count>;
  upsertOneUser_realms_count?: Maybe<User_Realms_Count>;
  upsertOneUser_text_generation?: Maybe<User_Text_Generation>;
  upsertOneWeapon?: Maybe<Weapon>;
  upsertOneWidget?: Maybe<Widget>;
};


export type MutationDeleteManyAlignmentsArgs = {
  query?: InputMaybe<AlignmentQueryInput>;
};


export type MutationDeleteManyArchetypesArgs = {
  query?: InputMaybe<ArchetypeQueryInput>;
};


export type MutationDeleteManyBody_ShapesArgs = {
  query?: InputMaybe<Body_ShapeQueryInput>;
};


export type MutationDeleteManyCampaign_ActsArgs = {
  query?: InputMaybe<Campaign_ActQueryInput>;
};


export type MutationDeleteManyCampaign_CalendarsArgs = {
  query?: InputMaybe<Campaign_CalendarQueryInput>;
};


export type MutationDeleteManyCampaign_EventsArgs = {
  query?: InputMaybe<Campaign_EventQueryInput>;
};


export type MutationDeleteManyCampaign_QuestsArgs = {
  query?: InputMaybe<Campaign_QuestQueryInput>;
};


export type MutationDeleteManyCampaignsArgs = {
  query?: InputMaybe<CampaignQueryInput>;
};


export type MutationDeleteManyCanvasesArgs = {
  query?: InputMaybe<CanvaseQueryInput>;
};


export type MutationDeleteManyCharacter_Content_PacksArgs = {
  query?: InputMaybe<Character_Content_PackQueryInput>;
};


export type MutationDeleteManyCharacter_HeightsArgs = {
  query?: InputMaybe<Character_HeightQueryInput>;
};


export type MutationDeleteManyCharacter_NotesArgs = {
  query?: InputMaybe<Character_NoteQueryInput>;
};


export type MutationDeleteManyCharacter_SetsArgs = {
  query?: InputMaybe<Character_SetQueryInput>;
};


export type MutationDeleteManyCharacter_TypesArgs = {
  query?: InputMaybe<Character_TypeQueryInput>;
};


export type MutationDeleteManyCharactersArgs = {
  query?: InputMaybe<CharacterQueryInput>;
};


export type MutationDeleteManyClassesArgs = {
  query?: InputMaybe<ClassQueryInput>;
};


export type MutationDeleteManyContainersArgs = {
  query?: InputMaybe<ContainerQueryInput>;
};


export type MutationDeleteManyEyesArgs = {
  query?: InputMaybe<EyeQueryInput>;
};


export type MutationDeleteManyGendersArgs = {
  query?: InputMaybe<GenderQueryInput>;
};


export type MutationDeleteManyHairsArgs = {
  query?: InputMaybe<HairQueryInput>;
};


export type MutationDeleteManyImage_Generation_SkusArgs = {
  query?: InputMaybe<Image_Generation_SkuQueryInput>;
};


export type MutationDeleteManyImage_Generation_StylesArgs = {
  query?: InputMaybe<Image_Generation_StyleQueryInput>;
};


export type MutationDeleteManyImage_MasksArgs = {
  query?: InputMaybe<Image_MaskQueryInput>;
};


export type MutationDeleteManyImage_Prompt_TemplatesArgs = {
  query?: InputMaybe<Image_Prompt_TemplateQueryInput>;
};


export type MutationDeleteManyLibrary_Content_PacksArgs = {
  query?: InputMaybe<Library_Content_PackQueryInput>;
};


export type MutationDeleteManyLocationsArgs = {
  query?: InputMaybe<LocationQueryInput>;
};


export type MutationDeleteManyMapsArgs = {
  query?: InputMaybe<MapQueryInput>;
};


export type MutationDeleteManyMedia_AssetsArgs = {
  query?: InputMaybe<Media_AssetQueryInput>;
};


export type MutationDeleteManyNotesArgs = {
  query?: InputMaybe<NoteQueryInput>;
};


export type MutationDeleteManyPersonalitiesArgs = {
  query?: InputMaybe<PersonalityQueryInput>;
};


export type MutationDeleteManyProfessionsArgs = {
  query?: InputMaybe<ProfessionQueryInput>;
};


export type MutationDeleteManyPrompt_TemplatesArgs = {
  query?: InputMaybe<Prompt_TemplateQueryInput>;
};


export type MutationDeleteManyPronounsArgs = {
  query?: InputMaybe<PronounQueryInput>;
};


export type MutationDeleteManyRacesArgs = {
  query?: InputMaybe<RaceQueryInput>;
};


export type MutationDeleteManyRealm_TemplatesArgs = {
  query?: InputMaybe<Realm_TemplateQueryInput>;
};


export type MutationDeleteManyRealmsArgs = {
  query?: InputMaybe<RealmQueryInput>;
};


export type MutationDeleteManyRelationship_StatusesArgs = {
  query?: InputMaybe<Relationship_StatusQueryInput>;
};


export type MutationDeleteManySkinsArgs = {
  query?: InputMaybe<SkinQueryInput>;
};


export type MutationDeleteManyStripe_CustomersArgs = {
  query?: InputMaybe<Stripe_CustomerQueryInput>;
};


export type MutationDeleteManySubscription_TiersArgs = {
  query?: InputMaybe<Subscription_TierQueryInput>;
};


export type MutationDeleteManyText_Generation_SkusArgs = {
  query?: InputMaybe<Text_Generation_SkuQueryInput>;
};


export type MutationDeleteManyThemesArgs = {
  query?: InputMaybe<ThemeQueryInput>;
};


export type MutationDeleteManyToken_SetsArgs = {
  query?: InputMaybe<Token_SetQueryInput>;
};


export type MutationDeleteManyTokensArgs = {
  query?: InputMaybe<TokenQueryInput>;
};


export type MutationDeleteManyUser_Character_Content_Pack_PurchasesArgs = {
  query?: InputMaybe<User_Character_Content_Pack_PurchaseQueryInput>;
};


export type MutationDeleteManyUser_Character_GenerationsArgs = {
  query?: InputMaybe<User_Character_GenerationQueryInput>;
};


export type MutationDeleteManyUser_Image_GenerationsArgs = {
  query?: InputMaybe<User_Image_GenerationQueryInput>;
};


export type MutationDeleteManyUser_InvoicesArgs = {
  query?: InputMaybe<User_InvoiceQueryInput>;
};


export type MutationDeleteManyUser_Library_Content_Pack_FavoritesArgs = {
  query?: InputMaybe<User_Library_Content_Pack_FavoriteQueryInput>;
};


export type MutationDeleteManyUser_Library_Image_UploadsArgs = {
  query?: InputMaybe<User_Library_Image_UploadQueryInput>;
};


export type MutationDeleteManyUser_Library_PurchasesArgs = {
  query?: InputMaybe<User_Library_PurchaseQueryInput>;
};


export type MutationDeleteManyUser_Realm_CountsArgs = {
  query?: InputMaybe<User_Realm_CountQueryInput>;
};


export type MutationDeleteManyUser_Realms_CountsArgs = {
  query?: InputMaybe<User_Realms_CountQueryInput>;
};


export type MutationDeleteManyUser_Text_GenerationsArgs = {
  query?: InputMaybe<User_Text_GenerationQueryInput>;
};


export type MutationDeleteManyUsersArgs = {
  query?: InputMaybe<UserQueryInput>;
};


export type MutationDeleteManyWeaponsArgs = {
  query?: InputMaybe<WeaponQueryInput>;
};


export type MutationDeleteManyWidgetsArgs = {
  query?: InputMaybe<WidgetQueryInput>;
};


export type MutationDeleteOneAlignmentArgs = {
  query: AlignmentQueryInput;
};


export type MutationDeleteOneArchetypeArgs = {
  query: ArchetypeQueryInput;
};


export type MutationDeleteOneBody_ShapeArgs = {
  query: Body_ShapeQueryInput;
};


export type MutationDeleteOneCampaignArgs = {
  query: CampaignQueryInput;
};


export type MutationDeleteOneCampaign_ActArgs = {
  query: Campaign_ActQueryInput;
};


export type MutationDeleteOneCampaign_CalendarArgs = {
  query: Campaign_CalendarQueryInput;
};


export type MutationDeleteOneCampaign_EventArgs = {
  query: Campaign_EventQueryInput;
};


export type MutationDeleteOneCampaign_QuestArgs = {
  query: Campaign_QuestQueryInput;
};


export type MutationDeleteOneCanvaseArgs = {
  query: CanvaseQueryInput;
};


export type MutationDeleteOneCharacterArgs = {
  query: CharacterQueryInput;
};


export type MutationDeleteOneCharacter_Content_PackArgs = {
  query: Character_Content_PackQueryInput;
};


export type MutationDeleteOneCharacter_HeightArgs = {
  query: Character_HeightQueryInput;
};


export type MutationDeleteOneCharacter_NoteArgs = {
  query: Character_NoteQueryInput;
};


export type MutationDeleteOneCharacter_SetArgs = {
  query: Character_SetQueryInput;
};


export type MutationDeleteOneCharacter_TypeArgs = {
  query: Character_TypeQueryInput;
};


export type MutationDeleteOneClassArgs = {
  query: ClassQueryInput;
};


export type MutationDeleteOneContainerArgs = {
  query: ContainerQueryInput;
};


export type MutationDeleteOneEyeArgs = {
  query: EyeQueryInput;
};


export type MutationDeleteOneGenderArgs = {
  query: GenderQueryInput;
};


export type MutationDeleteOneHairArgs = {
  query: HairQueryInput;
};


export type MutationDeleteOneImage_Generation_SkuArgs = {
  query: Image_Generation_SkuQueryInput;
};


export type MutationDeleteOneImage_Generation_StyleArgs = {
  query: Image_Generation_StyleQueryInput;
};


export type MutationDeleteOneImage_MaskArgs = {
  query: Image_MaskQueryInput;
};


export type MutationDeleteOneImage_Prompt_TemplateArgs = {
  query: Image_Prompt_TemplateQueryInput;
};


export type MutationDeleteOneLibrary_Content_PackArgs = {
  query: Library_Content_PackQueryInput;
};


export type MutationDeleteOneLocationArgs = {
  query: LocationQueryInput;
};


export type MutationDeleteOneMapArgs = {
  query: MapQueryInput;
};


export type MutationDeleteOneMedia_AssetArgs = {
  query: Media_AssetQueryInput;
};


export type MutationDeleteOneNoteArgs = {
  query: NoteQueryInput;
};


export type MutationDeleteOnePersonalityArgs = {
  query: PersonalityQueryInput;
};


export type MutationDeleteOneProfessionArgs = {
  query: ProfessionQueryInput;
};


export type MutationDeleteOnePrompt_TemplateArgs = {
  query: Prompt_TemplateQueryInput;
};


export type MutationDeleteOnePronounArgs = {
  query: PronounQueryInput;
};


export type MutationDeleteOneRaceArgs = {
  query: RaceQueryInput;
};


export type MutationDeleteOneRealmArgs = {
  query: RealmQueryInput;
};


export type MutationDeleteOneRealm_TemplateArgs = {
  query: Realm_TemplateQueryInput;
};


export type MutationDeleteOneRelationship_StatusArgs = {
  query: Relationship_StatusQueryInput;
};


export type MutationDeleteOneSkinArgs = {
  query: SkinQueryInput;
};


export type MutationDeleteOneStripe_CustomerArgs = {
  query: Stripe_CustomerQueryInput;
};


export type MutationDeleteOneSubscription_TierArgs = {
  query: Subscription_TierQueryInput;
};


export type MutationDeleteOneText_Generation_SkuArgs = {
  query: Text_Generation_SkuQueryInput;
};


export type MutationDeleteOneThemeArgs = {
  query: ThemeQueryInput;
};


export type MutationDeleteOneTokenArgs = {
  query: TokenQueryInput;
};


export type MutationDeleteOneToken_SetArgs = {
  query: Token_SetQueryInput;
};


export type MutationDeleteOneUserArgs = {
  query: UserQueryInput;
};


export type MutationDeleteOneUser_Character_Content_Pack_PurchaseArgs = {
  query: User_Character_Content_Pack_PurchaseQueryInput;
};


export type MutationDeleteOneUser_Character_GenerationArgs = {
  query: User_Character_GenerationQueryInput;
};


export type MutationDeleteOneUser_Image_GenerationArgs = {
  query: User_Image_GenerationQueryInput;
};


export type MutationDeleteOneUser_InvoiceArgs = {
  query: User_InvoiceQueryInput;
};


export type MutationDeleteOneUser_Library_Content_Pack_FavoriteArgs = {
  query: User_Library_Content_Pack_FavoriteQueryInput;
};


export type MutationDeleteOneUser_Library_Image_UploadArgs = {
  query: User_Library_Image_UploadQueryInput;
};


export type MutationDeleteOneUser_Library_PurchaseArgs = {
  query: User_Library_PurchaseQueryInput;
};


export type MutationDeleteOneUser_Realm_CountArgs = {
  query: User_Realm_CountQueryInput;
};


export type MutationDeleteOneUser_Realms_CountArgs = {
  query: User_Realms_CountQueryInput;
};


export type MutationDeleteOneUser_Text_GenerationArgs = {
  query: User_Text_GenerationQueryInput;
};


export type MutationDeleteOneWeaponArgs = {
  query: WeaponQueryInput;
};


export type MutationDeleteOneWidgetArgs = {
  query: WidgetQueryInput;
};


export type MutationInsertManyAlignmentsArgs = {
  data: Array<AlignmentInsertInput>;
};


export type MutationInsertManyArchetypesArgs = {
  data: Array<ArchetypeInsertInput>;
};


export type MutationInsertManyBody_ShapesArgs = {
  data: Array<Body_ShapeInsertInput>;
};


export type MutationInsertManyCampaign_ActsArgs = {
  data: Array<Campaign_ActInsertInput>;
};


export type MutationInsertManyCampaign_CalendarsArgs = {
  data: Array<Campaign_CalendarInsertInput>;
};


export type MutationInsertManyCampaign_EventsArgs = {
  data: Array<Campaign_EventInsertInput>;
};


export type MutationInsertManyCampaign_QuestsArgs = {
  data: Array<Campaign_QuestInsertInput>;
};


export type MutationInsertManyCampaignsArgs = {
  data: Array<CampaignInsertInput>;
};


export type MutationInsertManyCanvasesArgs = {
  data: Array<CanvaseInsertInput>;
};


export type MutationInsertManyCharacter_Content_PacksArgs = {
  data: Array<Character_Content_PackInsertInput>;
};


export type MutationInsertManyCharacter_HeightsArgs = {
  data: Array<Character_HeightInsertInput>;
};


export type MutationInsertManyCharacter_NotesArgs = {
  data: Array<Character_NoteInsertInput>;
};


export type MutationInsertManyCharacter_SetsArgs = {
  data: Array<Character_SetInsertInput>;
};


export type MutationInsertManyCharacter_TypesArgs = {
  data: Array<Character_TypeInsertInput>;
};


export type MutationInsertManyCharactersArgs = {
  data: Array<CharacterInsertInput>;
};


export type MutationInsertManyClassesArgs = {
  data: Array<ClassInsertInput>;
};


export type MutationInsertManyContainersArgs = {
  data: Array<ContainerInsertInput>;
};


export type MutationInsertManyEyesArgs = {
  data: Array<EyeInsertInput>;
};


export type MutationInsertManyGendersArgs = {
  data: Array<GenderInsertInput>;
};


export type MutationInsertManyHairsArgs = {
  data: Array<HairInsertInput>;
};


export type MutationInsertManyImage_Generation_SkusArgs = {
  data: Array<Image_Generation_SkuInsertInput>;
};


export type MutationInsertManyImage_Generation_StylesArgs = {
  data: Array<Image_Generation_StyleInsertInput>;
};


export type MutationInsertManyImage_MasksArgs = {
  data: Array<Image_MaskInsertInput>;
};


export type MutationInsertManyImage_Prompt_TemplatesArgs = {
  data: Array<Image_Prompt_TemplateInsertInput>;
};


export type MutationInsertManyLibrary_Content_PacksArgs = {
  data: Array<Library_Content_PackInsertInput>;
};


export type MutationInsertManyLocationsArgs = {
  data: Array<LocationInsertInput>;
};


export type MutationInsertManyMapsArgs = {
  data: Array<MapInsertInput>;
};


export type MutationInsertManyMedia_AssetsArgs = {
  data: Array<Media_AssetInsertInput>;
};


export type MutationInsertManyNotesArgs = {
  data: Array<NoteInsertInput>;
};


export type MutationInsertManyPersonalitiesArgs = {
  data: Array<PersonalityInsertInput>;
};


export type MutationInsertManyProfessionsArgs = {
  data: Array<ProfessionInsertInput>;
};


export type MutationInsertManyPrompt_TemplatesArgs = {
  data: Array<Prompt_TemplateInsertInput>;
};


export type MutationInsertManyPronounsArgs = {
  data: Array<PronounInsertInput>;
};


export type MutationInsertManyRacesArgs = {
  data: Array<RaceInsertInput>;
};


export type MutationInsertManyRealm_TemplatesArgs = {
  data: Array<Realm_TemplateInsertInput>;
};


export type MutationInsertManyRealmsArgs = {
  data: Array<RealmInsertInput>;
};


export type MutationInsertManyRelationship_StatusesArgs = {
  data: Array<Relationship_StatusInsertInput>;
};


export type MutationInsertManySkinsArgs = {
  data: Array<SkinInsertInput>;
};


export type MutationInsertManyStripe_CustomersArgs = {
  data: Array<Stripe_CustomerInsertInput>;
};


export type MutationInsertManySubscription_TiersArgs = {
  data: Array<Subscription_TierInsertInput>;
};


export type MutationInsertManyText_Generation_SkusArgs = {
  data: Array<Text_Generation_SkuInsertInput>;
};


export type MutationInsertManyThemesArgs = {
  data: Array<ThemeInsertInput>;
};


export type MutationInsertManyToken_SetsArgs = {
  data: Array<Token_SetInsertInput>;
};


export type MutationInsertManyTokensArgs = {
  data: Array<TokenInsertInput>;
};


export type MutationInsertManyUser_Character_Content_Pack_PurchasesArgs = {
  data: Array<User_Character_Content_Pack_PurchaseInsertInput>;
};


export type MutationInsertManyUser_Character_GenerationsArgs = {
  data: Array<User_Character_GenerationInsertInput>;
};


export type MutationInsertManyUser_Image_GenerationsArgs = {
  data: Array<User_Image_GenerationInsertInput>;
};


export type MutationInsertManyUser_InvoicesArgs = {
  data: Array<User_InvoiceInsertInput>;
};


export type MutationInsertManyUser_Library_Content_Pack_FavoritesArgs = {
  data: Array<User_Library_Content_Pack_FavoriteInsertInput>;
};


export type MutationInsertManyUser_Library_Image_UploadsArgs = {
  data: Array<User_Library_Image_UploadInsertInput>;
};


export type MutationInsertManyUser_Library_PurchasesArgs = {
  data: Array<User_Library_PurchaseInsertInput>;
};


export type MutationInsertManyUser_Realm_CountsArgs = {
  data: Array<User_Realm_CountInsertInput>;
};


export type MutationInsertManyUser_Realms_CountsArgs = {
  data: Array<User_Realms_CountInsertInput>;
};


export type MutationInsertManyUser_Text_GenerationsArgs = {
  data: Array<User_Text_GenerationInsertInput>;
};


export type MutationInsertManyUsersArgs = {
  data: Array<UserInsertInput>;
};


export type MutationInsertManyWeaponsArgs = {
  data: Array<WeaponInsertInput>;
};


export type MutationInsertManyWidgetsArgs = {
  data: Array<WidgetInsertInput>;
};


export type MutationInsertOneAlignmentArgs = {
  data: AlignmentInsertInput;
};


export type MutationInsertOneArchetypeArgs = {
  data: ArchetypeInsertInput;
};


export type MutationInsertOneBody_ShapeArgs = {
  data: Body_ShapeInsertInput;
};


export type MutationInsertOneCampaignArgs = {
  data: CampaignInsertInput;
};


export type MutationInsertOneCampaign_ActArgs = {
  data: Campaign_ActInsertInput;
};


export type MutationInsertOneCampaign_CalendarArgs = {
  data: Campaign_CalendarInsertInput;
};


export type MutationInsertOneCampaign_EventArgs = {
  data: Campaign_EventInsertInput;
};


export type MutationInsertOneCampaign_QuestArgs = {
  data: Campaign_QuestInsertInput;
};


export type MutationInsertOneCanvaseArgs = {
  data: CanvaseInsertInput;
};


export type MutationInsertOneCharacterArgs = {
  data: CharacterInsertInput;
};


export type MutationInsertOneCharacter_Content_PackArgs = {
  data: Character_Content_PackInsertInput;
};


export type MutationInsertOneCharacter_HeightArgs = {
  data: Character_HeightInsertInput;
};


export type MutationInsertOneCharacter_NoteArgs = {
  data: Character_NoteInsertInput;
};


export type MutationInsertOneCharacter_SetArgs = {
  data: Character_SetInsertInput;
};


export type MutationInsertOneCharacter_TypeArgs = {
  data: Character_TypeInsertInput;
};


export type MutationInsertOneClassArgs = {
  data: ClassInsertInput;
};


export type MutationInsertOneContainerArgs = {
  data: ContainerInsertInput;
};


export type MutationInsertOneEyeArgs = {
  data: EyeInsertInput;
};


export type MutationInsertOneGenderArgs = {
  data: GenderInsertInput;
};


export type MutationInsertOneHairArgs = {
  data: HairInsertInput;
};


export type MutationInsertOneImage_Generation_SkuArgs = {
  data: Image_Generation_SkuInsertInput;
};


export type MutationInsertOneImage_Generation_StyleArgs = {
  data: Image_Generation_StyleInsertInput;
};


export type MutationInsertOneImage_MaskArgs = {
  data: Image_MaskInsertInput;
};


export type MutationInsertOneImage_Prompt_TemplateArgs = {
  data: Image_Prompt_TemplateInsertInput;
};


export type MutationInsertOneLibrary_Content_PackArgs = {
  data: Library_Content_PackInsertInput;
};


export type MutationInsertOneLocationArgs = {
  data: LocationInsertInput;
};


export type MutationInsertOneMapArgs = {
  data: MapInsertInput;
};


export type MutationInsertOneMedia_AssetArgs = {
  data: Media_AssetInsertInput;
};


export type MutationInsertOneNoteArgs = {
  data: NoteInsertInput;
};


export type MutationInsertOnePersonalityArgs = {
  data: PersonalityInsertInput;
};


export type MutationInsertOneProfessionArgs = {
  data: ProfessionInsertInput;
};


export type MutationInsertOnePrompt_TemplateArgs = {
  data: Prompt_TemplateInsertInput;
};


export type MutationInsertOnePronounArgs = {
  data: PronounInsertInput;
};


export type MutationInsertOneRaceArgs = {
  data: RaceInsertInput;
};


export type MutationInsertOneRealmArgs = {
  data: RealmInsertInput;
};


export type MutationInsertOneRealm_TemplateArgs = {
  data: Realm_TemplateInsertInput;
};


export type MutationInsertOneRelationship_StatusArgs = {
  data: Relationship_StatusInsertInput;
};


export type MutationInsertOneSkinArgs = {
  data: SkinInsertInput;
};


export type MutationInsertOneStripe_CustomerArgs = {
  data: Stripe_CustomerInsertInput;
};


export type MutationInsertOneSubscription_TierArgs = {
  data: Subscription_TierInsertInput;
};


export type MutationInsertOneText_Generation_SkuArgs = {
  data: Text_Generation_SkuInsertInput;
};


export type MutationInsertOneThemeArgs = {
  data: ThemeInsertInput;
};


export type MutationInsertOneTokenArgs = {
  data: TokenInsertInput;
};


export type MutationInsertOneToken_SetArgs = {
  data: Token_SetInsertInput;
};


export type MutationInsertOneUserArgs = {
  data: UserInsertInput;
};


export type MutationInsertOneUser_Character_Content_Pack_PurchaseArgs = {
  data: User_Character_Content_Pack_PurchaseInsertInput;
};


export type MutationInsertOneUser_Character_GenerationArgs = {
  data: User_Character_GenerationInsertInput;
};


export type MutationInsertOneUser_Image_GenerationArgs = {
  data: User_Image_GenerationInsertInput;
};


export type MutationInsertOneUser_InvoiceArgs = {
  data: User_InvoiceInsertInput;
};


export type MutationInsertOneUser_Library_Content_Pack_FavoriteArgs = {
  data: User_Library_Content_Pack_FavoriteInsertInput;
};


export type MutationInsertOneUser_Library_Image_UploadArgs = {
  data: User_Library_Image_UploadInsertInput;
};


export type MutationInsertOneUser_Library_PurchaseArgs = {
  data: User_Library_PurchaseInsertInput;
};


export type MutationInsertOneUser_Realm_CountArgs = {
  data: User_Realm_CountInsertInput;
};


export type MutationInsertOneUser_Realms_CountArgs = {
  data: User_Realms_CountInsertInput;
};


export type MutationInsertOneUser_Text_GenerationArgs = {
  data: User_Text_GenerationInsertInput;
};


export type MutationInsertOneWeaponArgs = {
  data: WeaponInsertInput;
};


export type MutationInsertOneWidgetArgs = {
  data: WidgetInsertInput;
};


export type MutationReplaceOneAlignmentArgs = {
  data: AlignmentInsertInput;
  query?: InputMaybe<AlignmentQueryInput>;
};


export type MutationReplaceOneArchetypeArgs = {
  data: ArchetypeInsertInput;
  query?: InputMaybe<ArchetypeQueryInput>;
};


export type MutationReplaceOneBody_ShapeArgs = {
  data: Body_ShapeInsertInput;
  query?: InputMaybe<Body_ShapeQueryInput>;
};


export type MutationReplaceOneCampaignArgs = {
  data: CampaignInsertInput;
  query?: InputMaybe<CampaignQueryInput>;
};


export type MutationReplaceOneCampaign_ActArgs = {
  data: Campaign_ActInsertInput;
  query?: InputMaybe<Campaign_ActQueryInput>;
};


export type MutationReplaceOneCampaign_CalendarArgs = {
  data: Campaign_CalendarInsertInput;
  query?: InputMaybe<Campaign_CalendarQueryInput>;
};


export type MutationReplaceOneCampaign_EventArgs = {
  data: Campaign_EventInsertInput;
  query?: InputMaybe<Campaign_EventQueryInput>;
};


export type MutationReplaceOneCampaign_QuestArgs = {
  data: Campaign_QuestInsertInput;
  query?: InputMaybe<Campaign_QuestQueryInput>;
};


export type MutationReplaceOneCanvaseArgs = {
  data: CanvaseInsertInput;
  query?: InputMaybe<CanvaseQueryInput>;
};


export type MutationReplaceOneCharacterArgs = {
  data: CharacterInsertInput;
  query?: InputMaybe<CharacterQueryInput>;
};


export type MutationReplaceOneCharacter_Content_PackArgs = {
  data: Character_Content_PackInsertInput;
  query?: InputMaybe<Character_Content_PackQueryInput>;
};


export type MutationReplaceOneCharacter_HeightArgs = {
  data: Character_HeightInsertInput;
  query?: InputMaybe<Character_HeightQueryInput>;
};


export type MutationReplaceOneCharacter_NoteArgs = {
  data: Character_NoteInsertInput;
  query?: InputMaybe<Character_NoteQueryInput>;
};


export type MutationReplaceOneCharacter_SetArgs = {
  data: Character_SetInsertInput;
  query?: InputMaybe<Character_SetQueryInput>;
};


export type MutationReplaceOneCharacter_TypeArgs = {
  data: Character_TypeInsertInput;
  query?: InputMaybe<Character_TypeQueryInput>;
};


export type MutationReplaceOneClassArgs = {
  data: ClassInsertInput;
  query?: InputMaybe<ClassQueryInput>;
};


export type MutationReplaceOneContainerArgs = {
  data: ContainerInsertInput;
  query?: InputMaybe<ContainerQueryInput>;
};


export type MutationReplaceOneEyeArgs = {
  data: EyeInsertInput;
  query?: InputMaybe<EyeQueryInput>;
};


export type MutationReplaceOneGenderArgs = {
  data: GenderInsertInput;
  query?: InputMaybe<GenderQueryInput>;
};


export type MutationReplaceOneHairArgs = {
  data: HairInsertInput;
  query?: InputMaybe<HairQueryInput>;
};


export type MutationReplaceOneImage_Generation_SkuArgs = {
  data: Image_Generation_SkuInsertInput;
  query?: InputMaybe<Image_Generation_SkuQueryInput>;
};


export type MutationReplaceOneImage_Generation_StyleArgs = {
  data: Image_Generation_StyleInsertInput;
  query?: InputMaybe<Image_Generation_StyleQueryInput>;
};


export type MutationReplaceOneImage_MaskArgs = {
  data: Image_MaskInsertInput;
  query?: InputMaybe<Image_MaskQueryInput>;
};


export type MutationReplaceOneImage_Prompt_TemplateArgs = {
  data: Image_Prompt_TemplateInsertInput;
  query?: InputMaybe<Image_Prompt_TemplateQueryInput>;
};


export type MutationReplaceOneLibrary_Content_PackArgs = {
  data: Library_Content_PackInsertInput;
  query?: InputMaybe<Library_Content_PackQueryInput>;
};


export type MutationReplaceOneLocationArgs = {
  data: LocationInsertInput;
  query?: InputMaybe<LocationQueryInput>;
};


export type MutationReplaceOneMapArgs = {
  data: MapInsertInput;
  query?: InputMaybe<MapQueryInput>;
};


export type MutationReplaceOneMedia_AssetArgs = {
  data: Media_AssetInsertInput;
  query?: InputMaybe<Media_AssetQueryInput>;
};


export type MutationReplaceOneNoteArgs = {
  data: NoteInsertInput;
  query?: InputMaybe<NoteQueryInput>;
};


export type MutationReplaceOnePersonalityArgs = {
  data: PersonalityInsertInput;
  query?: InputMaybe<PersonalityQueryInput>;
};


export type MutationReplaceOneProfessionArgs = {
  data: ProfessionInsertInput;
  query?: InputMaybe<ProfessionQueryInput>;
};


export type MutationReplaceOnePrompt_TemplateArgs = {
  data: Prompt_TemplateInsertInput;
  query?: InputMaybe<Prompt_TemplateQueryInput>;
};


export type MutationReplaceOnePronounArgs = {
  data: PronounInsertInput;
  query?: InputMaybe<PronounQueryInput>;
};


export type MutationReplaceOneRaceArgs = {
  data: RaceInsertInput;
  query?: InputMaybe<RaceQueryInput>;
};


export type MutationReplaceOneRealmArgs = {
  data: RealmInsertInput;
  query?: InputMaybe<RealmQueryInput>;
};


export type MutationReplaceOneRealm_TemplateArgs = {
  data: Realm_TemplateInsertInput;
  query?: InputMaybe<Realm_TemplateQueryInput>;
};


export type MutationReplaceOneRelationship_StatusArgs = {
  data: Relationship_StatusInsertInput;
  query?: InputMaybe<Relationship_StatusQueryInput>;
};


export type MutationReplaceOneSkinArgs = {
  data: SkinInsertInput;
  query?: InputMaybe<SkinQueryInput>;
};


export type MutationReplaceOneStripe_CustomerArgs = {
  data: Stripe_CustomerInsertInput;
  query?: InputMaybe<Stripe_CustomerQueryInput>;
};


export type MutationReplaceOneSubscription_TierArgs = {
  data: Subscription_TierInsertInput;
  query?: InputMaybe<Subscription_TierQueryInput>;
};


export type MutationReplaceOneText_Generation_SkuArgs = {
  data: Text_Generation_SkuInsertInput;
  query?: InputMaybe<Text_Generation_SkuQueryInput>;
};


export type MutationReplaceOneThemeArgs = {
  data: ThemeInsertInput;
  query?: InputMaybe<ThemeQueryInput>;
};


export type MutationReplaceOneTokenArgs = {
  data: TokenInsertInput;
  query?: InputMaybe<TokenQueryInput>;
};


export type MutationReplaceOneToken_SetArgs = {
  data: Token_SetInsertInput;
  query?: InputMaybe<Token_SetQueryInput>;
};


export type MutationReplaceOneUserArgs = {
  data: UserInsertInput;
  query?: InputMaybe<UserQueryInput>;
};


export type MutationReplaceOneUser_Character_Content_Pack_PurchaseArgs = {
  data: User_Character_Content_Pack_PurchaseInsertInput;
  query?: InputMaybe<User_Character_Content_Pack_PurchaseQueryInput>;
};


export type MutationReplaceOneUser_Character_GenerationArgs = {
  data: User_Character_GenerationInsertInput;
  query?: InputMaybe<User_Character_GenerationQueryInput>;
};


export type MutationReplaceOneUser_Image_GenerationArgs = {
  data: User_Image_GenerationInsertInput;
  query?: InputMaybe<User_Image_GenerationQueryInput>;
};


export type MutationReplaceOneUser_InvoiceArgs = {
  data: User_InvoiceInsertInput;
  query?: InputMaybe<User_InvoiceQueryInput>;
};


export type MutationReplaceOneUser_Library_Content_Pack_FavoriteArgs = {
  data: User_Library_Content_Pack_FavoriteInsertInput;
  query?: InputMaybe<User_Library_Content_Pack_FavoriteQueryInput>;
};


export type MutationReplaceOneUser_Library_Image_UploadArgs = {
  data: User_Library_Image_UploadInsertInput;
  query?: InputMaybe<User_Library_Image_UploadQueryInput>;
};


export type MutationReplaceOneUser_Library_PurchaseArgs = {
  data: User_Library_PurchaseInsertInput;
  query?: InputMaybe<User_Library_PurchaseQueryInput>;
};


export type MutationReplaceOneUser_Realm_CountArgs = {
  data: User_Realm_CountInsertInput;
  query?: InputMaybe<User_Realm_CountQueryInput>;
};


export type MutationReplaceOneUser_Realms_CountArgs = {
  data: User_Realms_CountInsertInput;
  query?: InputMaybe<User_Realms_CountQueryInput>;
};


export type MutationReplaceOneUser_Text_GenerationArgs = {
  data: User_Text_GenerationInsertInput;
  query?: InputMaybe<User_Text_GenerationQueryInput>;
};


export type MutationReplaceOneWeaponArgs = {
  data: WeaponInsertInput;
  query?: InputMaybe<WeaponQueryInput>;
};


export type MutationReplaceOneWidgetArgs = {
  data: WidgetInsertInput;
  query?: InputMaybe<WidgetQueryInput>;
};


export type MutationUpdateManyAlignmentsArgs = {
  query?: InputMaybe<AlignmentQueryInput>;
  set: AlignmentUpdateInput;
};


export type MutationUpdateManyArchetypesArgs = {
  query?: InputMaybe<ArchetypeQueryInput>;
  set: ArchetypeUpdateInput;
};


export type MutationUpdateManyBody_ShapesArgs = {
  query?: InputMaybe<Body_ShapeQueryInput>;
  set: Body_ShapeUpdateInput;
};


export type MutationUpdateManyCampaign_ActsArgs = {
  query?: InputMaybe<Campaign_ActQueryInput>;
  set: Campaign_ActUpdateInput;
};


export type MutationUpdateManyCampaign_CalendarsArgs = {
  query?: InputMaybe<Campaign_CalendarQueryInput>;
  set: Campaign_CalendarUpdateInput;
};


export type MutationUpdateManyCampaign_EventsArgs = {
  query?: InputMaybe<Campaign_EventQueryInput>;
  set: Campaign_EventUpdateInput;
};


export type MutationUpdateManyCampaign_QuestsArgs = {
  query?: InputMaybe<Campaign_QuestQueryInput>;
  set: Campaign_QuestUpdateInput;
};


export type MutationUpdateManyCampaignsArgs = {
  query?: InputMaybe<CampaignQueryInput>;
  set: CampaignUpdateInput;
};


export type MutationUpdateManyCanvasesArgs = {
  query?: InputMaybe<CanvaseQueryInput>;
  set: CanvaseUpdateInput;
};


export type MutationUpdateManyCharacter_Content_PacksArgs = {
  query?: InputMaybe<Character_Content_PackQueryInput>;
  set: Character_Content_PackUpdateInput;
};


export type MutationUpdateManyCharacter_HeightsArgs = {
  query?: InputMaybe<Character_HeightQueryInput>;
  set: Character_HeightUpdateInput;
};


export type MutationUpdateManyCharacter_NotesArgs = {
  query?: InputMaybe<Character_NoteQueryInput>;
  set: Character_NoteUpdateInput;
};


export type MutationUpdateManyCharacter_SetsArgs = {
  query?: InputMaybe<Character_SetQueryInput>;
  set: Character_SetUpdateInput;
};


export type MutationUpdateManyCharacter_TypesArgs = {
  query?: InputMaybe<Character_TypeQueryInput>;
  set: Character_TypeUpdateInput;
};


export type MutationUpdateManyCharactersArgs = {
  query?: InputMaybe<CharacterQueryInput>;
  set: CharacterUpdateInput;
};


export type MutationUpdateManyClassesArgs = {
  query?: InputMaybe<ClassQueryInput>;
  set: ClassUpdateInput;
};


export type MutationUpdateManyContainersArgs = {
  query?: InputMaybe<ContainerQueryInput>;
  set: ContainerUpdateInput;
};


export type MutationUpdateManyEyesArgs = {
  query?: InputMaybe<EyeQueryInput>;
  set: EyeUpdateInput;
};


export type MutationUpdateManyGendersArgs = {
  query?: InputMaybe<GenderQueryInput>;
  set: GenderUpdateInput;
};


export type MutationUpdateManyHairsArgs = {
  query?: InputMaybe<HairQueryInput>;
  set: HairUpdateInput;
};


export type MutationUpdateManyImage_Generation_SkusArgs = {
  query?: InputMaybe<Image_Generation_SkuQueryInput>;
  set: Image_Generation_SkuUpdateInput;
};


export type MutationUpdateManyImage_Generation_StylesArgs = {
  query?: InputMaybe<Image_Generation_StyleQueryInput>;
  set: Image_Generation_StyleUpdateInput;
};


export type MutationUpdateManyImage_MasksArgs = {
  query?: InputMaybe<Image_MaskQueryInput>;
  set: Image_MaskUpdateInput;
};


export type MutationUpdateManyImage_Prompt_TemplatesArgs = {
  query?: InputMaybe<Image_Prompt_TemplateQueryInput>;
  set: Image_Prompt_TemplateUpdateInput;
};


export type MutationUpdateManyLibrary_Content_PacksArgs = {
  query?: InputMaybe<Library_Content_PackQueryInput>;
  set: Library_Content_PackUpdateInput;
};


export type MutationUpdateManyLocationsArgs = {
  query?: InputMaybe<LocationQueryInput>;
  set: LocationUpdateInput;
};


export type MutationUpdateManyMapsArgs = {
  query?: InputMaybe<MapQueryInput>;
  set: MapUpdateInput;
};


export type MutationUpdateManyMedia_AssetsArgs = {
  query?: InputMaybe<Media_AssetQueryInput>;
  set: Media_AssetUpdateInput;
};


export type MutationUpdateManyNotesArgs = {
  query?: InputMaybe<NoteQueryInput>;
  set: NoteUpdateInput;
};


export type MutationUpdateManyPersonalitiesArgs = {
  query?: InputMaybe<PersonalityQueryInput>;
  set: PersonalityUpdateInput;
};


export type MutationUpdateManyProfessionsArgs = {
  query?: InputMaybe<ProfessionQueryInput>;
  set: ProfessionUpdateInput;
};


export type MutationUpdateManyPrompt_TemplatesArgs = {
  query?: InputMaybe<Prompt_TemplateQueryInput>;
  set: Prompt_TemplateUpdateInput;
};


export type MutationUpdateManyPronounsArgs = {
  query?: InputMaybe<PronounQueryInput>;
  set: PronounUpdateInput;
};


export type MutationUpdateManyRacesArgs = {
  query?: InputMaybe<RaceQueryInput>;
  set: RaceUpdateInput;
};


export type MutationUpdateManyRealm_TemplatesArgs = {
  query?: InputMaybe<Realm_TemplateQueryInput>;
  set: Realm_TemplateUpdateInput;
};


export type MutationUpdateManyRealmsArgs = {
  query?: InputMaybe<RealmQueryInput>;
  set: RealmUpdateInput;
};


export type MutationUpdateManyRelationship_StatusesArgs = {
  query?: InputMaybe<Relationship_StatusQueryInput>;
  set: Relationship_StatusUpdateInput;
};


export type MutationUpdateManySkinsArgs = {
  query?: InputMaybe<SkinQueryInput>;
  set: SkinUpdateInput;
};


export type MutationUpdateManyStripe_CustomersArgs = {
  query?: InputMaybe<Stripe_CustomerQueryInput>;
  set: Stripe_CustomerUpdateInput;
};


export type MutationUpdateManySubscription_TiersArgs = {
  query?: InputMaybe<Subscription_TierQueryInput>;
  set: Subscription_TierUpdateInput;
};


export type MutationUpdateManyText_Generation_SkusArgs = {
  query?: InputMaybe<Text_Generation_SkuQueryInput>;
  set: Text_Generation_SkuUpdateInput;
};


export type MutationUpdateManyThemesArgs = {
  query?: InputMaybe<ThemeQueryInput>;
  set: ThemeUpdateInput;
};


export type MutationUpdateManyToken_SetsArgs = {
  query?: InputMaybe<Token_SetQueryInput>;
  set: Token_SetUpdateInput;
};


export type MutationUpdateManyTokensArgs = {
  query?: InputMaybe<TokenQueryInput>;
  set: TokenUpdateInput;
};


export type MutationUpdateManyUser_Character_Content_Pack_PurchasesArgs = {
  query?: InputMaybe<User_Character_Content_Pack_PurchaseQueryInput>;
  set: User_Character_Content_Pack_PurchaseUpdateInput;
};


export type MutationUpdateManyUser_Character_GenerationsArgs = {
  query?: InputMaybe<User_Character_GenerationQueryInput>;
  set: User_Character_GenerationUpdateInput;
};


export type MutationUpdateManyUser_Image_GenerationsArgs = {
  query?: InputMaybe<User_Image_GenerationQueryInput>;
  set: User_Image_GenerationUpdateInput;
};


export type MutationUpdateManyUser_InvoicesArgs = {
  query?: InputMaybe<User_InvoiceQueryInput>;
  set: User_InvoiceUpdateInput;
};


export type MutationUpdateManyUser_Library_Content_Pack_FavoritesArgs = {
  query?: InputMaybe<User_Library_Content_Pack_FavoriteQueryInput>;
  set: User_Library_Content_Pack_FavoriteUpdateInput;
};


export type MutationUpdateManyUser_Library_Image_UploadsArgs = {
  query?: InputMaybe<User_Library_Image_UploadQueryInput>;
  set: User_Library_Image_UploadUpdateInput;
};


export type MutationUpdateManyUser_Library_PurchasesArgs = {
  query?: InputMaybe<User_Library_PurchaseQueryInput>;
  set: User_Library_PurchaseUpdateInput;
};


export type MutationUpdateManyUser_Realm_CountsArgs = {
  query?: InputMaybe<User_Realm_CountQueryInput>;
  set: User_Realm_CountUpdateInput;
};


export type MutationUpdateManyUser_Realms_CountsArgs = {
  query?: InputMaybe<User_Realms_CountQueryInput>;
  set: User_Realms_CountUpdateInput;
};


export type MutationUpdateManyUser_Text_GenerationsArgs = {
  query?: InputMaybe<User_Text_GenerationQueryInput>;
  set: User_Text_GenerationUpdateInput;
};


export type MutationUpdateManyUsersArgs = {
  query?: InputMaybe<UserQueryInput>;
  set: UserUpdateInput;
};


export type MutationUpdateManyWeaponsArgs = {
  query?: InputMaybe<WeaponQueryInput>;
  set: WeaponUpdateInput;
};


export type MutationUpdateManyWidgetsArgs = {
  query?: InputMaybe<WidgetQueryInput>;
  set: WidgetUpdateInput;
};


export type MutationUpdateOneAlignmentArgs = {
  query?: InputMaybe<AlignmentQueryInput>;
  set: AlignmentUpdateInput;
};


export type MutationUpdateOneArchetypeArgs = {
  query?: InputMaybe<ArchetypeQueryInput>;
  set: ArchetypeUpdateInput;
};


export type MutationUpdateOneBody_ShapeArgs = {
  query?: InputMaybe<Body_ShapeQueryInput>;
  set: Body_ShapeUpdateInput;
};


export type MutationUpdateOneCampaignArgs = {
  query?: InputMaybe<CampaignQueryInput>;
  set: CampaignUpdateInput;
};


export type MutationUpdateOneCampaign_ActArgs = {
  query?: InputMaybe<Campaign_ActQueryInput>;
  set: Campaign_ActUpdateInput;
};


export type MutationUpdateOneCampaign_CalendarArgs = {
  query?: InputMaybe<Campaign_CalendarQueryInput>;
  set: Campaign_CalendarUpdateInput;
};


export type MutationUpdateOneCampaign_EventArgs = {
  query?: InputMaybe<Campaign_EventQueryInput>;
  set: Campaign_EventUpdateInput;
};


export type MutationUpdateOneCampaign_QuestArgs = {
  query?: InputMaybe<Campaign_QuestQueryInput>;
  set: Campaign_QuestUpdateInput;
};


export type MutationUpdateOneCanvaseArgs = {
  query?: InputMaybe<CanvaseQueryInput>;
  set: CanvaseUpdateInput;
};


export type MutationUpdateOneCharacterArgs = {
  query?: InputMaybe<CharacterQueryInput>;
  set: CharacterUpdateInput;
};


export type MutationUpdateOneCharacter_Content_PackArgs = {
  query?: InputMaybe<Character_Content_PackQueryInput>;
  set: Character_Content_PackUpdateInput;
};


export type MutationUpdateOneCharacter_HeightArgs = {
  query?: InputMaybe<Character_HeightQueryInput>;
  set: Character_HeightUpdateInput;
};


export type MutationUpdateOneCharacter_NoteArgs = {
  query?: InputMaybe<Character_NoteQueryInput>;
  set: Character_NoteUpdateInput;
};


export type MutationUpdateOneCharacter_SetArgs = {
  query?: InputMaybe<Character_SetQueryInput>;
  set: Character_SetUpdateInput;
};


export type MutationUpdateOneCharacter_TypeArgs = {
  query?: InputMaybe<Character_TypeQueryInput>;
  set: Character_TypeUpdateInput;
};


export type MutationUpdateOneClassArgs = {
  query?: InputMaybe<ClassQueryInput>;
  set: ClassUpdateInput;
};


export type MutationUpdateOneContainerArgs = {
  query?: InputMaybe<ContainerQueryInput>;
  set: ContainerUpdateInput;
};


export type MutationUpdateOneEyeArgs = {
  query?: InputMaybe<EyeQueryInput>;
  set: EyeUpdateInput;
};


export type MutationUpdateOneGenderArgs = {
  query?: InputMaybe<GenderQueryInput>;
  set: GenderUpdateInput;
};


export type MutationUpdateOneHairArgs = {
  query?: InputMaybe<HairQueryInput>;
  set: HairUpdateInput;
};


export type MutationUpdateOneImage_Generation_SkuArgs = {
  query?: InputMaybe<Image_Generation_SkuQueryInput>;
  set: Image_Generation_SkuUpdateInput;
};


export type MutationUpdateOneImage_Generation_StyleArgs = {
  query?: InputMaybe<Image_Generation_StyleQueryInput>;
  set: Image_Generation_StyleUpdateInput;
};


export type MutationUpdateOneImage_MaskArgs = {
  query?: InputMaybe<Image_MaskQueryInput>;
  set: Image_MaskUpdateInput;
};


export type MutationUpdateOneImage_Prompt_TemplateArgs = {
  query?: InputMaybe<Image_Prompt_TemplateQueryInput>;
  set: Image_Prompt_TemplateUpdateInput;
};


export type MutationUpdateOneLibrary_Content_PackArgs = {
  query?: InputMaybe<Library_Content_PackQueryInput>;
  set: Library_Content_PackUpdateInput;
};


export type MutationUpdateOneLocationArgs = {
  query?: InputMaybe<LocationQueryInput>;
  set: LocationUpdateInput;
};


export type MutationUpdateOneMapArgs = {
  query?: InputMaybe<MapQueryInput>;
  set: MapUpdateInput;
};


export type MutationUpdateOneMedia_AssetArgs = {
  query?: InputMaybe<Media_AssetQueryInput>;
  set: Media_AssetUpdateInput;
};


export type MutationUpdateOneNoteArgs = {
  query?: InputMaybe<NoteQueryInput>;
  set: NoteUpdateInput;
};


export type MutationUpdateOnePersonalityArgs = {
  query?: InputMaybe<PersonalityQueryInput>;
  set: PersonalityUpdateInput;
};


export type MutationUpdateOneProfessionArgs = {
  query?: InputMaybe<ProfessionQueryInput>;
  set: ProfessionUpdateInput;
};


export type MutationUpdateOnePrompt_TemplateArgs = {
  query?: InputMaybe<Prompt_TemplateQueryInput>;
  set: Prompt_TemplateUpdateInput;
};


export type MutationUpdateOnePronounArgs = {
  query?: InputMaybe<PronounQueryInput>;
  set: PronounUpdateInput;
};


export type MutationUpdateOneRaceArgs = {
  query?: InputMaybe<RaceQueryInput>;
  set: RaceUpdateInput;
};


export type MutationUpdateOneRealmArgs = {
  query?: InputMaybe<RealmQueryInput>;
  set: RealmUpdateInput;
};


export type MutationUpdateOneRealm_TemplateArgs = {
  query?: InputMaybe<Realm_TemplateQueryInput>;
  set: Realm_TemplateUpdateInput;
};


export type MutationUpdateOneRelationship_StatusArgs = {
  query?: InputMaybe<Relationship_StatusQueryInput>;
  set: Relationship_StatusUpdateInput;
};


export type MutationUpdateOneSkinArgs = {
  query?: InputMaybe<SkinQueryInput>;
  set: SkinUpdateInput;
};


export type MutationUpdateOneStripe_CustomerArgs = {
  query?: InputMaybe<Stripe_CustomerQueryInput>;
  set: Stripe_CustomerUpdateInput;
};


export type MutationUpdateOneSubscription_TierArgs = {
  query?: InputMaybe<Subscription_TierQueryInput>;
  set: Subscription_TierUpdateInput;
};


export type MutationUpdateOneText_Generation_SkuArgs = {
  query?: InputMaybe<Text_Generation_SkuQueryInput>;
  set: Text_Generation_SkuUpdateInput;
};


export type MutationUpdateOneThemeArgs = {
  query?: InputMaybe<ThemeQueryInput>;
  set: ThemeUpdateInput;
};


export type MutationUpdateOneTokenArgs = {
  query?: InputMaybe<TokenQueryInput>;
  set: TokenUpdateInput;
};


export type MutationUpdateOneToken_SetArgs = {
  query?: InputMaybe<Token_SetQueryInput>;
  set: Token_SetUpdateInput;
};


export type MutationUpdateOneUserArgs = {
  query?: InputMaybe<UserQueryInput>;
  set: UserUpdateInput;
};


export type MutationUpdateOneUser_Character_Content_Pack_PurchaseArgs = {
  query?: InputMaybe<User_Character_Content_Pack_PurchaseQueryInput>;
  set: User_Character_Content_Pack_PurchaseUpdateInput;
};


export type MutationUpdateOneUser_Character_GenerationArgs = {
  query?: InputMaybe<User_Character_GenerationQueryInput>;
  set: User_Character_GenerationUpdateInput;
};


export type MutationUpdateOneUser_Image_GenerationArgs = {
  query?: InputMaybe<User_Image_GenerationQueryInput>;
  set: User_Image_GenerationUpdateInput;
};


export type MutationUpdateOneUser_InvoiceArgs = {
  query?: InputMaybe<User_InvoiceQueryInput>;
  set: User_InvoiceUpdateInput;
};


export type MutationUpdateOneUser_Library_Content_Pack_FavoriteArgs = {
  query?: InputMaybe<User_Library_Content_Pack_FavoriteQueryInput>;
  set: User_Library_Content_Pack_FavoriteUpdateInput;
};


export type MutationUpdateOneUser_Library_Image_UploadArgs = {
  query?: InputMaybe<User_Library_Image_UploadQueryInput>;
  set: User_Library_Image_UploadUpdateInput;
};


export type MutationUpdateOneUser_Library_PurchaseArgs = {
  query?: InputMaybe<User_Library_PurchaseQueryInput>;
  set: User_Library_PurchaseUpdateInput;
};


export type MutationUpdateOneUser_Realm_CountArgs = {
  query?: InputMaybe<User_Realm_CountQueryInput>;
  set: User_Realm_CountUpdateInput;
};


export type MutationUpdateOneUser_Realms_CountArgs = {
  query?: InputMaybe<User_Realms_CountQueryInput>;
  set: User_Realms_CountUpdateInput;
};


export type MutationUpdateOneUser_Text_GenerationArgs = {
  query?: InputMaybe<User_Text_GenerationQueryInput>;
  set: User_Text_GenerationUpdateInput;
};


export type MutationUpdateOneWeaponArgs = {
  query?: InputMaybe<WeaponQueryInput>;
  set: WeaponUpdateInput;
};


export type MutationUpdateOneWidgetArgs = {
  query?: InputMaybe<WidgetQueryInput>;
  set: WidgetUpdateInput;
};


export type MutationUpsertOneAlignmentArgs = {
  data: AlignmentInsertInput;
  query?: InputMaybe<AlignmentQueryInput>;
};


export type MutationUpsertOneArchetypeArgs = {
  data: ArchetypeInsertInput;
  query?: InputMaybe<ArchetypeQueryInput>;
};


export type MutationUpsertOneBody_ShapeArgs = {
  data: Body_ShapeInsertInput;
  query?: InputMaybe<Body_ShapeQueryInput>;
};


export type MutationUpsertOneCampaignArgs = {
  data: CampaignInsertInput;
  query?: InputMaybe<CampaignQueryInput>;
};


export type MutationUpsertOneCampaign_ActArgs = {
  data: Campaign_ActInsertInput;
  query?: InputMaybe<Campaign_ActQueryInput>;
};


export type MutationUpsertOneCampaign_CalendarArgs = {
  data: Campaign_CalendarInsertInput;
  query?: InputMaybe<Campaign_CalendarQueryInput>;
};


export type MutationUpsertOneCampaign_EventArgs = {
  data: Campaign_EventInsertInput;
  query?: InputMaybe<Campaign_EventQueryInput>;
};


export type MutationUpsertOneCampaign_QuestArgs = {
  data: Campaign_QuestInsertInput;
  query?: InputMaybe<Campaign_QuestQueryInput>;
};


export type MutationUpsertOneCanvaseArgs = {
  data: CanvaseInsertInput;
  query?: InputMaybe<CanvaseQueryInput>;
};


export type MutationUpsertOneCharacterArgs = {
  data: CharacterInsertInput;
  query?: InputMaybe<CharacterQueryInput>;
};


export type MutationUpsertOneCharacter_Content_PackArgs = {
  data: Character_Content_PackInsertInput;
  query?: InputMaybe<Character_Content_PackQueryInput>;
};


export type MutationUpsertOneCharacter_HeightArgs = {
  data: Character_HeightInsertInput;
  query?: InputMaybe<Character_HeightQueryInput>;
};


export type MutationUpsertOneCharacter_NoteArgs = {
  data: Character_NoteInsertInput;
  query?: InputMaybe<Character_NoteQueryInput>;
};


export type MutationUpsertOneCharacter_SetArgs = {
  data: Character_SetInsertInput;
  query?: InputMaybe<Character_SetQueryInput>;
};


export type MutationUpsertOneCharacter_TypeArgs = {
  data: Character_TypeInsertInput;
  query?: InputMaybe<Character_TypeQueryInput>;
};


export type MutationUpsertOneClassArgs = {
  data: ClassInsertInput;
  query?: InputMaybe<ClassQueryInput>;
};


export type MutationUpsertOneContainerArgs = {
  data: ContainerInsertInput;
  query?: InputMaybe<ContainerQueryInput>;
};


export type MutationUpsertOneEyeArgs = {
  data: EyeInsertInput;
  query?: InputMaybe<EyeQueryInput>;
};


export type MutationUpsertOneGenderArgs = {
  data: GenderInsertInput;
  query?: InputMaybe<GenderQueryInput>;
};


export type MutationUpsertOneHairArgs = {
  data: HairInsertInput;
  query?: InputMaybe<HairQueryInput>;
};


export type MutationUpsertOneImage_Generation_SkuArgs = {
  data: Image_Generation_SkuInsertInput;
  query?: InputMaybe<Image_Generation_SkuQueryInput>;
};


export type MutationUpsertOneImage_Generation_StyleArgs = {
  data: Image_Generation_StyleInsertInput;
  query?: InputMaybe<Image_Generation_StyleQueryInput>;
};


export type MutationUpsertOneImage_MaskArgs = {
  data: Image_MaskInsertInput;
  query?: InputMaybe<Image_MaskQueryInput>;
};


export type MutationUpsertOneImage_Prompt_TemplateArgs = {
  data: Image_Prompt_TemplateInsertInput;
  query?: InputMaybe<Image_Prompt_TemplateQueryInput>;
};


export type MutationUpsertOneLibrary_Content_PackArgs = {
  data: Library_Content_PackInsertInput;
  query?: InputMaybe<Library_Content_PackQueryInput>;
};


export type MutationUpsertOneLocationArgs = {
  data: LocationInsertInput;
  query?: InputMaybe<LocationQueryInput>;
};


export type MutationUpsertOneMapArgs = {
  data: MapInsertInput;
  query?: InputMaybe<MapQueryInput>;
};


export type MutationUpsertOneMedia_AssetArgs = {
  data: Media_AssetInsertInput;
  query?: InputMaybe<Media_AssetQueryInput>;
};


export type MutationUpsertOneNoteArgs = {
  data: NoteInsertInput;
  query?: InputMaybe<NoteQueryInput>;
};


export type MutationUpsertOnePersonalityArgs = {
  data: PersonalityInsertInput;
  query?: InputMaybe<PersonalityQueryInput>;
};


export type MutationUpsertOneProfessionArgs = {
  data: ProfessionInsertInput;
  query?: InputMaybe<ProfessionQueryInput>;
};


export type MutationUpsertOnePrompt_TemplateArgs = {
  data: Prompt_TemplateInsertInput;
  query?: InputMaybe<Prompt_TemplateQueryInput>;
};


export type MutationUpsertOnePronounArgs = {
  data: PronounInsertInput;
  query?: InputMaybe<PronounQueryInput>;
};


export type MutationUpsertOneRaceArgs = {
  data: RaceInsertInput;
  query?: InputMaybe<RaceQueryInput>;
};


export type MutationUpsertOneRealmArgs = {
  data: RealmInsertInput;
  query?: InputMaybe<RealmQueryInput>;
};


export type MutationUpsertOneRealm_TemplateArgs = {
  data: Realm_TemplateInsertInput;
  query?: InputMaybe<Realm_TemplateQueryInput>;
};


export type MutationUpsertOneRelationship_StatusArgs = {
  data: Relationship_StatusInsertInput;
  query?: InputMaybe<Relationship_StatusQueryInput>;
};


export type MutationUpsertOneSkinArgs = {
  data: SkinInsertInput;
  query?: InputMaybe<SkinQueryInput>;
};


export type MutationUpsertOneStripe_CustomerArgs = {
  data: Stripe_CustomerInsertInput;
  query?: InputMaybe<Stripe_CustomerQueryInput>;
};


export type MutationUpsertOneSubscription_TierArgs = {
  data: Subscription_TierInsertInput;
  query?: InputMaybe<Subscription_TierQueryInput>;
};


export type MutationUpsertOneText_Generation_SkuArgs = {
  data: Text_Generation_SkuInsertInput;
  query?: InputMaybe<Text_Generation_SkuQueryInput>;
};


export type MutationUpsertOneThemeArgs = {
  data: ThemeInsertInput;
  query?: InputMaybe<ThemeQueryInput>;
};


export type MutationUpsertOneTokenArgs = {
  data: TokenInsertInput;
  query?: InputMaybe<TokenQueryInput>;
};


export type MutationUpsertOneToken_SetArgs = {
  data: Token_SetInsertInput;
  query?: InputMaybe<Token_SetQueryInput>;
};


export type MutationUpsertOneUserArgs = {
  data: UserInsertInput;
  query?: InputMaybe<UserQueryInput>;
};


export type MutationUpsertOneUser_Character_Content_Pack_PurchaseArgs = {
  data: User_Character_Content_Pack_PurchaseInsertInput;
  query?: InputMaybe<User_Character_Content_Pack_PurchaseQueryInput>;
};


export type MutationUpsertOneUser_Character_GenerationArgs = {
  data: User_Character_GenerationInsertInput;
  query?: InputMaybe<User_Character_GenerationQueryInput>;
};


export type MutationUpsertOneUser_Image_GenerationArgs = {
  data: User_Image_GenerationInsertInput;
  query?: InputMaybe<User_Image_GenerationQueryInput>;
};


export type MutationUpsertOneUser_InvoiceArgs = {
  data: User_InvoiceInsertInput;
  query?: InputMaybe<User_InvoiceQueryInput>;
};


export type MutationUpsertOneUser_Library_Content_Pack_FavoriteArgs = {
  data: User_Library_Content_Pack_FavoriteInsertInput;
  query?: InputMaybe<User_Library_Content_Pack_FavoriteQueryInput>;
};


export type MutationUpsertOneUser_Library_Image_UploadArgs = {
  data: User_Library_Image_UploadInsertInput;
  query?: InputMaybe<User_Library_Image_UploadQueryInput>;
};


export type MutationUpsertOneUser_Library_PurchaseArgs = {
  data: User_Library_PurchaseInsertInput;
  query?: InputMaybe<User_Library_PurchaseQueryInput>;
};


export type MutationUpsertOneUser_Realm_CountArgs = {
  data: User_Realm_CountInsertInput;
  query?: InputMaybe<User_Realm_CountQueryInput>;
};


export type MutationUpsertOneUser_Realms_CountArgs = {
  data: User_Realms_CountInsertInput;
  query?: InputMaybe<User_Realms_CountQueryInput>;
};


export type MutationUpsertOneUser_Text_GenerationArgs = {
  data: User_Text_GenerationInsertInput;
  query?: InputMaybe<User_Text_GenerationQueryInput>;
};


export type MutationUpsertOneWeaponArgs = {
  data: WeaponInsertInput;
  query?: InputMaybe<WeaponQueryInput>;
};


export type MutationUpsertOneWidgetArgs = {
  data: WidgetInsertInput;
  query?: InputMaybe<WidgetQueryInput>;
};

export type Note = {
  __typename?: 'Note';
  _id: Scalars['ObjectId']['output'];
  content?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<User>;
  realm: Realm;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title: Scalars['String']['output'];
};

export type NoteInsertInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<NoteOwnerRelationInput>;
  realm: NoteRealmRelationInput;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title: Scalars['String']['input'];
};

export type NoteOwnerRelationInput = {
  create?: InputMaybe<UserInsertInput>;
  link?: InputMaybe<Scalars['String']['input']>;
};

export type NoteQueryInput = {
  AND?: InputMaybe<Array<NoteQueryInput>>;
  OR?: InputMaybe<Array<NoteQueryInput>>;
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  _id_gt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_gte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  _id_lt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_lte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_ne?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  content?: InputMaybe<Scalars['String']['input']>;
  content_exists?: InputMaybe<Scalars['Boolean']['input']>;
  content_gt?: InputMaybe<Scalars['String']['input']>;
  content_gte?: InputMaybe<Scalars['String']['input']>;
  content_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  content_lt?: InputMaybe<Scalars['String']['input']>;
  content_lte?: InputMaybe<Scalars['String']['input']>;
  content_ne?: InputMaybe<Scalars['String']['input']>;
  content_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  owner?: InputMaybe<UserQueryInput>;
  owner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  realm?: InputMaybe<RealmQueryInput>;
  realm_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tags_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_gt?: InputMaybe<Scalars['String']['input']>;
  title_gte?: InputMaybe<Scalars['String']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_lt?: InputMaybe<Scalars['String']['input']>;
  title_lte?: InputMaybe<Scalars['String']['input']>;
  title_ne?: InputMaybe<Scalars['String']['input']>;
  title_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type NoteRealmRelationInput = {
  create?: InputMaybe<RealmInsertInput>;
  link?: InputMaybe<Scalars['ObjectId']['input']>;
};

export enum NoteSortByInput {
  ContentAsc = 'CONTENT_ASC',
  ContentDesc = 'CONTENT_DESC',
  OwnerAsc = 'OWNER_ASC',
  OwnerDesc = 'OWNER_DESC',
  RealmAsc = 'REALM_ASC',
  RealmDesc = 'REALM_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type NoteUpdateInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  content_unset?: InputMaybe<Scalars['Boolean']['input']>;
  owner?: InputMaybe<NoteOwnerRelationInput>;
  owner_unset?: InputMaybe<Scalars['Boolean']['input']>;
  realm?: InputMaybe<NoteRealmRelationInput>;
  realm_unset?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_unset?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Personality = {
  __typename?: 'Personality';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type PersonalityInsertInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type PersonalityQueryInput = {
  AND?: InputMaybe<Array<PersonalityQueryInput>>;
  OR?: InputMaybe<Array<PersonalityQueryInput>>;
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  _id_gt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_gte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  _id_lt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_lte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_ne?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_gt?: InputMaybe<Scalars['String']['input']>;
  description_gte?: InputMaybe<Scalars['String']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_lt?: InputMaybe<Scalars['String']['input']>;
  description_lte?: InputMaybe<Scalars['String']['input']>;
  description_ne?: InputMaybe<Scalars['String']['input']>;
  description_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type_gt?: InputMaybe<Scalars['String']['input']>;
  type_gte?: InputMaybe<Scalars['String']['input']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_lt?: InputMaybe<Scalars['String']['input']>;
  type_lte?: InputMaybe<Scalars['String']['input']>;
  type_ne?: InputMaybe<Scalars['String']['input']>;
  type_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum PersonalitySortByInput {
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type PersonalityUpdateInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_unset?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_unset?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Profession = {
  __typename?: 'Profession';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ProfessionInsertInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ProfessionQueryInput = {
  AND?: InputMaybe<Array<ProfessionQueryInput>>;
  OR?: InputMaybe<Array<ProfessionQueryInput>>;
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  _id_gt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_gte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  _id_lt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_lte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_ne?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum ProfessionSortByInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type ProfessionUpdateInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Prompt_Template = {
  __typename?: 'Prompt_template';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  negative_prompt?: Maybe<Scalars['String']['output']>;
  optional_attributes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  required_attributes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  template?: Maybe<Scalars['String']['output']>;
  ui_preview?: Maybe<Scalars['String']['output']>;
};

export type Prompt_TemplateInsertInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  negative_prompt?: InputMaybe<Scalars['String']['input']>;
  optional_attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  required_attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  template?: InputMaybe<Scalars['String']['input']>;
  ui_preview?: InputMaybe<Scalars['String']['input']>;
};

export type Prompt_TemplateQueryInput = {
  AND?: InputMaybe<Array<Prompt_TemplateQueryInput>>;
  OR?: InputMaybe<Array<Prompt_TemplateQueryInput>>;
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  _id_gt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_gte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  _id_lt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_lte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_ne?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_exists?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_ne?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt_exists?: InputMaybe<Scalars['Boolean']['input']>;
  modifiedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  modifiedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt_ne?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  negative_prompt?: InputMaybe<Scalars['String']['input']>;
  negative_prompt_exists?: InputMaybe<Scalars['Boolean']['input']>;
  negative_prompt_gt?: InputMaybe<Scalars['String']['input']>;
  negative_prompt_gte?: InputMaybe<Scalars['String']['input']>;
  negative_prompt_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  negative_prompt_lt?: InputMaybe<Scalars['String']['input']>;
  negative_prompt_lte?: InputMaybe<Scalars['String']['input']>;
  negative_prompt_ne?: InputMaybe<Scalars['String']['input']>;
  negative_prompt_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optional_attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optional_attributes_exists?: InputMaybe<Scalars['Boolean']['input']>;
  optional_attributes_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optional_attributes_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  required_attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  required_attributes_exists?: InputMaybe<Scalars['Boolean']['input']>;
  required_attributes_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  required_attributes_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tags_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  template?: InputMaybe<Scalars['String']['input']>;
  template_exists?: InputMaybe<Scalars['Boolean']['input']>;
  template_gt?: InputMaybe<Scalars['String']['input']>;
  template_gte?: InputMaybe<Scalars['String']['input']>;
  template_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  template_lt?: InputMaybe<Scalars['String']['input']>;
  template_lte?: InputMaybe<Scalars['String']['input']>;
  template_ne?: InputMaybe<Scalars['String']['input']>;
  template_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ui_preview?: InputMaybe<Scalars['String']['input']>;
  ui_preview_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ui_preview_gt?: InputMaybe<Scalars['String']['input']>;
  ui_preview_gte?: InputMaybe<Scalars['String']['input']>;
  ui_preview_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ui_preview_lt?: InputMaybe<Scalars['String']['input']>;
  ui_preview_lte?: InputMaybe<Scalars['String']['input']>;
  ui_preview_ne?: InputMaybe<Scalars['String']['input']>;
  ui_preview_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum Prompt_TemplateSortByInput {
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  ModifiedatAsc = 'MODIFIEDAT_ASC',
  ModifiedatDesc = 'MODIFIEDAT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  NegativePromptAsc = 'NEGATIVE_PROMPT_ASC',
  NegativePromptDesc = 'NEGATIVE_PROMPT_DESC',
  TemplateAsc = 'TEMPLATE_ASC',
  TemplateDesc = 'TEMPLATE_DESC',
  UiPreviewAsc = 'UI_PREVIEW_ASC',
  UiPreviewDesc = 'UI_PREVIEW_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type Prompt_TemplateUpdateInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_unset?: InputMaybe<Scalars['Boolean']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt_unset?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_unset?: InputMaybe<Scalars['Boolean']['input']>;
  negative_prompt?: InputMaybe<Scalars['String']['input']>;
  negative_prompt_unset?: InputMaybe<Scalars['Boolean']['input']>;
  optional_attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optional_attributes_unset?: InputMaybe<Scalars['Boolean']['input']>;
  required_attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  required_attributes_unset?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_unset?: InputMaybe<Scalars['Boolean']['input']>;
  template?: InputMaybe<Scalars['String']['input']>;
  template_unset?: InputMaybe<Scalars['Boolean']['input']>;
  ui_preview?: InputMaybe<Scalars['String']['input']>;
  ui_preview_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Pronoun = {
  __typename?: 'Pronoun';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type PronounInsertInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type PronounQueryInput = {
  AND?: InputMaybe<Array<PronounQueryInput>>;
  OR?: InputMaybe<Array<PronounQueryInput>>;
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  _id_gt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_gte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  _id_lt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_lte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_ne?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum PronounSortByInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type PronounUpdateInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Query = {
  __typename?: 'Query';
  alignment?: Maybe<Alignment>;
  alignments: Array<Maybe<Alignment>>;
  archetype?: Maybe<Archetype>;
  archetypes: Array<Maybe<Archetype>>;
  body_shape?: Maybe<Body_Shape>;
  body_shapes: Array<Maybe<Body_Shape>>;
  campaign?: Maybe<Campaign>;
  campaign_act?: Maybe<Campaign_Act>;
  campaign_acts: Array<Maybe<Campaign_Act>>;
  campaign_calendar?: Maybe<Campaign_Calendar>;
  campaign_calendars: Array<Maybe<Campaign_Calendar>>;
  campaign_event?: Maybe<Campaign_Event>;
  campaign_events: Array<Maybe<Campaign_Event>>;
  campaign_quest?: Maybe<Campaign_Quest>;
  campaign_quests: Array<Maybe<Campaign_Quest>>;
  campaigns: Array<Maybe<Campaign>>;
  canvase?: Maybe<Canvase>;
  canvases: Array<Maybe<Canvase>>;
  character?: Maybe<Character>;
  character_content_pack?: Maybe<Character_Content_Pack>;
  character_content_packs: Array<Maybe<Character_Content_Pack>>;
  character_height?: Maybe<Character_Height>;
  character_heights: Array<Maybe<Character_Height>>;
  character_note?: Maybe<Character_Note>;
  character_notes: Array<Maybe<Character_Note>>;
  character_set?: Maybe<Character_Set>;
  character_sets: Array<Maybe<Character_Set>>;
  character_type?: Maybe<Character_Type>;
  character_types: Array<Maybe<Character_Type>>;
  characters: Array<Maybe<Character>>;
  class?: Maybe<Class>;
  classes: Array<Maybe<Class>>;
  container?: Maybe<Container>;
  containers: Array<Maybe<Container>>;
  eye?: Maybe<Eye>;
  eyes: Array<Maybe<Eye>>;
  gender?: Maybe<Gender>;
  genders: Array<Maybe<Gender>>;
  hair?: Maybe<Hair>;
  hairs: Array<Maybe<Hair>>;
  image_generation_sku?: Maybe<Image_Generation_Sku>;
  image_generation_skus: Array<Maybe<Image_Generation_Sku>>;
  image_generation_style?: Maybe<Image_Generation_Style>;
  image_generation_styles: Array<Maybe<Image_Generation_Style>>;
  image_mask?: Maybe<Image_Mask>;
  image_masks: Array<Maybe<Image_Mask>>;
  image_prompt_template?: Maybe<Image_Prompt_Template>;
  image_prompt_templates: Array<Maybe<Image_Prompt_Template>>;
  library_content_pack?: Maybe<Library_Content_Pack>;
  library_content_packs: Array<Maybe<Library_Content_Pack>>;
  location?: Maybe<Location>;
  locations: Array<Maybe<Location>>;
  map?: Maybe<Map>;
  maps: Array<Maybe<Map>>;
  media_asset?: Maybe<Media_Asset>;
  media_assets: Array<Maybe<Media_Asset>>;
  note?: Maybe<Note>;
  notes: Array<Maybe<Note>>;
  personalities: Array<Maybe<Personality>>;
  personality?: Maybe<Personality>;
  profession?: Maybe<Profession>;
  professions: Array<Maybe<Profession>>;
  prompt_template?: Maybe<Prompt_Template>;
  prompt_templates: Array<Maybe<Prompt_Template>>;
  pronoun?: Maybe<Pronoun>;
  pronouns: Array<Maybe<Pronoun>>;
  race?: Maybe<Race>;
  races: Array<Maybe<Race>>;
  realm?: Maybe<Realm>;
  realm_template?: Maybe<Realm_Template>;
  realm_templates: Array<Maybe<Realm_Template>>;
  realms: Array<Maybe<Realm>>;
  relationship_status?: Maybe<Relationship_Status>;
  relationship_statuses: Array<Maybe<Relationship_Status>>;
  skin?: Maybe<Skin>;
  skins: Array<Maybe<Skin>>;
  stripe_customer?: Maybe<Stripe_Customer>;
  stripe_customers: Array<Maybe<Stripe_Customer>>;
  subscription_tier?: Maybe<Subscription_Tier>;
  subscription_tiers: Array<Maybe<Subscription_Tier>>;
  text_generation_sku?: Maybe<Text_Generation_Sku>;
  text_generation_skus: Array<Maybe<Text_Generation_Sku>>;
  theme?: Maybe<Theme>;
  themes: Array<Maybe<Theme>>;
  token?: Maybe<Token>;
  token_set?: Maybe<Token_Set>;
  token_sets: Array<Maybe<Token_Set>>;
  tokens: Array<Maybe<Token>>;
  user?: Maybe<User>;
  user_character_content_pack_purchase?: Maybe<User_Character_Content_Pack_Purchase>;
  user_character_content_pack_purchases: Array<Maybe<User_Character_Content_Pack_Purchase>>;
  user_character_generation?: Maybe<User_Character_Generation>;
  user_character_generations: Array<Maybe<User_Character_Generation>>;
  user_image_generation?: Maybe<User_Image_Generation>;
  user_image_generations: Array<Maybe<User_Image_Generation>>;
  user_invoice?: Maybe<User_Invoice>;
  user_invoices: Array<Maybe<User_Invoice>>;
  user_library_content_pack_favorite?: Maybe<User_Library_Content_Pack_Favorite>;
  user_library_content_pack_favorites: Array<Maybe<User_Library_Content_Pack_Favorite>>;
  user_library_image_upload?: Maybe<User_Library_Image_Upload>;
  user_library_image_uploads: Array<Maybe<User_Library_Image_Upload>>;
  user_library_purchase?: Maybe<User_Library_Purchase>;
  user_library_purchases: Array<Maybe<User_Library_Purchase>>;
  user_realm_count?: Maybe<User_Realm_Count>;
  user_realm_counts: Array<Maybe<User_Realm_Count>>;
  user_realms_count?: Maybe<User_Realms_Count>;
  user_realms_counts: Array<Maybe<User_Realms_Count>>;
  user_text_generation?: Maybe<User_Text_Generation>;
  user_text_generations: Array<Maybe<User_Text_Generation>>;
  users: Array<Maybe<User>>;
  weapon?: Maybe<Weapon>;
  weapons: Array<Maybe<Weapon>>;
  widget?: Maybe<Widget>;
  widgets: Array<Maybe<Widget>>;
};


export type QueryAlignmentArgs = {
  query?: InputMaybe<AlignmentQueryInput>;
};


export type QueryAlignmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<AlignmentQueryInput>;
  sortBy?: InputMaybe<AlignmentSortByInput>;
};


export type QueryArchetypeArgs = {
  query?: InputMaybe<ArchetypeQueryInput>;
};


export type QueryArchetypesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<ArchetypeQueryInput>;
  sortBy?: InputMaybe<ArchetypeSortByInput>;
};


export type QueryBody_ShapeArgs = {
  query?: InputMaybe<Body_ShapeQueryInput>;
};


export type QueryBody_ShapesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Body_ShapeQueryInput>;
  sortBy?: InputMaybe<Body_ShapeSortByInput>;
};


export type QueryCampaignArgs = {
  query?: InputMaybe<CampaignQueryInput>;
};


export type QueryCampaign_ActArgs = {
  query?: InputMaybe<Campaign_ActQueryInput>;
};


export type QueryCampaign_ActsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Campaign_ActQueryInput>;
  sortBy?: InputMaybe<Campaign_ActSortByInput>;
};


export type QueryCampaign_CalendarArgs = {
  query?: InputMaybe<Campaign_CalendarQueryInput>;
};


export type QueryCampaign_CalendarsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Campaign_CalendarQueryInput>;
  sortBy?: InputMaybe<Campaign_CalendarSortByInput>;
};


export type QueryCampaign_EventArgs = {
  query?: InputMaybe<Campaign_EventQueryInput>;
};


export type QueryCampaign_EventsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Campaign_EventQueryInput>;
  sortBy?: InputMaybe<Campaign_EventSortByInput>;
};


export type QueryCampaign_QuestArgs = {
  query?: InputMaybe<Campaign_QuestQueryInput>;
};


export type QueryCampaign_QuestsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Campaign_QuestQueryInput>;
  sortBy?: InputMaybe<Campaign_QuestSortByInput>;
};


export type QueryCampaignsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<CampaignQueryInput>;
  sortBy?: InputMaybe<CampaignSortByInput>;
};


export type QueryCanvaseArgs = {
  query?: InputMaybe<CanvaseQueryInput>;
};


export type QueryCanvasesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<CanvaseQueryInput>;
  sortBy?: InputMaybe<CanvaseSortByInput>;
};


export type QueryCharacterArgs = {
  query?: InputMaybe<CharacterQueryInput>;
};


export type QueryCharacter_Content_PackArgs = {
  query?: InputMaybe<Character_Content_PackQueryInput>;
};


export type QueryCharacter_Content_PacksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Character_Content_PackQueryInput>;
  sortBy?: InputMaybe<Character_Content_PackSortByInput>;
};


export type QueryCharacter_HeightArgs = {
  query?: InputMaybe<Character_HeightQueryInput>;
};


export type QueryCharacter_HeightsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Character_HeightQueryInput>;
  sortBy?: InputMaybe<Character_HeightSortByInput>;
};


export type QueryCharacter_NoteArgs = {
  query?: InputMaybe<Character_NoteQueryInput>;
};


export type QueryCharacter_NotesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Character_NoteQueryInput>;
  sortBy?: InputMaybe<Character_NoteSortByInput>;
};


export type QueryCharacter_SetArgs = {
  query?: InputMaybe<Character_SetQueryInput>;
};


export type QueryCharacter_SetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Character_SetQueryInput>;
  sortBy?: InputMaybe<Character_SetSortByInput>;
};


export type QueryCharacter_TypeArgs = {
  query?: InputMaybe<Character_TypeQueryInput>;
};


export type QueryCharacter_TypesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Character_TypeQueryInput>;
  sortBy?: InputMaybe<Character_TypeSortByInput>;
};


export type QueryCharactersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<CharacterQueryInput>;
  sortBy?: InputMaybe<CharacterSortByInput>;
};


export type QueryClassArgs = {
  query?: InputMaybe<ClassQueryInput>;
};


export type QueryClassesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<ClassQueryInput>;
  sortBy?: InputMaybe<ClassSortByInput>;
};


export type QueryContainerArgs = {
  query?: InputMaybe<ContainerQueryInput>;
};


export type QueryContainersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<ContainerQueryInput>;
  sortBy?: InputMaybe<ContainerSortByInput>;
};


export type QueryEyeArgs = {
  query?: InputMaybe<EyeQueryInput>;
};


export type QueryEyesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<EyeQueryInput>;
  sortBy?: InputMaybe<EyeSortByInput>;
};


export type QueryGenderArgs = {
  query?: InputMaybe<GenderQueryInput>;
};


export type QueryGendersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<GenderQueryInput>;
  sortBy?: InputMaybe<GenderSortByInput>;
};


export type QueryHairArgs = {
  query?: InputMaybe<HairQueryInput>;
};


export type QueryHairsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<HairQueryInput>;
  sortBy?: InputMaybe<HairSortByInput>;
};


export type QueryImage_Generation_SkuArgs = {
  query?: InputMaybe<Image_Generation_SkuQueryInput>;
};


export type QueryImage_Generation_SkusArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Image_Generation_SkuQueryInput>;
  sortBy?: InputMaybe<Image_Generation_SkuSortByInput>;
};


export type QueryImage_Generation_StyleArgs = {
  query?: InputMaybe<Image_Generation_StyleQueryInput>;
};


export type QueryImage_Generation_StylesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Image_Generation_StyleQueryInput>;
  sortBy?: InputMaybe<Image_Generation_StyleSortByInput>;
};


export type QueryImage_MaskArgs = {
  query?: InputMaybe<Image_MaskQueryInput>;
};


export type QueryImage_MasksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Image_MaskQueryInput>;
  sortBy?: InputMaybe<Image_MaskSortByInput>;
};


export type QueryImage_Prompt_TemplateArgs = {
  query?: InputMaybe<Image_Prompt_TemplateQueryInput>;
};


export type QueryImage_Prompt_TemplatesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Image_Prompt_TemplateQueryInput>;
  sortBy?: InputMaybe<Image_Prompt_TemplateSortByInput>;
};


export type QueryLibrary_Content_PackArgs = {
  query?: InputMaybe<Library_Content_PackQueryInput>;
};


export type QueryLibrary_Content_PacksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Library_Content_PackQueryInput>;
  sortBy?: InputMaybe<Library_Content_PackSortByInput>;
};


export type QueryLocationArgs = {
  query?: InputMaybe<LocationQueryInput>;
};


export type QueryLocationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<LocationQueryInput>;
  sortBy?: InputMaybe<LocationSortByInput>;
};


export type QueryMapArgs = {
  query?: InputMaybe<MapQueryInput>;
};


export type QueryMapsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<MapQueryInput>;
  sortBy?: InputMaybe<MapSortByInput>;
};


export type QueryMedia_AssetArgs = {
  query?: InputMaybe<Media_AssetQueryInput>;
};


export type QueryMedia_AssetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Media_AssetQueryInput>;
  sortBy?: InputMaybe<Media_AssetSortByInput>;
};


export type QueryNoteArgs = {
  query?: InputMaybe<NoteQueryInput>;
};


export type QueryNotesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<NoteQueryInput>;
  sortBy?: InputMaybe<NoteSortByInput>;
};


export type QueryPersonalitiesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<PersonalityQueryInput>;
  sortBy?: InputMaybe<PersonalitySortByInput>;
};


export type QueryPersonalityArgs = {
  query?: InputMaybe<PersonalityQueryInput>;
};


export type QueryProfessionArgs = {
  query?: InputMaybe<ProfessionQueryInput>;
};


export type QueryProfessionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<ProfessionQueryInput>;
  sortBy?: InputMaybe<ProfessionSortByInput>;
};


export type QueryPrompt_TemplateArgs = {
  query?: InputMaybe<Prompt_TemplateQueryInput>;
};


export type QueryPrompt_TemplatesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Prompt_TemplateQueryInput>;
  sortBy?: InputMaybe<Prompt_TemplateSortByInput>;
};


export type QueryPronounArgs = {
  query?: InputMaybe<PronounQueryInput>;
};


export type QueryPronounsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<PronounQueryInput>;
  sortBy?: InputMaybe<PronounSortByInput>;
};


export type QueryRaceArgs = {
  query?: InputMaybe<RaceQueryInput>;
};


export type QueryRacesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<RaceQueryInput>;
  sortBy?: InputMaybe<RaceSortByInput>;
};


export type QueryRealmArgs = {
  query?: InputMaybe<RealmQueryInput>;
};


export type QueryRealm_TemplateArgs = {
  query?: InputMaybe<Realm_TemplateQueryInput>;
};


export type QueryRealm_TemplatesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Realm_TemplateQueryInput>;
  sortBy?: InputMaybe<Realm_TemplateSortByInput>;
};


export type QueryRealmsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<RealmQueryInput>;
  sortBy?: InputMaybe<RealmSortByInput>;
};


export type QueryRelationship_StatusArgs = {
  query?: InputMaybe<Relationship_StatusQueryInput>;
};


export type QueryRelationship_StatusesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Relationship_StatusQueryInput>;
  sortBy?: InputMaybe<Relationship_StatusSortByInput>;
};


export type QuerySkinArgs = {
  query?: InputMaybe<SkinQueryInput>;
};


export type QuerySkinsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<SkinQueryInput>;
  sortBy?: InputMaybe<SkinSortByInput>;
};


export type QueryStripe_CustomerArgs = {
  query?: InputMaybe<Stripe_CustomerQueryInput>;
};


export type QueryStripe_CustomersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Stripe_CustomerQueryInput>;
  sortBy?: InputMaybe<Stripe_CustomerSortByInput>;
};


export type QuerySubscription_TierArgs = {
  query?: InputMaybe<Subscription_TierQueryInput>;
};


export type QuerySubscription_TiersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Subscription_TierQueryInput>;
  sortBy?: InputMaybe<Subscription_TierSortByInput>;
};


export type QueryText_Generation_SkuArgs = {
  query?: InputMaybe<Text_Generation_SkuQueryInput>;
};


export type QueryText_Generation_SkusArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Text_Generation_SkuQueryInput>;
  sortBy?: InputMaybe<Text_Generation_SkuSortByInput>;
};


export type QueryThemeArgs = {
  query?: InputMaybe<ThemeQueryInput>;
};


export type QueryThemesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<ThemeQueryInput>;
  sortBy?: InputMaybe<ThemeSortByInput>;
};


export type QueryTokenArgs = {
  query?: InputMaybe<TokenQueryInput>;
};


export type QueryToken_SetArgs = {
  query?: InputMaybe<Token_SetQueryInput>;
};


export type QueryToken_SetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Token_SetQueryInput>;
  sortBy?: InputMaybe<Token_SetSortByInput>;
};


export type QueryTokensArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<TokenQueryInput>;
  sortBy?: InputMaybe<TokenSortByInput>;
};


export type QueryUserArgs = {
  query?: InputMaybe<UserQueryInput>;
};


export type QueryUser_Character_Content_Pack_PurchaseArgs = {
  query?: InputMaybe<User_Character_Content_Pack_PurchaseQueryInput>;
};


export type QueryUser_Character_Content_Pack_PurchasesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<User_Character_Content_Pack_PurchaseQueryInput>;
  sortBy?: InputMaybe<User_Character_Content_Pack_PurchaseSortByInput>;
};


export type QueryUser_Character_GenerationArgs = {
  query?: InputMaybe<User_Character_GenerationQueryInput>;
};


export type QueryUser_Character_GenerationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<User_Character_GenerationQueryInput>;
  sortBy?: InputMaybe<User_Character_GenerationSortByInput>;
};


export type QueryUser_Image_GenerationArgs = {
  query?: InputMaybe<User_Image_GenerationQueryInput>;
};


export type QueryUser_Image_GenerationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<User_Image_GenerationQueryInput>;
  sortBy?: InputMaybe<User_Image_GenerationSortByInput>;
};


export type QueryUser_InvoiceArgs = {
  query?: InputMaybe<User_InvoiceQueryInput>;
};


export type QueryUser_InvoicesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<User_InvoiceQueryInput>;
  sortBy?: InputMaybe<User_InvoiceSortByInput>;
};


export type QueryUser_Library_Content_Pack_FavoriteArgs = {
  query?: InputMaybe<User_Library_Content_Pack_FavoriteQueryInput>;
};


export type QueryUser_Library_Content_Pack_FavoritesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<User_Library_Content_Pack_FavoriteQueryInput>;
  sortBy?: InputMaybe<User_Library_Content_Pack_FavoriteSortByInput>;
};


export type QueryUser_Library_Image_UploadArgs = {
  query?: InputMaybe<User_Library_Image_UploadQueryInput>;
};


export type QueryUser_Library_Image_UploadsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<User_Library_Image_UploadQueryInput>;
  sortBy?: InputMaybe<User_Library_Image_UploadSortByInput>;
};


export type QueryUser_Library_PurchaseArgs = {
  query?: InputMaybe<User_Library_PurchaseQueryInput>;
};


export type QueryUser_Library_PurchasesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<User_Library_PurchaseQueryInput>;
  sortBy?: InputMaybe<User_Library_PurchaseSortByInput>;
};


export type QueryUser_Realm_CountArgs = {
  query?: InputMaybe<User_Realm_CountQueryInput>;
};


export type QueryUser_Realm_CountsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<User_Realm_CountQueryInput>;
  sortBy?: InputMaybe<User_Realm_CountSortByInput>;
};


export type QueryUser_Realms_CountArgs = {
  query?: InputMaybe<User_Realms_CountQueryInput>;
};


export type QueryUser_Realms_CountsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<User_Realms_CountQueryInput>;
  sortBy?: InputMaybe<User_Realms_CountSortByInput>;
};


export type QueryUser_Text_GenerationArgs = {
  query?: InputMaybe<User_Text_GenerationQueryInput>;
};


export type QueryUser_Text_GenerationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<User_Text_GenerationQueryInput>;
  sortBy?: InputMaybe<User_Text_GenerationSortByInput>;
};


export type QueryUsersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<UserQueryInput>;
  sortBy?: InputMaybe<UserSortByInput>;
};


export type QueryWeaponArgs = {
  query?: InputMaybe<WeaponQueryInput>;
};


export type QueryWeaponsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<WeaponQueryInput>;
  sortBy?: InputMaybe<WeaponSortByInput>;
};


export type QueryWidgetArgs = {
  query?: InputMaybe<WidgetQueryInput>;
};


export type QueryWidgetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<WidgetQueryInput>;
  sortBy?: InputMaybe<WidgetSortByInput>;
};

export type Race = {
  __typename?: 'Race';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type RaceInsertInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type RaceQueryInput = {
  AND?: InputMaybe<Array<RaceQueryInput>>;
  OR?: InputMaybe<Array<RaceQueryInput>>;
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  _id_gt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_gte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  _id_lt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_lte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_ne?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum RaceSortByInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type RaceUpdateInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Realm = {
  __typename?: 'Realm';
  _id: Scalars['ObjectId']['output'];
  characters?: Maybe<Array<Maybe<Character>>>;
  cloned_from_realm?: Maybe<Realm>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  editors?: Maybe<Array<Maybe<User>>>;
  is_favorited: Scalars['Boolean']['output'];
  is_public: Scalars['Boolean']['output'];
  media_asset?: Maybe<Media_Asset>;
  name: Scalars['String']['output'];
  original_creator?: Maybe<User>;
  owner: User;
  realm_template?: Maybe<Realm_Template>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  thumbnail_url?: Maybe<Scalars['String']['output']>;
  token_sets?: Maybe<Array<Maybe<Token_Set>>>;
  tokens?: Maybe<Array<Maybe<Token>>>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  viewers?: Maybe<Array<Maybe<User>>>;
};

export type RealmCharactersRelationInput = {
  create?: InputMaybe<Array<InputMaybe<CharacterInsertInput>>>;
  link?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
};

export type RealmCloned_From_RealmRelationInput = {
  create?: InputMaybe<RealmInsertInput>;
  link?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type RealmEditorsRelationInput = {
  create?: InputMaybe<Array<InputMaybe<UserInsertInput>>>;
  link?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type RealmInsertInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  characters?: InputMaybe<RealmCharactersRelationInput>;
  cloned_from_realm?: InputMaybe<RealmCloned_From_RealmRelationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  editors?: InputMaybe<RealmEditorsRelationInput>;
  is_favorited: Scalars['Boolean']['input'];
  is_public: Scalars['Boolean']['input'];
  media_asset?: InputMaybe<RealmMedia_AssetRelationInput>;
  name: Scalars['String']['input'];
  original_creator?: InputMaybe<RealmOriginal_CreatorRelationInput>;
  owner: RealmOwnerRelationInput;
  realm_template?: InputMaybe<RealmRealm_TemplateRelationInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  thumbnail_url?: InputMaybe<Scalars['String']['input']>;
  token_sets?: InputMaybe<RealmToken_SetsRelationInput>;
  tokens?: InputMaybe<RealmTokensRelationInput>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  viewers?: InputMaybe<RealmViewersRelationInput>;
};

export type RealmMedia_AssetRelationInput = {
  create?: InputMaybe<Media_AssetInsertInput>;
  link?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type RealmOriginal_CreatorRelationInput = {
  create?: InputMaybe<UserInsertInput>;
  link?: InputMaybe<Scalars['String']['input']>;
};

export type RealmOwnerRelationInput = {
  create?: InputMaybe<UserInsertInput>;
  link?: InputMaybe<Scalars['String']['input']>;
};

export type RealmQueryInput = {
  AND?: InputMaybe<Array<RealmQueryInput>>;
  OR?: InputMaybe<Array<RealmQueryInput>>;
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  _id_gt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_gte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  _id_lt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_lte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_ne?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  characters?: InputMaybe<Array<InputMaybe<CharacterQueryInput>>>;
  characters_exists?: InputMaybe<Scalars['Boolean']['input']>;
  characters_in?: InputMaybe<Array<InputMaybe<CharacterQueryInput>>>;
  characters_nin?: InputMaybe<Array<InputMaybe<CharacterQueryInput>>>;
  cloned_from_realm?: InputMaybe<RealmQueryInput>;
  cloned_from_realm_exists?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_exists?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_ne?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_gt?: InputMaybe<Scalars['String']['input']>;
  description_gte?: InputMaybe<Scalars['String']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_lt?: InputMaybe<Scalars['String']['input']>;
  description_lte?: InputMaybe<Scalars['String']['input']>;
  description_ne?: InputMaybe<Scalars['String']['input']>;
  description_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  editors?: InputMaybe<Array<InputMaybe<UserQueryInput>>>;
  editors_exists?: InputMaybe<Scalars['Boolean']['input']>;
  editors_in?: InputMaybe<Array<InputMaybe<UserQueryInput>>>;
  editors_nin?: InputMaybe<Array<InputMaybe<UserQueryInput>>>;
  is_favorited?: InputMaybe<Scalars['Boolean']['input']>;
  is_favorited_exists?: InputMaybe<Scalars['Boolean']['input']>;
  is_favorited_ne?: InputMaybe<Scalars['Boolean']['input']>;
  is_public?: InputMaybe<Scalars['Boolean']['input']>;
  is_public_exists?: InputMaybe<Scalars['Boolean']['input']>;
  is_public_ne?: InputMaybe<Scalars['Boolean']['input']>;
  media_asset?: InputMaybe<Media_AssetQueryInput>;
  media_asset_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  original_creator?: InputMaybe<UserQueryInput>;
  original_creator_exists?: InputMaybe<Scalars['Boolean']['input']>;
  owner?: InputMaybe<UserQueryInput>;
  owner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  realm_template?: InputMaybe<Realm_TemplateQueryInput>;
  realm_template_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tags_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  thumbnail_url?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  thumbnail_url_gt?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url_gte?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  thumbnail_url_lt?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url_lte?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url_ne?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  token_sets?: InputMaybe<Array<InputMaybe<Token_SetQueryInput>>>;
  token_sets_exists?: InputMaybe<Scalars['Boolean']['input']>;
  token_sets_in?: InputMaybe<Array<InputMaybe<Token_SetQueryInput>>>;
  token_sets_nin?: InputMaybe<Array<InputMaybe<Token_SetQueryInput>>>;
  tokens?: InputMaybe<Array<InputMaybe<TokenQueryInput>>>;
  tokens_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tokens_in?: InputMaybe<Array<InputMaybe<TokenQueryInput>>>;
  tokens_nin?: InputMaybe<Array<InputMaybe<TokenQueryInput>>>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at_exists?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updated_at_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at_ne?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  viewers?: InputMaybe<Array<InputMaybe<UserQueryInput>>>;
  viewers_exists?: InputMaybe<Scalars['Boolean']['input']>;
  viewers_in?: InputMaybe<Array<InputMaybe<UserQueryInput>>>;
  viewers_nin?: InputMaybe<Array<InputMaybe<UserQueryInput>>>;
};

export type RealmRealm_TemplateRelationInput = {
  create?: InputMaybe<Realm_TemplateInsertInput>;
  link?: InputMaybe<Scalars['ObjectId']['input']>;
};

export enum RealmSortByInput {
  ClonedFromRealmAsc = 'CLONED_FROM_REALM_ASC',
  ClonedFromRealmDesc = 'CLONED_FROM_REALM_DESC',
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  MediaAssetAsc = 'MEDIA_ASSET_ASC',
  MediaAssetDesc = 'MEDIA_ASSET_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  OriginalCreatorAsc = 'ORIGINAL_CREATOR_ASC',
  OriginalCreatorDesc = 'ORIGINAL_CREATOR_DESC',
  OwnerAsc = 'OWNER_ASC',
  OwnerDesc = 'OWNER_DESC',
  RealmTemplateAsc = 'REALM_TEMPLATE_ASC',
  RealmTemplateDesc = 'REALM_TEMPLATE_DESC',
  ThumbnailUrlAsc = 'THUMBNAIL_URL_ASC',
  ThumbnailUrlDesc = 'THUMBNAIL_URL_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type RealmToken_SetsRelationInput = {
  create?: InputMaybe<Array<InputMaybe<Token_SetInsertInput>>>;
  link?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
};

export type RealmTokensRelationInput = {
  create?: InputMaybe<Array<InputMaybe<TokenInsertInput>>>;
  link?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
};

export type RealmUpdateInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  characters?: InputMaybe<RealmCharactersRelationInput>;
  characters_unset?: InputMaybe<Scalars['Boolean']['input']>;
  cloned_from_realm?: InputMaybe<RealmCloned_From_RealmRelationInput>;
  cloned_from_realm_unset?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_unset?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_unset?: InputMaybe<Scalars['Boolean']['input']>;
  editors?: InputMaybe<RealmEditorsRelationInput>;
  editors_unset?: InputMaybe<Scalars['Boolean']['input']>;
  is_favorited?: InputMaybe<Scalars['Boolean']['input']>;
  is_favorited_unset?: InputMaybe<Scalars['Boolean']['input']>;
  is_public?: InputMaybe<Scalars['Boolean']['input']>;
  is_public_unset?: InputMaybe<Scalars['Boolean']['input']>;
  media_asset?: InputMaybe<RealmMedia_AssetRelationInput>;
  media_asset_unset?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_unset?: InputMaybe<Scalars['Boolean']['input']>;
  original_creator?: InputMaybe<RealmOriginal_CreatorRelationInput>;
  original_creator_unset?: InputMaybe<Scalars['Boolean']['input']>;
  owner?: InputMaybe<RealmOwnerRelationInput>;
  owner_unset?: InputMaybe<Scalars['Boolean']['input']>;
  realm_template?: InputMaybe<RealmRealm_TemplateRelationInput>;
  realm_template_unset?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_unset?: InputMaybe<Scalars['Boolean']['input']>;
  thumbnail_url?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url_unset?: InputMaybe<Scalars['Boolean']['input']>;
  token_sets?: InputMaybe<RealmToken_SetsRelationInput>;
  token_sets_unset?: InputMaybe<Scalars['Boolean']['input']>;
  tokens?: InputMaybe<RealmTokensRelationInput>;
  tokens_unset?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at_unset?: InputMaybe<Scalars['Boolean']['input']>;
  viewers?: InputMaybe<RealmViewersRelationInput>;
  viewers_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RealmViewersRelationInput = {
  create?: InputMaybe<Array<InputMaybe<UserInsertInput>>>;
  link?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Realm_Template = {
  __typename?: 'Realm_template';
  _id: Scalars['ObjectId']['output'];
  creator: User;
  name: Scalars['String']['output'];
  realm: Realm;
};

export type Realm_TemplateCreatorRelationInput = {
  create?: InputMaybe<UserInsertInput>;
  link?: InputMaybe<Scalars['String']['input']>;
};

export type Realm_TemplateInsertInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  creator: Realm_TemplateCreatorRelationInput;
  name: Scalars['String']['input'];
  realm: Realm_TemplateRealmRelationInput;
};

export type Realm_TemplateQueryInput = {
  AND?: InputMaybe<Array<Realm_TemplateQueryInput>>;
  OR?: InputMaybe<Array<Realm_TemplateQueryInput>>;
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  _id_gt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_gte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  _id_lt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_lte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_ne?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  creator?: InputMaybe<UserQueryInput>;
  creator_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  realm?: InputMaybe<RealmQueryInput>;
  realm_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Realm_TemplateRealmRelationInput = {
  create?: InputMaybe<RealmInsertInput>;
  link?: InputMaybe<Scalars['ObjectId']['input']>;
};

export enum Realm_TemplateSortByInput {
  CreatorAsc = 'CREATOR_ASC',
  CreatorDesc = 'CREATOR_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  RealmAsc = 'REALM_ASC',
  RealmDesc = 'REALM_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type Realm_TemplateUpdateInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  creator?: InputMaybe<Realm_TemplateCreatorRelationInput>;
  creator_unset?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_unset?: InputMaybe<Scalars['Boolean']['input']>;
  realm?: InputMaybe<Realm_TemplateRealmRelationInput>;
  realm_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Relationship_Status = {
  __typename?: 'Relationship_status';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Relationship_StatusInsertInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Relationship_StatusQueryInput = {
  AND?: InputMaybe<Array<Relationship_StatusQueryInput>>;
  OR?: InputMaybe<Array<Relationship_StatusQueryInput>>;
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  _id_gt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_gte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  _id_lt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_lte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_ne?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum Relationship_StatusSortByInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type Relationship_StatusUpdateInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Room = {
  __typename?: 'Room';
  assets?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>;
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type RoomInsertInput = {
  assets?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type RoomQueryInput = {
  AND?: InputMaybe<Array<RoomQueryInput>>;
  OR?: InputMaybe<Array<RoomQueryInput>>;
  assets?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  assets_exists?: InputMaybe<Scalars['Boolean']['input']>;
  assets_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  assets_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_gt?: InputMaybe<Scalars['String']['input']>;
  description_gte?: InputMaybe<Scalars['String']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_lt?: InputMaybe<Scalars['String']['input']>;
  description_lte?: InputMaybe<Scalars['String']['input']>;
  description_ne?: InputMaybe<Scalars['String']['input']>;
  description_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tags_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type RoomUpdateInput = {
  assets?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  assets_unset?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_unset?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_unset?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Skin = {
  __typename?: 'Skin';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type SkinInsertInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type SkinQueryInput = {
  AND?: InputMaybe<Array<SkinQueryInput>>;
  OR?: InputMaybe<Array<SkinQueryInput>>;
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  _id_gt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_gte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  _id_lt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_lte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_ne?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum SkinSortByInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type SkinUpdateInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Stripe_Customer = {
  __typename?: 'Stripe_customer';
  customer_id?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type Stripe_CustomerInsertInput = {
  customer_id?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Stripe_CustomerUserRelationInput>;
};

export type Stripe_CustomerQueryInput = {
  AND?: InputMaybe<Array<Stripe_CustomerQueryInput>>;
  OR?: InputMaybe<Array<Stripe_CustomerQueryInput>>;
  customer_id?: InputMaybe<Scalars['String']['input']>;
  customer_id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  customer_id_gt?: InputMaybe<Scalars['String']['input']>;
  customer_id_gte?: InputMaybe<Scalars['String']['input']>;
  customer_id_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  customer_id_lt?: InputMaybe<Scalars['String']['input']>;
  customer_id_lte?: InputMaybe<Scalars['String']['input']>;
  customer_id_ne?: InputMaybe<Scalars['String']['input']>;
  customer_id_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  user?: InputMaybe<UserQueryInput>;
  user_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum Stripe_CustomerSortByInput {
  CustomerIdAsc = 'CUSTOMER_ID_ASC',
  CustomerIdDesc = 'CUSTOMER_ID_DESC',
  UserAsc = 'USER_ASC',
  UserDesc = 'USER_DESC'
}

export type Stripe_CustomerUpdateInput = {
  customer_id?: InputMaybe<Scalars['String']['input']>;
  customer_id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  user?: InputMaybe<Stripe_CustomerUserRelationInput>;
  user_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Stripe_CustomerUserRelationInput = {
  create?: InputMaybe<UserInsertInput>;
  link?: InputMaybe<Scalars['String']['input']>;
};

export type Subscription_Tier = {
  __typename?: 'Subscription_tier';
  _id: Scalars['ObjectId']['output'];
  currency: Scalars['String']['output'];
  description: Scalars['String']['output'];
  imageUrl: Scalars['String']['output'];
  interval: Scalars['String']['output'];
  max_character_count?: Maybe<Scalars['Int']['output']>;
  max_realm_count: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  price: Scalars['String']['output'];
  ssgp_id?: Maybe<Scalars['Int']['output']>;
  stripe_product_id?: Maybe<Scalars['String']['output']>;
  tier_numeric_id?: Maybe<Scalars['Int']['output']>;
};

export type Subscription_TierInsertInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  currency: Scalars['String']['input'];
  description: Scalars['String']['input'];
  imageUrl: Scalars['String']['input'];
  interval: Scalars['String']['input'];
  max_character_count?: InputMaybe<Scalars['Int']['input']>;
  max_realm_count: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  price: Scalars['String']['input'];
  ssgp_id?: InputMaybe<Scalars['Int']['input']>;
  stripe_product_id?: InputMaybe<Scalars['String']['input']>;
  tier_numeric_id?: InputMaybe<Scalars['Int']['input']>;
};

export type Subscription_TierQueryInput = {
  AND?: InputMaybe<Array<Subscription_TierQueryInput>>;
  OR?: InputMaybe<Array<Subscription_TierQueryInput>>;
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  _id_gt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_gte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  _id_lt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_lte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_ne?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currency_exists?: InputMaybe<Scalars['Boolean']['input']>;
  currency_gt?: InputMaybe<Scalars['String']['input']>;
  currency_gte?: InputMaybe<Scalars['String']['input']>;
  currency_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  currency_lt?: InputMaybe<Scalars['String']['input']>;
  currency_lte?: InputMaybe<Scalars['String']['input']>;
  currency_ne?: InputMaybe<Scalars['String']['input']>;
  currency_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_gt?: InputMaybe<Scalars['String']['input']>;
  description_gte?: InputMaybe<Scalars['String']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_lt?: InputMaybe<Scalars['String']['input']>;
  description_lte?: InputMaybe<Scalars['String']['input']>;
  description_ne?: InputMaybe<Scalars['String']['input']>;
  description_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  imageUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageUrl_gt?: InputMaybe<Scalars['String']['input']>;
  imageUrl_gte?: InputMaybe<Scalars['String']['input']>;
  imageUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageUrl_lt?: InputMaybe<Scalars['String']['input']>;
  imageUrl_lte?: InputMaybe<Scalars['String']['input']>;
  imageUrl_ne?: InputMaybe<Scalars['String']['input']>;
  imageUrl_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  interval?: InputMaybe<Scalars['String']['input']>;
  interval_exists?: InputMaybe<Scalars['Boolean']['input']>;
  interval_gt?: InputMaybe<Scalars['String']['input']>;
  interval_gte?: InputMaybe<Scalars['String']['input']>;
  interval_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  interval_lt?: InputMaybe<Scalars['String']['input']>;
  interval_lte?: InputMaybe<Scalars['String']['input']>;
  interval_ne?: InputMaybe<Scalars['String']['input']>;
  interval_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  max_character_count?: InputMaybe<Scalars['Int']['input']>;
  max_character_count_exists?: InputMaybe<Scalars['Boolean']['input']>;
  max_character_count_gt?: InputMaybe<Scalars['Int']['input']>;
  max_character_count_gte?: InputMaybe<Scalars['Int']['input']>;
  max_character_count_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  max_character_count_lt?: InputMaybe<Scalars['Int']['input']>;
  max_character_count_lte?: InputMaybe<Scalars['Int']['input']>;
  max_character_count_ne?: InputMaybe<Scalars['Int']['input']>;
  max_character_count_nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  max_realm_count?: InputMaybe<Scalars['Int']['input']>;
  max_realm_count_exists?: InputMaybe<Scalars['Boolean']['input']>;
  max_realm_count_gt?: InputMaybe<Scalars['Int']['input']>;
  max_realm_count_gte?: InputMaybe<Scalars['Int']['input']>;
  max_realm_count_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  max_realm_count_lt?: InputMaybe<Scalars['Int']['input']>;
  max_realm_count_lte?: InputMaybe<Scalars['Int']['input']>;
  max_realm_count_ne?: InputMaybe<Scalars['Int']['input']>;
  max_realm_count_nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  price?: InputMaybe<Scalars['String']['input']>;
  price_exists?: InputMaybe<Scalars['Boolean']['input']>;
  price_gt?: InputMaybe<Scalars['String']['input']>;
  price_gte?: InputMaybe<Scalars['String']['input']>;
  price_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  price_lt?: InputMaybe<Scalars['String']['input']>;
  price_lte?: InputMaybe<Scalars['String']['input']>;
  price_ne?: InputMaybe<Scalars['String']['input']>;
  price_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ssgp_id?: InputMaybe<Scalars['Int']['input']>;
  ssgp_id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ssgp_id_gt?: InputMaybe<Scalars['Int']['input']>;
  ssgp_id_gte?: InputMaybe<Scalars['Int']['input']>;
  ssgp_id_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  ssgp_id_lt?: InputMaybe<Scalars['Int']['input']>;
  ssgp_id_lte?: InputMaybe<Scalars['Int']['input']>;
  ssgp_id_ne?: InputMaybe<Scalars['Int']['input']>;
  ssgp_id_nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  stripe_product_id?: InputMaybe<Scalars['String']['input']>;
  stripe_product_id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  stripe_product_id_gt?: InputMaybe<Scalars['String']['input']>;
  stripe_product_id_gte?: InputMaybe<Scalars['String']['input']>;
  stripe_product_id_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stripe_product_id_lt?: InputMaybe<Scalars['String']['input']>;
  stripe_product_id_lte?: InputMaybe<Scalars['String']['input']>;
  stripe_product_id_ne?: InputMaybe<Scalars['String']['input']>;
  stripe_product_id_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tier_numeric_id?: InputMaybe<Scalars['Int']['input']>;
  tier_numeric_id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tier_numeric_id_gt?: InputMaybe<Scalars['Int']['input']>;
  tier_numeric_id_gte?: InputMaybe<Scalars['Int']['input']>;
  tier_numeric_id_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  tier_numeric_id_lt?: InputMaybe<Scalars['Int']['input']>;
  tier_numeric_id_lte?: InputMaybe<Scalars['Int']['input']>;
  tier_numeric_id_ne?: InputMaybe<Scalars['Int']['input']>;
  tier_numeric_id_nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export enum Subscription_TierSortByInput {
  CurrencyAsc = 'CURRENCY_ASC',
  CurrencyDesc = 'CURRENCY_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  ImageurlAsc = 'IMAGEURL_ASC',
  ImageurlDesc = 'IMAGEURL_DESC',
  IntervalAsc = 'INTERVAL_ASC',
  IntervalDesc = 'INTERVAL_DESC',
  MaxCharacterCountAsc = 'MAX_CHARACTER_COUNT_ASC',
  MaxCharacterCountDesc = 'MAX_CHARACTER_COUNT_DESC',
  MaxRealmCountAsc = 'MAX_REALM_COUNT_ASC',
  MaxRealmCountDesc = 'MAX_REALM_COUNT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  PriceAsc = 'PRICE_ASC',
  PriceDesc = 'PRICE_DESC',
  SsgpIdAsc = 'SSGP_ID_ASC',
  SsgpIdDesc = 'SSGP_ID_DESC',
  StripeProductIdAsc = 'STRIPE_PRODUCT_ID_ASC',
  StripeProductIdDesc = 'STRIPE_PRODUCT_ID_DESC',
  TierNumericIdAsc = 'TIER_NUMERIC_ID_ASC',
  TierNumericIdDesc = 'TIER_NUMERIC_ID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type Subscription_TierUpdateInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currency_unset?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_unset?: InputMaybe<Scalars['Boolean']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  imageUrl_unset?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<Scalars['String']['input']>;
  interval_unset?: InputMaybe<Scalars['Boolean']['input']>;
  max_character_count?: InputMaybe<Scalars['Int']['input']>;
  max_character_count_inc?: InputMaybe<Scalars['Int']['input']>;
  max_character_count_unset?: InputMaybe<Scalars['Boolean']['input']>;
  max_realm_count?: InputMaybe<Scalars['Int']['input']>;
  max_realm_count_inc?: InputMaybe<Scalars['Int']['input']>;
  max_realm_count_unset?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_unset?: InputMaybe<Scalars['Boolean']['input']>;
  price?: InputMaybe<Scalars['String']['input']>;
  price_unset?: InputMaybe<Scalars['Boolean']['input']>;
  ssgp_id?: InputMaybe<Scalars['Int']['input']>;
  ssgp_id_inc?: InputMaybe<Scalars['Int']['input']>;
  ssgp_id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  stripe_product_id?: InputMaybe<Scalars['String']['input']>;
  stripe_product_id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  tier_numeric_id?: InputMaybe<Scalars['Int']['input']>;
  tier_numeric_id_inc?: InputMaybe<Scalars['Int']['input']>;
  tier_numeric_id_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Text_Generation_Sku = {
  __typename?: 'Text_generation_sku';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  min_subscription_tier_id?: Maybe<Subscription_Tier>;
  model?: Maybe<Scalars['String']['output']>;
  modified_at?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  repeat_penalty?: Maybe<Scalars['Float']['output']>;
  speed_tier?: Maybe<Scalars['String']['output']>;
  temperature?: Maybe<Scalars['Float']['output']>;
  token_count?: Maybe<Scalars['Int']['output']>;
  top_k?: Maybe<Scalars['Float']['output']>;
  top_p?: Maybe<Scalars['Float']['output']>;
};

export type Text_Generation_SkuInsertInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  min_subscription_tier_id?: InputMaybe<Text_Generation_SkuMin_Subscription_Tier_IdRelationInput>;
  model?: InputMaybe<Scalars['String']['input']>;
  modified_at?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  repeat_penalty?: InputMaybe<Scalars['Float']['input']>;
  speed_tier?: InputMaybe<Scalars['String']['input']>;
  temperature?: InputMaybe<Scalars['Float']['input']>;
  token_count?: InputMaybe<Scalars['Int']['input']>;
  top_k?: InputMaybe<Scalars['Float']['input']>;
  top_p?: InputMaybe<Scalars['Float']['input']>;
};

export type Text_Generation_SkuMin_Subscription_Tier_IdRelationInput = {
  create?: InputMaybe<Subscription_TierInsertInput>;
  link?: InputMaybe<Scalars['Int']['input']>;
};

export type Text_Generation_SkuQueryInput = {
  AND?: InputMaybe<Array<Text_Generation_SkuQueryInput>>;
  OR?: InputMaybe<Array<Text_Generation_SkuQueryInput>>;
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  _id_gt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_gte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  _id_lt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_lte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_ne?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_exists?: InputMaybe<Scalars['Boolean']['input']>;
  created_at_gt?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_gte?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  created_at_lt?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_lte?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_ne?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_gt?: InputMaybe<Scalars['String']['input']>;
  description_gte?: InputMaybe<Scalars['String']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_lt?: InputMaybe<Scalars['String']['input']>;
  description_lte?: InputMaybe<Scalars['String']['input']>;
  description_ne?: InputMaybe<Scalars['String']['input']>;
  description_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  min_subscription_tier_id?: InputMaybe<Subscription_TierQueryInput>;
  min_subscription_tier_id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  model_exists?: InputMaybe<Scalars['Boolean']['input']>;
  model_gt?: InputMaybe<Scalars['String']['input']>;
  model_gte?: InputMaybe<Scalars['String']['input']>;
  model_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  model_lt?: InputMaybe<Scalars['String']['input']>;
  model_lte?: InputMaybe<Scalars['String']['input']>;
  model_ne?: InputMaybe<Scalars['String']['input']>;
  model_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modified_at?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_exists?: InputMaybe<Scalars['Boolean']['input']>;
  modified_at_gt?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_gte?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  modified_at_lt?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_lte?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_ne?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  repeat_penalty?: InputMaybe<Scalars['Float']['input']>;
  repeat_penalty_exists?: InputMaybe<Scalars['Boolean']['input']>;
  repeat_penalty_gt?: InputMaybe<Scalars['Float']['input']>;
  repeat_penalty_gte?: InputMaybe<Scalars['Float']['input']>;
  repeat_penalty_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  repeat_penalty_lt?: InputMaybe<Scalars['Float']['input']>;
  repeat_penalty_lte?: InputMaybe<Scalars['Float']['input']>;
  repeat_penalty_ne?: InputMaybe<Scalars['Float']['input']>;
  repeat_penalty_nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  speed_tier?: InputMaybe<Scalars['String']['input']>;
  speed_tier_exists?: InputMaybe<Scalars['Boolean']['input']>;
  speed_tier_gt?: InputMaybe<Scalars['String']['input']>;
  speed_tier_gte?: InputMaybe<Scalars['String']['input']>;
  speed_tier_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  speed_tier_lt?: InputMaybe<Scalars['String']['input']>;
  speed_tier_lte?: InputMaybe<Scalars['String']['input']>;
  speed_tier_ne?: InputMaybe<Scalars['String']['input']>;
  speed_tier_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  temperature?: InputMaybe<Scalars['Float']['input']>;
  temperature_exists?: InputMaybe<Scalars['Boolean']['input']>;
  temperature_gt?: InputMaybe<Scalars['Float']['input']>;
  temperature_gte?: InputMaybe<Scalars['Float']['input']>;
  temperature_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  temperature_lt?: InputMaybe<Scalars['Float']['input']>;
  temperature_lte?: InputMaybe<Scalars['Float']['input']>;
  temperature_ne?: InputMaybe<Scalars['Float']['input']>;
  temperature_nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  token_count?: InputMaybe<Scalars['Int']['input']>;
  token_count_exists?: InputMaybe<Scalars['Boolean']['input']>;
  token_count_gt?: InputMaybe<Scalars['Int']['input']>;
  token_count_gte?: InputMaybe<Scalars['Int']['input']>;
  token_count_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  token_count_lt?: InputMaybe<Scalars['Int']['input']>;
  token_count_lte?: InputMaybe<Scalars['Int']['input']>;
  token_count_ne?: InputMaybe<Scalars['Int']['input']>;
  token_count_nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  top_k?: InputMaybe<Scalars['Float']['input']>;
  top_k_exists?: InputMaybe<Scalars['Boolean']['input']>;
  top_k_gt?: InputMaybe<Scalars['Float']['input']>;
  top_k_gte?: InputMaybe<Scalars['Float']['input']>;
  top_k_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  top_k_lt?: InputMaybe<Scalars['Float']['input']>;
  top_k_lte?: InputMaybe<Scalars['Float']['input']>;
  top_k_ne?: InputMaybe<Scalars['Float']['input']>;
  top_k_nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  top_p?: InputMaybe<Scalars['Float']['input']>;
  top_p_exists?: InputMaybe<Scalars['Boolean']['input']>;
  top_p_gt?: InputMaybe<Scalars['Float']['input']>;
  top_p_gte?: InputMaybe<Scalars['Float']['input']>;
  top_p_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  top_p_lt?: InputMaybe<Scalars['Float']['input']>;
  top_p_lte?: InputMaybe<Scalars['Float']['input']>;
  top_p_ne?: InputMaybe<Scalars['Float']['input']>;
  top_p_nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export enum Text_Generation_SkuSortByInput {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  MinSubscriptionTierIdAsc = 'MIN_SUBSCRIPTION_TIER_ID_ASC',
  MinSubscriptionTierIdDesc = 'MIN_SUBSCRIPTION_TIER_ID_DESC',
  ModelAsc = 'MODEL_ASC',
  ModelDesc = 'MODEL_DESC',
  ModifiedAtAsc = 'MODIFIED_AT_ASC',
  ModifiedAtDesc = 'MODIFIED_AT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  RepeatPenaltyAsc = 'REPEAT_PENALTY_ASC',
  RepeatPenaltyDesc = 'REPEAT_PENALTY_DESC',
  SpeedTierAsc = 'SPEED_TIER_ASC',
  SpeedTierDesc = 'SPEED_TIER_DESC',
  TemperatureAsc = 'TEMPERATURE_ASC',
  TemperatureDesc = 'TEMPERATURE_DESC',
  TokenCountAsc = 'TOKEN_COUNT_ASC',
  TokenCountDesc = 'TOKEN_COUNT_DESC',
  TopKAsc = 'TOP_K_ASC',
  TopKDesc = 'TOP_K_DESC',
  TopPAsc = 'TOP_P_ASC',
  TopPDesc = 'TOP_P_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type Text_Generation_SkuUpdateInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_unset?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_unset?: InputMaybe<Scalars['Boolean']['input']>;
  min_subscription_tier_id?: InputMaybe<Text_Generation_SkuMin_Subscription_Tier_IdRelationInput>;
  min_subscription_tier_id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  model_unset?: InputMaybe<Scalars['Boolean']['input']>;
  modified_at?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_unset?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_unset?: InputMaybe<Scalars['Boolean']['input']>;
  repeat_penalty?: InputMaybe<Scalars['Float']['input']>;
  repeat_penalty_inc?: InputMaybe<Scalars['Float']['input']>;
  repeat_penalty_unset?: InputMaybe<Scalars['Boolean']['input']>;
  speed_tier?: InputMaybe<Scalars['String']['input']>;
  speed_tier_unset?: InputMaybe<Scalars['Boolean']['input']>;
  temperature?: InputMaybe<Scalars['Float']['input']>;
  temperature_inc?: InputMaybe<Scalars['Float']['input']>;
  temperature_unset?: InputMaybe<Scalars['Boolean']['input']>;
  token_count?: InputMaybe<Scalars['Int']['input']>;
  token_count_inc?: InputMaybe<Scalars['Int']['input']>;
  token_count_unset?: InputMaybe<Scalars['Boolean']['input']>;
  top_k?: InputMaybe<Scalars['Float']['input']>;
  top_k_inc?: InputMaybe<Scalars['Float']['input']>;
  top_k_unset?: InputMaybe<Scalars['Boolean']['input']>;
  top_p?: InputMaybe<Scalars['Float']['input']>;
  top_p_inc?: InputMaybe<Scalars['Float']['input']>;
  top_p_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Theme = {
  __typename?: 'Theme';
  _id: Scalars['ObjectId']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type ThemeInsertInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ThemeQueryInput = {
  AND?: InputMaybe<Array<ThemeQueryInput>>;
  OR?: InputMaybe<Array<ThemeQueryInput>>;
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  _id_gt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_gte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  _id_lt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_lte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_ne?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum ThemeSortByInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type ThemeUpdateInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Token = {
  __typename?: 'Token';
  _id: Scalars['ObjectId']['output'];
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  is_favorited: Scalars['Boolean']['output'];
  is_public: Scalars['Boolean']['output'];
  is_visible_in_tool: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  notes?: Maybe<Array<Maybe<Note>>>;
  owner: User;
  realm: Realm;
  thumbnail_image_path: Scalars['String']['output'];
  thumbnail_url?: Maybe<Scalars['String']['output']>;
  token_base_image_path?: Maybe<Scalars['String']['output']>;
  token_base_image_url: Scalars['String']['output'];
  token_edits?: Maybe<Array<Maybe<TokenToken_Edit>>>;
  token_image_path?: Maybe<Scalars['String']['output']>;
  token_set?: Maybe<Token_Set>;
  token_url?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['String']['output']>;
};

export type TokenInsertInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  created_at: Scalars['DateTime']['input'];
  created_by?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  is_favorited: Scalars['Boolean']['input'];
  is_public: Scalars['Boolean']['input'];
  is_visible_in_tool: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  notes?: InputMaybe<TokenNotesRelationInput>;
  owner: TokenOwnerRelationInput;
  realm: TokenRealmRelationInput;
  thumbnail_image_path: Scalars['String']['input'];
  thumbnail_url?: InputMaybe<Scalars['String']['input']>;
  token_base_image_path?: InputMaybe<Scalars['String']['input']>;
  token_base_image_url: Scalars['String']['input'];
  token_edits?: InputMaybe<Array<InputMaybe<TokenToken_EditInsertInput>>>;
  token_image_path?: InputMaybe<Scalars['String']['input']>;
  token_set?: InputMaybe<TokenToken_SetRelationInput>;
  token_url?: InputMaybe<Scalars['String']['input']>;
  updated_at: Scalars['DateTime']['input'];
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

export type TokenNotesRelationInput = {
  create?: InputMaybe<Array<InputMaybe<NoteInsertInput>>>;
  link?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
};

export type TokenOwnerRelationInput = {
  create?: InputMaybe<UserInsertInput>;
  link?: InputMaybe<Scalars['String']['input']>;
};

export type TokenQueryInput = {
  AND?: InputMaybe<Array<TokenQueryInput>>;
  OR?: InputMaybe<Array<TokenQueryInput>>;
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  _id_gt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_gte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  _id_lt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_lte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_ne?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_exists?: InputMaybe<Scalars['Boolean']['input']>;
  created_at_gt?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_gte?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  created_at_lt?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_lte?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_ne?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  created_by_exists?: InputMaybe<Scalars['Boolean']['input']>;
  created_by_gt?: InputMaybe<Scalars['String']['input']>;
  created_by_gte?: InputMaybe<Scalars['String']['input']>;
  created_by_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  created_by_lt?: InputMaybe<Scalars['String']['input']>;
  created_by_lte?: InputMaybe<Scalars['String']['input']>;
  created_by_ne?: InputMaybe<Scalars['String']['input']>;
  created_by_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_gt?: InputMaybe<Scalars['String']['input']>;
  description_gte?: InputMaybe<Scalars['String']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_lt?: InputMaybe<Scalars['String']['input']>;
  description_lte?: InputMaybe<Scalars['String']['input']>;
  description_ne?: InputMaybe<Scalars['String']['input']>;
  description_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  is_favorited?: InputMaybe<Scalars['Boolean']['input']>;
  is_favorited_exists?: InputMaybe<Scalars['Boolean']['input']>;
  is_favorited_ne?: InputMaybe<Scalars['Boolean']['input']>;
  is_public?: InputMaybe<Scalars['Boolean']['input']>;
  is_public_exists?: InputMaybe<Scalars['Boolean']['input']>;
  is_public_ne?: InputMaybe<Scalars['Boolean']['input']>;
  is_visible_in_tool?: InputMaybe<Scalars['Boolean']['input']>;
  is_visible_in_tool_exists?: InputMaybe<Scalars['Boolean']['input']>;
  is_visible_in_tool_ne?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notes?: InputMaybe<Array<InputMaybe<NoteQueryInput>>>;
  notes_exists?: InputMaybe<Scalars['Boolean']['input']>;
  notes_in?: InputMaybe<Array<InputMaybe<NoteQueryInput>>>;
  notes_nin?: InputMaybe<Array<InputMaybe<NoteQueryInput>>>;
  owner?: InputMaybe<UserQueryInput>;
  owner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  realm?: InputMaybe<RealmQueryInput>;
  realm_exists?: InputMaybe<Scalars['Boolean']['input']>;
  thumbnail_image_path?: InputMaybe<Scalars['String']['input']>;
  thumbnail_image_path_exists?: InputMaybe<Scalars['Boolean']['input']>;
  thumbnail_image_path_gt?: InputMaybe<Scalars['String']['input']>;
  thumbnail_image_path_gte?: InputMaybe<Scalars['String']['input']>;
  thumbnail_image_path_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  thumbnail_image_path_lt?: InputMaybe<Scalars['String']['input']>;
  thumbnail_image_path_lte?: InputMaybe<Scalars['String']['input']>;
  thumbnail_image_path_ne?: InputMaybe<Scalars['String']['input']>;
  thumbnail_image_path_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  thumbnail_url?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  thumbnail_url_gt?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url_gte?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  thumbnail_url_lt?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url_lte?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url_ne?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  token_base_image_path?: InputMaybe<Scalars['String']['input']>;
  token_base_image_path_exists?: InputMaybe<Scalars['Boolean']['input']>;
  token_base_image_path_gt?: InputMaybe<Scalars['String']['input']>;
  token_base_image_path_gte?: InputMaybe<Scalars['String']['input']>;
  token_base_image_path_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  token_base_image_path_lt?: InputMaybe<Scalars['String']['input']>;
  token_base_image_path_lte?: InputMaybe<Scalars['String']['input']>;
  token_base_image_path_ne?: InputMaybe<Scalars['String']['input']>;
  token_base_image_path_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  token_base_image_url?: InputMaybe<Scalars['String']['input']>;
  token_base_image_url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  token_base_image_url_gt?: InputMaybe<Scalars['String']['input']>;
  token_base_image_url_gte?: InputMaybe<Scalars['String']['input']>;
  token_base_image_url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  token_base_image_url_lt?: InputMaybe<Scalars['String']['input']>;
  token_base_image_url_lte?: InputMaybe<Scalars['String']['input']>;
  token_base_image_url_ne?: InputMaybe<Scalars['String']['input']>;
  token_base_image_url_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  token_edits?: InputMaybe<Array<InputMaybe<TokenToken_EditQueryInput>>>;
  token_edits_exists?: InputMaybe<Scalars['Boolean']['input']>;
  token_edits_in?: InputMaybe<Array<InputMaybe<TokenToken_EditQueryInput>>>;
  token_edits_nin?: InputMaybe<Array<InputMaybe<TokenToken_EditQueryInput>>>;
  token_image_path?: InputMaybe<Scalars['String']['input']>;
  token_image_path_exists?: InputMaybe<Scalars['Boolean']['input']>;
  token_image_path_gt?: InputMaybe<Scalars['String']['input']>;
  token_image_path_gte?: InputMaybe<Scalars['String']['input']>;
  token_image_path_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  token_image_path_lt?: InputMaybe<Scalars['String']['input']>;
  token_image_path_lte?: InputMaybe<Scalars['String']['input']>;
  token_image_path_ne?: InputMaybe<Scalars['String']['input']>;
  token_image_path_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  token_set?: InputMaybe<Token_SetQueryInput>;
  token_set_exists?: InputMaybe<Scalars['Boolean']['input']>;
  token_url?: InputMaybe<Scalars['String']['input']>;
  token_url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  token_url_gt?: InputMaybe<Scalars['String']['input']>;
  token_url_gte?: InputMaybe<Scalars['String']['input']>;
  token_url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  token_url_lt?: InputMaybe<Scalars['String']['input']>;
  token_url_lte?: InputMaybe<Scalars['String']['input']>;
  token_url_ne?: InputMaybe<Scalars['String']['input']>;
  token_url_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at_exists?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updated_at_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at_ne?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
  updated_by_exists?: InputMaybe<Scalars['Boolean']['input']>;
  updated_by_gt?: InputMaybe<Scalars['String']['input']>;
  updated_by_gte?: InputMaybe<Scalars['String']['input']>;
  updated_by_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updated_by_lt?: InputMaybe<Scalars['String']['input']>;
  updated_by_lte?: InputMaybe<Scalars['String']['input']>;
  updated_by_ne?: InputMaybe<Scalars['String']['input']>;
  updated_by_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TokenRealmRelationInput = {
  create?: InputMaybe<RealmInsertInput>;
  link?: InputMaybe<Scalars['ObjectId']['input']>;
};

export enum TokenSortByInput {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByAsc = 'CREATED_BY_ASC',
  CreatedByDesc = 'CREATED_BY_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  OwnerAsc = 'OWNER_ASC',
  OwnerDesc = 'OWNER_DESC',
  RealmAsc = 'REALM_ASC',
  RealmDesc = 'REALM_DESC',
  ThumbnailImagePathAsc = 'THUMBNAIL_IMAGE_PATH_ASC',
  ThumbnailImagePathDesc = 'THUMBNAIL_IMAGE_PATH_DESC',
  ThumbnailUrlAsc = 'THUMBNAIL_URL_ASC',
  ThumbnailUrlDesc = 'THUMBNAIL_URL_DESC',
  TokenBaseImagePathAsc = 'TOKEN_BASE_IMAGE_PATH_ASC',
  TokenBaseImagePathDesc = 'TOKEN_BASE_IMAGE_PATH_DESC',
  TokenBaseImageUrlAsc = 'TOKEN_BASE_IMAGE_URL_ASC',
  TokenBaseImageUrlDesc = 'TOKEN_BASE_IMAGE_URL_DESC',
  TokenImagePathAsc = 'TOKEN_IMAGE_PATH_ASC',
  TokenImagePathDesc = 'TOKEN_IMAGE_PATH_DESC',
  TokenSetAsc = 'TOKEN_SET_ASC',
  TokenSetDesc = 'TOKEN_SET_DESC',
  TokenUrlAsc = 'TOKEN_URL_ASC',
  TokenUrlDesc = 'TOKEN_URL_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UpdatedByAsc = 'UPDATED_BY_ASC',
  UpdatedByDesc = 'UPDATED_BY_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type TokenToken_Edit = {
  __typename?: 'TokenToken_edit';
  attributes?: Maybe<TokenToken_EditAttribute>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type TokenToken_EditAttribute = {
  __typename?: 'TokenToken_editAttribute';
  brightness?: Maybe<Scalars['Float']['output']>;
  data_frame_type?: Maybe<Scalars['String']['output']>;
  data_item_type?: Maybe<Scalars['String']['output']>;
  draggable?: Maybe<Scalars['Boolean']['output']>;
  fill?: Maybe<Scalars['String']['output']>;
  filters?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  height?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  offset_x?: Maybe<Scalars['Float']['output']>;
  offset_y?: Maybe<Scalars['Float']['output']>;
  opacity?: Maybe<Scalars['Float']['output']>;
  rotation?: Maybe<Scalars['Float']['output']>;
  scale_x?: Maybe<Scalars['Float']['output']>;
  scale_y?: Maybe<Scalars['Float']['output']>;
  skew_x?: Maybe<Scalars['Float']['output']>;
  skew_y?: Maybe<Scalars['Float']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
  x?: Maybe<Scalars['Float']['output']>;
  y?: Maybe<Scalars['Float']['output']>;
  z_index?: Maybe<Scalars['Int']['output']>;
};

export type TokenToken_EditAttributeInsertInput = {
  brightness?: InputMaybe<Scalars['Float']['input']>;
  data_frame_type?: InputMaybe<Scalars['String']['input']>;
  data_item_type?: InputMaybe<Scalars['String']['input']>;
  draggable?: InputMaybe<Scalars['Boolean']['input']>;
  fill?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  height?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset_x?: InputMaybe<Scalars['Float']['input']>;
  offset_y?: InputMaybe<Scalars['Float']['input']>;
  opacity?: InputMaybe<Scalars['Float']['input']>;
  rotation?: InputMaybe<Scalars['Float']['input']>;
  scale_x?: InputMaybe<Scalars['Float']['input']>;
  scale_y?: InputMaybe<Scalars['Float']['input']>;
  skew_x?: InputMaybe<Scalars['Float']['input']>;
  skew_y?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
  x?: InputMaybe<Scalars['Float']['input']>;
  y?: InputMaybe<Scalars['Float']['input']>;
  z_index?: InputMaybe<Scalars['Int']['input']>;
};

export type TokenToken_EditAttributeQueryInput = {
  AND?: InputMaybe<Array<TokenToken_EditAttributeQueryInput>>;
  OR?: InputMaybe<Array<TokenToken_EditAttributeQueryInput>>;
  brightness?: InputMaybe<Scalars['Float']['input']>;
  brightness_exists?: InputMaybe<Scalars['Boolean']['input']>;
  brightness_gt?: InputMaybe<Scalars['Float']['input']>;
  brightness_gte?: InputMaybe<Scalars['Float']['input']>;
  brightness_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  brightness_lt?: InputMaybe<Scalars['Float']['input']>;
  brightness_lte?: InputMaybe<Scalars['Float']['input']>;
  brightness_ne?: InputMaybe<Scalars['Float']['input']>;
  brightness_nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  data_frame_type?: InputMaybe<Scalars['String']['input']>;
  data_frame_type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  data_frame_type_gt?: InputMaybe<Scalars['String']['input']>;
  data_frame_type_gte?: InputMaybe<Scalars['String']['input']>;
  data_frame_type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  data_frame_type_lt?: InputMaybe<Scalars['String']['input']>;
  data_frame_type_lte?: InputMaybe<Scalars['String']['input']>;
  data_frame_type_ne?: InputMaybe<Scalars['String']['input']>;
  data_frame_type_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  data_item_type?: InputMaybe<Scalars['String']['input']>;
  data_item_type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  data_item_type_gt?: InputMaybe<Scalars['String']['input']>;
  data_item_type_gte?: InputMaybe<Scalars['String']['input']>;
  data_item_type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  data_item_type_lt?: InputMaybe<Scalars['String']['input']>;
  data_item_type_lte?: InputMaybe<Scalars['String']['input']>;
  data_item_type_ne?: InputMaybe<Scalars['String']['input']>;
  data_item_type_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  draggable?: InputMaybe<Scalars['Boolean']['input']>;
  draggable_exists?: InputMaybe<Scalars['Boolean']['input']>;
  draggable_ne?: InputMaybe<Scalars['Boolean']['input']>;
  fill?: InputMaybe<Scalars['String']['input']>;
  fill_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fill_gt?: InputMaybe<Scalars['String']['input']>;
  fill_gte?: InputMaybe<Scalars['String']['input']>;
  fill_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fill_lt?: InputMaybe<Scalars['String']['input']>;
  fill_lte?: InputMaybe<Scalars['String']['input']>;
  fill_ne?: InputMaybe<Scalars['String']['input']>;
  fill_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filters_exists?: InputMaybe<Scalars['Boolean']['input']>;
  filters_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filters_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  height?: InputMaybe<Scalars['Int']['input']>;
  height_exists?: InputMaybe<Scalars['Boolean']['input']>;
  height_gt?: InputMaybe<Scalars['Int']['input']>;
  height_gte?: InputMaybe<Scalars['Int']['input']>;
  height_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  height_lt?: InputMaybe<Scalars['Int']['input']>;
  height_lte?: InputMaybe<Scalars['Int']['input']>;
  height_ne?: InputMaybe<Scalars['Int']['input']>;
  height_nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  offset_x?: InputMaybe<Scalars['Float']['input']>;
  offset_x_exists?: InputMaybe<Scalars['Boolean']['input']>;
  offset_x_gt?: InputMaybe<Scalars['Float']['input']>;
  offset_x_gte?: InputMaybe<Scalars['Float']['input']>;
  offset_x_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  offset_x_lt?: InputMaybe<Scalars['Float']['input']>;
  offset_x_lte?: InputMaybe<Scalars['Float']['input']>;
  offset_x_ne?: InputMaybe<Scalars['Float']['input']>;
  offset_x_nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  offset_y?: InputMaybe<Scalars['Float']['input']>;
  offset_y_exists?: InputMaybe<Scalars['Boolean']['input']>;
  offset_y_gt?: InputMaybe<Scalars['Float']['input']>;
  offset_y_gte?: InputMaybe<Scalars['Float']['input']>;
  offset_y_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  offset_y_lt?: InputMaybe<Scalars['Float']['input']>;
  offset_y_lte?: InputMaybe<Scalars['Float']['input']>;
  offset_y_ne?: InputMaybe<Scalars['Float']['input']>;
  offset_y_nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  opacity?: InputMaybe<Scalars['Float']['input']>;
  opacity_exists?: InputMaybe<Scalars['Boolean']['input']>;
  opacity_gt?: InputMaybe<Scalars['Float']['input']>;
  opacity_gte?: InputMaybe<Scalars['Float']['input']>;
  opacity_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  opacity_lt?: InputMaybe<Scalars['Float']['input']>;
  opacity_lte?: InputMaybe<Scalars['Float']['input']>;
  opacity_ne?: InputMaybe<Scalars['Float']['input']>;
  opacity_nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  rotation?: InputMaybe<Scalars['Float']['input']>;
  rotation_exists?: InputMaybe<Scalars['Boolean']['input']>;
  rotation_gt?: InputMaybe<Scalars['Float']['input']>;
  rotation_gte?: InputMaybe<Scalars['Float']['input']>;
  rotation_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  rotation_lt?: InputMaybe<Scalars['Float']['input']>;
  rotation_lte?: InputMaybe<Scalars['Float']['input']>;
  rotation_ne?: InputMaybe<Scalars['Float']['input']>;
  rotation_nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  scale_x?: InputMaybe<Scalars['Float']['input']>;
  scale_x_exists?: InputMaybe<Scalars['Boolean']['input']>;
  scale_x_gt?: InputMaybe<Scalars['Float']['input']>;
  scale_x_gte?: InputMaybe<Scalars['Float']['input']>;
  scale_x_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  scale_x_lt?: InputMaybe<Scalars['Float']['input']>;
  scale_x_lte?: InputMaybe<Scalars['Float']['input']>;
  scale_x_ne?: InputMaybe<Scalars['Float']['input']>;
  scale_x_nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  scale_y?: InputMaybe<Scalars['Float']['input']>;
  scale_y_exists?: InputMaybe<Scalars['Boolean']['input']>;
  scale_y_gt?: InputMaybe<Scalars['Float']['input']>;
  scale_y_gte?: InputMaybe<Scalars['Float']['input']>;
  scale_y_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  scale_y_lt?: InputMaybe<Scalars['Float']['input']>;
  scale_y_lte?: InputMaybe<Scalars['Float']['input']>;
  scale_y_ne?: InputMaybe<Scalars['Float']['input']>;
  scale_y_nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  skew_x?: InputMaybe<Scalars['Float']['input']>;
  skew_x_exists?: InputMaybe<Scalars['Boolean']['input']>;
  skew_x_gt?: InputMaybe<Scalars['Float']['input']>;
  skew_x_gte?: InputMaybe<Scalars['Float']['input']>;
  skew_x_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  skew_x_lt?: InputMaybe<Scalars['Float']['input']>;
  skew_x_lte?: InputMaybe<Scalars['Float']['input']>;
  skew_x_ne?: InputMaybe<Scalars['Float']['input']>;
  skew_x_nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  skew_y?: InputMaybe<Scalars['Float']['input']>;
  skew_y_exists?: InputMaybe<Scalars['Boolean']['input']>;
  skew_y_gt?: InputMaybe<Scalars['Float']['input']>;
  skew_y_gte?: InputMaybe<Scalars['Float']['input']>;
  skew_y_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  skew_y_lt?: InputMaybe<Scalars['Float']['input']>;
  skew_y_lte?: InputMaybe<Scalars['Float']['input']>;
  skew_y_ne?: InputMaybe<Scalars['Float']['input']>;
  skew_y_nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  width?: InputMaybe<Scalars['Int']['input']>;
  width_exists?: InputMaybe<Scalars['Boolean']['input']>;
  width_gt?: InputMaybe<Scalars['Int']['input']>;
  width_gte?: InputMaybe<Scalars['Int']['input']>;
  width_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  width_lt?: InputMaybe<Scalars['Int']['input']>;
  width_lte?: InputMaybe<Scalars['Int']['input']>;
  width_ne?: InputMaybe<Scalars['Int']['input']>;
  width_nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  x?: InputMaybe<Scalars['Float']['input']>;
  x_exists?: InputMaybe<Scalars['Boolean']['input']>;
  x_gt?: InputMaybe<Scalars['Float']['input']>;
  x_gte?: InputMaybe<Scalars['Float']['input']>;
  x_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  x_lt?: InputMaybe<Scalars['Float']['input']>;
  x_lte?: InputMaybe<Scalars['Float']['input']>;
  x_ne?: InputMaybe<Scalars['Float']['input']>;
  x_nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  y?: InputMaybe<Scalars['Float']['input']>;
  y_exists?: InputMaybe<Scalars['Boolean']['input']>;
  y_gt?: InputMaybe<Scalars['Float']['input']>;
  y_gte?: InputMaybe<Scalars['Float']['input']>;
  y_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  y_lt?: InputMaybe<Scalars['Float']['input']>;
  y_lte?: InputMaybe<Scalars['Float']['input']>;
  y_ne?: InputMaybe<Scalars['Float']['input']>;
  y_nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  z_index?: InputMaybe<Scalars['Int']['input']>;
  z_index_exists?: InputMaybe<Scalars['Boolean']['input']>;
  z_index_gt?: InputMaybe<Scalars['Int']['input']>;
  z_index_gte?: InputMaybe<Scalars['Int']['input']>;
  z_index_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  z_index_lt?: InputMaybe<Scalars['Int']['input']>;
  z_index_lte?: InputMaybe<Scalars['Int']['input']>;
  z_index_ne?: InputMaybe<Scalars['Int']['input']>;
  z_index_nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type TokenToken_EditAttributeUpdateInput = {
  brightness?: InputMaybe<Scalars['Float']['input']>;
  brightness_inc?: InputMaybe<Scalars['Float']['input']>;
  brightness_unset?: InputMaybe<Scalars['Boolean']['input']>;
  data_frame_type?: InputMaybe<Scalars['String']['input']>;
  data_frame_type_unset?: InputMaybe<Scalars['Boolean']['input']>;
  data_item_type?: InputMaybe<Scalars['String']['input']>;
  data_item_type_unset?: InputMaybe<Scalars['Boolean']['input']>;
  draggable?: InputMaybe<Scalars['Boolean']['input']>;
  draggable_unset?: InputMaybe<Scalars['Boolean']['input']>;
  fill?: InputMaybe<Scalars['String']['input']>;
  fill_unset?: InputMaybe<Scalars['Boolean']['input']>;
  filters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filters_unset?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  height_inc?: InputMaybe<Scalars['Int']['input']>;
  height_unset?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_unset?: InputMaybe<Scalars['Boolean']['input']>;
  offset_x?: InputMaybe<Scalars['Float']['input']>;
  offset_x_inc?: InputMaybe<Scalars['Float']['input']>;
  offset_x_unset?: InputMaybe<Scalars['Boolean']['input']>;
  offset_y?: InputMaybe<Scalars['Float']['input']>;
  offset_y_inc?: InputMaybe<Scalars['Float']['input']>;
  offset_y_unset?: InputMaybe<Scalars['Boolean']['input']>;
  opacity?: InputMaybe<Scalars['Float']['input']>;
  opacity_inc?: InputMaybe<Scalars['Float']['input']>;
  opacity_unset?: InputMaybe<Scalars['Boolean']['input']>;
  rotation?: InputMaybe<Scalars['Float']['input']>;
  rotation_inc?: InputMaybe<Scalars['Float']['input']>;
  rotation_unset?: InputMaybe<Scalars['Boolean']['input']>;
  scale_x?: InputMaybe<Scalars['Float']['input']>;
  scale_x_inc?: InputMaybe<Scalars['Float']['input']>;
  scale_x_unset?: InputMaybe<Scalars['Boolean']['input']>;
  scale_y?: InputMaybe<Scalars['Float']['input']>;
  scale_y_inc?: InputMaybe<Scalars['Float']['input']>;
  scale_y_unset?: InputMaybe<Scalars['Boolean']['input']>;
  skew_x?: InputMaybe<Scalars['Float']['input']>;
  skew_x_inc?: InputMaybe<Scalars['Float']['input']>;
  skew_x_unset?: InputMaybe<Scalars['Boolean']['input']>;
  skew_y?: InputMaybe<Scalars['Float']['input']>;
  skew_y_inc?: InputMaybe<Scalars['Float']['input']>;
  skew_y_unset?: InputMaybe<Scalars['Boolean']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
  width_inc?: InputMaybe<Scalars['Int']['input']>;
  width_unset?: InputMaybe<Scalars['Boolean']['input']>;
  x?: InputMaybe<Scalars['Float']['input']>;
  x_inc?: InputMaybe<Scalars['Float']['input']>;
  x_unset?: InputMaybe<Scalars['Boolean']['input']>;
  y?: InputMaybe<Scalars['Float']['input']>;
  y_inc?: InputMaybe<Scalars['Float']['input']>;
  y_unset?: InputMaybe<Scalars['Boolean']['input']>;
  z_index?: InputMaybe<Scalars['Int']['input']>;
  z_index_inc?: InputMaybe<Scalars['Int']['input']>;
  z_index_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TokenToken_EditInsertInput = {
  attributes?: InputMaybe<TokenToken_EditAttributeInsertInput>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TokenToken_EditQueryInput = {
  AND?: InputMaybe<Array<TokenToken_EditQueryInput>>;
  OR?: InputMaybe<Array<TokenToken_EditQueryInput>>;
  attributes?: InputMaybe<TokenToken_EditAttributeQueryInput>;
  attributes_exists?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_exists?: InputMaybe<Scalars['Boolean']['input']>;
  created_at_gt?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_gte?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  created_at_lt?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_lte?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_ne?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at_exists?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updated_at_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at_ne?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export type TokenToken_EditUpdateInput = {
  attributes?: InputMaybe<TokenToken_EditAttributeUpdateInput>;
  attributes_unset?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_unset?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TokenToken_SetRelationInput = {
  create?: InputMaybe<Token_SetInsertInput>;
  link?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type TokenUpdateInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_unset?: InputMaybe<Scalars['Boolean']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  created_by_unset?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_unset?: InputMaybe<Scalars['Boolean']['input']>;
  is_favorited?: InputMaybe<Scalars['Boolean']['input']>;
  is_favorited_unset?: InputMaybe<Scalars['Boolean']['input']>;
  is_public?: InputMaybe<Scalars['Boolean']['input']>;
  is_public_unset?: InputMaybe<Scalars['Boolean']['input']>;
  is_visible_in_tool?: InputMaybe<Scalars['Boolean']['input']>;
  is_visible_in_tool_unset?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_unset?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<TokenNotesRelationInput>;
  notes_unset?: InputMaybe<Scalars['Boolean']['input']>;
  owner?: InputMaybe<TokenOwnerRelationInput>;
  owner_unset?: InputMaybe<Scalars['Boolean']['input']>;
  realm?: InputMaybe<TokenRealmRelationInput>;
  realm_unset?: InputMaybe<Scalars['Boolean']['input']>;
  thumbnail_image_path?: InputMaybe<Scalars['String']['input']>;
  thumbnail_image_path_unset?: InputMaybe<Scalars['Boolean']['input']>;
  thumbnail_url?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url_unset?: InputMaybe<Scalars['Boolean']['input']>;
  token_base_image_path?: InputMaybe<Scalars['String']['input']>;
  token_base_image_path_unset?: InputMaybe<Scalars['Boolean']['input']>;
  token_base_image_url?: InputMaybe<Scalars['String']['input']>;
  token_base_image_url_unset?: InputMaybe<Scalars['Boolean']['input']>;
  token_edits?: InputMaybe<Array<InputMaybe<TokenToken_EditUpdateInput>>>;
  token_edits_unset?: InputMaybe<Scalars['Boolean']['input']>;
  token_image_path?: InputMaybe<Scalars['String']['input']>;
  token_image_path_unset?: InputMaybe<Scalars['Boolean']['input']>;
  token_set?: InputMaybe<TokenToken_SetRelationInput>;
  token_set_unset?: InputMaybe<Scalars['Boolean']['input']>;
  token_url?: InputMaybe<Scalars['String']['input']>;
  token_url_unset?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at_unset?: InputMaybe<Scalars['Boolean']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
  updated_by_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Token_Set = {
  __typename?: 'Token_set';
  _id: Scalars['ObjectId']['output'];
  created_at?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<User>;
  realm?: Maybe<Realm>;
  thumbnail_url?: Maybe<Scalars['String']['output']>;
  tokens?: Maybe<Array<Maybe<Token>>>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type Token_SetInsertInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Token_SetOwnerRelationInput>;
  realm?: InputMaybe<Token_SetRealmRelationInput>;
  thumbnail_url?: InputMaybe<Scalars['String']['input']>;
  tokens?: InputMaybe<Token_SetTokensRelationInput>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Token_SetOwnerRelationInput = {
  create?: InputMaybe<UserInsertInput>;
  link?: InputMaybe<Scalars['String']['input']>;
};

export type Token_SetQueryInput = {
  AND?: InputMaybe<Array<Token_SetQueryInput>>;
  OR?: InputMaybe<Array<Token_SetQueryInput>>;
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  _id_gt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_gte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  _id_lt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_lte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_ne?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_exists?: InputMaybe<Scalars['Boolean']['input']>;
  created_at_gt?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_gte?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  created_at_lt?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_lte?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_ne?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_gt?: InputMaybe<Scalars['String']['input']>;
  description_gte?: InputMaybe<Scalars['String']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_lt?: InputMaybe<Scalars['String']['input']>;
  description_lte?: InputMaybe<Scalars['String']['input']>;
  description_ne?: InputMaybe<Scalars['String']['input']>;
  description_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  owner?: InputMaybe<UserQueryInput>;
  owner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  realm?: InputMaybe<RealmQueryInput>;
  realm_exists?: InputMaybe<Scalars['Boolean']['input']>;
  thumbnail_url?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  thumbnail_url_gt?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url_gte?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  thumbnail_url_lt?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url_lte?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url_ne?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tokens?: InputMaybe<Array<InputMaybe<TokenQueryInput>>>;
  tokens_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tokens_in?: InputMaybe<Array<InputMaybe<TokenQueryInput>>>;
  tokens_nin?: InputMaybe<Array<InputMaybe<TokenQueryInput>>>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at_exists?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updated_at_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at_ne?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export type Token_SetRealmRelationInput = {
  create?: InputMaybe<RealmInsertInput>;
  link?: InputMaybe<Scalars['ObjectId']['input']>;
};

export enum Token_SetSortByInput {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  OwnerAsc = 'OWNER_ASC',
  OwnerDesc = 'OWNER_DESC',
  RealmAsc = 'REALM_ASC',
  RealmDesc = 'REALM_DESC',
  ThumbnailUrlAsc = 'THUMBNAIL_URL_ASC',
  ThumbnailUrlDesc = 'THUMBNAIL_URL_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type Token_SetTokensRelationInput = {
  create?: InputMaybe<Array<InputMaybe<TokenInsertInput>>>;
  link?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
};

export type Token_SetUpdateInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_unset?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_unset?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_unset?: InputMaybe<Scalars['Boolean']['input']>;
  owner?: InputMaybe<Token_SetOwnerRelationInput>;
  owner_unset?: InputMaybe<Scalars['Boolean']['input']>;
  realm?: InputMaybe<Token_SetRealmRelationInput>;
  realm_unset?: InputMaybe<Scalars['Boolean']['input']>;
  thumbnail_url?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url_unset?: InputMaybe<Scalars['Boolean']['input']>;
  tokens?: InputMaybe<Token_SetTokensRelationInput>;
  tokens_unset?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateManyPayload = {
  __typename?: 'UpdateManyPayload';
  matchedCount: Scalars['Int']['output'];
  modifiedCount: Scalars['Int']['output'];
};

export type User = {
  __typename?: 'User';
  _id: Scalars['String']['output'];
  atlasUserId?: Maybe<Scalars['String']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  config?: Maybe<UserConfig>;
  email?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  photo_url?: Maybe<Scalars['String']['output']>;
  profile?: Maybe<UserProfilePayload>;
  user_subscription?: Maybe<UserUser_Subscription>;
  username?: Maybe<Scalars['String']['output']>;
  wallet?: Maybe<UserWalletPayload>;
};

export type UserConfig = {
  __typename?: 'UserConfig';
  autoDismissIntroScreen?: Maybe<Scalars['Boolean']['output']>;
  defaultTheme?: Maybe<Scalars['String']['output']>;
  disableTutorial?: Maybe<Scalars['Boolean']['output']>;
  isNewUser?: Maybe<Scalars['Boolean']['output']>;
  showInToolByDefault?: Maybe<Scalars['Boolean']['output']>;
};

export type UserConfigInsertInput = {
  autoDismissIntroScreen?: InputMaybe<Scalars['Boolean']['input']>;
  defaultTheme?: InputMaybe<Scalars['String']['input']>;
  disableTutorial?: InputMaybe<Scalars['Boolean']['input']>;
  isNewUser?: InputMaybe<Scalars['Boolean']['input']>;
  showInToolByDefault?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserConfigQueryInput = {
  AND?: InputMaybe<Array<UserConfigQueryInput>>;
  OR?: InputMaybe<Array<UserConfigQueryInput>>;
  autoDismissIntroScreen?: InputMaybe<Scalars['Boolean']['input']>;
  autoDismissIntroScreen_exists?: InputMaybe<Scalars['Boolean']['input']>;
  autoDismissIntroScreen_ne?: InputMaybe<Scalars['Boolean']['input']>;
  defaultTheme?: InputMaybe<Scalars['String']['input']>;
  defaultTheme_exists?: InputMaybe<Scalars['Boolean']['input']>;
  defaultTheme_gt?: InputMaybe<Scalars['String']['input']>;
  defaultTheme_gte?: InputMaybe<Scalars['String']['input']>;
  defaultTheme_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  defaultTheme_lt?: InputMaybe<Scalars['String']['input']>;
  defaultTheme_lte?: InputMaybe<Scalars['String']['input']>;
  defaultTheme_ne?: InputMaybe<Scalars['String']['input']>;
  defaultTheme_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disableTutorial?: InputMaybe<Scalars['Boolean']['input']>;
  disableTutorial_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableTutorial_ne?: InputMaybe<Scalars['Boolean']['input']>;
  isNewUser?: InputMaybe<Scalars['Boolean']['input']>;
  isNewUser_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isNewUser_ne?: InputMaybe<Scalars['Boolean']['input']>;
  showInToolByDefault?: InputMaybe<Scalars['Boolean']['input']>;
  showInToolByDefault_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showInToolByDefault_ne?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserConfigUpdateInput = {
  autoDismissIntroScreen?: InputMaybe<Scalars['Boolean']['input']>;
  autoDismissIntroScreen_unset?: InputMaybe<Scalars['Boolean']['input']>;
  defaultTheme?: InputMaybe<Scalars['String']['input']>;
  defaultTheme_unset?: InputMaybe<Scalars['Boolean']['input']>;
  disableTutorial?: InputMaybe<Scalars['Boolean']['input']>;
  disableTutorial_unset?: InputMaybe<Scalars['Boolean']['input']>;
  isNewUser?: InputMaybe<Scalars['Boolean']['input']>;
  isNewUser_unset?: InputMaybe<Scalars['Boolean']['input']>;
  showInToolByDefault?: InputMaybe<Scalars['Boolean']['input']>;
  showInToolByDefault_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserInsertInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  atlasUserId?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<UserConfigInsertInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  photo_url?: InputMaybe<Scalars['String']['input']>;
  user_subscription?: InputMaybe<UserUser_SubscriptionInsertInput>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UserProfilePayload = {
  __typename?: 'UserProfilePayload';
  facebook_url?: Maybe<Scalars['String']['output']>;
  instagram_url?: Maybe<Scalars['String']['output']>;
  linkedin_url?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  photo_url?: Maybe<Scalars['String']['output']>;
  tiktok_url?: Maybe<Scalars['String']['output']>;
  twitter_url?: Maybe<Scalars['String']['output']>;
  youtube_url?: Maybe<Scalars['String']['output']>;
};

export type UserQueryInput = {
  AND?: InputMaybe<Array<UserQueryInput>>;
  OR?: InputMaybe<Array<UserQueryInput>>;
  _id?: InputMaybe<Scalars['String']['input']>;
  _id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  _id_gt?: InputMaybe<Scalars['String']['input']>;
  _id_gte?: InputMaybe<Scalars['String']['input']>;
  _id_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  _id_lt?: InputMaybe<Scalars['String']['input']>;
  _id_lte?: InputMaybe<Scalars['String']['input']>;
  _id_ne?: InputMaybe<Scalars['String']['input']>;
  _id_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  atlasUserId?: InputMaybe<Scalars['String']['input']>;
  atlasUserId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  atlasUserId_gt?: InputMaybe<Scalars['String']['input']>;
  atlasUserId_gte?: InputMaybe<Scalars['String']['input']>;
  atlasUserId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  atlasUserId_lt?: InputMaybe<Scalars['String']['input']>;
  atlasUserId_lte?: InputMaybe<Scalars['String']['input']>;
  atlasUserId_ne?: InputMaybe<Scalars['String']['input']>;
  atlasUserId_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bio?: InputMaybe<Scalars['String']['input']>;
  bio_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bio_gt?: InputMaybe<Scalars['String']['input']>;
  bio_gte?: InputMaybe<Scalars['String']['input']>;
  bio_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bio_lt?: InputMaybe<Scalars['String']['input']>;
  bio_lte?: InputMaybe<Scalars['String']['input']>;
  bio_ne?: InputMaybe<Scalars['String']['input']>;
  bio_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  config?: InputMaybe<UserConfigQueryInput>;
  config_exists?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_exists?: InputMaybe<Scalars['Boolean']['input']>;
  email_gt?: InputMaybe<Scalars['String']['input']>;
  email_gte?: InputMaybe<Scalars['String']['input']>;
  email_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email_lt?: InputMaybe<Scalars['String']['input']>;
  email_lte?: InputMaybe<Scalars['String']['input']>;
  email_ne?: InputMaybe<Scalars['String']['input']>;
  email_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  location?: InputMaybe<Scalars['String']['input']>;
  location_exists?: InputMaybe<Scalars['Boolean']['input']>;
  location_gt?: InputMaybe<Scalars['String']['input']>;
  location_gte?: InputMaybe<Scalars['String']['input']>;
  location_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  location_lt?: InputMaybe<Scalars['String']['input']>;
  location_lte?: InputMaybe<Scalars['String']['input']>;
  location_ne?: InputMaybe<Scalars['String']['input']>;
  location_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  photo_url?: InputMaybe<Scalars['String']['input']>;
  photo_url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  photo_url_gt?: InputMaybe<Scalars['String']['input']>;
  photo_url_gte?: InputMaybe<Scalars['String']['input']>;
  photo_url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  photo_url_lt?: InputMaybe<Scalars['String']['input']>;
  photo_url_lte?: InputMaybe<Scalars['String']['input']>;
  photo_url_ne?: InputMaybe<Scalars['String']['input']>;
  photo_url_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  user_subscription?: InputMaybe<UserUser_SubscriptionQueryInput>;
  user_subscription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  username_exists?: InputMaybe<Scalars['Boolean']['input']>;
  username_gt?: InputMaybe<Scalars['String']['input']>;
  username_gte?: InputMaybe<Scalars['String']['input']>;
  username_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  username_lt?: InputMaybe<Scalars['String']['input']>;
  username_lte?: InputMaybe<Scalars['String']['input']>;
  username_ne?: InputMaybe<Scalars['String']['input']>;
  username_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum UserSortByInput {
  AtlasuseridAsc = 'ATLASUSERID_ASC',
  AtlasuseridDesc = 'ATLASUSERID_DESC',
  BioAsc = 'BIO_ASC',
  BioDesc = 'BIO_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  LocationAsc = 'LOCATION_ASC',
  LocationDesc = 'LOCATION_DESC',
  PhotoUrlAsc = 'PHOTO_URL_ASC',
  PhotoUrlDesc = 'PHOTO_URL_DESC',
  UsernameAsc = 'USERNAME_ASC',
  UsernameDesc = 'USERNAME_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type UserUpdateInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  _id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  atlasUserId?: InputMaybe<Scalars['String']['input']>;
  atlasUserId_unset?: InputMaybe<Scalars['Boolean']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  bio_unset?: InputMaybe<Scalars['Boolean']['input']>;
  config?: InputMaybe<UserConfigUpdateInput>;
  config_unset?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_unset?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  location_unset?: InputMaybe<Scalars['Boolean']['input']>;
  photo_url?: InputMaybe<Scalars['String']['input']>;
  photo_url_unset?: InputMaybe<Scalars['Boolean']['input']>;
  user_subscription?: InputMaybe<UserUser_SubscriptionUpdateInput>;
  user_subscription_unset?: InputMaybe<Scalars['Boolean']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  username_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserUser_Subscription = {
  __typename?: 'UserUser_subscription';
  last_purchase_price?: Maybe<Scalars['String']['output']>;
  purchase_date?: Maybe<Scalars['DateTime']['output']>;
  renew_date?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  stripe_subscription_id?: Maybe<Scalars['String']['output']>;
  stripe_subscription_product_id?: Maybe<Scalars['String']['output']>;
  subscription_tier?: Maybe<Subscription_Tier>;
};

export type UserUser_SubscriptionInsertInput = {
  last_purchase_price?: InputMaybe<Scalars['String']['input']>;
  purchase_date?: InputMaybe<Scalars['DateTime']['input']>;
  renew_date?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  stripe_subscription_id?: InputMaybe<Scalars['String']['input']>;
  stripe_subscription_product_id?: InputMaybe<Scalars['String']['input']>;
  subscription_tier?: InputMaybe<UserUser_SubscriptionSubscription_TierRelationInput>;
};

export type UserUser_SubscriptionQueryInput = {
  AND?: InputMaybe<Array<UserUser_SubscriptionQueryInput>>;
  OR?: InputMaybe<Array<UserUser_SubscriptionQueryInput>>;
  last_purchase_price?: InputMaybe<Scalars['String']['input']>;
  last_purchase_price_exists?: InputMaybe<Scalars['Boolean']['input']>;
  last_purchase_price_gt?: InputMaybe<Scalars['String']['input']>;
  last_purchase_price_gte?: InputMaybe<Scalars['String']['input']>;
  last_purchase_price_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  last_purchase_price_lt?: InputMaybe<Scalars['String']['input']>;
  last_purchase_price_lte?: InputMaybe<Scalars['String']['input']>;
  last_purchase_price_ne?: InputMaybe<Scalars['String']['input']>;
  last_purchase_price_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  purchase_date?: InputMaybe<Scalars['DateTime']['input']>;
  purchase_date_exists?: InputMaybe<Scalars['Boolean']['input']>;
  purchase_date_gt?: InputMaybe<Scalars['DateTime']['input']>;
  purchase_date_gte?: InputMaybe<Scalars['DateTime']['input']>;
  purchase_date_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  purchase_date_lt?: InputMaybe<Scalars['DateTime']['input']>;
  purchase_date_lte?: InputMaybe<Scalars['DateTime']['input']>;
  purchase_date_ne?: InputMaybe<Scalars['DateTime']['input']>;
  purchase_date_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  renew_date?: InputMaybe<Scalars['DateTime']['input']>;
  renew_date_exists?: InputMaybe<Scalars['Boolean']['input']>;
  renew_date_gt?: InputMaybe<Scalars['DateTime']['input']>;
  renew_date_gte?: InputMaybe<Scalars['DateTime']['input']>;
  renew_date_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  renew_date_lt?: InputMaybe<Scalars['DateTime']['input']>;
  renew_date_lte?: InputMaybe<Scalars['DateTime']['input']>;
  renew_date_ne?: InputMaybe<Scalars['DateTime']['input']>;
  renew_date_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_exists?: InputMaybe<Scalars['Boolean']['input']>;
  status_gt?: InputMaybe<Scalars['String']['input']>;
  status_gte?: InputMaybe<Scalars['String']['input']>;
  status_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status_lt?: InputMaybe<Scalars['String']['input']>;
  status_lte?: InputMaybe<Scalars['String']['input']>;
  status_ne?: InputMaybe<Scalars['String']['input']>;
  status_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stripe_subscription_id?: InputMaybe<Scalars['String']['input']>;
  stripe_subscription_id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  stripe_subscription_id_gt?: InputMaybe<Scalars['String']['input']>;
  stripe_subscription_id_gte?: InputMaybe<Scalars['String']['input']>;
  stripe_subscription_id_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stripe_subscription_id_lt?: InputMaybe<Scalars['String']['input']>;
  stripe_subscription_id_lte?: InputMaybe<Scalars['String']['input']>;
  stripe_subscription_id_ne?: InputMaybe<Scalars['String']['input']>;
  stripe_subscription_id_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stripe_subscription_product_id?: InputMaybe<Scalars['String']['input']>;
  stripe_subscription_product_id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  stripe_subscription_product_id_gt?: InputMaybe<Scalars['String']['input']>;
  stripe_subscription_product_id_gte?: InputMaybe<Scalars['String']['input']>;
  stripe_subscription_product_id_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stripe_subscription_product_id_lt?: InputMaybe<Scalars['String']['input']>;
  stripe_subscription_product_id_lte?: InputMaybe<Scalars['String']['input']>;
  stripe_subscription_product_id_ne?: InputMaybe<Scalars['String']['input']>;
  stripe_subscription_product_id_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subscription_tier?: InputMaybe<Subscription_TierQueryInput>;
  subscription_tier_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserUser_SubscriptionSubscription_TierRelationInput = {
  create?: InputMaybe<Subscription_TierInsertInput>;
  link?: InputMaybe<Scalars['Int']['input']>;
};

export type UserUser_SubscriptionUpdateInput = {
  last_purchase_price?: InputMaybe<Scalars['String']['input']>;
  last_purchase_price_unset?: InputMaybe<Scalars['Boolean']['input']>;
  purchase_date?: InputMaybe<Scalars['DateTime']['input']>;
  purchase_date_unset?: InputMaybe<Scalars['Boolean']['input']>;
  renew_date?: InputMaybe<Scalars['DateTime']['input']>;
  renew_date_unset?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_unset?: InputMaybe<Scalars['Boolean']['input']>;
  stripe_subscription_id?: InputMaybe<Scalars['String']['input']>;
  stripe_subscription_id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  stripe_subscription_product_id?: InputMaybe<Scalars['String']['input']>;
  stripe_subscription_product_id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  subscription_tier?: InputMaybe<UserUser_SubscriptionSubscription_TierRelationInput>;
  subscription_tier_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserWalletPayload = {
  __typename?: 'UserWalletPayload';
  ssgpCreditPackCreditsRemaining?: Maybe<Scalars['Float']['output']>;
  ssgpCreditPackCreditsUsed?: Maybe<Scalars['Float']['output']>;
  ssgpPendingCredits?: Maybe<Scalars['Float']['output']>;
  ssgpSubscriptionCreditsRemaining?: Maybe<Scalars['Float']['output']>;
  ssgpSubscriptionCreditsUsed?: Maybe<Scalars['Float']['output']>;
  ssgpUserSubscriptionId?: Maybe<Scalars['Float']['output']>;
};

export type User_Character_Content_Pack_Purchase = {
  __typename?: 'User_character_content_pack_purchase';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  character_content_pack?: Maybe<Scalars['ObjectId']['output']>;
  purchase_date?: Maybe<Scalars['DateTime']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type User_Character_Content_Pack_PurchaseInsertInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  character_content_pack?: InputMaybe<Scalars['ObjectId']['input']>;
  purchase_date?: InputMaybe<Scalars['DateTime']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type User_Character_Content_Pack_PurchaseQueryInput = {
  AND?: InputMaybe<Array<User_Character_Content_Pack_PurchaseQueryInput>>;
  OR?: InputMaybe<Array<User_Character_Content_Pack_PurchaseQueryInput>>;
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  _id_gt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_gte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  _id_lt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_lte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_ne?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  character_content_pack?: InputMaybe<Scalars['ObjectId']['input']>;
  character_content_pack_exists?: InputMaybe<Scalars['Boolean']['input']>;
  character_content_pack_gt?: InputMaybe<Scalars['ObjectId']['input']>;
  character_content_pack_gte?: InputMaybe<Scalars['ObjectId']['input']>;
  character_content_pack_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  character_content_pack_lt?: InputMaybe<Scalars['ObjectId']['input']>;
  character_content_pack_lte?: InputMaybe<Scalars['ObjectId']['input']>;
  character_content_pack_ne?: InputMaybe<Scalars['ObjectId']['input']>;
  character_content_pack_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  purchase_date?: InputMaybe<Scalars['DateTime']['input']>;
  purchase_date_exists?: InputMaybe<Scalars['Boolean']['input']>;
  purchase_date_gt?: InputMaybe<Scalars['DateTime']['input']>;
  purchase_date_gte?: InputMaybe<Scalars['DateTime']['input']>;
  purchase_date_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  purchase_date_lt?: InputMaybe<Scalars['DateTime']['input']>;
  purchase_date_lte?: InputMaybe<Scalars['DateTime']['input']>;
  purchase_date_ne?: InputMaybe<Scalars['DateTime']['input']>;
  purchase_date_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  state?: InputMaybe<Scalars['String']['input']>;
  state_exists?: InputMaybe<Scalars['Boolean']['input']>;
  state_gt?: InputMaybe<Scalars['String']['input']>;
  state_gte?: InputMaybe<Scalars['String']['input']>;
  state_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  state_lt?: InputMaybe<Scalars['String']['input']>;
  state_lte?: InputMaybe<Scalars['String']['input']>;
  state_ne?: InputMaybe<Scalars['String']['input']>;
  state_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum User_Character_Content_Pack_PurchaseSortByInput {
  CharacterContentPackAsc = 'CHARACTER_CONTENT_PACK_ASC',
  CharacterContentPackDesc = 'CHARACTER_CONTENT_PACK_DESC',
  PurchaseDateAsc = 'PURCHASE_DATE_ASC',
  PurchaseDateDesc = 'PURCHASE_DATE_DESC',
  StateAsc = 'STATE_ASC',
  StateDesc = 'STATE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type User_Character_Content_Pack_PurchaseUpdateInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  character_content_pack?: InputMaybe<Scalars['ObjectId']['input']>;
  character_content_pack_unset?: InputMaybe<Scalars['Boolean']['input']>;
  purchase_date?: InputMaybe<Scalars['DateTime']['input']>;
  purchase_date_unset?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  state_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type User_Character_Generation = {
  __typename?: 'User_character_generation';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  attributes?: Maybe<Array<Maybe<User_Character_GenerationAttribute>>>;
  character?: Maybe<Character>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  modified_at?: Maybe<Scalars['DateTime']['output']>;
  owner?: Maybe<User>;
  title?: Maybe<Scalars['String']['output']>;
  user_text_generation?: Maybe<User_Text_Generation>;
};

export type User_Character_GenerationAttribute = {
  __typename?: 'User_character_generationAttribute';
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type User_Character_GenerationAttributeInsertInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type User_Character_GenerationAttributeQueryInput = {
  AND?: InputMaybe<Array<User_Character_GenerationAttributeQueryInput>>;
  OR?: InputMaybe<Array<User_Character_GenerationAttributeQueryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_exists?: InputMaybe<Scalars['Boolean']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_ne?: InputMaybe<Scalars['String']['input']>;
  value_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type User_Character_GenerationAttributeUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  name_unset?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type User_Character_GenerationCharacterRelationInput = {
  create?: InputMaybe<CharacterInsertInput>;
  link?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type User_Character_GenerationInsertInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  attributes?: InputMaybe<Array<InputMaybe<User_Character_GenerationAttributeInsertInput>>>;
  character?: InputMaybe<User_Character_GenerationCharacterRelationInput>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at?: InputMaybe<Scalars['DateTime']['input']>;
  owner?: InputMaybe<User_Character_GenerationOwnerRelationInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  user_text_generation?: InputMaybe<User_Character_GenerationUser_Text_GenerationRelationInput>;
};

export type User_Character_GenerationOwnerRelationInput = {
  create?: InputMaybe<UserInsertInput>;
  link?: InputMaybe<Scalars['String']['input']>;
};

export type User_Character_GenerationQueryInput = {
  AND?: InputMaybe<Array<User_Character_GenerationQueryInput>>;
  OR?: InputMaybe<Array<User_Character_GenerationQueryInput>>;
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  _id_gt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_gte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  _id_lt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_lte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_ne?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  attributes?: InputMaybe<Array<InputMaybe<User_Character_GenerationAttributeQueryInput>>>;
  attributes_exists?: InputMaybe<Scalars['Boolean']['input']>;
  attributes_in?: InputMaybe<Array<InputMaybe<User_Character_GenerationAttributeQueryInput>>>;
  attributes_nin?: InputMaybe<Array<InputMaybe<User_Character_GenerationAttributeQueryInput>>>;
  character?: InputMaybe<CharacterQueryInput>;
  character_exists?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_exists?: InputMaybe<Scalars['Boolean']['input']>;
  created_at_gt?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_gte?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  created_at_lt?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_lte?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_ne?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  modified_at?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_exists?: InputMaybe<Scalars['Boolean']['input']>;
  modified_at_gt?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_gte?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  modified_at_lt?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_lte?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_ne?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  owner?: InputMaybe<UserQueryInput>;
  owner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_gt?: InputMaybe<Scalars['String']['input']>;
  title_gte?: InputMaybe<Scalars['String']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_lt?: InputMaybe<Scalars['String']['input']>;
  title_lte?: InputMaybe<Scalars['String']['input']>;
  title_ne?: InputMaybe<Scalars['String']['input']>;
  title_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  user_text_generation?: InputMaybe<User_Text_GenerationQueryInput>;
  user_text_generation_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum User_Character_GenerationSortByInput {
  CharacterAsc = 'CHARACTER_ASC',
  CharacterDesc = 'CHARACTER_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  ModifiedAtAsc = 'MODIFIED_AT_ASC',
  ModifiedAtDesc = 'MODIFIED_AT_DESC',
  OwnerAsc = 'OWNER_ASC',
  OwnerDesc = 'OWNER_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC',
  UserTextGenerationAsc = 'USER_TEXT_GENERATION_ASC',
  UserTextGenerationDesc = 'USER_TEXT_GENERATION_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type User_Character_GenerationUpdateInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  attributes?: InputMaybe<Array<InputMaybe<User_Character_GenerationAttributeUpdateInput>>>;
  attributes_unset?: InputMaybe<Scalars['Boolean']['input']>;
  character?: InputMaybe<User_Character_GenerationCharacterRelationInput>;
  character_unset?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_unset?: InputMaybe<Scalars['Boolean']['input']>;
  modified_at?: InputMaybe<Scalars['DateTime']['input']>;
  modified_at_unset?: InputMaybe<Scalars['Boolean']['input']>;
  owner?: InputMaybe<User_Character_GenerationOwnerRelationInput>;
  owner_unset?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_unset?: InputMaybe<Scalars['Boolean']['input']>;
  user_text_generation?: InputMaybe<User_Character_GenerationUser_Text_GenerationRelationInput>;
  user_text_generation_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type User_Character_GenerationUser_Text_GenerationRelationInput = {
  create?: InputMaybe<User_Text_GenerationInsertInput>;
  link?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type User_Image_Generation = {
  __typename?: 'User_image_generation';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  image_attributes?: Maybe<Array<Maybe<User_Image_GenerationImage_Attribute>>>;
  image_path?: Maybe<Scalars['String']['output']>;
  image_url?: Maybe<Scalars['String']['output']>;
  is_favorited?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<User>;
  prompt_attributes?: Maybe<Array<Maybe<User_Image_GenerationPrompt_Attribute>>>;
  prompt_template_id?: Maybe<Scalars['ObjectId']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  thumbnail_path?: Maybe<Scalars['String']['output']>;
  thumbnail_url?: Maybe<Scalars['String']['output']>;
  workflow_id?: Maybe<Scalars['Int']['output']>;
};

export type User_Image_GenerationImage_Attribute = {
  __typename?: 'User_image_generationImage_attribute';
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type User_Image_GenerationImage_AttributeInsertInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type User_Image_GenerationImage_AttributeQueryInput = {
  AND?: InputMaybe<Array<User_Image_GenerationImage_AttributeQueryInput>>;
  OR?: InputMaybe<Array<User_Image_GenerationImage_AttributeQueryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_exists?: InputMaybe<Scalars['Boolean']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_ne?: InputMaybe<Scalars['String']['input']>;
  value_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type User_Image_GenerationImage_AttributeUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  name_unset?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type User_Image_GenerationInsertInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  created_date?: InputMaybe<Scalars['DateTime']['input']>;
  image_attributes?: InputMaybe<Array<InputMaybe<User_Image_GenerationImage_AttributeInsertInput>>>;
  image_path?: InputMaybe<Scalars['String']['input']>;
  image_url?: InputMaybe<Scalars['String']['input']>;
  is_favorited?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<User_Image_GenerationOwnerRelationInput>;
  prompt_attributes?: InputMaybe<Array<InputMaybe<User_Image_GenerationPrompt_AttributeInsertInput>>>;
  prompt_template_id?: InputMaybe<Scalars['ObjectId']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  thumbnail_path?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url?: InputMaybe<Scalars['String']['input']>;
  workflow_id?: InputMaybe<Scalars['Int']['input']>;
};

export type User_Image_GenerationOwnerRelationInput = {
  create?: InputMaybe<UserInsertInput>;
  link?: InputMaybe<Scalars['String']['input']>;
};

export type User_Image_GenerationPrompt_Attribute = {
  __typename?: 'User_image_generationPrompt_attribute';
  attribute?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type User_Image_GenerationPrompt_AttributeInsertInput = {
  attribute?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type User_Image_GenerationPrompt_AttributeQueryInput = {
  AND?: InputMaybe<Array<User_Image_GenerationPrompt_AttributeQueryInput>>;
  OR?: InputMaybe<Array<User_Image_GenerationPrompt_AttributeQueryInput>>;
  attribute?: InputMaybe<Scalars['String']['input']>;
  attribute_exists?: InputMaybe<Scalars['Boolean']['input']>;
  attribute_gt?: InputMaybe<Scalars['String']['input']>;
  attribute_gte?: InputMaybe<Scalars['String']['input']>;
  attribute_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attribute_lt?: InputMaybe<Scalars['String']['input']>;
  attribute_lte?: InputMaybe<Scalars['String']['input']>;
  attribute_ne?: InputMaybe<Scalars['String']['input']>;
  attribute_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_exists?: InputMaybe<Scalars['Boolean']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_ne?: InputMaybe<Scalars['String']['input']>;
  value_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type User_Image_GenerationPrompt_AttributeUpdateInput = {
  attribute?: InputMaybe<Scalars['String']['input']>;
  attribute_unset?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type User_Image_GenerationQueryInput = {
  AND?: InputMaybe<Array<User_Image_GenerationQueryInput>>;
  OR?: InputMaybe<Array<User_Image_GenerationQueryInput>>;
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  _id_gt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_gte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  _id_lt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_lte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_ne?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  created_date?: InputMaybe<Scalars['DateTime']['input']>;
  created_date_exists?: InputMaybe<Scalars['Boolean']['input']>;
  created_date_gt?: InputMaybe<Scalars['DateTime']['input']>;
  created_date_gte?: InputMaybe<Scalars['DateTime']['input']>;
  created_date_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  created_date_lt?: InputMaybe<Scalars['DateTime']['input']>;
  created_date_lte?: InputMaybe<Scalars['DateTime']['input']>;
  created_date_ne?: InputMaybe<Scalars['DateTime']['input']>;
  created_date_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  image_attributes?: InputMaybe<Array<InputMaybe<User_Image_GenerationImage_AttributeQueryInput>>>;
  image_attributes_exists?: InputMaybe<Scalars['Boolean']['input']>;
  image_attributes_in?: InputMaybe<Array<InputMaybe<User_Image_GenerationImage_AttributeQueryInput>>>;
  image_attributes_nin?: InputMaybe<Array<InputMaybe<User_Image_GenerationImage_AttributeQueryInput>>>;
  image_path?: InputMaybe<Scalars['String']['input']>;
  image_path_exists?: InputMaybe<Scalars['Boolean']['input']>;
  image_path_gt?: InputMaybe<Scalars['String']['input']>;
  image_path_gte?: InputMaybe<Scalars['String']['input']>;
  image_path_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image_path_lt?: InputMaybe<Scalars['String']['input']>;
  image_path_lte?: InputMaybe<Scalars['String']['input']>;
  image_path_ne?: InputMaybe<Scalars['String']['input']>;
  image_path_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image_url?: InputMaybe<Scalars['String']['input']>;
  image_url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  image_url_gt?: InputMaybe<Scalars['String']['input']>;
  image_url_gte?: InputMaybe<Scalars['String']['input']>;
  image_url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image_url_lt?: InputMaybe<Scalars['String']['input']>;
  image_url_lte?: InputMaybe<Scalars['String']['input']>;
  image_url_ne?: InputMaybe<Scalars['String']['input']>;
  image_url_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  is_favorited?: InputMaybe<Scalars['Boolean']['input']>;
  is_favorited_exists?: InputMaybe<Scalars['Boolean']['input']>;
  is_favorited_ne?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  owner?: InputMaybe<UserQueryInput>;
  owner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  prompt_attributes?: InputMaybe<Array<InputMaybe<User_Image_GenerationPrompt_AttributeQueryInput>>>;
  prompt_attributes_exists?: InputMaybe<Scalars['Boolean']['input']>;
  prompt_attributes_in?: InputMaybe<Array<InputMaybe<User_Image_GenerationPrompt_AttributeQueryInput>>>;
  prompt_attributes_nin?: InputMaybe<Array<InputMaybe<User_Image_GenerationPrompt_AttributeQueryInput>>>;
  prompt_template_id?: InputMaybe<Scalars['ObjectId']['input']>;
  prompt_template_id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  prompt_template_id_gt?: InputMaybe<Scalars['ObjectId']['input']>;
  prompt_template_id_gte?: InputMaybe<Scalars['ObjectId']['input']>;
  prompt_template_id_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  prompt_template_id_lt?: InputMaybe<Scalars['ObjectId']['input']>;
  prompt_template_id_lte?: InputMaybe<Scalars['ObjectId']['input']>;
  prompt_template_id_ne?: InputMaybe<Scalars['ObjectId']['input']>;
  prompt_template_id_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tags_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  thumbnail_path?: InputMaybe<Scalars['String']['input']>;
  thumbnail_path_exists?: InputMaybe<Scalars['Boolean']['input']>;
  thumbnail_path_gt?: InputMaybe<Scalars['String']['input']>;
  thumbnail_path_gte?: InputMaybe<Scalars['String']['input']>;
  thumbnail_path_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  thumbnail_path_lt?: InputMaybe<Scalars['String']['input']>;
  thumbnail_path_lte?: InputMaybe<Scalars['String']['input']>;
  thumbnail_path_ne?: InputMaybe<Scalars['String']['input']>;
  thumbnail_path_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  thumbnail_url?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  thumbnail_url_gt?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url_gte?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  thumbnail_url_lt?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url_lte?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url_ne?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workflow_id?: InputMaybe<Scalars['Int']['input']>;
  workflow_id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  workflow_id_gt?: InputMaybe<Scalars['Int']['input']>;
  workflow_id_gte?: InputMaybe<Scalars['Int']['input']>;
  workflow_id_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  workflow_id_lt?: InputMaybe<Scalars['Int']['input']>;
  workflow_id_lte?: InputMaybe<Scalars['Int']['input']>;
  workflow_id_ne?: InputMaybe<Scalars['Int']['input']>;
  workflow_id_nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export enum User_Image_GenerationSortByInput {
  CreatedDateAsc = 'CREATED_DATE_ASC',
  CreatedDateDesc = 'CREATED_DATE_DESC',
  ImagePathAsc = 'IMAGE_PATH_ASC',
  ImagePathDesc = 'IMAGE_PATH_DESC',
  ImageUrlAsc = 'IMAGE_URL_ASC',
  ImageUrlDesc = 'IMAGE_URL_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  OwnerAsc = 'OWNER_ASC',
  OwnerDesc = 'OWNER_DESC',
  PromptTemplateIdAsc = 'PROMPT_TEMPLATE_ID_ASC',
  PromptTemplateIdDesc = 'PROMPT_TEMPLATE_ID_DESC',
  ThumbnailPathAsc = 'THUMBNAIL_PATH_ASC',
  ThumbnailPathDesc = 'THUMBNAIL_PATH_DESC',
  ThumbnailUrlAsc = 'THUMBNAIL_URL_ASC',
  ThumbnailUrlDesc = 'THUMBNAIL_URL_DESC',
  WorkflowIdAsc = 'WORKFLOW_ID_ASC',
  WorkflowIdDesc = 'WORKFLOW_ID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type User_Image_GenerationUpdateInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  created_date?: InputMaybe<Scalars['DateTime']['input']>;
  created_date_unset?: InputMaybe<Scalars['Boolean']['input']>;
  image_attributes?: InputMaybe<Array<InputMaybe<User_Image_GenerationImage_AttributeUpdateInput>>>;
  image_attributes_unset?: InputMaybe<Scalars['Boolean']['input']>;
  image_path?: InputMaybe<Scalars['String']['input']>;
  image_path_unset?: InputMaybe<Scalars['Boolean']['input']>;
  image_url?: InputMaybe<Scalars['String']['input']>;
  image_url_unset?: InputMaybe<Scalars['Boolean']['input']>;
  is_favorited?: InputMaybe<Scalars['Boolean']['input']>;
  is_favorited_unset?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_unset?: InputMaybe<Scalars['Boolean']['input']>;
  owner?: InputMaybe<User_Image_GenerationOwnerRelationInput>;
  owner_unset?: InputMaybe<Scalars['Boolean']['input']>;
  prompt_attributes?: InputMaybe<Array<InputMaybe<User_Image_GenerationPrompt_AttributeUpdateInput>>>;
  prompt_attributes_unset?: InputMaybe<Scalars['Boolean']['input']>;
  prompt_template_id?: InputMaybe<Scalars['ObjectId']['input']>;
  prompt_template_id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_unset?: InputMaybe<Scalars['Boolean']['input']>;
  thumbnail_path?: InputMaybe<Scalars['String']['input']>;
  thumbnail_path_unset?: InputMaybe<Scalars['Boolean']['input']>;
  thumbnail_url?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url_unset?: InputMaybe<Scalars['Boolean']['input']>;
  workflow_id?: InputMaybe<Scalars['Int']['input']>;
  workflow_id_inc?: InputMaybe<Scalars['Int']['input']>;
  workflow_id_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type User_Invoice = {
  __typename?: 'User_invoice';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  current_period_end?: Maybe<Scalars['DateTime']['output']>;
  current_period_start?: Maybe<Scalars['DateTime']['output']>;
  is_reccuring?: Maybe<Scalars['Boolean']['output']>;
  is_subscription?: Maybe<Scalars['Boolean']['output']>;
  price_decimal?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  stripe_customer_id?: Maybe<Stripe_Customer>;
  stripe_invoice_id?: Maybe<Scalars['String']['output']>;
  stripe_product_id?: Maybe<Scalars['String']['output']>;
  subscription_tier?: Maybe<Subscription_Tier>;
};

export type User_InvoiceInsertInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  created_date?: InputMaybe<Scalars['DateTime']['input']>;
  current_period_end?: InputMaybe<Scalars['DateTime']['input']>;
  current_period_start?: InputMaybe<Scalars['DateTime']['input']>;
  is_reccuring?: InputMaybe<Scalars['Boolean']['input']>;
  is_subscription?: InputMaybe<Scalars['Boolean']['input']>;
  price_decimal?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  stripe_customer_id?: InputMaybe<User_InvoiceStripe_Customer_IdRelationInput>;
  stripe_invoice_id?: InputMaybe<Scalars['String']['input']>;
  stripe_product_id?: InputMaybe<Scalars['String']['input']>;
  subscription_tier?: InputMaybe<User_InvoiceSubscription_TierRelationInput>;
};

export type User_InvoiceQueryInput = {
  AND?: InputMaybe<Array<User_InvoiceQueryInput>>;
  OR?: InputMaybe<Array<User_InvoiceQueryInput>>;
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  _id_gt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_gte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  _id_lt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_lte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_ne?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  created_date?: InputMaybe<Scalars['DateTime']['input']>;
  created_date_exists?: InputMaybe<Scalars['Boolean']['input']>;
  created_date_gt?: InputMaybe<Scalars['DateTime']['input']>;
  created_date_gte?: InputMaybe<Scalars['DateTime']['input']>;
  created_date_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  created_date_lt?: InputMaybe<Scalars['DateTime']['input']>;
  created_date_lte?: InputMaybe<Scalars['DateTime']['input']>;
  created_date_ne?: InputMaybe<Scalars['DateTime']['input']>;
  created_date_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  current_period_end?: InputMaybe<Scalars['DateTime']['input']>;
  current_period_end_exists?: InputMaybe<Scalars['Boolean']['input']>;
  current_period_end_gt?: InputMaybe<Scalars['DateTime']['input']>;
  current_period_end_gte?: InputMaybe<Scalars['DateTime']['input']>;
  current_period_end_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  current_period_end_lt?: InputMaybe<Scalars['DateTime']['input']>;
  current_period_end_lte?: InputMaybe<Scalars['DateTime']['input']>;
  current_period_end_ne?: InputMaybe<Scalars['DateTime']['input']>;
  current_period_end_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  current_period_start?: InputMaybe<Scalars['DateTime']['input']>;
  current_period_start_exists?: InputMaybe<Scalars['Boolean']['input']>;
  current_period_start_gt?: InputMaybe<Scalars['DateTime']['input']>;
  current_period_start_gte?: InputMaybe<Scalars['DateTime']['input']>;
  current_period_start_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  current_period_start_lt?: InputMaybe<Scalars['DateTime']['input']>;
  current_period_start_lte?: InputMaybe<Scalars['DateTime']['input']>;
  current_period_start_ne?: InputMaybe<Scalars['DateTime']['input']>;
  current_period_start_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  is_reccuring?: InputMaybe<Scalars['Boolean']['input']>;
  is_reccuring_exists?: InputMaybe<Scalars['Boolean']['input']>;
  is_reccuring_ne?: InputMaybe<Scalars['Boolean']['input']>;
  is_subscription?: InputMaybe<Scalars['Boolean']['input']>;
  is_subscription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  is_subscription_ne?: InputMaybe<Scalars['Boolean']['input']>;
  price_decimal?: InputMaybe<Scalars['String']['input']>;
  price_decimal_exists?: InputMaybe<Scalars['Boolean']['input']>;
  price_decimal_gt?: InputMaybe<Scalars['String']['input']>;
  price_decimal_gte?: InputMaybe<Scalars['String']['input']>;
  price_decimal_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  price_decimal_lt?: InputMaybe<Scalars['String']['input']>;
  price_decimal_lte?: InputMaybe<Scalars['String']['input']>;
  price_decimal_ne?: InputMaybe<Scalars['String']['input']>;
  price_decimal_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  product?: InputMaybe<Scalars['String']['input']>;
  product_exists?: InputMaybe<Scalars['Boolean']['input']>;
  product_gt?: InputMaybe<Scalars['String']['input']>;
  product_gte?: InputMaybe<Scalars['String']['input']>;
  product_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  product_lt?: InputMaybe<Scalars['String']['input']>;
  product_lte?: InputMaybe<Scalars['String']['input']>;
  product_ne?: InputMaybe<Scalars['String']['input']>;
  product_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_exists?: InputMaybe<Scalars['Boolean']['input']>;
  status_gt?: InputMaybe<Scalars['String']['input']>;
  status_gte?: InputMaybe<Scalars['String']['input']>;
  status_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status_lt?: InputMaybe<Scalars['String']['input']>;
  status_lte?: InputMaybe<Scalars['String']['input']>;
  status_ne?: InputMaybe<Scalars['String']['input']>;
  status_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stripe_customer_id?: InputMaybe<Stripe_CustomerQueryInput>;
  stripe_customer_id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  stripe_invoice_id?: InputMaybe<Scalars['String']['input']>;
  stripe_invoice_id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  stripe_invoice_id_gt?: InputMaybe<Scalars['String']['input']>;
  stripe_invoice_id_gte?: InputMaybe<Scalars['String']['input']>;
  stripe_invoice_id_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stripe_invoice_id_lt?: InputMaybe<Scalars['String']['input']>;
  stripe_invoice_id_lte?: InputMaybe<Scalars['String']['input']>;
  stripe_invoice_id_ne?: InputMaybe<Scalars['String']['input']>;
  stripe_invoice_id_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stripe_product_id?: InputMaybe<Scalars['String']['input']>;
  stripe_product_id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  stripe_product_id_gt?: InputMaybe<Scalars['String']['input']>;
  stripe_product_id_gte?: InputMaybe<Scalars['String']['input']>;
  stripe_product_id_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stripe_product_id_lt?: InputMaybe<Scalars['String']['input']>;
  stripe_product_id_lte?: InputMaybe<Scalars['String']['input']>;
  stripe_product_id_ne?: InputMaybe<Scalars['String']['input']>;
  stripe_product_id_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subscription_tier?: InputMaybe<Subscription_TierQueryInput>;
  subscription_tier_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum User_InvoiceSortByInput {
  CreatedDateAsc = 'CREATED_DATE_ASC',
  CreatedDateDesc = 'CREATED_DATE_DESC',
  CurrentPeriodEndAsc = 'CURRENT_PERIOD_END_ASC',
  CurrentPeriodEndDesc = 'CURRENT_PERIOD_END_DESC',
  CurrentPeriodStartAsc = 'CURRENT_PERIOD_START_ASC',
  CurrentPeriodStartDesc = 'CURRENT_PERIOD_START_DESC',
  PriceDecimalAsc = 'PRICE_DECIMAL_ASC',
  PriceDecimalDesc = 'PRICE_DECIMAL_DESC',
  ProductAsc = 'PRODUCT_ASC',
  ProductDesc = 'PRODUCT_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  StripeCustomerIdAsc = 'STRIPE_CUSTOMER_ID_ASC',
  StripeCustomerIdDesc = 'STRIPE_CUSTOMER_ID_DESC',
  StripeInvoiceIdAsc = 'STRIPE_INVOICE_ID_ASC',
  StripeInvoiceIdDesc = 'STRIPE_INVOICE_ID_DESC',
  StripeProductIdAsc = 'STRIPE_PRODUCT_ID_ASC',
  StripeProductIdDesc = 'STRIPE_PRODUCT_ID_DESC',
  SubscriptionTierAsc = 'SUBSCRIPTION_TIER_ASC',
  SubscriptionTierDesc = 'SUBSCRIPTION_TIER_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type User_InvoiceStripe_Customer_IdRelationInput = {
  create?: InputMaybe<Stripe_CustomerInsertInput>;
  link?: InputMaybe<Scalars['String']['input']>;
};

export type User_InvoiceSubscription_TierRelationInput = {
  create?: InputMaybe<Subscription_TierInsertInput>;
  link?: InputMaybe<Scalars['String']['input']>;
};

export type User_InvoiceUpdateInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  created_date?: InputMaybe<Scalars['DateTime']['input']>;
  created_date_unset?: InputMaybe<Scalars['Boolean']['input']>;
  current_period_end?: InputMaybe<Scalars['DateTime']['input']>;
  current_period_end_unset?: InputMaybe<Scalars['Boolean']['input']>;
  current_period_start?: InputMaybe<Scalars['DateTime']['input']>;
  current_period_start_unset?: InputMaybe<Scalars['Boolean']['input']>;
  is_reccuring?: InputMaybe<Scalars['Boolean']['input']>;
  is_reccuring_unset?: InputMaybe<Scalars['Boolean']['input']>;
  is_subscription?: InputMaybe<Scalars['Boolean']['input']>;
  is_subscription_unset?: InputMaybe<Scalars['Boolean']['input']>;
  price_decimal?: InputMaybe<Scalars['String']['input']>;
  price_decimal_unset?: InputMaybe<Scalars['Boolean']['input']>;
  product?: InputMaybe<Scalars['String']['input']>;
  product_unset?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_unset?: InputMaybe<Scalars['Boolean']['input']>;
  stripe_customer_id?: InputMaybe<User_InvoiceStripe_Customer_IdRelationInput>;
  stripe_customer_id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  stripe_invoice_id?: InputMaybe<Scalars['String']['input']>;
  stripe_invoice_id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  stripe_product_id?: InputMaybe<Scalars['String']['input']>;
  stripe_product_id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  subscription_tier?: InputMaybe<User_InvoiceSubscription_TierRelationInput>;
  subscription_tier_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type User_Library_Content_Pack_Favorite = {
  __typename?: 'User_library_content_pack_favorite';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  asset_category_type?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  library_content_pack?: Maybe<Library_Content_Pack>;
  name?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<User>;
};

export type User_Library_Content_Pack_FavoriteInsertInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  asset_category_type?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  library_content_pack?: InputMaybe<User_Library_Content_Pack_FavoriteLibrary_Content_PackRelationInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<User_Library_Content_Pack_FavoriteOwnerRelationInput>;
};

export type User_Library_Content_Pack_FavoriteLibrary_Content_PackRelationInput = {
  create?: InputMaybe<Library_Content_PackInsertInput>;
  link?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type User_Library_Content_Pack_FavoriteOwnerRelationInput = {
  create?: InputMaybe<UserInsertInput>;
  link?: InputMaybe<Scalars['String']['input']>;
};

export type User_Library_Content_Pack_FavoriteQueryInput = {
  AND?: InputMaybe<Array<User_Library_Content_Pack_FavoriteQueryInput>>;
  OR?: InputMaybe<Array<User_Library_Content_Pack_FavoriteQueryInput>>;
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  _id_gt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_gte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  _id_lt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_lte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_ne?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  asset_category_type?: InputMaybe<Scalars['String']['input']>;
  asset_category_type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  asset_category_type_gt?: InputMaybe<Scalars['String']['input']>;
  asset_category_type_gte?: InputMaybe<Scalars['String']['input']>;
  asset_category_type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  asset_category_type_lt?: InputMaybe<Scalars['String']['input']>;
  asset_category_type_lte?: InputMaybe<Scalars['String']['input']>;
  asset_category_type_ne?: InputMaybe<Scalars['String']['input']>;
  asset_category_type_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_exists?: InputMaybe<Scalars['Boolean']['input']>;
  created_at_gt?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_gte?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  created_at_lt?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_lte?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_ne?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  library_content_pack?: InputMaybe<Library_Content_PackQueryInput>;
  library_content_pack_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  owner?: InputMaybe<UserQueryInput>;
  owner_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum User_Library_Content_Pack_FavoriteSortByInput {
  AssetCategoryTypeAsc = 'ASSET_CATEGORY_TYPE_ASC',
  AssetCategoryTypeDesc = 'ASSET_CATEGORY_TYPE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  LibraryContentPackAsc = 'LIBRARY_CONTENT_PACK_ASC',
  LibraryContentPackDesc = 'LIBRARY_CONTENT_PACK_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  OwnerAsc = 'OWNER_ASC',
  OwnerDesc = 'OWNER_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type User_Library_Content_Pack_FavoriteUpdateInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  asset_category_type?: InputMaybe<Scalars['String']['input']>;
  asset_category_type_unset?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_unset?: InputMaybe<Scalars['Boolean']['input']>;
  library_content_pack?: InputMaybe<User_Library_Content_Pack_FavoriteLibrary_Content_PackRelationInput>;
  library_content_pack_unset?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_unset?: InputMaybe<Scalars['Boolean']['input']>;
  owner?: InputMaybe<User_Library_Content_Pack_FavoriteOwnerRelationInput>;
  owner_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type User_Library_Image_Upload = {
  __typename?: 'User_library_image_upload';
  _id: Scalars['ObjectId']['output'];
  asset_category_type: Scalars['String']['output'];
  asset_content_type: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  owner: Scalars['String']['output'];
  path?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  thumbnail_path?: Maybe<Scalars['String']['output']>;
  thumbnail_url: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type User_Library_Image_UploadInsertInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  asset_category_type: Scalars['String']['input'];
  asset_content_type: Scalars['String']['input'];
  created_at: Scalars['DateTime']['input'];
  name: Scalars['String']['input'];
  owner: Scalars['String']['input'];
  path?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  thumbnail_path?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type User_Library_Image_UploadQueryInput = {
  AND?: InputMaybe<Array<User_Library_Image_UploadQueryInput>>;
  OR?: InputMaybe<Array<User_Library_Image_UploadQueryInput>>;
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  _id_gt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_gte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  _id_lt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_lte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_ne?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  asset_category_type?: InputMaybe<Scalars['String']['input']>;
  asset_category_type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  asset_category_type_gt?: InputMaybe<Scalars['String']['input']>;
  asset_category_type_gte?: InputMaybe<Scalars['String']['input']>;
  asset_category_type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  asset_category_type_lt?: InputMaybe<Scalars['String']['input']>;
  asset_category_type_lte?: InputMaybe<Scalars['String']['input']>;
  asset_category_type_ne?: InputMaybe<Scalars['String']['input']>;
  asset_category_type_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  asset_content_type?: InputMaybe<Scalars['String']['input']>;
  asset_content_type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  asset_content_type_gt?: InputMaybe<Scalars['String']['input']>;
  asset_content_type_gte?: InputMaybe<Scalars['String']['input']>;
  asset_content_type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  asset_content_type_lt?: InputMaybe<Scalars['String']['input']>;
  asset_content_type_lte?: InputMaybe<Scalars['String']['input']>;
  asset_content_type_ne?: InputMaybe<Scalars['String']['input']>;
  asset_content_type_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_exists?: InputMaybe<Scalars['Boolean']['input']>;
  created_at_gt?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_gte?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  created_at_lt?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_lte?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_ne?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  owner?: InputMaybe<Scalars['String']['input']>;
  owner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  owner_gt?: InputMaybe<Scalars['String']['input']>;
  owner_gte?: InputMaybe<Scalars['String']['input']>;
  owner_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  owner_lt?: InputMaybe<Scalars['String']['input']>;
  owner_lte?: InputMaybe<Scalars['String']['input']>;
  owner_ne?: InputMaybe<Scalars['String']['input']>;
  owner_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  path?: InputMaybe<Scalars['String']['input']>;
  path_exists?: InputMaybe<Scalars['Boolean']['input']>;
  path_gt?: InputMaybe<Scalars['String']['input']>;
  path_gte?: InputMaybe<Scalars['String']['input']>;
  path_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  path_lt?: InputMaybe<Scalars['String']['input']>;
  path_lte?: InputMaybe<Scalars['String']['input']>;
  path_ne?: InputMaybe<Scalars['String']['input']>;
  path_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tags_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  thumbnail_path?: InputMaybe<Scalars['String']['input']>;
  thumbnail_path_exists?: InputMaybe<Scalars['Boolean']['input']>;
  thumbnail_path_gt?: InputMaybe<Scalars['String']['input']>;
  thumbnail_path_gte?: InputMaybe<Scalars['String']['input']>;
  thumbnail_path_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  thumbnail_path_lt?: InputMaybe<Scalars['String']['input']>;
  thumbnail_path_lte?: InputMaybe<Scalars['String']['input']>;
  thumbnail_path_ne?: InputMaybe<Scalars['String']['input']>;
  thumbnail_path_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  thumbnail_url?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  thumbnail_url_gt?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url_gte?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  thumbnail_url_lt?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url_lte?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url_ne?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url?: InputMaybe<Scalars['String']['input']>;
  url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  url_gt?: InputMaybe<Scalars['String']['input']>;
  url_gte?: InputMaybe<Scalars['String']['input']>;
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_lt?: InputMaybe<Scalars['String']['input']>;
  url_lte?: InputMaybe<Scalars['String']['input']>;
  url_ne?: InputMaybe<Scalars['String']['input']>;
  url_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum User_Library_Image_UploadSortByInput {
  AssetCategoryTypeAsc = 'ASSET_CATEGORY_TYPE_ASC',
  AssetCategoryTypeDesc = 'ASSET_CATEGORY_TYPE_DESC',
  AssetContentTypeAsc = 'ASSET_CONTENT_TYPE_ASC',
  AssetContentTypeDesc = 'ASSET_CONTENT_TYPE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  OwnerAsc = 'OWNER_ASC',
  OwnerDesc = 'OWNER_DESC',
  PathAsc = 'PATH_ASC',
  PathDesc = 'PATH_DESC',
  ThumbnailPathAsc = 'THUMBNAIL_PATH_ASC',
  ThumbnailPathDesc = 'THUMBNAIL_PATH_DESC',
  ThumbnailUrlAsc = 'THUMBNAIL_URL_ASC',
  ThumbnailUrlDesc = 'THUMBNAIL_URL_DESC',
  UrlAsc = 'URL_ASC',
  UrlDesc = 'URL_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type User_Library_Image_UploadUpdateInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  asset_category_type?: InputMaybe<Scalars['String']['input']>;
  asset_category_type_unset?: InputMaybe<Scalars['Boolean']['input']>;
  asset_content_type?: InputMaybe<Scalars['String']['input']>;
  asset_content_type_unset?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_unset?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_unset?: InputMaybe<Scalars['Boolean']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  owner_unset?: InputMaybe<Scalars['Boolean']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  path_unset?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_unset?: InputMaybe<Scalars['Boolean']['input']>;
  thumbnail_path?: InputMaybe<Scalars['String']['input']>;
  thumbnail_path_unset?: InputMaybe<Scalars['Boolean']['input']>;
  thumbnail_url?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url_unset?: InputMaybe<Scalars['Boolean']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  url_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type User_Library_Purchase = {
  __typename?: 'User_library_purchase';
  _id?: Maybe<Scalars['String']['output']>;
  library_content_pack?: Maybe<Library_Content_Pack>;
  owner?: Maybe<User>;
  purchase_date?: Maybe<Scalars['DateTime']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type User_Library_PurchaseInsertInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  library_content_pack?: InputMaybe<User_Library_PurchaseLibrary_Content_PackRelationInput>;
  owner?: InputMaybe<User_Library_PurchaseOwnerRelationInput>;
  purchase_date?: InputMaybe<Scalars['DateTime']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type User_Library_PurchaseLibrary_Content_PackRelationInput = {
  create?: InputMaybe<Library_Content_PackInsertInput>;
  link?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type User_Library_PurchaseOwnerRelationInput = {
  create?: InputMaybe<UserInsertInput>;
  link?: InputMaybe<Scalars['String']['input']>;
};

export type User_Library_PurchaseQueryInput = {
  AND?: InputMaybe<Array<User_Library_PurchaseQueryInput>>;
  OR?: InputMaybe<Array<User_Library_PurchaseQueryInput>>;
  _id?: InputMaybe<Scalars['String']['input']>;
  _id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  _id_gt?: InputMaybe<Scalars['String']['input']>;
  _id_gte?: InputMaybe<Scalars['String']['input']>;
  _id_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  _id_lt?: InputMaybe<Scalars['String']['input']>;
  _id_lte?: InputMaybe<Scalars['String']['input']>;
  _id_ne?: InputMaybe<Scalars['String']['input']>;
  _id_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  library_content_pack?: InputMaybe<Library_Content_PackQueryInput>;
  library_content_pack_exists?: InputMaybe<Scalars['Boolean']['input']>;
  owner?: InputMaybe<UserQueryInput>;
  owner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  purchase_date?: InputMaybe<Scalars['DateTime']['input']>;
  purchase_date_exists?: InputMaybe<Scalars['Boolean']['input']>;
  purchase_date_gt?: InputMaybe<Scalars['DateTime']['input']>;
  purchase_date_gte?: InputMaybe<Scalars['DateTime']['input']>;
  purchase_date_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  purchase_date_lt?: InputMaybe<Scalars['DateTime']['input']>;
  purchase_date_lte?: InputMaybe<Scalars['DateTime']['input']>;
  purchase_date_ne?: InputMaybe<Scalars['DateTime']['input']>;
  purchase_date_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  state?: InputMaybe<Scalars['String']['input']>;
  state_exists?: InputMaybe<Scalars['Boolean']['input']>;
  state_gt?: InputMaybe<Scalars['String']['input']>;
  state_gte?: InputMaybe<Scalars['String']['input']>;
  state_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  state_lt?: InputMaybe<Scalars['String']['input']>;
  state_lte?: InputMaybe<Scalars['String']['input']>;
  state_ne?: InputMaybe<Scalars['String']['input']>;
  state_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum User_Library_PurchaseSortByInput {
  LibraryContentPackAsc = 'LIBRARY_CONTENT_PACK_ASC',
  LibraryContentPackDesc = 'LIBRARY_CONTENT_PACK_DESC',
  OwnerAsc = 'OWNER_ASC',
  OwnerDesc = 'OWNER_DESC',
  PurchaseDateAsc = 'PURCHASE_DATE_ASC',
  PurchaseDateDesc = 'PURCHASE_DATE_DESC',
  StateAsc = 'STATE_ASC',
  StateDesc = 'STATE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type User_Library_PurchaseUpdateInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  _id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  library_content_pack?: InputMaybe<User_Library_PurchaseLibrary_Content_PackRelationInput>;
  library_content_pack_unset?: InputMaybe<Scalars['Boolean']['input']>;
  owner?: InputMaybe<User_Library_PurchaseOwnerRelationInput>;
  owner_unset?: InputMaybe<Scalars['Boolean']['input']>;
  purchase_date?: InputMaybe<Scalars['DateTime']['input']>;
  purchase_date_unset?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  state_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type User_Realm_Count = {
  __typename?: 'User_realm_count';
  _id: Scalars['ObjectId']['output'];
  owner?: Maybe<Scalars['String']['output']>;
  realms_count?: Maybe<Scalars['Long']['output']>;
};

export type User_Realm_CountInsertInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  realms_count?: InputMaybe<Scalars['Long']['input']>;
};

export type User_Realm_CountQueryInput = {
  AND?: InputMaybe<Array<User_Realm_CountQueryInput>>;
  OR?: InputMaybe<Array<User_Realm_CountQueryInput>>;
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  _id_gt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_gte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  _id_lt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_lte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_ne?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  owner?: InputMaybe<Scalars['String']['input']>;
  owner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  owner_gt?: InputMaybe<Scalars['String']['input']>;
  owner_gte?: InputMaybe<Scalars['String']['input']>;
  owner_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  owner_lt?: InputMaybe<Scalars['String']['input']>;
  owner_lte?: InputMaybe<Scalars['String']['input']>;
  owner_ne?: InputMaybe<Scalars['String']['input']>;
  owner_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  realms_count?: InputMaybe<Scalars['Long']['input']>;
  realms_count_exists?: InputMaybe<Scalars['Boolean']['input']>;
  realms_count_gt?: InputMaybe<Scalars['Long']['input']>;
  realms_count_gte?: InputMaybe<Scalars['Long']['input']>;
  realms_count_in?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  realms_count_lt?: InputMaybe<Scalars['Long']['input']>;
  realms_count_lte?: InputMaybe<Scalars['Long']['input']>;
  realms_count_ne?: InputMaybe<Scalars['Long']['input']>;
  realms_count_nin?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};

export enum User_Realm_CountSortByInput {
  OwnerAsc = 'OWNER_ASC',
  OwnerDesc = 'OWNER_DESC',
  RealmsCountAsc = 'REALMS_COUNT_ASC',
  RealmsCountDesc = 'REALMS_COUNT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type User_Realm_CountUpdateInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  owner_unset?: InputMaybe<Scalars['Boolean']['input']>;
  realms_count?: InputMaybe<Scalars['Long']['input']>;
  realms_count_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type User_Realms_Count = {
  __typename?: 'User_realms_count';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  atlas_user?: Maybe<User>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  realms_count?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type User_Realms_CountAtlas_UserRelationInput = {
  create?: InputMaybe<UserInsertInput>;
  link?: InputMaybe<Scalars['String']['input']>;
};

export type User_Realms_CountInsertInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  atlas_user?: InputMaybe<User_Realms_CountAtlas_UserRelationInput>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  realms_count?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type User_Realms_CountQueryInput = {
  AND?: InputMaybe<Array<User_Realms_CountQueryInput>>;
  OR?: InputMaybe<Array<User_Realms_CountQueryInput>>;
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  _id_gt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_gte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  _id_lt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_lte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_ne?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  atlas_user?: InputMaybe<UserQueryInput>;
  atlas_user_exists?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_exists?: InputMaybe<Scalars['Boolean']['input']>;
  created_at_gt?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_gte?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  created_at_lt?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_lte?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_ne?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  realms_count?: InputMaybe<Scalars['Int']['input']>;
  realms_count_exists?: InputMaybe<Scalars['Boolean']['input']>;
  realms_count_gt?: InputMaybe<Scalars['Int']['input']>;
  realms_count_gte?: InputMaybe<Scalars['Int']['input']>;
  realms_count_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  realms_count_lt?: InputMaybe<Scalars['Int']['input']>;
  realms_count_lte?: InputMaybe<Scalars['Int']['input']>;
  realms_count_ne?: InputMaybe<Scalars['Int']['input']>;
  realms_count_nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at_exists?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updated_at_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at_ne?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum User_Realms_CountSortByInput {
  AtlasUserAsc = 'ATLAS_USER_ASC',
  AtlasUserDesc = 'ATLAS_USER_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  RealmsCountAsc = 'REALMS_COUNT_ASC',
  RealmsCountDesc = 'REALMS_COUNT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type User_Realms_CountUpdateInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  atlas_user?: InputMaybe<User_Realms_CountAtlas_UserRelationInput>;
  atlas_user_unset?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_unset?: InputMaybe<Scalars['Boolean']['input']>;
  realms_count?: InputMaybe<Scalars['Int']['input']>;
  realms_count_inc?: InputMaybe<Scalars['Int']['input']>;
  realms_count_unset?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type User_Text_Generation = {
  __typename?: 'User_text_generation';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  modified_date?: Maybe<Scalars['DateTime']['output']>;
  owner?: Maybe<User>;
  prompt_attributes?: Maybe<Array<Maybe<User_Text_GenerationPrompt_Attribute>>>;
  prompt_template_id?: Maybe<Scalars['ObjectId']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  text?: Maybe<Scalars['String']['output']>;
  workflow_id?: Maybe<Scalars['Int']['output']>;
};

export type User_Text_GenerationInsertInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  created_date?: InputMaybe<Scalars['DateTime']['input']>;
  modified_date?: InputMaybe<Scalars['DateTime']['input']>;
  owner?: InputMaybe<User_Text_GenerationOwnerRelationInput>;
  prompt_attributes?: InputMaybe<Array<InputMaybe<User_Text_GenerationPrompt_AttributeInsertInput>>>;
  prompt_template_id?: InputMaybe<Scalars['ObjectId']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  text?: InputMaybe<Scalars['String']['input']>;
  workflow_id?: InputMaybe<Scalars['Int']['input']>;
};

export type User_Text_GenerationOwnerRelationInput = {
  create?: InputMaybe<UserInsertInput>;
  link?: InputMaybe<Scalars['String']['input']>;
};

export type User_Text_GenerationPrompt_Attribute = {
  __typename?: 'User_text_generationPrompt_attribute';
  attribute?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type User_Text_GenerationPrompt_AttributeInsertInput = {
  attribute?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type User_Text_GenerationPrompt_AttributeQueryInput = {
  AND?: InputMaybe<Array<User_Text_GenerationPrompt_AttributeQueryInput>>;
  OR?: InputMaybe<Array<User_Text_GenerationPrompt_AttributeQueryInput>>;
  attribute?: InputMaybe<Scalars['String']['input']>;
  attribute_exists?: InputMaybe<Scalars['Boolean']['input']>;
  attribute_gt?: InputMaybe<Scalars['String']['input']>;
  attribute_gte?: InputMaybe<Scalars['String']['input']>;
  attribute_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attribute_lt?: InputMaybe<Scalars['String']['input']>;
  attribute_lte?: InputMaybe<Scalars['String']['input']>;
  attribute_ne?: InputMaybe<Scalars['String']['input']>;
  attribute_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_exists?: InputMaybe<Scalars['Boolean']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_ne?: InputMaybe<Scalars['String']['input']>;
  value_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type User_Text_GenerationPrompt_AttributeUpdateInput = {
  attribute?: InputMaybe<Scalars['String']['input']>;
  attribute_unset?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type User_Text_GenerationQueryInput = {
  AND?: InputMaybe<Array<User_Text_GenerationQueryInput>>;
  OR?: InputMaybe<Array<User_Text_GenerationQueryInput>>;
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  _id_gt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_gte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  _id_lt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_lte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_ne?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  created_date?: InputMaybe<Scalars['DateTime']['input']>;
  created_date_exists?: InputMaybe<Scalars['Boolean']['input']>;
  created_date_gt?: InputMaybe<Scalars['DateTime']['input']>;
  created_date_gte?: InputMaybe<Scalars['DateTime']['input']>;
  created_date_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  created_date_lt?: InputMaybe<Scalars['DateTime']['input']>;
  created_date_lte?: InputMaybe<Scalars['DateTime']['input']>;
  created_date_ne?: InputMaybe<Scalars['DateTime']['input']>;
  created_date_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  modified_date?: InputMaybe<Scalars['DateTime']['input']>;
  modified_date_exists?: InputMaybe<Scalars['Boolean']['input']>;
  modified_date_gt?: InputMaybe<Scalars['DateTime']['input']>;
  modified_date_gte?: InputMaybe<Scalars['DateTime']['input']>;
  modified_date_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  modified_date_lt?: InputMaybe<Scalars['DateTime']['input']>;
  modified_date_lte?: InputMaybe<Scalars['DateTime']['input']>;
  modified_date_ne?: InputMaybe<Scalars['DateTime']['input']>;
  modified_date_nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  owner?: InputMaybe<UserQueryInput>;
  owner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  prompt_attributes?: InputMaybe<Array<InputMaybe<User_Text_GenerationPrompt_AttributeQueryInput>>>;
  prompt_attributes_exists?: InputMaybe<Scalars['Boolean']['input']>;
  prompt_attributes_in?: InputMaybe<Array<InputMaybe<User_Text_GenerationPrompt_AttributeQueryInput>>>;
  prompt_attributes_nin?: InputMaybe<Array<InputMaybe<User_Text_GenerationPrompt_AttributeQueryInput>>>;
  prompt_template_id?: InputMaybe<Scalars['ObjectId']['input']>;
  prompt_template_id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  prompt_template_id_gt?: InputMaybe<Scalars['ObjectId']['input']>;
  prompt_template_id_gte?: InputMaybe<Scalars['ObjectId']['input']>;
  prompt_template_id_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  prompt_template_id_lt?: InputMaybe<Scalars['ObjectId']['input']>;
  prompt_template_id_lte?: InputMaybe<Scalars['ObjectId']['input']>;
  prompt_template_id_ne?: InputMaybe<Scalars['ObjectId']['input']>;
  prompt_template_id_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_exists?: InputMaybe<Scalars['Boolean']['input']>;
  status_gt?: InputMaybe<Scalars['String']['input']>;
  status_gte?: InputMaybe<Scalars['String']['input']>;
  status_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status_lt?: InputMaybe<Scalars['String']['input']>;
  status_lte?: InputMaybe<Scalars['String']['input']>;
  status_ne?: InputMaybe<Scalars['String']['input']>;
  status_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tags_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  text?: InputMaybe<Scalars['String']['input']>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
  text_gt?: InputMaybe<Scalars['String']['input']>;
  text_gte?: InputMaybe<Scalars['String']['input']>;
  text_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  text_lt?: InputMaybe<Scalars['String']['input']>;
  text_lte?: InputMaybe<Scalars['String']['input']>;
  text_ne?: InputMaybe<Scalars['String']['input']>;
  text_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workflow_id?: InputMaybe<Scalars['Int']['input']>;
  workflow_id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  workflow_id_gt?: InputMaybe<Scalars['Int']['input']>;
  workflow_id_gte?: InputMaybe<Scalars['Int']['input']>;
  workflow_id_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  workflow_id_lt?: InputMaybe<Scalars['Int']['input']>;
  workflow_id_lte?: InputMaybe<Scalars['Int']['input']>;
  workflow_id_ne?: InputMaybe<Scalars['Int']['input']>;
  workflow_id_nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export enum User_Text_GenerationSortByInput {
  CreatedDateAsc = 'CREATED_DATE_ASC',
  CreatedDateDesc = 'CREATED_DATE_DESC',
  ModifiedDateAsc = 'MODIFIED_DATE_ASC',
  ModifiedDateDesc = 'MODIFIED_DATE_DESC',
  OwnerAsc = 'OWNER_ASC',
  OwnerDesc = 'OWNER_DESC',
  PromptTemplateIdAsc = 'PROMPT_TEMPLATE_ID_ASC',
  PromptTemplateIdDesc = 'PROMPT_TEMPLATE_ID_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  TextAsc = 'TEXT_ASC',
  TextDesc = 'TEXT_DESC',
  WorkflowIdAsc = 'WORKFLOW_ID_ASC',
  WorkflowIdDesc = 'WORKFLOW_ID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type User_Text_GenerationUpdateInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  created_date?: InputMaybe<Scalars['DateTime']['input']>;
  created_date_unset?: InputMaybe<Scalars['Boolean']['input']>;
  modified_date?: InputMaybe<Scalars['DateTime']['input']>;
  modified_date_unset?: InputMaybe<Scalars['Boolean']['input']>;
  owner?: InputMaybe<User_Text_GenerationOwnerRelationInput>;
  owner_unset?: InputMaybe<Scalars['Boolean']['input']>;
  prompt_attributes?: InputMaybe<Array<InputMaybe<User_Text_GenerationPrompt_AttributeUpdateInput>>>;
  prompt_attributes_unset?: InputMaybe<Scalars['Boolean']['input']>;
  prompt_template_id?: InputMaybe<Scalars['ObjectId']['input']>;
  prompt_template_id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_unset?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_unset?: InputMaybe<Scalars['Boolean']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  text_unset?: InputMaybe<Scalars['Boolean']['input']>;
  workflow_id?: InputMaybe<Scalars['Int']['input']>;
  workflow_id_inc?: InputMaybe<Scalars['Int']['input']>;
  workflow_id_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Weapon = {
  __typename?: 'Weapon';
  _id?: Maybe<Scalars['ObjectId']['output']>;
  mask_url?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type WeaponInsertInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  mask_url?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type WeaponQueryInput = {
  AND?: InputMaybe<Array<WeaponQueryInput>>;
  OR?: InputMaybe<Array<WeaponQueryInput>>;
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  _id_gt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_gte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  _id_lt?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_lte?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_ne?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  mask_url?: InputMaybe<Scalars['String']['input']>;
  mask_url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mask_url_gt?: InputMaybe<Scalars['String']['input']>;
  mask_url_gte?: InputMaybe<Scalars['String']['input']>;
  mask_url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mask_url_lt?: InputMaybe<Scalars['String']['input']>;
  mask_url_lte?: InputMaybe<Scalars['String']['input']>;
  mask_url_ne?: InputMaybe<Scalars['String']['input']>;
  mask_url_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_ne?: InputMaybe<Scalars['String']['input']>;
  name_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum WeaponSortByInput {
  MaskUrlAsc = 'MASK_URL_ASC',
  MaskUrlDesc = 'MASK_URL_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type WeaponUpdateInput = {
  _id?: InputMaybe<Scalars['ObjectId']['input']>;
  _id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  mask_url?: InputMaybe<Scalars['String']['input']>;
  mask_url_unset?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Widget = {
  __typename?: 'Widget';
  _id: Scalars['String']['output'];
  assets?: Maybe<Array<Maybe<Scalars['ObjectId']['output']>>>;
  canvas: Scalars['ObjectId']['output'];
  hasParentContainer?: Maybe<Scalars['ObjectId']['output']>;
  position?: Maybe<WidgetPosition>;
  style?: Maybe<WidgetStyle>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  widgetType: Scalars['String']['output'];
};

export type WidgetInsertInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  assets?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  canvas: Scalars['ObjectId']['input'];
  hasParentContainer?: InputMaybe<Scalars['ObjectId']['input']>;
  position?: InputMaybe<WidgetPositionInsertInput>;
  style?: InputMaybe<WidgetStyleInsertInput>;
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  widgetType: Scalars['String']['input'];
};

export type WidgetPosition = {
  __typename?: 'WidgetPosition';
  x?: Maybe<Scalars['Long']['output']>;
  y?: Maybe<Scalars['Long']['output']>;
  z?: Maybe<Scalars['Long']['output']>;
};

export type WidgetPositionInsertInput = {
  x?: InputMaybe<Scalars['Long']['input']>;
  y?: InputMaybe<Scalars['Long']['input']>;
  z?: InputMaybe<Scalars['Long']['input']>;
};

export type WidgetPositionQueryInput = {
  AND?: InputMaybe<Array<WidgetPositionQueryInput>>;
  OR?: InputMaybe<Array<WidgetPositionQueryInput>>;
  x?: InputMaybe<Scalars['Long']['input']>;
  x_exists?: InputMaybe<Scalars['Boolean']['input']>;
  x_gt?: InputMaybe<Scalars['Long']['input']>;
  x_gte?: InputMaybe<Scalars['Long']['input']>;
  x_in?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  x_lt?: InputMaybe<Scalars['Long']['input']>;
  x_lte?: InputMaybe<Scalars['Long']['input']>;
  x_ne?: InputMaybe<Scalars['Long']['input']>;
  x_nin?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  y?: InputMaybe<Scalars['Long']['input']>;
  y_exists?: InputMaybe<Scalars['Boolean']['input']>;
  y_gt?: InputMaybe<Scalars['Long']['input']>;
  y_gte?: InputMaybe<Scalars['Long']['input']>;
  y_in?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  y_lt?: InputMaybe<Scalars['Long']['input']>;
  y_lte?: InputMaybe<Scalars['Long']['input']>;
  y_ne?: InputMaybe<Scalars['Long']['input']>;
  y_nin?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  z?: InputMaybe<Scalars['Long']['input']>;
  z_exists?: InputMaybe<Scalars['Boolean']['input']>;
  z_gt?: InputMaybe<Scalars['Long']['input']>;
  z_gte?: InputMaybe<Scalars['Long']['input']>;
  z_in?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  z_lt?: InputMaybe<Scalars['Long']['input']>;
  z_lte?: InputMaybe<Scalars['Long']['input']>;
  z_ne?: InputMaybe<Scalars['Long']['input']>;
  z_nin?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};

export type WidgetPositionUpdateInput = {
  x?: InputMaybe<Scalars['Long']['input']>;
  x_unset?: InputMaybe<Scalars['Boolean']['input']>;
  y?: InputMaybe<Scalars['Long']['input']>;
  y_unset?: InputMaybe<Scalars['Boolean']['input']>;
  z?: InputMaybe<Scalars['Long']['input']>;
  z_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WidgetQueryInput = {
  AND?: InputMaybe<Array<WidgetQueryInput>>;
  OR?: InputMaybe<Array<WidgetQueryInput>>;
  _id?: InputMaybe<Scalars['String']['input']>;
  _id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  _id_gt?: InputMaybe<Scalars['String']['input']>;
  _id_gte?: InputMaybe<Scalars['String']['input']>;
  _id_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  _id_lt?: InputMaybe<Scalars['String']['input']>;
  _id_lte?: InputMaybe<Scalars['String']['input']>;
  _id_ne?: InputMaybe<Scalars['String']['input']>;
  _id_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  assets?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  assets_exists?: InputMaybe<Scalars['Boolean']['input']>;
  assets_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  assets_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  canvas?: InputMaybe<Scalars['ObjectId']['input']>;
  canvas_exists?: InputMaybe<Scalars['Boolean']['input']>;
  canvas_gt?: InputMaybe<Scalars['ObjectId']['input']>;
  canvas_gte?: InputMaybe<Scalars['ObjectId']['input']>;
  canvas_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  canvas_lt?: InputMaybe<Scalars['ObjectId']['input']>;
  canvas_lte?: InputMaybe<Scalars['ObjectId']['input']>;
  canvas_ne?: InputMaybe<Scalars['ObjectId']['input']>;
  canvas_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  hasParentContainer?: InputMaybe<Scalars['ObjectId']['input']>;
  hasParentContainer_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hasParentContainer_gt?: InputMaybe<Scalars['ObjectId']['input']>;
  hasParentContainer_gte?: InputMaybe<Scalars['ObjectId']['input']>;
  hasParentContainer_in?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  hasParentContainer_lt?: InputMaybe<Scalars['ObjectId']['input']>;
  hasParentContainer_lte?: InputMaybe<Scalars['ObjectId']['input']>;
  hasParentContainer_ne?: InputMaybe<Scalars['ObjectId']['input']>;
  hasParentContainer_nin?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  position?: InputMaybe<WidgetPositionQueryInput>;
  position_exists?: InputMaybe<Scalars['Boolean']['input']>;
  style?: InputMaybe<WidgetStyleQueryInput>;
  style_exists?: InputMaybe<Scalars['Boolean']['input']>;
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  thumbnailUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  thumbnailUrl_gt?: InputMaybe<Scalars['String']['input']>;
  thumbnailUrl_gte?: InputMaybe<Scalars['String']['input']>;
  thumbnailUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  thumbnailUrl_lt?: InputMaybe<Scalars['String']['input']>;
  thumbnailUrl_lte?: InputMaybe<Scalars['String']['input']>;
  thumbnailUrl_ne?: InputMaybe<Scalars['String']['input']>;
  thumbnailUrl_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_gt?: InputMaybe<Scalars['String']['input']>;
  title_gte?: InputMaybe<Scalars['String']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_lt?: InputMaybe<Scalars['String']['input']>;
  title_lte?: InputMaybe<Scalars['String']['input']>;
  title_ne?: InputMaybe<Scalars['String']['input']>;
  title_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  widgetType?: InputMaybe<Scalars['String']['input']>;
  widgetType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  widgetType_gt?: InputMaybe<Scalars['String']['input']>;
  widgetType_gte?: InputMaybe<Scalars['String']['input']>;
  widgetType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  widgetType_lt?: InputMaybe<Scalars['String']['input']>;
  widgetType_lte?: InputMaybe<Scalars['String']['input']>;
  widgetType_ne?: InputMaybe<Scalars['String']['input']>;
  widgetType_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum WidgetSortByInput {
  CanvasAsc = 'CANVAS_ASC',
  CanvasDesc = 'CANVAS_DESC',
  HasparentcontainerAsc = 'HASPARENTCONTAINER_ASC',
  HasparentcontainerDesc = 'HASPARENTCONTAINER_DESC',
  ThumbnailurlAsc = 'THUMBNAILURL_ASC',
  ThumbnailurlDesc = 'THUMBNAILURL_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC',
  WidgettypeAsc = 'WIDGETTYPE_ASC',
  WidgettypeDesc = 'WIDGETTYPE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type WidgetStyle = {
  __typename?: 'WidgetStyle';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  borderColor?: Maybe<Scalars['String']['output']>;
  borderRadius?: Maybe<Scalars['Long']['output']>;
  borderWidth?: Maybe<Scalars['Long']['output']>;
  opacity?: Maybe<Scalars['Long']['output']>;
};

export type WidgetStyleInsertInput = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  borderColor?: InputMaybe<Scalars['String']['input']>;
  borderRadius?: InputMaybe<Scalars['Long']['input']>;
  borderWidth?: InputMaybe<Scalars['Long']['input']>;
  opacity?: InputMaybe<Scalars['Long']['input']>;
};

export type WidgetStyleQueryInput = {
  AND?: InputMaybe<Array<WidgetStyleQueryInput>>;
  OR?: InputMaybe<Array<WidgetStyleQueryInput>>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_gt?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_gte?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_lt?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_lte?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_ne?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  borderColor?: InputMaybe<Scalars['String']['input']>;
  borderColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  borderColor_gt?: InputMaybe<Scalars['String']['input']>;
  borderColor_gte?: InputMaybe<Scalars['String']['input']>;
  borderColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  borderColor_lt?: InputMaybe<Scalars['String']['input']>;
  borderColor_lte?: InputMaybe<Scalars['String']['input']>;
  borderColor_ne?: InputMaybe<Scalars['String']['input']>;
  borderColor_nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  borderRadius?: InputMaybe<Scalars['Long']['input']>;
  borderRadius_exists?: InputMaybe<Scalars['Boolean']['input']>;
  borderRadius_gt?: InputMaybe<Scalars['Long']['input']>;
  borderRadius_gte?: InputMaybe<Scalars['Long']['input']>;
  borderRadius_in?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  borderRadius_lt?: InputMaybe<Scalars['Long']['input']>;
  borderRadius_lte?: InputMaybe<Scalars['Long']['input']>;
  borderRadius_ne?: InputMaybe<Scalars['Long']['input']>;
  borderRadius_nin?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  borderWidth?: InputMaybe<Scalars['Long']['input']>;
  borderWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  borderWidth_gt?: InputMaybe<Scalars['Long']['input']>;
  borderWidth_gte?: InputMaybe<Scalars['Long']['input']>;
  borderWidth_in?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  borderWidth_lt?: InputMaybe<Scalars['Long']['input']>;
  borderWidth_lte?: InputMaybe<Scalars['Long']['input']>;
  borderWidth_ne?: InputMaybe<Scalars['Long']['input']>;
  borderWidth_nin?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  opacity?: InputMaybe<Scalars['Long']['input']>;
  opacity_exists?: InputMaybe<Scalars['Boolean']['input']>;
  opacity_gt?: InputMaybe<Scalars['Long']['input']>;
  opacity_gte?: InputMaybe<Scalars['Long']['input']>;
  opacity_in?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  opacity_lt?: InputMaybe<Scalars['Long']['input']>;
  opacity_lte?: InputMaybe<Scalars['Long']['input']>;
  opacity_ne?: InputMaybe<Scalars['Long']['input']>;
  opacity_nin?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};

export type WidgetStyleUpdateInput = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_unset?: InputMaybe<Scalars['Boolean']['input']>;
  borderColor?: InputMaybe<Scalars['String']['input']>;
  borderColor_unset?: InputMaybe<Scalars['Boolean']['input']>;
  borderRadius?: InputMaybe<Scalars['Long']['input']>;
  borderRadius_unset?: InputMaybe<Scalars['Boolean']['input']>;
  borderWidth?: InputMaybe<Scalars['Long']['input']>;
  borderWidth_unset?: InputMaybe<Scalars['Boolean']['input']>;
  opacity?: InputMaybe<Scalars['Long']['input']>;
  opacity_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WidgetUpdateInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  _id_unset?: InputMaybe<Scalars['Boolean']['input']>;
  assets?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  assets_unset?: InputMaybe<Scalars['Boolean']['input']>;
  canvas?: InputMaybe<Scalars['ObjectId']['input']>;
  canvas_unset?: InputMaybe<Scalars['Boolean']['input']>;
  hasParentContainer?: InputMaybe<Scalars['ObjectId']['input']>;
  hasParentContainer_unset?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<WidgetPositionUpdateInput>;
  position_unset?: InputMaybe<Scalars['Boolean']['input']>;
  style?: InputMaybe<WidgetStyleUpdateInput>;
  style_unset?: InputMaybe<Scalars['Boolean']['input']>;
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  thumbnailUrl_unset?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_unset?: InputMaybe<Scalars['Boolean']['input']>;
  widgetType?: InputMaybe<Scalars['String']['input']>;
  widgetType_unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateCharacterMutationVariables = Exact<{
  data: CharacterInsertInput;
}>;


export type CreateCharacterMutation = { __typename?: 'Mutation', insertOneCharacter?: { __typename?: 'Character', _id: any, name: string, avatar_url?: string | null, character_image_thumbnail_url?: string | null, race?: string | null, motivations?: Array<string | null> | null, backstory?: string | null, attributes?: Array<string | null> | null, owner?: { __typename?: 'User', _id: string } | null, physical_profile?: { __typename?: 'CharacterPhysical_profile', body_type?: string | null, eye_color?: string | null, hair_color?: string | null, hair_style?: string | null, skin_color?: string | null } | null, notes?: Array<{ __typename?: 'Note', _id: any, content?: string | null, tags?: Array<string | null> | null, title: string, owner?: { __typename?: 'User', _id: string } | null, realm: { __typename?: 'Realm', _id: any } } | null> | null, home?: Array<{ __typename?: 'Location', _id: any, description?: string | null, title?: string | null } | null> | null, abilities?: { __typename?: 'CharacterAbility', charisma?: number | null, consitution?: number | null, dexterity?: number | null, intelligence?: number | null, strength?: string | null, wisdom?: number | null } | null, character_sets?: Array<{ __typename?: 'Character_set', _id?: any | null } | null> | null } | null };

export type CreateCharacterSetMutationVariables = Exact<{
  data: Character_SetInsertInput;
}>;


export type CreateCharacterSetMutation = { __typename?: 'Mutation', insertOneCharacter_set?: { __typename?: 'Character_set', _id?: any | null, name?: string | null, background_url?: string | null, characters?: Array<{ __typename?: 'Character', _id: any } | null> | null, owner?: { __typename?: 'User', _id: string } | null } | null };

export type CreateMyLibraryFavoritesMutationVariables = Exact<{
  data: User_Library_Content_Pack_FavoriteInsertInput;
}>;


export type CreateMyLibraryFavoritesMutation = { __typename?: 'Mutation', insertOneUser_library_content_pack_favorite?: { __typename?: 'User_library_content_pack_favorite', _id?: any | null, name?: string | null, asset_category_type?: string | null, created_at?: any | null, owner?: { __typename?: 'User', _id: string } | null, library_content_pack?: { __typename?: 'Library_content_pack', _id: any } | null } | null };

export type CreateNoteMutationVariables = Exact<{
  data: NoteInsertInput;
}>;


export type CreateNoteMutation = { __typename?: 'Mutation', insertOneNote?: { __typename?: 'Note', _id: any, title: string, content?: string | null, owner?: { __typename?: 'User', _id: string } | null } | null };

export type CreateRealmMutationVariables = Exact<{
  data: RealmInsertInput;
}>;


export type CreateRealmMutation = { __typename?: 'Mutation', insertOneRealm?: { __typename?: 'Realm', _id: any, name: string, description?: string | null, tags?: Array<string | null> | null, thumbnail_url?: string | null, is_favorited: boolean, createdAt?: any | null } | null };

export type CreateTokenSetMutationVariables = Exact<{
  data: Token_SetInsertInput;
}>;


export type CreateTokenSetMutation = { __typename?: 'Mutation', insertOneToken_set?: { __typename?: 'Token_set', _id: any, name?: string | null, description?: string | null, thumbnail_url?: string | null, tokens?: Array<{ __typename?: 'Token', _id: any, thumbnail_url?: string | null } | null> | null, owner?: { __typename?: 'User', _id: string } | null } | null };

export type DeleteManyNotesMutationVariables = Exact<{
  query: NoteQueryInput;
}>;


export type DeleteManyNotesMutation = { __typename?: 'Mutation', deleteManyNotes?: { __typename?: 'DeleteManyPayload', deletedCount: number } | null };

export type DeleteManyRealmsMutationVariables = Exact<{
  query: RealmQueryInput;
}>;


export type DeleteManyRealmsMutation = { __typename?: 'Mutation', deleteManyRealms?: { __typename?: 'DeleteManyPayload', deletedCount: number } | null };

export type DeleteOneCharacterMutationVariables = Exact<{
  query: CharacterQueryInput;
}>;


export type DeleteOneCharacterMutation = { __typename?: 'Mutation', deleteOneCharacter?: { __typename?: 'Character', _id: any, name: string } | null };

export type DeleteOneCharacterSetMutationVariables = Exact<{
  query: Character_SetQueryInput;
}>;


export type DeleteOneCharacterSetMutation = { __typename?: 'Mutation', deleteOneCharacter_set?: { __typename?: 'Character_set', _id?: any | null, name?: string | null } | null };

export type DeleteOneMyLibraryFavoritesMutationVariables = Exact<{
  query: User_Library_Content_Pack_FavoriteQueryInput;
}>;


export type DeleteOneMyLibraryFavoritesMutation = { __typename?: 'Mutation', deleteOneUser_library_content_pack_favorite?: { __typename?: 'User_library_content_pack_favorite', _id?: any | null, name?: string | null } | null };

export type DeleteOneRealmMutationVariables = Exact<{
  query: RealmQueryInput;
}>;


export type DeleteOneRealmMutation = { __typename?: 'Mutation', deleteOneRealm?: { __typename?: 'Realm', _id: any, name: string } | null };

export type DeleteOneTokenMutationVariables = Exact<{
  query: TokenQueryInput;
}>;


export type DeleteOneTokenMutation = { __typename?: 'Mutation', deleteOneToken?: { __typename?: 'Token', _id: any, name: string } | null };

export type DeleteOneTokenSetMutationVariables = Exact<{
  query: Token_SetQueryInput;
}>;


export type DeleteOneTokenSetMutation = { __typename?: 'Mutation', deleteOneToken_set?: { __typename?: 'Token_set', _id: any, name?: string | null } | null };

export type GetAllCampaignsQueryVariables = Exact<{
  query?: InputMaybe<CampaignQueryInput>;
}>;


export type GetAllCampaignsQuery = { __typename?: 'Query', campaigns: Array<{ __typename?: 'Campaign', _id?: any | null, name: string, background_asset?: { __typename?: 'Media_asset', asset_url: string, thumbnail_url: string } | null, campaign_acts?: Array<{ __typename?: 'Campaign_act', title?: string | null, narrative?: string | null, _id?: any | null, outcomes?: Array<{ __typename?: 'Campaign_actOutcome', description?: string | null, name?: string | null, impact?: string | null } | null> | null, background_asset?: { __typename?: 'Media_asset', asset_url: string, thumbnail_url: string } | null, thumbnail_asset?: { __typename?: 'Media_asset', asset_url: string, thumbnail_url: string } | null } | null> | null, main_location?: { __typename?: 'Location', title?: string | null, _id: any, description?: string | null } | null } | null> };

export type GetHairAttributesQueryVariables = Exact<{
  query?: InputMaybe<HairQueryInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<HairSortByInput>;
}>;


export type GetHairAttributesQuery = { __typename?: 'Query', hairs: Array<{ __typename?: 'Hair', name?: string | null, _id?: any | null } | null> };

export type GetEyesAttributesQueryVariables = Exact<{
  query?: InputMaybe<EyeQueryInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<EyeSortByInput>;
}>;


export type GetEyesAttributesQuery = { __typename?: 'Query', eyes: Array<{ __typename?: 'Eye', name?: string | null, _id?: any | null } | null> };

export type GetSkinsAttributesQueryVariables = Exact<{
  query?: InputMaybe<SkinQueryInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SkinSortByInput>;
}>;


export type GetSkinsAttributesQuery = { __typename?: 'Query', skins: Array<{ __typename?: 'Skin', name?: string | null, _id?: any | null } | null> };

export type GetRacesAttributesQueryVariables = Exact<{
  query?: InputMaybe<RaceQueryInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<RaceSortByInput>;
}>;


export type GetRacesAttributesQuery = { __typename?: 'Query', races: Array<{ __typename?: 'Race', name?: string | null, _id?: any | null } | null> };

export type GetGendersAttributesQueryVariables = Exact<{
  query?: InputMaybe<GenderQueryInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<GenderSortByInput>;
}>;


export type GetGendersAttributesQuery = { __typename?: 'Query', genders: Array<{ __typename?: 'Gender', name?: string | null, _id?: any | null } | null> };

export type GetBodyShapesAttributesQueryVariables = Exact<{
  query?: InputMaybe<Body_ShapeQueryInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Body_ShapeSortByInput>;
}>;


export type GetBodyShapesAttributesQuery = { __typename?: 'Query', body_shapes: Array<{ __typename?: 'Body_shape', name?: string | null, _id?: any | null, mask_url?: string | null } | null> };

export type GetClassesAttributesQueryVariables = Exact<{
  query?: InputMaybe<ClassQueryInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<ClassSortByInput>;
}>;


export type GetClassesAttributesQuery = { __typename?: 'Query', classes: Array<{ __typename?: 'Class', name?: string | null, _id?: any | null } | null> };

export type GetWeaponsAttributesQueryVariables = Exact<{
  query?: InputMaybe<WeaponQueryInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<WeaponSortByInput>;
}>;


export type GetWeaponsAttributesQuery = { __typename?: 'Query', weapons: Array<{ __typename?: 'Weapon', name?: string | null, _id?: any | null, mask_url?: string | null } | null> };

export type GetPersonalitiesAttributesQueryVariables = Exact<{
  query?: InputMaybe<PersonalityQueryInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<PersonalitySortByInput>;
}>;


export type GetPersonalitiesAttributesQuery = { __typename?: 'Query', personalities: Array<{ __typename?: 'Personality', name?: string | null, _id?: any | null } | null> };

export type GetArchtypesAttributesQueryVariables = Exact<{
  query?: InputMaybe<ArchetypeQueryInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<ArchetypeSortByInput>;
}>;


export type GetArchtypesAttributesQuery = { __typename?: 'Query', archetypes: Array<{ __typename?: 'Archetype', name?: string | null, _id?: any | null } | null> };

export type GetImageMasksQueryVariables = Exact<{
  query?: InputMaybe<Image_MaskQueryInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Image_MaskSortByInput>;
}>;


export type GetImageMasksQuery = { __typename?: 'Query', image_masks: Array<{ __typename?: 'Image_mask', name?: string | null, _id: any, created_at?: any | null, mask_url?: string | null } | null> };

export type GetCharacterHeightsQueryVariables = Exact<{
  query?: InputMaybe<Character_HeightQueryInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Character_HeightSortByInput>;
}>;


export type GetCharacterHeightsQuery = { __typename?: 'Query', character_heights: Array<{ __typename?: 'Character_height', name?: string | null, _id: any } | null> };

export type GetAlignmentsQueryVariables = Exact<{
  query?: InputMaybe<AlignmentQueryInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<AlignmentSortByInput>;
}>;


export type GetAlignmentsQuery = { __typename?: 'Query', alignments: Array<{ __typename?: 'Alignment', name?: string | null, _id?: any | null } | null> };

export type GetPronounsQueryVariables = Exact<{
  query?: InputMaybe<PronounQueryInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<PronounSortByInput>;
}>;


export type GetPronounsQuery = { __typename?: 'Query', pronouns: Array<{ __typename?: 'Pronoun', name?: string | null, _id?: any | null } | null> };

export type GetRelationshipsQueryVariables = Exact<{
  query?: InputMaybe<Relationship_StatusQueryInput>;
}>;


export type GetRelationshipsQuery = { __typename?: 'Query', relationship_status?: { __typename?: 'Relationship_status', name?: string | null, _id?: any | null } | null };

export type GetProfessionsQueryVariables = Exact<{
  query?: InputMaybe<ProfessionQueryInput>;
}>;


export type GetProfessionsQuery = { __typename?: 'Query', profession?: { __typename?: 'Profession', name?: string | null, _id?: any | null } | null };

export type GetCharactersQueryVariables = Exact<{
  query?: InputMaybe<CharacterQueryInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<CharacterSortByInput>;
}>;


export type GetCharactersQuery = { __typename?: 'Query', characters: Array<{ __typename?: 'Character', _id: any, name: string, avatar_url?: string | null, avatar_thumbnail_url?: string | null, character_image_thumbnail_url?: string | null, race?: string | null, motivations?: Array<string | null> | null, gender?: string | null, pronoun?: string | null, class?: string | null, alignment?: string | null, profession?: string | null, relationship_status?: string | null, life_altering_event?: string | null, backstory?: string | null, attributes?: Array<string | null> | null, owner?: { __typename?: 'User', _id: string } | null, physical_profile?: { __typename?: 'CharacterPhysical_profile', body_type?: string | null, eye_color?: string | null, hair_color?: string | null, hair_style?: string | null, skin_color?: string | null } | null, notes?: Array<{ __typename?: 'Note', _id: any, content?: string | null, tags?: Array<string | null> | null, title: string, owner?: { __typename?: 'User', _id: string } | null, realm: { __typename?: 'Realm', _id: any } } | null> | null, home?: Array<{ __typename?: 'Location', _id: any, description?: string | null, title?: string | null } | null> | null, abilities?: { __typename?: 'CharacterAbility', charisma?: number | null, consitution?: number | null, dexterity?: number | null, intelligence?: number | null, strength?: string | null, wisdom?: number | null } | null, character_sets?: Array<{ __typename?: 'Character_set', _id?: any | null } | null> | null, short_term_goals?: Array<{ __typename?: 'CharacterShort_term_goal', title?: string | null, content?: string | null } | null> | null, long_term_goals?: Array<{ __typename?: 'CharacterLong_term_goal', title?: string | null, content?: string | null } | null> | null } | null> };

export type GetCharactersSetsQueryVariables = Exact<{
  query?: InputMaybe<Character_SetQueryInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Character_SetSortByInput>;
}>;


export type GetCharactersSetsQuery = { __typename?: 'Query', character_sets: Array<{ __typename?: 'Character_set', name?: string | null, _id?: any | null, background_url?: string | null, created_at?: any | null, updated_at?: any | null, characters?: Array<{ __typename?: 'Character', _id: any, name: string, avatar_url?: string | null, avatar_thumbnail_url?: string | null, character_image_thumbnail_url?: string | null, race?: string | null, profession?: string | null, relationship_status?: string | null, life_altering_event?: string | null, gender?: string | null, height?: string | null, weight?: string | null, class?: string | null, pronoun?: string | null, alignment?: string | null, motivations?: Array<string | null> | null, backstory?: string | null, attributes?: Array<string | null> | null, owner?: { __typename?: 'User', _id: string } | null, character_sets?: Array<{ __typename?: 'Character_set', _id?: any | null } | null> | null, physical_profile?: { __typename?: 'CharacterPhysical_profile', body_type?: string | null, eye_color?: string | null, hair_color?: string | null, hair_style?: string | null, skin_color?: string | null } | null, home?: Array<{ __typename?: 'Location', _id: any, description?: string | null, title?: string | null } | null> | null, abilities?: { __typename?: 'CharacterAbility', charisma?: number | null, consitution?: number | null, dexterity?: number | null, intelligence?: number | null, strength?: string | null, wisdom?: number | null } | null, short_term_goals?: Array<{ __typename?: 'CharacterShort_term_goal', title?: string | null, content?: string | null } | null> | null, long_term_goals?: Array<{ __typename?: 'CharacterLong_term_goal', title?: string | null, content?: string | null } | null> | null, notes?: Array<{ __typename?: 'Note', _id: any, content?: string | null, tags?: Array<string | null> | null, title: string, owner?: { __typename?: 'User', _id: string } | null } | null> | null } | null> | null } | null> };

export type GetRealmsQueryVariables = Exact<{
  query?: InputMaybe<RealmQueryInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<RealmSortByInput>;
}>;


export type GetRealmsQuery = { __typename?: 'Query', realms: Array<{ __typename?: 'Realm', _id: any, name: string, description?: string | null, tags?: Array<string | null> | null, thumbnail_url?: string | null, is_favorited: boolean } | null> };

export type GetImageGenerationSkusQueryVariables = Exact<{
  query?: InputMaybe<Image_Generation_SkuQueryInput>;
}>;


export type GetImageGenerationSkusQuery = { __typename?: 'Query', image_generation_skus: Array<{ __typename?: 'Image_generation_sku', _id?: any | null, name?: string | null, description?: string | null, image_count?: number | null, image_height?: number | null, image_width?: number | null, speed_tier?: string | null, credit_cost?: number | null } | null> };

export type GetManyContentPacksQueryVariables = Exact<{
  query?: InputMaybe<Library_Content_PackQueryInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Library_Content_PackSortByInput>;
}>;


export type GetManyContentPacksQuery = { __typename?: 'Query', library_content_packs: Array<{ __typename?: 'Library_content_pack', name: string, created_date?: any | null, _id: any, media_assets?: Array<{ __typename?: 'Media_asset', _id: any, thumbnail_url: string } | null> | null } | null> };

export type GetManyMediaAssetsQueryVariables = Exact<{
  query?: InputMaybe<Media_AssetQueryInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetManyMediaAssetsQuery = { __typename?: 'Query', media_assets: Array<{ __typename?: 'Media_asset', name: string, thumbnail_url: string, asset_url: string } | null> };

export type GetMyLibraryFavoritesQueryVariables = Exact<{
  query?: InputMaybe<User_Library_Content_Pack_FavoriteQueryInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<User_Library_Content_Pack_FavoriteSortByInput>;
}>;


export type GetMyLibraryFavoritesQuery = { __typename?: 'Query', user_library_content_pack_favorites: Array<{ __typename?: 'User_library_content_pack_favorite', name?: string | null, created_at?: any | null, _id?: any | null, asset_category_type?: string | null, library_content_pack?: { __typename?: 'Library_content_pack', _id: any, title_image_url?: string | null, name: string, media_assets?: Array<{ __typename?: 'Media_asset', thumbnail_url: string, _id: any } | null> | null } | null } | null> };

export type GetPrompt_TemplateQueryInputQueryVariables = Exact<{
  query?: InputMaybe<Prompt_TemplateQueryInput>;
}>;


export type GetPrompt_TemplateQueryInputQuery = { __typename?: 'Query', prompt_templates: Array<{ __typename?: 'Prompt_template', _id?: any | null, name?: string | null, tags?: Array<string | null> | null, negative_prompt?: string | null, optional_attributes?: Array<string | null> | null, required_attributes?: Array<string | null> | null, template?: string | null, ui_preview?: string | null } | null> };

export type GetRealmQueryVariables = Exact<{
  query?: InputMaybe<RealmQueryInput>;
}>;


export type GetRealmQuery = { __typename?: 'Query', realm?: { __typename?: 'Realm', _id: any, name: string, description?: string | null, tags?: Array<string | null> | null, thumbnail_url?: string | null, is_favorited: boolean, is_public: boolean, token_sets?: Array<{ __typename?: 'Token_set', _id: any, name?: string | null, tokens?: Array<{ __typename?: 'Token', _id: any, thumbnail_url?: string | null, is_favorited: boolean, name: string, description?: string | null } | null> | null, owner?: { __typename?: 'User', _id: string } | null } | null> | null } | null };

export type GetText_Generation_SkusQueryVariables = Exact<{
  query?: InputMaybe<Text_Generation_SkuQueryInput>;
}>;


export type GetText_Generation_SkusQuery = { __typename?: 'Query', text_generation_skus: Array<{ __typename?: 'Text_generation_sku', _id?: any | null, model?: string | null, name?: string | null, token_count?: number | null, top_k?: number | null, top_p?: number | null, speed_tier?: string | null, repeat_penalty?: number | null } | null> };

export type GetTokenQueryVariables = Exact<{
  query?: InputMaybe<TokenQueryInput>;
}>;


export type GetTokenQuery = { __typename?: 'Query', token?: { __typename?: 'Token', _id: any, name: string, thumbnail_url?: string | null, is_favorited: boolean, token_url?: string | null, description?: string | null, token_base_image_url: string, updated_at: any, notes?: Array<{ __typename?: 'Note', _id: any, content?: string | null, title: string, tags?: Array<string | null> | null, realm: { __typename?: 'Realm', _id: any } } | null> | null, token_edits?: Array<{ __typename?: 'TokenToken_edit', created_at?: any | null, updated_at?: any | null, attributes?: { __typename?: 'TokenToken_editAttribute', brightness?: number | null, data_frame_type?: string | null, data_item_type?: string | null, draggable?: boolean | null, fill?: string | null, filters?: Array<string | null> | null, height?: number | null, name?: string | null, offset_x?: number | null, offset_y?: number | null, opacity?: number | null, rotation?: number | null, scale_x?: number | null, scale_y?: number | null, skew_x?: number | null, skew_y?: number | null, width?: number | null, x?: number | null, y?: number | null, z_index?: number | null } | null } | null> | null } | null };

export type GetTokenSetsQueryVariables = Exact<{
  query?: InputMaybe<Token_SetQueryInput>;
}>;


export type GetTokenSetsQuery = { __typename?: 'Query', token_sets: Array<{ __typename?: 'Token_set', _id: any, description?: string | null, name?: string | null, thumbnail_url?: string | null, tokens?: Array<{ __typename?: 'Token', _id: any, name: string, created_at: any, thumbnail_url?: string | null, is_favorited: boolean } | null> | null } | null> };

export type GetUserCharacterGenerationQueryVariables = Exact<{
  query?: InputMaybe<User_Character_GenerationQueryInput>;
}>;


export type GetUserCharacterGenerationQuery = { __typename?: 'Query', user_character_generation?: { __typename?: 'User_character_generation', _id?: any | null, created_at?: any | null, modified_at?: any | null, title?: string | null, attributes?: Array<{ __typename?: 'User_character_generationAttribute', name?: string | null, value?: string | null } | null> | null, user_text_generation?: { __typename?: 'User_text_generation', _id?: any | null } | null } | null };

export type GetUserConfigQueryVariables = Exact<{
  query?: InputMaybe<UserQueryInput>;
}>;


export type GetUserConfigQuery = { __typename?: 'Query', user?: { __typename?: 'User', config?: { __typename?: 'UserConfig', autoDismissIntroScreen?: boolean | null, defaultTheme?: string | null, disableTutorial?: boolean | null, isNewUser?: boolean | null, showInToolByDefault?: boolean | null } | null } | null };

export type GetUserGeneratedImagesQueryVariables = Exact<{
  query?: InputMaybe<User_Image_GenerationQueryInput>;
}>;


export type GetUserGeneratedImagesQuery = { __typename?: 'Query', user_image_generations: Array<{ __typename?: 'User_image_generation', _id?: any | null, created_date?: any | null, image_url?: string | null, name?: string | null } | null> };

export type GetUserProfileQueryVariables = Exact<{
  query?: InputMaybe<UserQueryInput>;
}>;


export type GetUserProfileQuery = { __typename?: 'Query', user?: { __typename?: 'User', _id: string, username?: string | null, email?: string | null, atlasUserId?: string | null, photo_url?: string | null, config?: { __typename?: 'UserConfig', autoDismissIntroScreen?: boolean | null, defaultTheme?: string | null, disableTutorial?: boolean | null, isNewUser?: boolean | null, showInToolByDefault?: boolean | null } | null } | null };

export type GetUserWalletQueryVariables = Exact<{
  query?: InputMaybe<UserQueryInput>;
}>;


export type GetUserWalletQuery = { __typename?: 'Query', user?: { __typename?: 'User', _id: string, email?: string | null, username?: string | null, user_subscription?: { __typename?: 'UserUser_subscription', purchase_date?: any | null, renew_date?: any | null, status?: string | null, subscription_tier?: { __typename?: 'Subscription_tier', name: string, currency: string, description: string, imageUrl: string, interval: string, max_realm_count: number, price: string } | null } | null, wallet?: { __typename?: 'UserWalletPayload', ssgpCreditPackCreditsRemaining?: number | null, ssgpCreditPackCreditsUsed?: number | null, ssgpPendingCredits?: number | null, ssgpSubscriptionCreditsRemaining?: number | null, ssgpSubscriptionCreditsUsed?: number | null, ssgpUserSubscriptionId?: number | null } | null } | null };

export type UpdateCharacterSetMutationVariables = Exact<{
  set: Character_SetUpdateInput;
  query?: InputMaybe<Character_SetQueryInput>;
}>;


export type UpdateCharacterSetMutation = { __typename?: 'Mutation', updateOneCharacter_set?: { __typename?: 'Character_set', _id?: any | null, characters?: Array<{ __typename?: 'Character', _id: any } | null> | null, owner?: { __typename?: 'User', _id: string } | null } | null };

export type UpdateManyNotesMutationVariables = Exact<{
  set: NoteUpdateInput;
  query?: InputMaybe<NoteQueryInput>;
}>;


export type UpdateManyNotesMutation = { __typename?: 'Mutation', updateManyNotes?: { __typename?: 'UpdateManyPayload', matchedCount: number, modifiedCount: number } | null };

export type UpdateOneCharacterMutationVariables = Exact<{
  set: CharacterUpdateInput;
  query?: InputMaybe<CharacterQueryInput>;
}>;


export type UpdateOneCharacterMutation = { __typename?: 'Mutation', updateOneCharacter?: { __typename?: 'Character', _id: any, name: string } | null };

export type UpdateOneNoteMutationVariables = Exact<{
  set: NoteUpdateInput;
  query?: InputMaybe<NoteQueryInput>;
}>;


export type UpdateOneNoteMutation = { __typename?: 'Mutation', updateOneNote?: { __typename?: 'Note', _id: any, title: string, content?: string | null } | null };

export type UpdateOneRealmMutationVariables = Exact<{
  set: RealmUpdateInput;
  query?: InputMaybe<RealmQueryInput>;
}>;


export type UpdateOneRealmMutation = { __typename?: 'Mutation', updateOneRealm?: { __typename?: 'Realm', _id: any, name: string, description?: string | null, tags?: Array<string | null> | null, thumbnail_url?: string | null, is_favorited: boolean, is_public: boolean, token_sets?: Array<{ __typename?: 'Token_set', _id: any, name?: string | null, tokens?: Array<{ __typename?: 'Token', _id: any, thumbnail_url?: string | null, is_favorited: boolean, name: string, description?: string | null } | null> | null, owner?: { __typename?: 'User', _id: string } | null } | null> | null } | null };

export type UpdateOneTokenMutationVariables = Exact<{
  set: TokenUpdateInput;
  query?: InputMaybe<TokenQueryInput>;
}>;


export type UpdateOneTokenMutation = { __typename?: 'Mutation', updateOneToken?: { __typename?: 'Token', _id: any, name: string, thumbnail_url?: string | null, token_base_image_url: string, token_url?: string | null, description?: string | null, is_favorited: boolean, is_public: boolean, is_visible_in_tool: boolean, realm: { __typename?: 'Realm', _id: any } } | null };

export type UpdateOneTokenSetMutationVariables = Exact<{
  set: Token_SetUpdateInput;
  query?: InputMaybe<Token_SetQueryInput>;
}>;


export type UpdateOneTokenSetMutation = { __typename?: 'Mutation', updateOneToken_set?: { __typename?: 'Token_set', _id: any, name?: string | null, thumbnail_url?: string | null, description?: string | null, realm?: { __typename?: 'Realm', _id: any } | null, tokens?: Array<{ __typename?: 'Token', _id: any, name: string, thumbnail_url?: string | null } | null> | null } | null };

export type UpdateUserMutationVariables = Exact<{
  data: UserUpdateInput;
  query: UserQueryInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateOneUser?: { __typename?: 'User', _id: string, username?: string | null, photo_url?: string | null, email?: string | null, atlasUserId?: string | null, config?: { __typename?: 'UserConfig', autoDismissIntroScreen?: boolean | null, defaultTheme?: string | null, disableTutorial?: boolean | null, isNewUser?: boolean | null, showInToolByDefault?: boolean | null } | null } | null };

export type UpdateUserConfigMutationVariables = Exact<{
  data: UserUpdateInput;
}>;


export type UpdateUserConfigMutation = { __typename?: 'Mutation', updateOneUser?: { __typename?: 'User', _id: string, config?: { __typename?: 'UserConfig', autoDismissIntroScreen?: boolean | null, defaultTheme?: string | null, disableTutorial?: boolean | null, isNewUser?: boolean | null, showInToolByDefault?: boolean | null } | null } | null };


export const CreateCharacterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCharacter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CharacterInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertOneCharacter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"avatar_url"}},{"kind":"Field","name":{"kind":"Name","value":"character_image_thumbnail_url"}},{"kind":"Field","name":{"kind":"Name","value":"race"}},{"kind":"Field","name":{"kind":"Name","value":"motivations"}},{"kind":"Field","name":{"kind":"Name","value":"physical_profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"body_type"}},{"kind":"Field","name":{"kind":"Name","value":"eye_color"}},{"kind":"Field","name":{"kind":"Name","value":"hair_color"}},{"kind":"Field","name":{"kind":"Name","value":"hair_style"}},{"kind":"Field","name":{"kind":"Name","value":"skin_color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"notes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"realm"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"backstory"}},{"kind":"Field","name":{"kind":"Name","value":"home"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"abilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"charisma"}},{"kind":"Field","name":{"kind":"Name","value":"consitution"}},{"kind":"Field","name":{"kind":"Name","value":"dexterity"}},{"kind":"Field","name":{"kind":"Name","value":"intelligence"}},{"kind":"Field","name":{"kind":"Name","value":"strength"}},{"kind":"Field","name":{"kind":"Name","value":"wisdom"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"character_sets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateCharacterMutation, CreateCharacterMutationVariables>;
export const CreateCharacterSetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCharacterSet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Character_setInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertOneCharacter_set"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"characters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"background_url"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateCharacterSetMutation, CreateCharacterSetMutationVariables>;
export const CreateMyLibraryFavoritesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateMyLibraryFavorites"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"User_library_content_pack_favoriteInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertOneUser_library_content_pack_favorite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"asset_category_type"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"library_content_pack"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}}]} as unknown as DocumentNode<CreateMyLibraryFavoritesMutation, CreateMyLibraryFavoritesMutationVariables>;
export const CreateNoteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateNote"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NoteInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertOneNote"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateNoteMutation, CreateNoteMutationVariables>;
export const CreateRealmDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateRealm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RealmInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertOneRealm"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail_url"}},{"kind":"Field","name":{"kind":"Name","value":"is_favorited"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<CreateRealmMutation, CreateRealmMutationVariables>;
export const CreateTokenSetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateTokenSet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Token_setInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertOneToken_set"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail_url"}},{"kind":"Field","name":{"kind":"Name","value":"tokens"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateTokenSetMutation, CreateTokenSetMutationVariables>;
export const DeleteManyNotesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteManyNotes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NoteQueryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteManyNotes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletedCount"}}]}}]}}]} as unknown as DocumentNode<DeleteManyNotesMutation, DeleteManyNotesMutationVariables>;
export const DeleteManyRealmsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteManyRealms"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RealmQueryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteManyRealms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletedCount"}}]}}]}}]} as unknown as DocumentNode<DeleteManyRealmsMutation, DeleteManyRealmsMutationVariables>;
export const DeleteOneCharacterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOneCharacter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CharacterQueryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneCharacter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<DeleteOneCharacterMutation, DeleteOneCharacterMutationVariables>;
export const DeleteOneCharacterSetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOneCharacterSet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Character_setQueryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneCharacter_set"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<DeleteOneCharacterSetMutation, DeleteOneCharacterSetMutationVariables>;
export const DeleteOneMyLibraryFavoritesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOneMyLibraryFavorites"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"User_library_content_pack_favoriteQueryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneUser_library_content_pack_favorite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<DeleteOneMyLibraryFavoritesMutation, DeleteOneMyLibraryFavoritesMutationVariables>;
export const DeleteOneRealmDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOneRealm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RealmQueryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneRealm"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<DeleteOneRealmMutation, DeleteOneRealmMutationVariables>;
export const DeleteOneTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOneToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TokenQueryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<DeleteOneTokenMutation, DeleteOneTokenMutationVariables>;
export const DeleteOneTokenSetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOneTokenSet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Token_setQueryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneToken_set"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<DeleteOneTokenSetMutation, DeleteOneTokenSetMutationVariables>;
export const GetAllCampaignsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllCampaigns"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CampaignQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"campaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"background_asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset_url"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"campaign_acts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"narrative"}},{"kind":"Field","name":{"kind":"Name","value":"outcomes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"impact"}}]}},{"kind":"Field","name":{"kind":"Name","value":"background_asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset_url"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail_asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset_url"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail_url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"main_location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]} as unknown as DocumentNode<GetAllCampaignsQuery, GetAllCampaignsQueryVariables>;
export const GetHairAttributesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetHairAttributes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"HairQueryInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"HairSortByInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hairs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]} as unknown as DocumentNode<GetHairAttributesQuery, GetHairAttributesQueryVariables>;
export const GetEyesAttributesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEyesAttributes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EyeQueryInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EyeSortByInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eyes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]} as unknown as DocumentNode<GetEyesAttributesQuery, GetEyesAttributesQueryVariables>;
export const GetSkinsAttributesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSkinsAttributes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SkinQueryInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SkinSortByInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"skins"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]} as unknown as DocumentNode<GetSkinsAttributesQuery, GetSkinsAttributesQueryVariables>;
export const GetRacesAttributesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRacesAttributes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"RaceQueryInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"RaceSortByInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"races"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]} as unknown as DocumentNode<GetRacesAttributesQuery, GetRacesAttributesQueryVariables>;
export const GetGendersAttributesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetGendersAttributes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"GenderQueryInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"GenderSortByInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"genders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]} as unknown as DocumentNode<GetGendersAttributesQuery, GetGendersAttributesQueryVariables>;
export const GetBodyShapesAttributesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBodyShapesAttributes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Body_shapeQueryInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Body_shapeSortByInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"body_shapes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"mask_url"}}]}}]}}]} as unknown as DocumentNode<GetBodyShapesAttributesQuery, GetBodyShapesAttributesQueryVariables>;
export const GetClassesAttributesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetClassesAttributes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ClassQueryInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ClassSortByInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"classes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]} as unknown as DocumentNode<GetClassesAttributesQuery, GetClassesAttributesQueryVariables>;
export const GetWeaponsAttributesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWeaponsAttributes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WeaponQueryInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WeaponSortByInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"weapons"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"mask_url"}}]}}]}}]} as unknown as DocumentNode<GetWeaponsAttributesQuery, GetWeaponsAttributesQueryVariables>;
export const GetPersonalitiesAttributesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPersonalitiesAttributes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PersonalityQueryInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PersonalitySortByInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"personalities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]} as unknown as DocumentNode<GetPersonalitiesAttributesQuery, GetPersonalitiesAttributesQueryVariables>;
export const GetArchtypesAttributesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetArchtypesAttributes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ArchetypeQueryInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ArchetypeSortByInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"archetypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]} as unknown as DocumentNode<GetArchtypesAttributesQuery, GetArchtypesAttributesQueryVariables>;
export const GetImageMasksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetImageMasks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Image_maskQueryInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Image_maskSortByInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image_masks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"mask_url"}}]}}]}}]} as unknown as DocumentNode<GetImageMasksQuery, GetImageMasksQueryVariables>;
export const GetCharacterHeightsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCharacterHeights"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Character_heightQueryInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Character_heightSortByInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"character_heights"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]} as unknown as DocumentNode<GetCharacterHeightsQuery, GetCharacterHeightsQueryVariables>;
export const GetAlignmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAlignments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AlignmentQueryInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AlignmentSortByInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alignments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]} as unknown as DocumentNode<GetAlignmentsQuery, GetAlignmentsQueryVariables>;
export const GetPronounsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPronouns"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PronounQueryInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PronounSortByInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pronouns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]} as unknown as DocumentNode<GetPronounsQuery, GetPronounsQueryVariables>;
export const GetRelationshipsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRelationships"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Relationship_statusQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"relationship_status"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]} as unknown as DocumentNode<GetRelationshipsQuery, GetRelationshipsQueryVariables>;
export const GetProfessionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProfessions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfessionQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]} as unknown as DocumentNode<GetProfessionsQuery, GetProfessionsQueryVariables>;
export const GetCharactersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCharacters"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CharacterQueryInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CharacterSortByInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"characters"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"avatar_url"}},{"kind":"Field","name":{"kind":"Name","value":"avatar_thumbnail_url"}},{"kind":"Field","name":{"kind":"Name","value":"character_image_thumbnail_url"}},{"kind":"Field","name":{"kind":"Name","value":"race"}},{"kind":"Field","name":{"kind":"Name","value":"motivations"}},{"kind":"Field","name":{"kind":"Name","value":"physical_profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"body_type"}},{"kind":"Field","name":{"kind":"Name","value":"eye_color"}},{"kind":"Field","name":{"kind":"Name","value":"hair_color"}},{"kind":"Field","name":{"kind":"Name","value":"hair_style"}},{"kind":"Field","name":{"kind":"Name","value":"skin_color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"notes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"realm"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"pronoun"}},{"kind":"Field","name":{"kind":"Name","value":"class"}},{"kind":"Field","name":{"kind":"Name","value":"alignment"}},{"kind":"Field","name":{"kind":"Name","value":"profession"}},{"kind":"Field","name":{"kind":"Name","value":"relationship_status"}},{"kind":"Field","name":{"kind":"Name","value":"life_altering_event"}},{"kind":"Field","name":{"kind":"Name","value":"backstory"}},{"kind":"Field","name":{"kind":"Name","value":"home"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"abilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"charisma"}},{"kind":"Field","name":{"kind":"Name","value":"consitution"}},{"kind":"Field","name":{"kind":"Name","value":"dexterity"}},{"kind":"Field","name":{"kind":"Name","value":"intelligence"}},{"kind":"Field","name":{"kind":"Name","value":"strength"}},{"kind":"Field","name":{"kind":"Name","value":"wisdom"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"character_sets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"short_term_goals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}},{"kind":"Field","name":{"kind":"Name","value":"long_term_goals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}}]}}]} as unknown as DocumentNode<GetCharactersQuery, GetCharactersQueryVariables>;
export const GetCharactersSetsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCharactersSets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Character_setQueryInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Character_setSortByInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"character_sets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"background_url"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"characters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"avatar_url"}},{"kind":"Field","name":{"kind":"Name","value":"avatar_thumbnail_url"}},{"kind":"Field","name":{"kind":"Name","value":"character_image_thumbnail_url"}},{"kind":"Field","name":{"kind":"Name","value":"race"}},{"kind":"Field","name":{"kind":"Name","value":"profession"}},{"kind":"Field","name":{"kind":"Name","value":"relationship_status"}},{"kind":"Field","name":{"kind":"Name","value":"life_altering_event"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"class"}},{"kind":"Field","name":{"kind":"Name","value":"pronoun"}},{"kind":"Field","name":{"kind":"Name","value":"alignment"}},{"kind":"Field","name":{"kind":"Name","value":"motivations"}},{"kind":"Field","name":{"kind":"Name","value":"character_sets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"physical_profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"body_type"}},{"kind":"Field","name":{"kind":"Name","value":"eye_color"}},{"kind":"Field","name":{"kind":"Name","value":"hair_color"}},{"kind":"Field","name":{"kind":"Name","value":"hair_style"}},{"kind":"Field","name":{"kind":"Name","value":"skin_color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"backstory"}},{"kind":"Field","name":{"kind":"Name","value":"home"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"abilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"charisma"}},{"kind":"Field","name":{"kind":"Name","value":"consitution"}},{"kind":"Field","name":{"kind":"Name","value":"dexterity"}},{"kind":"Field","name":{"kind":"Name","value":"intelligence"}},{"kind":"Field","name":{"kind":"Name","value":"strength"}},{"kind":"Field","name":{"kind":"Name","value":"wisdom"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"short_term_goals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}},{"kind":"Field","name":{"kind":"Name","value":"long_term_goals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}},{"kind":"Field","name":{"kind":"Name","value":"notes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCharactersSetsQuery, GetCharactersSetsQueryVariables>;
export const GetRealmsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRealms"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"RealmQueryInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"100"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"RealmSortByInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"realms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail_url"}},{"kind":"Field","name":{"kind":"Name","value":"is_favorited"}}]}}]}}]} as unknown as DocumentNode<GetRealmsQuery, GetRealmsQueryVariables>;
export const GetImageGenerationSkusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetImageGenerationSkus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Image_generation_skuQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image_generation_skus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"image_count"}},{"kind":"Field","name":{"kind":"Name","value":"image_height"}},{"kind":"Field","name":{"kind":"Name","value":"image_width"}},{"kind":"Field","name":{"kind":"Name","value":"speed_tier"}},{"kind":"Field","name":{"kind":"Name","value":"credit_cost"}}]}}]}}]} as unknown as DocumentNode<GetImageGenerationSkusQuery, GetImageGenerationSkusQueryVariables>;
export const GetManyContentPacksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetManyContentPacks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Library_content_packQueryInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Library_content_packSortByInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"library_content_packs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"created_date"}},{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"media_assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail_url"}}]}}]}}]}}]} as unknown as DocumentNode<GetManyContentPacksQuery, GetManyContentPacksQueryVariables>;
export const GetManyMediaAssetsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetManyMediaAssets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Media_assetQueryInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"media_assets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail_url"}},{"kind":"Field","name":{"kind":"Name","value":"asset_url"}}]}}]}}]} as unknown as DocumentNode<GetManyMediaAssetsQuery, GetManyMediaAssetsQueryVariables>;
export const GetMyLibraryFavoritesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMyLibraryFavorites"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"User_library_content_pack_favoriteQueryInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"User_library_content_pack_favoriteSortByInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_library_content_pack_favorites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"asset_category_type"}},{"kind":"Field","name":{"kind":"Name","value":"library_content_pack"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"title_image_url"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"media_assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnail_url"}},{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetMyLibraryFavoritesQuery, GetMyLibraryFavoritesQueryVariables>;
export const GetPrompt_TemplateQueryInputDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPrompt_TemplateQueryInput"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Prompt_templateQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prompt_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"negative_prompt"}},{"kind":"Field","name":{"kind":"Name","value":"optional_attributes"}},{"kind":"Field","name":{"kind":"Name","value":"required_attributes"}},{"kind":"Field","name":{"kind":"Name","value":"template"}},{"kind":"Field","name":{"kind":"Name","value":"ui_preview"}}]}}]}}]} as unknown as DocumentNode<GetPrompt_TemplateQueryInputQuery, GetPrompt_TemplateQueryInputQueryVariables>;
export const GetRealmDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRealm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"RealmQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"realm"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail_url"}},{"kind":"Field","name":{"kind":"Name","value":"is_favorited"}},{"kind":"Field","name":{"kind":"Name","value":"is_public"}},{"kind":"Field","name":{"kind":"Name","value":"token_sets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tokens"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail_url"}},{"kind":"Field","name":{"kind":"Name","value":"is_favorited"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetRealmQuery, GetRealmQueryVariables>;
export const GetText_Generation_SkusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetText_Generation_Skus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Text_generation_skuQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text_generation_skus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"token_count"}},{"kind":"Field","name":{"kind":"Name","value":"top_k"}},{"kind":"Field","name":{"kind":"Name","value":"top_p"}},{"kind":"Field","name":{"kind":"Name","value":"speed_tier"}},{"kind":"Field","name":{"kind":"Name","value":"repeat_penalty"}}]}}]}}]} as unknown as DocumentNode<GetText_Generation_SkusQuery, GetText_Generation_SkusQueryVariables>;
export const GetTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TokenQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail_url"}},{"kind":"Field","name":{"kind":"Name","value":"is_favorited"}},{"kind":"Field","name":{"kind":"Name","value":"token_url"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"token_base_image_url"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"notes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"realm"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"}}]}},{"kind":"Field","name":{"kind":"Name","value":"token_edits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brightness"}},{"kind":"Field","name":{"kind":"Name","value":"data_frame_type"}},{"kind":"Field","name":{"kind":"Name","value":"data_item_type"}},{"kind":"Field","name":{"kind":"Name","value":"draggable"}},{"kind":"Field","name":{"kind":"Name","value":"fill"}},{"kind":"Field","name":{"kind":"Name","value":"filters"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"offset_x"}},{"kind":"Field","name":{"kind":"Name","value":"offset_y"}},{"kind":"Field","name":{"kind":"Name","value":"opacity"}},{"kind":"Field","name":{"kind":"Name","value":"rotation"}},{"kind":"Field","name":{"kind":"Name","value":"scale_x"}},{"kind":"Field","name":{"kind":"Name","value":"scale_y"}},{"kind":"Field","name":{"kind":"Name","value":"skew_x"}},{"kind":"Field","name":{"kind":"Name","value":"skew_y"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"z_index"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetTokenQuery, GetTokenQueryVariables>;
export const GetTokenSetsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTokenSets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Token_setQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token_sets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail_url"}},{"kind":"Field","name":{"kind":"Name","value":"tokens"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail_url"}},{"kind":"Field","name":{"kind":"Name","value":"is_favorited"}}]}}]}}]}}]} as unknown as DocumentNode<GetTokenSetsQuery, GetTokenSetsQueryVariables>;
export const GetUserCharacterGenerationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserCharacterGeneration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"User_character_generationQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_character_generation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"modified_at"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"user_text_generation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserCharacterGenerationQuery, GetUserCharacterGenerationQueryVariables>;
export const GetUserConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"config"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"autoDismissIntroScreen"}},{"kind":"Field","name":{"kind":"Name","value":"defaultTheme"}},{"kind":"Field","name":{"kind":"Name","value":"disableTutorial"}},{"kind":"Field","name":{"kind":"Name","value":"isNewUser"}},{"kind":"Field","name":{"kind":"Name","value":"showInToolByDefault"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserConfigQuery, GetUserConfigQueryVariables>;
export const GetUserGeneratedImagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserGeneratedImages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"User_image_generationQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_image_generations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_date"}},{"kind":"Field","name":{"kind":"Name","value":"image_url"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetUserGeneratedImagesQuery, GetUserGeneratedImagesQueryVariables>;
export const GetUserProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"atlasUserId"}},{"kind":"Field","name":{"kind":"Name","value":"photo_url"}},{"kind":"Field","name":{"kind":"Name","value":"config"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"autoDismissIntroScreen"}},{"kind":"Field","name":{"kind":"Name","value":"defaultTheme"}},{"kind":"Field","name":{"kind":"Name","value":"disableTutorial"}},{"kind":"Field","name":{"kind":"Name","value":"isNewUser"}},{"kind":"Field","name":{"kind":"Name","value":"showInToolByDefault"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserProfileQuery, GetUserProfileQueryVariables>;
export const GetUserWalletDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserWallet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"user_subscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"purchase_date"}},{"kind":"Field","name":{"kind":"Name","value":"renew_date"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"subscription_tier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"max_realm_count"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"wallet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ssgpCreditPackCreditsRemaining"}},{"kind":"Field","name":{"kind":"Name","value":"ssgpCreditPackCreditsUsed"}},{"kind":"Field","name":{"kind":"Name","value":"ssgpPendingCredits"}},{"kind":"Field","name":{"kind":"Name","value":"ssgpSubscriptionCreditsRemaining"}},{"kind":"Field","name":{"kind":"Name","value":"ssgpSubscriptionCreditsUsed"}},{"kind":"Field","name":{"kind":"Name","value":"ssgpUserSubscriptionId"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserWalletQuery, GetUserWalletQueryVariables>;
export const UpdateCharacterSetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCharacterSet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"set"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Character_setUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Character_setQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneCharacter_set"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"set"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"characters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateCharacterSetMutation, UpdateCharacterSetMutationVariables>;
export const UpdateManyNotesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateManyNotes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"set"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NoteUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"NoteQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateManyNotes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"set"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"matchedCount"}},{"kind":"Field","name":{"kind":"Name","value":"modifiedCount"}}]}}]}}]} as unknown as DocumentNode<UpdateManyNotesMutation, UpdateManyNotesMutationVariables>;
export const UpdateOneCharacterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOneCharacter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"set"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CharacterUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CharacterQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneCharacter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"set"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<UpdateOneCharacterMutation, UpdateOneCharacterMutationVariables>;
export const UpdateOneNoteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOneNote"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"set"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NoteUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"NoteQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneNote"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"set"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}}]} as unknown as DocumentNode<UpdateOneNoteMutation, UpdateOneNoteMutationVariables>;
export const UpdateOneRealmDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOneRealm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"set"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RealmUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"RealmQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneRealm"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"set"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail_url"}},{"kind":"Field","name":{"kind":"Name","value":"is_favorited"}},{"kind":"Field","name":{"kind":"Name","value":"is_public"}},{"kind":"Field","name":{"kind":"Name","value":"token_sets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tokens"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail_url"}},{"kind":"Field","name":{"kind":"Name","value":"is_favorited"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateOneRealmMutation, UpdateOneRealmMutationVariables>;
export const UpdateOneTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOneToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"set"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TokenUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TokenQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"set"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"realm"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail_url"}},{"kind":"Field","name":{"kind":"Name","value":"token_base_image_url"}},{"kind":"Field","name":{"kind":"Name","value":"token_url"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"is_favorited"}},{"kind":"Field","name":{"kind":"Name","value":"is_public"}},{"kind":"Field","name":{"kind":"Name","value":"is_visible_in_tool"}}]}}]}}]} as unknown as DocumentNode<UpdateOneTokenMutation, UpdateOneTokenMutationVariables>;
export const UpdateOneTokenSetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOneTokenSet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"set"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Token_setUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Token_setQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneToken_set"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"set"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"realm"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail_url"}},{"kind":"Field","name":{"kind":"Name","value":"tokens"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<UpdateOneTokenSetMutation, UpdateOneTokenSetMutationVariables>;
export const UpdateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserQueryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"photo_url"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"atlasUserId"}},{"kind":"Field","name":{"kind":"Name","value":"config"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"autoDismissIntroScreen"}},{"kind":"Field","name":{"kind":"Name","value":"defaultTheme"}},{"kind":"Field","name":{"kind":"Name","value":"disableTutorial"}},{"kind":"Field","name":{"kind":"Name","value":"isNewUser"}},{"kind":"Field","name":{"kind":"Name","value":"showInToolByDefault"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateUserMutation, UpdateUserMutationVariables>;
export const UpdateUserConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"config"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"autoDismissIntroScreen"}},{"kind":"Field","name":{"kind":"Name","value":"defaultTheme"}},{"kind":"Field","name":{"kind":"Name","value":"disableTutorial"}},{"kind":"Field","name":{"kind":"Name","value":"isNewUser"}},{"kind":"Field","name":{"kind":"Name","value":"showInToolByDefault"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateUserConfigMutation, UpdateUserConfigMutationVariables>;